// MessagesPage.tsx · v12.10.30 (#1155 #1156 #1157 Call back from the browser: 0a split button, call window in the drawer, call back block + note + Activity, transfer opens the card; #2242 server filters / search; #2258 drawer gap / tints / jump) · 2026-11-03 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.29.1 (#2246 the open drawer stays put when the same caller calls again - quiet "New call · Show"; #2238 to work / Me / Reminders / Urgent / Phone calls count cards; #2243 999+ shows the exact number on hover) · 2026-11-03 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.30 (#2242 long ranges: fill to 1,000 then scroll for more, counters from the server, Oldest pages from the oldest end) · 2026-11-03 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.29 (#2237 drawer header: the card's coloured request pill; #2226 group pill = "×N times" only; hover lists the calls; a searched older reference shows after it) · 2026-11-02 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.28 (#2185 templates do not repeat the practice name; #2182 staff texts never carry the "Texting not supported" line; STOP keeps its own row) · 2026-11-01 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.27 (#2146 Text messages tab = kind text list, teal workspace, +N new, chat drawer with the reply box always open, Call back in the footer; #2151 our sent texts show in the transcript - role staff, TEXT "Sent by text") · 2026-10-31 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.26 (#T154 small additive: Text messages tab when the workflow is On -> TextMessagesPanel; New text pill + follow-up flag on the card; TEXT mark in the transcript; template closing sentence follows Text replies) · 2026-10-30 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.26 (#2121 the counters come with the first page (server SQL counts for the dates) and show while the list loads; #2122 Oldest / Newest or Pending changed while loading restarts the load with that order) · 2026-10-30 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.25 (#2117 calls with a group number are grouped by it; #2104 default refresh 60 s; the list is the chosen dates + only the follow-up calls of other dates (server)) · 2026-10-30 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.23 (#2070 What the caller needs: Wants call tag first + 3 lines, Next step with the call-back number, History behind View, card = Wants + call back + Next step) · 2026-10-29 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.22.2 (#2069 Combined view: EN / ES translates every call of the group, oldest first; #2059 Esc closes the Filters / date panels) · 2026-10-28 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.22.1 (#2055 the Call route gets the Call path switch - showPath) · 2026-10-28 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.22 (#2011 the drawer header names the exact workflow › intent when the category is shared; #2010 the path icon opens the Call route, Owner only; #2001 the open drawer keeps its transcript when the heartbeat brings a changed lean row, then reads it again; #1971 Filters: Audit moved to column 1 under Label; #2002 a browser refresh keeps the filters - the left-menu reset is applied once, not again on reload) · 2026-10-28 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.21 (#1944 #1945 while the rest of the list loads the counters show a soft loading mark and the logo frame replaces the yellow bar; #1953 a missed call where the agent spoke reads 'Hung up during the call' with its transcript + recording; #1751 a picked Combined call plays ITS recording or says 'No recording for <ref>'; #1952 download named '<call number> - <yyyymmdd>.mp3') · 2026-10-26 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.20 (T165: #1934 a date change shows the first cards at once, the yellow bar counts the rest in chunks, never a stale list or count; #1935 only the cards near the screen are drawn; #1936 lean rows keep the drawer's Call data) · 2026-10-24 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.19 (#1885 #1925 Combined: the latest meaningful call leads, several -> one line each, all empty -> "No request given"; #1905 the card line = the full Wants + Next step; #1920 Combined Call data = ONE table with each value's reference; #1910 heard / corrections in Call data) · 2026-10-23 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.19 (#1882 heartbeat asks only what changed (?since= cursor, delta merge); the list never says "0 calls" / "No messages" while the rest is loading) · 2026-10-23 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.18 (#1865 Mark for audit in More actions (divider STATUS / ACTIONS), AUDIT filter, Activity line) · 2026-10-22 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.17.2 (#1818 the group's call with the most content leads the card + WANTS, "Dr." never cuts a sentence; #1821 HISTORY row; #1820 Combined transcript always shown, oldest first) · 2026-10-19 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.17.1 (#1792 card middle line drops the fixed request words; #1781 no "earlier: Request"; #1794 one face for card + drawer header - group name / caller type / request, the contact book's name for a call with none) · 2026-10-16 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.17 (#1723 T120 / BDR-018: avatar = caller type only, Unclassified slate person (D1 D2); middle line never "Request" (D3); pill row below, "card · request type" in the card's colour + icon, grey Unclassified (D4 D5 D6); no "From voicemail" anywhere (D7); key-first lookup for card, drawer, filters, print (D12); quiet drawer header (D13)) · 2026-10-16 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.17 (#1751 Combined plays the picked call + "Playing #.."; #1748 Combined copies every call, oldest first, under its header; #1698 Combined Call data per call; #1773 formatReference moved to lib/reference.ts) · 2026-10-16 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.16.1 (#1701 a group is open while any call is open; #1707 #1700 Combined rows on any call + caller from an earlier call; #1708 note -> tooltip; #1709 spoken language from the caller; #1702 refresh = practice setting; #1703 first page by sort / Pending) · 2026-10-14 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.16 (T104 #1677 stale refresh guard, next from the updated list, log line; #1688 kept list + first page; #1673 Activity refresh; T113 #1690 grouped list + Combined drawer; T115 #1693 batch select) · 2026-10-14 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.15 (T95: #1651 read only on an action; #1648 Activity - who / when / from → to, hover on status and assignee; #1636 Copy call record in Print ▾; #1637 #1650; T105 #1663 Callback on the card and drawer; T109 #1668 click a phone to copy the 10 digits; T107 #1666 from voicemail tags) · 2026-10-13 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.14 (T83 #1605-#1613 date control, filter panel multi-select, cards, phone; T84 #1616-#1619 drawer footer (mini player + Call path left; Print P · M · Ctrl+Enter right), "Read in" gone, ES · As spoken | EN, Rows | Paragraph, look A removed, speakers + time right, print here; #1620 Copy call data; P = Print, U = Urgent) · 2026-10-12 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.13 (T83 #1558 #1559 #1560 #1561 #1566 #1567 #1568 #1569 #1570 - Filters panel to T2_UI_PRINCIPLES §42 with the practice's own lists and Type / Opened / Notes / Outcome; one-line top bar; two-line scrolled bar; Yesterday; phone list; named filters + Reset when nothing matches · T84 #1562-#1565 #1604 drawer · #1556 Follow-ups empty wording · #1601 data-track names) · 2026-10-10 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.12 T69 (UI-PROTO-12.10.11.4 v1.6 LOCKED: #1529 to work / Me / Reminders / Urgent inside the dates; #1530 UP NEXT + "N to work" + white pills that combine; #1531 Reminders replaces Due; #1532 "Phone calls · N"; #1533 Filters in three columns; #1534 Follow-ups opens on Your account choice; #1535 Text messages "Not available yet", Newest / Oldest; #1536 Follow-ups top bar) · 2026-10-10 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.11.3 HOTFIX (#1522 every call in the dates + every open call, exact counts 999+, Next never grey early, lean list + detail on open; #1523 total + day counts; #1521 Newest/Oldest, sort + date remembered; #1524 drawer stays open, Last opened, position; #1525 Me; #1526 flag chip; #1527 due = today/overdue, Follow-ups view with pills) · 2026-10-09 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.11.2 (#1497 Filters › Status lists Pending once - Pending = new + in progress) · 2026-10-09 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.11.1 (#1461 the provisioning test call is marked "Setup test call" and left out of the counts) · 2026-10-09
// MessagesPage.tsx · v12.10.11.1 (#982 a call with no saved recording says so - no Retry, no pop-ups; #1491 #1492 #1493 phone layout; #1472 a text never goes out with "[appointment date]"; practice named by its Display name; #1494 every note shows, newest first, readable time; #1445 a note after Send Text is no longer hidden; #1442 caller speaker name = header name) · 2026-10-09 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.11 (#1445 a failed note save gives the typed text back; #1459 carrier on hover) · 2026-10-08 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.10 (#1399 Assigned to: real users, chip menu, filter, 'Assigned to me (N)', card assignee; #1402 call type in the drawer; #1403 Call back / Send Text always shown) · 2026-10-08 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.9.4 (#1379 403 = no access; #1381 one tick per action; #1380 menu resets filters, refresh keeps; #1358 phone compact bar only; #1359 one player in the footer row) · 2026-10-07 · VoiceSpectrum AI
// MessagesPage.tsx · v12.10.9.3 (#1331 shorter search hint on a phone; #1326 / #1331 phone layout = desktop, CSS in agent-workspace.css) · 2026-10-07
// MessagesPage.tsx - v12.10.9.1 (#1280 one "Your account" menu entry; #1277 phone footer icon buttons with the player in the row; #1278 phone details as text rows, Phone row only on desktop).
// MessagesPage.tsx - v12.10.7.1 (#1210 the Text messages tab is disabled with FUTURE; the composer note no longer points to it).
// MessagesPage.tsx - v12.10.7 (#1163 /messages?q=<reference> fills the search - Contacts › Calls opens a call this way).
// MessagesPage.tsx - v12.10.6 (#1153 the Date scope panel is the shared control (Source/src/shared-ui) - Year / Month added under Custom).
// MessagesPage.tsx - v12.10.6 (#982 reopened: the recording link is renewed silently while paused and on return to the tab; a refused link may be renewed again after 20 s - no "Recording unavailable" after idle).
// MessagesPage.tsx - v12.10.2 (#1103 Call data lists only the fields the call went through - no "never reached" rows).
// MessagesPage.tsx - v12.9.27.1 (#1063 no flags chip in the open message's header; the list row keeps it. #1064 summary header: title + EN/ES + copy as one group like Transcript, Classic on the right).
// MessagesPage.tsx - v12.9.27 (#1048 the row chip names the flagged fields; STRUGGLE (was CHECK) in Call data; one plain flag reason).
// MessagesPage.tsx - v12.9.26 (#938 Send Text / summary / templates follow the organization's languages, not a fixed EN/ES pair; #931 untagged turns; #935 banner mentions tags only when there are tags; #830-d not captured; #977 structured staff summary + Classic switch + Wants preview; #978 end-of-call rows; #1013 CHECK in Call data).
// MessagesPage.tsx - v12.9.25 (#830): Call data shows FLAGGED / CORRECTED only (his definition, no "cleared"); (#959) "Not confirmed by caller" on the row and in the drawer.
// MessagesPage.tsx — v12.9.24 (#913 per-turn language tags, As-spoken default, English view translates only non-English turns; #908 failure reasons; #909 summary EN/ES switch)
// v12.7.0 (#581 the Verified badge is gone - it was `?? true` on every call ever recorded; #583 the drawer stops
//          saying "Live" on a call that ended; #580 LineMark; #582 BookingPill - three states, colour on the exception)
// VoiceSpectrum.Web.T2 - Agent workspace (Messages) - v12.4.16
// v12.4.16 (#469 / #490): THE PAGE HAS TWO SCROLLERS ON A PHONE AND THREE ATTEMPTS ASSUMED ONE. `.tenant-app`
// is `height: 100vh` with a 56px mobile topbar row above `.tenant-main`, which carried `min-height: 100dvh` -
// so the DOCUMENT had scroll travel of its own (measured 900 against 844). Reaching the end of the list chains
// the scroll to the document, `.tenant-main` rides up, and the collapsed bar - sticky to `.tenant-main`, not to
// the screen - goes under the opaque topbar. Fixed in agent-workspace.css by removing the second scroller, not
// by moving the bar; the JS half here is the EXPANDER, which read its baseline off an element that does not
// scroll on a phone and therefore cancelled itself on the same tick. See both call sites below.
// v12.4.13 (#469): the collapse logic watched `.aw-main` and the window. Below 980px NEITHER scrolls - the
// scrollport there is `.tenant-main` - so on a phone the collapse never fired and the header, which is static at
// that width, simply scrolled away and never came back. Measured in his browser 2026-09-18. The scroller is now
// RESOLVED by walking up from the header to the nearest ancestor that actually scrolls, and the listeners follow
// it. Also his look note: the pinned band now spans wider than the cards and carries a seam whenever the list has
// scrolled under it, instead of white meeting white.
// v12.4.12 (#469): collapsed header keeps the full header's footprint (bottom margin) so collapsing never moves the list - the scroll-anchoring loop behind the flicker.
// v12.4.12 (#479): reference number on the card top line after Verified.
// v12.4.12 (#468 reopened): picked labels survive the heartbeat and are committed on EVERY way out of the
// Apply-labels editor (drawer close, Escape, prev/next, Mark complete, Mark as unread, switching tool), not
// only on Done. Still ONE write per editing session (HH). NOT BUILT - coded 2026-09-10.
// v12.2.6.0: download fix (send download=true, not =1, which 400'd on the bool bind); three-state card
// clarity in agent-workspace.css (unread dot on New, calmer border on Read, check on Completed). Part of
// the merged voicemail-route + workflow batch.
// v12.2.5.0 (CE-F1c): voicemail player polish - the waveform now FILLS as a progress bar while playing
// (bars up to the current position turn accent; it was static before), a playback-speed toggle
// (1x -> 1.5x -> 2x -> 0.5x) sits next to the waveform, and Download stays the last control. T2-only.
// v12.2.4.0 (CE-F1b): designed voicemail player restored - styled play/pause button + waveform +
// Download, backed by a hidden native <audio> (the plain browser controls were only a stopgap while
// the CSP media-src was broken; that is fixed on the T2 site now). Voicemail cards use a dedicated
// voicemail glyph instead of a bare mic. (Cards still showing the phone icon are calls whose voicemail
// was not captured - saved as "missed" - which the API capture-reliability batch fixes.)
// v12.2.3.0 (CE-E1): voicemail playback fix. The recording card now binds the short-lived signed
// stream URL to a NATIVE <audio controls> element (fetched on selection via a useEffect). The prior
// button ran `new Audio(url).play()` AFTER an `await` inside the click handler; the await consumed
// the click's transient user-activation so Chrome blocked the scripted play() and issued no media
// request ("Recording is not available", no stream?token in the network tab). Native controls need
// no scripted activation and surface HTTP/decode errors via the <audio> error event -> Retry.
// v12.1.31.0 (Round 4, T2-only): HH - label editor accumulates toggles locally (optimistic, no
// PUT per chip) and sends ONE persist({labels}) on Done; per-toggle success toasts removed (error
// only). II - the whole top panel (nav + identity + Flag/Call back) is sticky; duplicate caller
// name/phone removed from the nav bar (revises FF). NN - amber saved-reminder strip in the drawer
// with a Remove link. OO - keyboard shortcut L opens the Apply-label editor + <kbd>L</kbd> hint on
// the action card. (LL/JJ/MM/footer alignment handled in agent-workspace.css.)
// v12.1.30.0 (Round 3): compact single-row action cards - sub-labels removed (AA);
// Skip removed from the drawer footer (CC); caller name + phone pinned in the sticky drawer
// top bar (FF). BB: open-on-status persist now sends a backend-recognized wire status
// ("in progress"/"complete") via toWireStatus() - the API's NormalizeStatus only maps
// "progress"/"working"/"open" to prog, so the raw "prog" we sent was silently stored (and
// echoed back) as "new", which is why opening a New message never stuck to In progress.
// v12.1.29.0 (Round 2): flag icon-only + tooltip (R); open auto-marks in progress (S);
// Chart#/Assigned/Language editable colored-link facts + language PUT (T/J); missed-call
// callout shown for missed/no-recording, empty player + system transcript suppressed (W);
// card meta = Name · phone · EN · ✓ Verified inline with formatted phone (V1); Follow-ups
// deep-link ?filter=follow-up auto-applies dueOnly (X).
// Card + drawer CSS consolidated in styles/agent-workspace.css (Workspace_Rebuild_Guide_v2_1).
// Status is encoded solely by the card's left accent (aw-st-* -> border-left color); the card
// right column carries no status pill (already de-duplicated). The drawer meta status chip
// (.aw-status) is intentionally retained.
// v12.1.28.0: wired to the NEW /t2/surface/messages ENVELOPE (messages + labelColors +
// availableLabels), structured transcript lines ({ ts, speaker, role, text }), and PUT
// /t2/surface/messages/{id} for ALL mutations (optimistic + reconcile). Canonical toaster.
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState, type ReactNode } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { CallRoute } from '../components/CallRoute';   // v12.10.22 (#2010)
import { useQuery, useQueryClient } from '@tanstack/react-query';   // v12.10.11.3 (#1527) refresh the left-menu Follow-ups badge after a save
import '../styles/agent-workspace.css';
import { ListLoadingFrame, LoadingMark } from '../components/ListLoadingFrame';   // v12.10.21 (#1944 #1945, UI-PROTO-MESSAGES-LOADING v1.5 LOCKED)
import { CallerTypeIcon, PracticeIcon } from '../components/CallerTypeIcon';   // v12.2.43.0 (#244) · v12.10.14 (#1608 #1613)
import api, { ApiError, buildUrl } from '../lib/api';
import { applyOutgoingWording, renderPhone, useTextingStatus } from '../lib/texting';   // v12.10.26 (#T154)
// v12.10.27 (#2146): TextMessagesPanel retired - the Text messages tab is the kind "text" list
import '../components/texting/texting.css';   // v12.10.26 (#T154): New text pill, follow-up flag, TEXT mark
import { nationalDigits, smsSegments, fillTemplate } from '../lib/smsText';
import { toast, type ToastHandle } from '../lib/toast';
import { useAuth } from '../lib/auth';
import { DateScopePanel, dayName } from '@shared-ui/DateScope';   // v12.10.6 (#1153) · v12.10.14 (#1605 #1611): the locked control, button in words
import { useAccess } from '../lib/useAccess';   // v12.10.9.1 (#1268)
import { usePracticeFeature } from '../lib/practiceFeatures';   // v12.10.30 (#2256): the practice's feature switches
import { CallBackBlock, CallBackButton, CallBackMiniPlayer, CallWindowSlot, usePhone, type CallBackInfo, type CallBackNumber } from '../components/BrowserPhone';   // v12.10.30 (#1155 #1156 #1157)
import { CALLBACK_DONE_EVENT, OPEN_MESSAGE_EVENT, startCallBack, takePendingOpen } from '../lib/browserPhone';   // v12.10.30 (#1156 #1157)
import { openYourAccount } from '../components/security/YourAccountDrawer';   // v12.10.9.1 (#1280)
import { fuPrefPills, getCachedFuPref, useFuPref } from '../lib/followUpsPref';   // v12.10.12 (#1534)
import { afterPaint, longestFrozen, sendListPerf, sendPerf, type ListAction } from '../lib/perfBeacon';   // v12.10.12 (#1540)
import { track, trackOverlay } from '../lib/uiTrack';   // v12.10.13 (#1601) the click analyzer
import { formatReference } from '../lib/reference';   // v12.10.17 (#1773): shared with Contacts
import { callerTypeDisplay, categoryDisplay, requestTypeOf, requestWords, resolveTaxonomy, UNCLASSIFIED_KEY } from '../lib/taxonomy';   // v12.10.17 (#1723 D12)
import { CallRecordPrint, callDataText, callRecordText, CRS_ALL, sessionPracticeName, type CrsAction, type CrsField, type CrsRecord } from './reports/CallRecordSheet';   // v12.10.14 (#1619 #1620) print here; copy call data
import type {
  Assignee,
  Category,
  Channel,
  CallerType,
  DateBucket,
  DateScope,
  Filters,
  Language,
  CapturedField,
  Message,
  SummaryRows,
  MessageKind,
  MsgStatus,
  Priority,
  TopMode,
} from '../features/agentWorkspace/types';

const callerTypes: (CallerType | 'all')[] = ['all', 'Patient', 'Pharmacy', 'Physician'];
const languages: (Language | 'all')[] = ['all', 'English', 'Spanish', 'French', 'German'];
// B2: Reschedule collapses into Appointment (derived, not raw DB) - not a distinct filter option.
const categories: (Category | 'all')[] = ['all', 'Appointment', 'Rx Refill', 'Pharmacy', 'Referral', 'General'];
const priorities: (Priority | 'all')[] = ['all', 'normal', 'urgent'];
// v12.10.11.2 (#1497): new and prog both read "Pending", so the filter offers Pending once (prog) and it matches both.
const statuses: (MsgStatus | 'all')[] = ['all', 'prog', 'done'];
const bucketOrder: DateBucket[] = ['Today', 'Yesterday', 'Older'];

// v12.10.10 (#1399): the made-up list (Front desk / Dr. John / Nurse Amy / Dr. Reyes) is gone - the people come from
// GET /t2/security/assignees (ACTIVE practice users only; support staff are never tenant users, so never listed).
interface ApiAssignee { id: number; name: string; groupNames?: string[]; photo?: string | null; self?: boolean }
// The signed-in person's user id, for the 'Me' filter (module scope: messageMatchesFilters is a plain function).
let assignMeId: number | null = null;
// ── v12.10.13 (#1561): the practice's own lists, read once by the page and used by the (module-level) matcher. ──
interface PracticeItem { key: string; name: string; color?: string; icon?: string; aliases?: string[]; active?: boolean; usedBy?: string[]; usedByKeys?: string[] }   // v12.10.22 (#2011): + usedBy / usedByKeys   // v12.10.17 (#1723 D12): + aliases, active
// v12.10.14 (#1607, FILTER-PANEL v1.0): several picks per group - the picked values live in the same string, joined by the
// unit separator (no practice word can contain it); 'all' = nothing picked. Inside a group = any of; between groups = all of.
const MSEP = '\u001F';
function fvals(v?: string | null): string[] { return !v || v === 'all' ? [] : v.split(MSEP); }
function fjoin(a: string[]): string { return a.length ? a.join(MSEP) : 'all'; }
let practiceCallerTypes: PracticeItem[] = [];
let practiceCategories: PracticeItem[] = [];
// v12.10.17 (#1723 D12): EVERY item, active or not - a card from a caller type the workflow has since switched off still renders.
let displayCallerTypes: PracticeItem[] = [];
let displayCategories: PracticeItem[] = [];
/** call id -> success | watch | failure (the Outcome filter; filled only when that filter is used). */
let outcomeById: Record<string, string> = {};
const TYPE_WORDS: Record<string, string> = { calls: 'Calls', missed: 'Missed', voicemails: 'Voicemails',
  aifinished: 'AI finished', textingnow: 'Texting now', closed: 'Closed - no reply' };   // v12.10.27 (#2146): the Conversation group of a text
const OUTCOME_WORDS: Record<string, string> = { success: 'Success', watch: 'Watch', failure: 'Failure' };
const LANG_NAMES: Record<string, string> = { en: 'English', es: 'Spanish', fr: 'French', de: 'German', pt: 'Portuguese', zh: 'Chinese', hi: 'Hindi', gu: 'Gujarati' };
const langName = (code: string) => LANG_NAMES[code.toLowerCase()] ?? code.toUpperCase();
const langCodeOfName = (name: string) => (Object.entries(LANG_NAMES).find(([, v]) => v.toLowerCase() === (name || '').toLowerCase())?.[0] ?? (name || '').toLowerCase().slice(0, 2));
/** v12.10.13 (#1561): does a raw stamped value (key or name) mean this practice item? */
// v12.10.17 (#1723 D12): the filter value is an item KEY; a message matches when its stored value resolves (key, then name,
// then alias) to that item - so new key records and old name records filter the same. "unclassified" = resolves to nothing.
function callerTypeMatches(message: { callerTypeRaw: string; callerType: string }, value: string): boolean {
  const v = value.toLowerCase();
  const hit = resolveTaxonomy(displayCallerTypes, message.callerTypeRaw);
  if (v === UNCLASSIFIED_KEY) return !hit;
  const item = resolveTaxonomy(displayCallerTypes, value);
  if (item) return hit?.key === item.key;
  return (message.callerTypeRaw || '').toLowerCase() === v;
}
function categoryMatches(message: { categoryRaw?: string; category: string }, value: string): boolean {
  const v = value.toLowerCase();
  const cat = categoryDisplay(displayCategories, message.categoryRaw);
  if (v === UNCLASSIFIED_KEY) return cat.unclassified;
  const item = resolveTaxonomy(displayCategories, value);
  if (item) return cat.key === item.key;
  return (message.categoryRaw || '').toLowerCase() === v;
}
/** v12.10.13 (#1601): the click analyzer's word for a date choice - a fixed list, never the dates themselves. */
function dateTrackValue(scope: DateScope): string {
  if (scope.kind !== 'preset') return 'custom';
  if (scope.value === 'Today') return 'today';
  if (scope.value === 'Yesterday') return 'yesterday';
  const m = scope.value.match(/(7|15|30)/);
  return m ? `${m[1]}d` : 'custom';
}
/** v12.10.13 (#1561): Type - Calls (answered), Missed, Voicemails. */
function typeMatches(channel: string, v: string): boolean {
  if (v === 'calls') return channel === 'live';
  if (v === 'missed') return channel === 'missed';
  if (v === 'voicemails') return channel === 'voicemail';
  return true;
}
/** v12.10.27 (#2146, prototype v1.3): on the Text messages tab the Type group is "Conversation" - AI finished / Texting now / Closed - no reply. */
function textStateMatches(m: { inProgress?: boolean; startedAt?: string | null }, v: string): boolean {
  const stale = !!m.startedAt && Date.now() - new Date(m.startedAt).getTime() > 24 * 3600_000;
  if (v === 'aifinished') return !m.inProgress;
  if (v === 'textingnow') return !!m.inProgress && !stale;
  if (v === 'closed') return !!m.inProgress && stale;
  return true;
}

// v12.10.9.4 (#1380): where the filters live between refreshes (this browser tab), and the event the left menu listens to.
const FILTERS_KEY = 'vs.messages.filters';
const MENU_RESET_KEY = 'vs.messages.menuReset.handled';   // v12.10.22 (#2002): the last left-menu reset this tab already applied
export const FILTERS_EVENT = 'vs:messages-filters';
// v12.10.11.3 (#1521, Tushar 10/9 "Sort + date remembered"): the sort and the date choice are remembered per person on
// this computer (localStorage, survives closing the browser); every other filter lasts the session only (sessionStorage).
const SORT_KEY = 'vs.messages.sort';
const DATE_KEY = 'vs.messages.date';
// Per PERSON: the keys carry the practice and the signed-in person (read from the stored sign-in token), so two people who
// share a front-desk computer each get their own sort and date.
function lsPerson(): string {
  try {
    const token = localStorage.getItem('vs_t2_token');
    const part = token?.split('.')[1];
    if (!part) return '';
    const p = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/'))) as Record<string, unknown>;
    const who = p.sub ?? p.nameid ?? p.email ?? '';
    const org = p.tenant_slug ?? p.tenant_id ?? '';
    return `.${String(org)}.${String(who)}`;
  } catch { return ''; }
}
function lsGet(key: string): string | null { try { return localStorage.getItem(key + lsPerson()); } catch { return null; } }
function lsSet(key: string, value: string): void { try { localStorage.setItem(key + lsPerson(), value); } catch { /* storage off */ } }
function savedDateScope(): DateScope | null {
  const raw = lsGet(DATE_KEY);
  if (!raw) return null;
  try { const v = JSON.parse(raw) as DateScope; return v && typeof v === 'object' && 'kind' in v ? v : null; } catch { return null; }
}
function loadSavedFilters(): Filters {
  let base: Filters = initialFilters;
  try {
    const raw = sessionStorage.getItem(FILTERS_KEY);
    if (raw) base = { ...initialFilters, ...(JSON.parse(raw) as Partial<Filters>), scopeAll: null };   // v12.10.12: scopeAll retired
  } catch { /* fall through */ }
  const date = savedDateScope();
  return date ? { ...base, dateScope: date } : base;
}

// ── v12.10.11.3 (#1522 / #1527): counts, due dates and the follow-up pills. ─────────────────────────────────
/** Up to 999, then "999+" (Tushar 10/9). */
function fmtCount(n: number): string { return n > 999 ? '999+' : String(n); }
// v12.10.29.1 (#2243, Tushar 11/3 "when i hover my mouse on 999+ ... we should display actual numbers"): 999+ carries the exact number.
function CountText({ n }: { n: number }) { return n > 999 ? <span title={n.toLocaleString()}>999+</span> : <>{n}</>; }
function isoDay(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}
function todayIso(): string { return isoDay(new Date()); }
/** "Due" = an open message whose reminder date is today or earlier (Tushar 10/9: "Overdue + today"). */
function isDue(m: { status: string; reminder: string | null; reminderDue?: string | null }): boolean {
  return m.status !== 'done' && Boolean(m.reminder) && Boolean(m.reminderDue) && (m.reminderDue as string) <= todayIso();
}
function dayDiff(iso: string): number {
  const [y, mo, d] = iso.split('-').map(Number);
  const a = new Date(y, mo - 1, d).getTime();
  const t = startOfLocalDay(new Date()).getTime();
  return Math.round((a - t) / 86400000);
}
/** The card / drawer wording for a follow-up: Overdue 2d · Due today · Tomorrow · In 3 days · Oct 20. */
function dueLabel(m: { reminder: string | null; reminderDue?: string | null }): string {
  if (!m.reminder) return '';
  if (!m.reminderDue) return m.reminder;
  const n = dayDiff(m.reminderDue);
  if (n < 0) return `Overdue ${-n}d`;
  if (n === 0) return 'Due today';
  if (n === 1) return 'Tomorrow';
  if (n <= 6) return `In ${n} days`;
  const [y, mo, d] = m.reminderDue.split('-').map(Number);
  return new Date(y, mo - 1, d).toLocaleDateString([], { month: 'short', day: 'numeric' });
}
/** The reminder's date from a preset label ("In 2 days", "In 1 week") or a picked date (yyyy-mm-dd). */
function reminderDueFor(label: string, pickedIso?: string): string | null {
  if (pickedIso) return pickedIso;
  if (/^today$/i.test(label.trim())) return isoDay(startOfLocalDay(new Date()));   // v12.10.15 (#1650): due today - Follow-ups › Today
  const m = /^in\s+(\d+)\s+(day|days|week|weeks)$/i.exec(label.trim());
  if (!m) return null;
  const d = startOfLocalDay(new Date());
  d.setDate(d.getDate() + Number(m[1]) * (m[2].toLowerCase().startsWith('week') ? 7 : 1));
  return isoDay(d);
}
const WEEKDAY_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
/** Which follow-up pill a reminder date falls in. */
function fuBucket(iso: string | null | undefined): string {
  if (!iso) return 'later';
  const n = dayDiff(iso);
  if (n < 0) return 'overdue';
  if (n === 0) return 'today';
  if (n === 1) return 'tomorrow';
  const dow = new Date().getDay();
  const toEndOfWeek = 6 - dow;
  if (n <= toEndOfWeek) { const [y, mo, d] = iso.split('-').map(Number); return 'wd' + new Date(y, mo - 1, d).getDay(); }
  if (n <= toEndOfWeek + 7) return 'nextweek';
  return 'later';
}
/** Overdue · Today · Tomorrow · the rest of this week by name · Next week · Later · All. */
function fuPillDefs(): { key: string; label: string }[] {
  const defs = [{ key: 'overdue', label: 'Overdue' }, { key: 'today', label: 'Today' }, { key: 'tomorrow', label: 'Tomorrow' }];
  for (let d = new Date().getDay() + 2; d <= 6; d++) defs.push({ key: 'wd' + d, label: WEEKDAY_SHORT[d] });
  defs.push({ key: 'nextweek', label: 'Next week' }, { key: 'later', label: 'Later' }, { key: 'all', label: 'All' });
  return defs;
}
// ── v12.10.12 (#1529-#1531): the three top-bar pills. Each is an OPEN call that matches; picked pills combine (AND). ──
function modeMatch(message: { status: string; priority: string; assignedToUserId?: number | null; reminder: string | null }, mode: TopMode): boolean {
  if (message.status === 'done') return false;
  if (mode === 'urgent') return message.priority === 'urgent';
  if (mode === 'me') return assignMeId !== null && message.assignedToUserId === assignMeId;
  return Boolean(message.reminder);   // 'marked' = Reminders: a follow-up set, whatever its date
}
function modesMatch(message: Parameters<typeof modeMatch>[0], modes: TopMode[] | undefined, skip?: TopMode): boolean {
  return (modes ?? []).every((m) => m === skip || modeMatch(message, m));
}
/** The pills the Follow-ups view opens on - the person's choice in Your account (#1534), default Today. */
function fuDefaultPills(): string[] { return fuPrefPills(getCachedFuPref(), fuPillDefs().map((p) => p.key)); }
/** The first moment of the date window the list shows - sent to the API as ?from= (every open call comes regardless). */
function scopeStartIso(scope: DateScope): string {
  const today = startOfLocalDay(new Date());
  if (scope.kind === 'preset') {
    if (scope.value === 'Today') return today.toISOString();
    const days = scope.value === 'Yesterday' ? 2 : scope.value === 'Last 30 days' ? 30 : scope.value === 'Last 15 days' ? 15 : 7;   // v12.10.13 (#1566)
    const start = new Date(today); start.setDate(start.getDate() - (days - 1));
    return start.toISOString();
  }
  if (scope.mode === 'before') return new Date(2000, 0, 1).toISOString();
  const from = parseInputDate(scope.from);
  return (from ? startOfLocalDay(from) : new Date(2000, 0, 1)).toISOString();
}

const initialFilters: Filters = {
  status: 'all',
  priority: 'all',
  callerType: 'all',
  language: 'all',
  category: 'all',
  label: 'all',
  type: 'all', opened: 'all', notes: 'all', outcome: 'all',   // v12.10.13 (#1561)
  audit: 'all',   // v12.10.18 (#1865)
  query: '',
  dueOnly: false,
  dateScope: { kind: 'preset', value: 'Last 7 days' },
  assigned: [],   // v12.10.10 (#1399)
};

type FilterKey = Exclude<keyof Filters, 'query' | 'dueOnly' | 'dateScope' | 'assigned'>;
type DrawerTool = 'note' | 'reminder' | 'label' | null;

interface ApiNoteRow {
  id: string;
  author: string;
  at: string;
  text: string;
  /** v12.9.12 (#795): what this remark IS. Absent on every note written before this release, which is
   *  exactly right - no kind means an ordinary hand-typed note and it renders as it always has. */
  kind?: 'note' | 'text-sent' | 'text-failed' | 'callback' | null;   // v12.10.30 (#1156 P1b): 'callback' = a call back's system note
}

// NEW transcript shape: structured lines (was string[]).
interface ApiTranscriptLine {
  ts: string | null;
  speaker: string;
  // v12.3.12 (#307): 'path' is a routing decision the CallEngine recorded - diagnostics, not something anyone
  // said. It is served like any other line and hidden behind the "Show call path" toggle.
  role: 'agent' | 'caller' | 'path';
  text: string;
  // v12.9.24 (#913): the language this turn was spoken in (absent on a transcript written before 12.9.24).
  lang?: string | null;
  // v12.9.24 (#913): set on the English view only - the language a TRANSLATED turn was spoken in.
  xlFrom?: string;
  via?: string | null;   // v12.10.26 (#T154 Q16): 'text' = a patient's text reply - marked TEXT in the drawer
  callBack?: CallBackInfo | null;   // v12.10.30 (#1156 P1): a call back made from this message - drawn as the indigo block (its role is "callback")
}

/** v12.10.15 (#1648): one action on a message - who, when, and from → to. */
interface ApiActivityRow { at: string; by: string; byUserId?: number | null; action: string; from?: string | null; to?: string | null }

interface ApiMessageRow {
  id: string;
  auditMarkedAt?: string | null;   // v12.10.18 (#1865): marked for audit (null = not marked)
  auditMarkedBy?: string | null;
  contactName?: string | null;   // v12.10.17.1 (#1794): the contact book's name when the call captured none
  callerKey?: string | null;   // v12.10.16 (#1690): the caller's number, digits only - what groups repeat calls (null = withheld)
  groupId?: number | null;     // v12.10.25 (#2117): the group the call joined when it arrived (null = grouped here by the rule)
  activity?: ApiActivityRow[] | null;   // v12.10.15 (#1648): the detail only (GET messages/{id} and the PUT echo); the list leaves it out
  referenceNo: string | null;   // v12.3.13 (#356)
  kind: string;
  channel: string;
  callerType: string;
  name: string;
  phone: string;
  language: string;
  verified: boolean;
  // v12.7.0 (#580 / R1): null = NOT KNOWN. Never rendered as a landline - see LineMark.
  lineType: string | null;
  lineCarrier: string | null;
  phone2?: import('../features/agentWorkspace/types').PhoneInfo | null;   // v12.10.19 (#1921 #1922)
  // v12.7.0 (#582 / R2): null = no booking action ran on this call. A third state, not a failure.
  bookingOk: boolean | null;
  bookingRef: string | null;
  /// v12.7.2 (#594): WHICH connected system answered - its short code (#597), or its name when it has none.
  /// Null when no action ran, and null when the action never reached a system at all (#616), so the pill
  /// never names a system that did not see the request.
  bookingSystem: string | null;
  capturedFields?: CapturedField[];   // v12.9.14 (#830 / #822): absent on pre-12.9.14 calls
  notConfirmed?: string | null;       // v12.9.25 (#959)
  summaryRows?: Record<string, SummaryRows> | null;   // v12.9.26 (#977): absent on calls before 12.9.26
  status: string;
  priority: string;
  category: string;
  labels: string[];
  summary: string;
  aiSummary: string;
  startedAt: string;
  durationSeconds: number;
  reminder: string | null;
  reminderDue?: string | null;   // v12.10.11.3 (#1527): the follow-up date, yyyy-MM-dd
  assignedTo: string | null;
  assignedToUserId?: number | null;   // v12.10.10 (#1399)
  chartNumber: string | null;
  notes: ApiNoteRow[];
  transcript: ApiTranscriptLine[];
  /** v12.4.15 (#476): the call has no ending stamped yet - it is on the line right now. */
  inProgress?: boolean;
  recordingCount?: number;   // v12.10.11.1 (#982): 0 = nothing was saved for this call
  hungUp?: boolean;          // v12.10.21 (#1953): a missed call where the agent spoke - the caller hung up during the call
  intentKey?: string | null; // v12.10.22 (#2011): the exact intent the call went through (its category may be shared)
  setupTestCall?: boolean;   // v12.10.11.1 (#1461): the provisioning Step 4 test call
  fromVoicemail?: boolean;   // v12.10.15 (#1666): details were read from the voicemail
  newText?: boolean;         // v12.10.26 (#T154 Q16): a text reply nobody has opened yet - the "New text" pill
  newTextCount?: number;     // v12.10.27 (#2146 Q33): the "+N new" badge on a text card
  followUp?: boolean;        // v12.10.26 (#T154 Q16): the follow-up flag a text reply turned on (until completed)
}

// NEW envelope from GET /t2/surface/messages (was a bare MessageRow[]).
interface ApiMessagesEnvelope {
  messages: ApiMessageRow[];
  // v12.4.9 (#456): labelColors is DELETED from the client, not patched. It was a second source for one
  // concept - the picker read availableLabels[].color and the card read labelColors[label], and the two
  // disagreed. availableLabels is now the only source. The API may still send labelColors; we ignore it.
  availableLabels: { name: string; color: string }[];
  // v12.10.11.3 (#1522): the window the list holds (every open call comes too) and whether the safety ceiling cut it.
  windowFrom?: string | null;
  truncated?: boolean;
  partial?: boolean;   // v12.10.16 (#1688): the first page only (?take=) - the rest is asked for at once
  grouping?: GroupRule | null;   // v12.10.16 (#1690): Settings › Personalization › Repeat callers › In the messages
  cursor?: number | null;   // v12.10.19 (#1882): send back as ?since= on the next heartbeat
  delta?: boolean;          // v12.10.19 (#1882): only the calls that changed - merged into the list, never replacing it
  removed?: string[] | null;   // v12.10.19 (#1882): calls that left the list since ?since=
  windowTotal?: number | null;  // v12.10.20 (#1934): calls inside the dates (first page only)
  total?: number | null;        // v12.10.20 (#1934): + the open calls outside the dates
  counts?: ApiWindowCounts | null;   // v12.10.26 (#2121): the counters for the dates, counted on the server (first page, ?counts=true)
}
/** v12.10.26 (#2121): the top-bar counters the first page brings - calls in the dates, open ("to work"), the open calls matching every pill
 *  of a combination ("" | "me" | "marked" | "urgent" | "me+marked" ... in that order) and one card per group. */
interface ApiWindowCounts { calls: number; open: number; combos: Record<string, number>; cards?: number | null }
/** v12.10.26 (#2121): the combo key of picked pills, in the server's order. */
function comboKey(modes: TopMode[]): string { return (['me', 'marked', 'urgent'] as TopMode[]).filter((m) => modes.includes(m)).join('+'); }

// ══ v12.10.16 (T113 #1690, LOCKED UI-PROTO-REPEAT-CALLER-GROUPING-B1 v1.10): ONE CARD PER CALLER. ════════════════════════
// Each call stays its own record; the SCREEN groups the calls of one number. A call joins the group when it starts within
// the Grouping window of the group's LATEST call (or on the same local day with Same day on). The newest call carries the
// group: it is the card, filters act on it, and the drawer reads every call Combined. A withheld number is never grouped.
interface GroupRule { mode: string; windowMinutes: number; sameDay: boolean; timeZone?: string | null; refreshSeconds?: number | null }   // v12.10.16.1 (#1702)
/** v12.10.16 (T115 #1693): the changes staged in the batch panel - nothing is written until Apply. */
interface BatchStage { note?: string; reminder?: string; reminderPick?: string; labels?: string[]; read?: 'Read' | 'Unread'; urgent?: 'Urgent' | 'Not urgent'; status?: 'Pending' | 'Completed' }
interface CallGroups { carrierOf: Map<string, string>; members: Map<string, WsMessage[]> }
const NO_GROUPS: CallGroups = { carrierOf: new Map(), members: new Map() };
function localDayOf(iso: string, tz?: string | null): string {
  try { return new Intl.DateTimeFormat('en-CA', { timeZone: tz || undefined, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(iso)); }
  catch { return iso.slice(0, 10); }
}
export function buildCallGroups(messages: WsMessage[], rule: GroupRule | null | undefined): CallGroups {
  const ruleOff = !rule || rule.mode === 'new';   // v12.10.25 (#2117): stored groups still show - a changed rule applies to new calls only (Q9)
  const carrierOf = new Map<string, string>();
  const members = new Map<string, WsMessage[]>();
  const byKey = new Map<string, WsMessage[]>();
  // v12.10.25 (#2117): a call that carries its group number is grouped by it - decided once, when the call arrived, so a changed
  // rule never re-makes an old group. Calls from before 12.10.25 (no number) are grouped by the rule below, as before.
  const byGroup = new Map<number, WsMessage[]>();
  for (const m of messages) {
    if (m.kind !== 'call' || m.groupId == null || !m.startedAt) continue;
    const list = byGroup.get(m.groupId) ?? [];
    list.push(m); byGroup.set(m.groupId, list);
  }
  for (const list of byGroup.values()) {
    if (list.length < 2) continue;
    list.sort((a, b) => (a.startedAt ?? '').localeCompare(b.startedAt ?? ''));
    const newestFirst = [...list].reverse();
    members.set(newestFirst[0].id, newestFirst);
    for (const x of list) carrierOf.set(x.id, newestFirst[0].id);
  }
  if (ruleOff) return members.size ? { carrierOf, members } : NO_GROUPS;
  for (const m of messages) {
    if (m.groupId != null) continue;   // v12.10.25 (#2117): already grouped by its number
    if (m.kind !== 'call' || !m.callerKey || !m.startedAt) continue;
    const list = byKey.get(m.callerKey) ?? [];
    list.push(m); byKey.set(m.callerKey, list);
  }
  const flush = (cur: WsMessage[]) => {
    if (cur.length < 2) return;
    const newestFirst = [...cur].reverse();
    members.set(newestFirst[0].id, newestFirst);
    for (const x of cur) carrierOf.set(x.id, newestFirst[0].id);
  };
  const rl = rule!;
  const windowMs = Math.max(1, rl.windowMinutes || 30) * 60000;
  for (const list of byKey.values()) {
    list.sort((a, b) => (a.startedAt ?? '').localeCompare(b.startedAt ?? ''));
    let cur: WsMessage[] = [];
    for (const m of list) {
      const last = cur[cur.length - 1];
      const joins = !!last && (rl.sameDay
        ? localDayOf(m.startedAt!, rl.timeZone) === localDayOf(last.startedAt!, rl.timeZone)
        : Date.parse(m.startedAt!) - Date.parse(last.startedAt!) <= windowMs);
      if (!joins && cur.length) { flush(cur); cur = []; }
      cur.push(m);
    }
    flush(cur);
  }
  return { carrierOf, members };
}
/** v12.10.16 (#1690): the line above each call's transcript in the Combined view - "#42-0510 · 10:11 AM · Voicemail · open". */
function groupSepLabel(m: WsMessage): string {
  const t = m.startedAt ? new Date(m.startedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : '';
  return [formatReference(m.referenceNo), t, msgChannelLabel(m), m.status === 'done' ? 'done' : 'open'].filter(Boolean).join(' \u00b7 ');
}
/** v12.10.17 (#1748): the header line above each call in a Combined copy - "#42-0627 · 3:49 PM · Voicemail" (no open/done). */
function groupCopyHeader(m: WsMessage): string {
  const t = m.startedAt ? new Date(m.startedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : '';
  return [formatReference(m.referenceNo), t, msgChannelLabel(m)].filter(Boolean).join(' · ');
}
/** v12.10.16 (#1690): "42-0503" -> "503" - the short number the card lists for the group's other calls. */
function shortRef(ref: string | null | undefined): string {
  const d = (ref ?? '').replace(/\D/g, '');
  return d ? String(Number(d.slice(-4))) : '';
}

// PUT /t2/surface/messages/{id} request body.
interface MessageMutation {
  status?: string;
  priority?: string;
  labels?: string[];
  reminder?: string | null;
  reminderDue?: string | null;   // v12.10.11.3 (#1527)
  assignedTo?: string | null;
  assignedToUserId?: number;   // v12.10.10 (#1399): assign to this person; Unassign sends assignedTo ''
  chartNumber?: string | null;
  // T/J: language is now client-editable. The API accepts arbitrary message fields (they land
  // in the transcript_json envelope), so wiring `language` is safe even where the server does not
  // yet echo it back in the MessageRow mapping.
  language?: string | null;
  addNote?: { text: string };
  /** v12.10.15 (#1651 #1648): the action that read the message (play, print, copy, assign ...) - recorded in the message's activity. */
  readBy?: string;
  /** v12.10.16 (#1677): Mark complete's log line on the server - where the drawer went and which list it was showing. */
  nav?: { next: string | null; listVersion: number; listCount: number; filter: string };
}

// D: label chips are dynamic strings (whatever the message carries / whatever the tenant
// configured), no longer constrained to the hardcoded LabelName enum. We carry a local
// workspace message shape that widens labels + transcript from the base Message type.
type TranscriptLine = ApiTranscriptLine;
type WsMessage = Omit<Message, 'labels' | 'transcript'> & {
  auditMarkedAt?: string | null;   // v12.10.18 (#1865)
  callerKey?: string | null;   // v12.10.16 (#1690)
  groupId?: number | null;     // v12.10.25 (#2117)
  contactName?: string | null;   // v12.10.17.1 (#1794)
  nameFromContact?: boolean;     // v12.10.17.1 (#1794): the name shown came from the contact book, not this call
  labels: string[];
  transcript: TranscriptLine[];
  callerTypeRaw: string;   // v12.2.43.0 (#244): raw stamped caller type, for avatar color/icon lookup
  categoryRaw?: string;    // v12.10.13 (#1561): the stamped category (key or name) - the Category filter matches the practice's own list
  // v12.4.9 (#458): `name` already falls back to the phone number, which makes "no name captured"
  // indistinguishable downstream. Carry the fact explicitly so the top line can move the phone into
  // the name slot and drop the duplicate, per SPEC_message_card_topline_v1_0 section 1.
  hasName: boolean;
  noRecording?: boolean;   // v12.10.11.1 (#982): the API says no recording row exists
  fromVoicemail?: boolean;   // v12.10.15 (#1666)
  hungUp?: boolean;          // v12.10.21 (#1953): channel missed, but the agent spoke - "Hung up during the call"
  intentKey?: string | null; // v12.10.22 (#2011)
  newText?: boolean;         // v12.10.26 (#T154 Q16)
  newTextCount?: number;     // v12.10.27 (#2146 Q33)
  followUp?: boolean;        // v12.10.26 (#T154 Q16)
};
// v12.4.11 (#458 REOPENED - MY OWN 12.4.9 REGRESSION, AND ITS OWN NOTE ALREADY SAID WHY).
//
// 12.4.9 decided "was a name captured?" from `row.name` being non-blank. The API NEVER ships it blank:
// TenantSurfaceController composes it as FirstNonBlank(metadata?.Name, call.FromNumber, "Unknown caller"),
// so on a call with no captured name `name` arrives holding the PHONE NUMBER. hasName was therefore true,
// the card printed the phone in the name slot AND again in the meta slot - "+14138229340 · (413) 822-9340" -
// which is defect D2 from his own SPEC_message_card_topline_v1_0, put back by the fix meant to remove it.
// #458's original note had already recorded that the root cause was server-side; I fixed the display and did
// not account for the substitution I was reading.
//
// So this rejects the two known fallbacks rather than testing for blankness: the literal "Unknown caller",
// and any value whose DIGITS match the phone's. Digit comparison is what makes it robust - the two fields
// are formatted differently ("+14138229340" vs "(413) 822-9340"), so a string compare would miss it, which
// is exactly how the duplicate reached the screen looking like two different values.
function capturedName(rawName: string | null | undefined, rawPhone: string | null | undefined): boolean {
  const name = (rawName ?? '').trim();
  if (!name) return false;
  if (name.toLowerCase() === 'unknown caller') return false;
  const digits = (value: string) => value.replace(/\D+/g, '');
  const nameDigits = digits(name);
  const phoneDigits = digits(rawPhone ?? '');
  // A value carrying no letters whose digits match the phone is the fallback, not a name. Compare on the
  // last 10 so a +1 country code present on one side and not the other cannot make them look different.
  if (!/[a-z]/i.test(name) && nameDigits && phoneDigits
      && (nameDigits.endsWith(phoneDigits.slice(-10)) || phoneDigits.endsWith(nameDigits.slice(-10)))) return false;
  return true;
}

interface WsQueues {
  call: WsMessage[];
  text: WsMessage[];
}

function iconPath(name: string) {
  switch (name) {
    case 'inbox': return 'M4 7h16l-2 10H6L4 7Zm3 6h2.5l1 2h3l1-2H17';
    case 'bell': return 'M12 4a5 5 0 0 0-5 5v3l-2 3h14l-2-3V9a5 5 0 0 0-5-5Zm-2 14h4';
    case 'users': return 'M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm6-1a2.5 2.5 0 1 0 0-5M4 19a5 5 0 0 1 10 0m2-1.5a4 4 0 0 1 4 1.5';
    case 'calendar': return 'M5 5h14v14H5V5Zm3-2v4m8-4v4M5 9h14';
    case 'chart': return 'M5 18V9m6 9V5m6 13v-6M3 19h18';
    case 'card': return 'M4 6h16v12H4V6Zm0 4h16';
    case 'settings': return 'M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm0-5v3m0 12v3M4.2 4.2l2.1 2.1m11.4 11.4 2.1 2.1M3 12h3m12 0h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1';
    case 'help': return 'M9.5 9a2.5 2.5 0 1 1 4.6 1.4c-.8 1.1-2.1 1.2-2.1 3.1M12 17h.01';
    case 'clock': return 'M12 8v4l3 2M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z';
    case 'phone': return 'M7 4h4l1 4-2 1c1 2 2.5 3.5 5 5l1-2 4 1v4c0 1-1 2-2 2A14 14 0 0 1 5 6c0-1 1-2 2-2Z';
    case 'message': return 'M4 5h16v11H8l-4 4V5Z';
    case 'mic': return 'M12 3a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Zm-6 8a6 6 0 0 0 12 0M12 17v4';
    case 'filter': return 'M4 6h16M7 12h10M10 18h4';
    case 'search': return 'M10.5 18a7.5 7.5 0 1 1 5.3-2.2L20 20';
    case 'menu': return 'M4 7h16M4 12h16M4 17h16';
    case 'chevron-left': return 'M15 18l-6-6 6-6';
    case 'flag': return 'M6 4v16M7 4h10l-1.5 4L17 12H7';
    case 'edit': return 'M4 20h4L19 9l-4-4L4 16v4Zm11-15 4 4';
    case 'tag': return 'M20 12l-8 8-8-8V4h8l8 8ZM8 8h.01';
    case 'play': return 'M8 5v14l11-7L8 5Z';
    case 'list': return 'M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01';
    // v12.9.14 (#830): Call data's own glyph, against Transcript's list.
    case 'database': return 'M12 3c4.1 0 7.5 1.3 7.5 3s-3.4 3-7.5 3-7.5-1.3-7.5-3 3.4-3 7.5-3ZM4.5 6v6c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3V6M4.5 12v6c0 1.7 3.4 3 7.5 3s7.5-1.3 7.5-3v-6';
    case 'star': return 'M12 3l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.8 1-6.1-4.4-4.3 6.1-.9L12 3Z';
    case 'shield': return 'M12 3l7 3v5c0 4.5-2.8 8.5-7 10-4.2-1.5-7-5.5-7-10V6l7-3Z';
    // v12.2.4.0: voicemail = the universal two-reels glyph (distinct from mic/phone); pause + download for the player.
    case 'voicemail': return 'M6.5 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Zm11 0a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM6.5 15.5h11';
    case 'pause': return 'M9 5v14M15 5v14';
    case 'download': return 'M12 3v11M8 10l4 4 4-4M5 20h14';
    case 'copy': return 'M9 9h10v10H9V9Zm-4 6H4V5h10v1';                 // v12.2.38.0 (#212)
    case 'check': return 'M5 13l4 4L19 7';                               // v12.2.38.0 (#212)
    // v12.9.12 (#792/#794): the more-menu and the footer's inline glyphs. 'mail' is an envelope for
    // Mark unread - re-queueing a message is the inbox gesture, not a document one.
    case 'mail': return 'M3 6h18v12H3V6Zm0 1 9 7 9-7';
    case 'printer': return 'M7 9V4h10v5M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v6H7v-6Z';   // v12.10.13 (#1564)
    case 'dots': return 'M12 5h.01M12 12h.01M12 19h.01';
    case 'send-text': return 'M4 5h16v10H9l-5 4V5Zm4 4h8M8 12h5';
    default: return 'M5 12h14M12 5v14';
  }
}

// v12.10.30 (#2258): the drawer's quick-jump chips, in Alt+1..4 order.
const JUMP_ORDER = ['needs', 'recording', 'note', 'transcript'] as const;
type JumpKey = typeof JUMP_ORDER[number];
const JUMP_META: Record<JumpKey, { label: string; icon: string }> = {
  needs: { label: 'Needs', icon: 'star' },
  recording: { label: 'Recording', icon: 'mic' },
  note: { label: 'Add note', icon: 'edit' },
  transcript: { label: 'Transcript', icon: 'list' },
};

function SvgIcon({ name }: { name: string }) {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d={iconPath(name)} />
    </svg>
  );
}

// ── v12.7.2 (#599 + #583): PENDING / COMPLETED. ────────────────────────────────────────────────────
//
// "In progress" was the message status AND the live-call indicator, so a call that ended hours ago read as
// though it were still happening. Tushar: *"in progress is confusing - it always feels that call is in
// progress... shoud we do pending action instead?"* He then weighed "New" against "Pending" and settled it
// himself: New would sit on a message read three days ago, which is the same lie as Verified (#581) and Live
// (#583) - a word that stops being true and never changes.
//
// **LABELS ONLY. The stored token is untouched.** toWireStatus() below still sends "in progress", and it
// MUST: that is #457, where `"prog".Contains("progress")` was false and every in-progress message read back
// as `new` for four months. BDR-001's rule is the whole point - the token is the stable key, the label is the
// tenant's word - so renaming what a person reads costs nothing and renaming the token costs four months.
//
// #583's second clause folds in here: opening a message marks it READ and no longer claims a person is
// working on it. That clause was tagged fixed with the rest of #583 in 12.7.0 and was never built - the third
// acceptance-partial in one release, and the one my own audit flagged and I argued away.
function statusLabel(status: MsgStatus) {
  if (status === 'prog') return 'Pending';
  if (status === 'done') return 'Completed';
  return 'Pending';
}

// BB: translate a local MsgStatus (or raw status string) to a wire value the API's
// NormalizeStatus recognizes. It maps to 'prog' only on "progress"/"working"/"open" and to
// 'done' on "complete"/"done"/"resolved"/"sent" - the bare "prog" we used to send matched
// neither and was stored as "new". Sending "in progress"/"complete" persists correctly.
function toWireStatus(status: string): string {
  if (status === 'prog') return 'in progress';
  if (status === 'done') return 'complete';
  return 'new';
}


// ── v12.7.0 (#580 / R1): WHAT KIND OF LINE THE CALLER WAS ON. ──────────────────────────────────────────
//
// FOUR SHAPES, NOT TWELVE. Twilio answers with twelve values; twelve bespoke glyphs are unreadable at 15px
// and unlearnable. Mobile / Landline (landline + fixedVoip) / VoIP (nonFixedVoip) / Special (everything else),
// plus a fifth hollow mark for NOT KNOWN - which is every call placed before this release, because the lookup
// 404'd until #575. It must never default to Landline: a wrong answer there costs a patient their text
// confirmation and nobody finds out.
//
// The dot carries the only fact staff act on - can a text reach this number - and reads the SAME allow-list
// the engine uses (LineTypes.IsTextable: mobile and nonFixedVoip, nothing else), so the list can never promise
// a text the call would refuse. Nothing else in the row is tinted; a row where four things compete for
// attention has no signal at all.
const LINE_TEXTABLE = new Set(['mobile', 'nonfixedvoip']);
function lineFamily(type: string | null): 'mobile' | 'landline' | 'voip' | 'special' | 'unknown' {
  const t = (type ?? '').toLowerCase();
  if (!t || t === 'unknown') return 'unknown';
  if (t === 'mobile') return 'mobile';
  if (t === 'landline' || t === 'fixedvoip') return 'landline';
  if (t === 'nonfixedvoip') return 'voip';
  return 'special';
}
function lineWords(type: string | null, carrier: string | null) {
  const f = lineFamily(type);
  const name = f === 'mobile' ? 'Mobile' : f === 'landline' ? 'Landline' : f === 'voip' ? 'VoIP'
             : f === 'special' ? (type ?? 'Other') : 'Line type not checked';
  const textable = LINE_TEXTABLE.has((type ?? '').toLowerCase());
  return `${name}${carrier ? ` \u00b7 ${carrier}` : ''}${f === 'unknown' ? '' : (textable ? ' \u00b7 takes texts' : ' \u00b7 no texts')}`;
}
/// v12.7.2 (#595): the line type ALONE. lineWords above still exists and is still what the hover title on
/// the list mark says - there the whole sentence is the point, because there is no room for anything else.
/// In the drawer the carrier moves to the detail grid and "takes texts" goes entirely: the Text button (#596)
/// demonstrates it, and a control that is present says it better than a sentence that might be stale.
function lineTypeWord(type: string | null) {
  const f = lineFamily(type);
  return f === 'mobile' ? 'Mobile' : f === 'landline' ? 'Landline' : f === 'voip' ? 'VoIP'
       : f === 'special' ? (type ?? 'Other') : 'Line type not checked';
}

/** v12.10.19 (#1921, LOCKED 10/23 S108): the hover keeps today's line and ADDS what Twilio told us for free - place, caller-ID check,
 *  this call's route - and the number's history. Read from what came with the list; nothing is fetched on hover. */
function lineHover(type: string | null, carrier: string | null, info?: import('../features/agentWorkspace/types').PhoneInfo | null): string {
  const lines = [lineWords(type, carrier)];
  if (info) {
    const place = [info.city, [info.state, info.zip].filter(Boolean).join(' ')].filter((x) => x && String(x).trim()).join(', ');
    if (place || info.country) lines.push([place, info.country].filter(Boolean).join(' \u00b7 '));
    if (info.verification) lines.push(`Caller ID: ${info.verified ? 'Verified' : 'Unverified'} (${info.verification})`);
    if (info.route) lines.push(`This call: ${info.route === 'direct' ? 'direct to the VoiceSpectrum number' : 'via the practice line (PBX)'}`);
    if (info.calls > 0) lines.push(`Seen ${info.calls} call${info.calls === 1 ? '' : 's'}${info.firstSeen ? ` \u00b7 first ${new Date(info.firstSeen).toLocaleDateString()}` : ''}${info.lineChecked ? ` \u00b7 line type checked ${new Date(info.lineChecked).toLocaleDateString()}` : ''}`);
  }
  return lines.join('\n');
}

function LineMark({ type, carrier, info }: { type: string | null; carrier?: string | null; info?: import('../features/agentWorkspace/types').PhoneInfo | null }) {
  // v12.10.19 (#1922): the number's own record wins over the call's copy (the Lookup now runs once per number)
  const lt = info?.lineType ?? type; const lc = info?.carrier ?? carrier ?? null;
  const f = lineFamily(lt);
  const textable = LINE_TEXTABLE.has((lt ?? '').toLowerCase());
  const p = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const };
  return (
    <span className={`aw-line-mark aw-line-${f}`} title={lineHover(lt, lc, info)}>
      <svg width="15" height="15" viewBox="0 0 24 24" aria-hidden="true">
        {f === 'mobile' && <><rect x="7" y="2.5" width="10" height="19" rx="2.6" {...p} /><path d="M10.8 18.6h2.4" {...p} /></>}
        {f === 'landline' && <><path d="M5.5 3.5h13a2 2 0 0 1 2 2v3.2a2 2 0 0 1-1.5 1.94l-2.6.65a1.4 1.4 0 0 0-1.06 1.36v.85h-6.7v-.85a1.4 1.4 0 0 0-1.06-1.36L5 10.64A2 2 0 0 1 3.5 8.7V5.5a2 2 0 0 1 2-2Z" {...p} /><rect x="4.5" y="15.5" width="15" height="5" rx="1.6" {...p} /></>}
        {f === 'voip' && <><path d="M3.2 7.4c0-2.2 1.9-3.6 3.6-3.1l1.3 2.7-1.8 1.3a9.4 9.4 0 0 0 4.6 4.6l1.3-1.8 2.7 1.3c.5 1.7-.9 3.6-3.1 3.6A8.6 8.6 0 0 1 3.2 7.4Z" {...p} /><path d="M16.5 3.6a6.4 6.4 0 0 1 4.2 4.2" {...p} /><path d="M15.8 7.2a2.9 2.9 0 0 1 1.9 1.9" {...p} /></>}
        {f === 'special' && <><path d="M3.2 8.4c0-2.2 1.9-3.6 3.6-3.1l1.3 2.7-1.8 1.3a9.4 9.4 0 0 0 4.6 4.6l1.3-1.8 2.7 1.3c.5 1.7-.9 3.6-3.1 3.6A8.6 8.6 0 0 1 3.2 8.4Z" {...p} /><circle cx="18" cy="6" r="2.9" {...p} /></>}
        {f === 'unknown' && <><circle cx="12" cy="12" r="8.6" strokeDasharray="2.6 3" {...p} /><path d="M9.9 9.7a2.2 2.2 0 1 1 2.9 2.1c-.5.2-.8.7-.8 1.2v.4" {...p} /><path d="M12 16.6h.01" {...p} /></>}
      </svg>
      {textable && <span className="aw-line-dot" aria-hidden="true" />}
    </span>
  );
}

// ── v12.7.0 (#582 / R2): DID THE OTHER SYSTEM TAKE THE BOOKING. ────────────────────────────────────────
//
// A DERIVED pill, not a label. Tushar asked whether two labels could be auto-applied; a label is the tenant's
// own taxonomy that staff apply and remove by hand, and a system-determined fact a person can delete becomes a
// lie the moment they do - which is #581 in a different hat. This reads the stored result of the action.
//
// THREE STATES, never two. null = no booking action ran on this call, and that shows NOTHING: no pill, no
// placeholder. Colour is on the exception only - "Not booked" is the follow-up queue and has to be findable
// while scanning; "Booked" will be on almost every row and a badge that is everywhere carries no information.
// ── v12.7.2 (#594): NAME THE SYSTEM, MARK THE OUTCOME. ─────────────────────────────────────────────
//
// "Booked / Not booked" is appointment vocabulary and cannot describe what happened for any other kind of
// connected system - a claim submitted, a chart looked up, a result posted to accounting. Tushar: *"i liked
// the idea of displaying system name and tick or x mark."*
//
// So the pill says WHICH system and whether it accepted, with no verb at all - which means no industry word
// to choose, and the amber case tells staff which system to go and look at. The short code is #597; a
// connection without one falls back to its name, truncated, so nothing renders blank while tenants fill them
// in. Colour stays on the exception only (#582): a mark that is on every row carries no information.
function BookingPill({ ok, reference, system }: { ok: boolean | null; reference?: string | null; system?: string | null }) {
  if (ok === null || ok === undefined) return null;
  // v12.7.2 (#616): a connected system that was never reached is not a system that refused. The engine now
  // records stage "config" / "value" for those, and the API sends no system name, so the pill says the honest
  // thing rather than naming a system that never saw the request.
  const name = (system ?? '').trim().slice(0, 8).toUpperCase();
  return ok
    ? <span className="aw-booked aw-booked-yes" title={reference ? `${name || 'The connected system'} accepted this \u00b7 reference ${reference}` : `${name || 'The connected system'} accepted this`}>
        {name && <span className="aw-booked-sys">{name}</span>}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5" /></svg>
        {!name && 'Accepted'}
      </span>
    : <span className="aw-booked aw-booked-no" title={name ? `${name} did not accept this \u2014 open the call path to see what it said` : 'The request did not succeed \u2014 open the call path to see why'}>
        {name && <span className="aw-booked-sys">{name}</span>}
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
        {!name && 'Not accepted'}
      </span>;
}

// v12.9.25 (#959 AC3): the caller never confirmed the read-back (silence, or the Confirm card's retries used up).
// Whatever route the card then took, the request carries this mark - a booking made on it was made on details
// nobody agreed to on the line, so staff should look before relying on it.
// v12.9.26 (#977, UI-LOCK-12.9.26 v1.3 LOCKED): the structured staff summary. The engine writes the rows in both
// languages from the stored record (StaffSummary.cs) - this only lays them out. Outcome and Flags are absent when
// the engine left them out (no Connect card ran / nothing to act on), and then the row is not drawn at all.
const SUMMARY_UI: Record<string, { title: string; keys: [string, string, string, string, string]; history: string }> = {
  en: { title: 'What the caller needs', keys: ['Caller', 'Wants', 'Outcome', 'Next step', 'Flags'], history: 'History' },
  es: { title: 'Lo que necesita la persona', keys: ['Persona', 'Solicita', 'Resultado', 'Siguiente paso', 'Alertas'], history: 'Historial' },
};
function summaryRowsFor(m: { summaryRows?: Record<string, SummaryRows> | null }, lang: string): SummaryRows | null {
  return m.summaryRows?.[lang] ?? null;
}
function summaryRowsText(r: SummaryRows, lang: string): string {
  const k = (SUMMARY_UI[lang] ?? SUMMARY_UI.en).keys;
  // v12.10.23 (#2070): Combined Wants = one line per call, the call tag first; Next step = the call-back number first, blank = left out.
  const wants = (r.wantsByCall ?? []).length > 1 ? '\n' + r.wantsByCall!.map((w) => `  #${w.ref} ${w.wants}`).join('\n') : ` ${r.wants}`;
  const next = [r.callBack ? `${CALL_BACK_WORD[lang] ?? CALL_BACK_WORD.en}: ${r.callBack}` : null, (r.next ?? '').trim() || null].filter(Boolean).join(' · ');
  return [
    `${k[0]}: ${r.caller}`,
    `${k[1]}:${wants}`,
    r.outcome ? `${k[2]}: ${r.outcome}` : null,
    next ? `${k[3]}: ${next}` : null,
    r.flags ? `${k[4]}: ${r.flags}` : null,
  ].filter(Boolean).join('\n');
}
// v12.10.23 (#2070, UI-PROTO-T178-2070 v1.2 LOCKED)
const CALL_BACK_WORD: Record<string, string> = { en: 'Call back', es: 'Devolver la llamada al' };
const VIEW_WORD: Record<string, [string, string]> = { en: ['View', 'Hide'], es: ['Ver', 'Ocultar'] };
const MORE_WORD: Record<string, [string, string]> = { en: ['more', 'less'], es: ['m\u00e1s', 'menos'] };
/** v12.10.23 (#2070): the call-back number - the row's callBack, else the captured caller.callback - only when it differs from the caller ID. */
function callBackOf(m: WsMessage, lang = 'en'): string | null {
  const r = m.summaryRows?.[lang]?.callBack ?? m.summaryRows?.en?.callBack ?? null;
  if (r && phoneDigits(r).length >= 10 && phoneDigits(r) !== phoneDigits(m.phone)) return formatCardPhone(r);
  const c = callbackOf(m);
  return c ? formatCardPhone(c) : null;
}
/** v12.10.23 (#2070): Combined - the newest call that has a different call-back number. */
function callBackOfGroup(group: WsMessage[], lang: string): string | null {
  for (const m of group) { const c = callBackOf(m, lang); if (c) return c; }
  return null;
}
/** v12.10.16.1 (#1707 #1700): the Combined view's rows for a group, whatever the newest call is. CALLER = the newest call that
 *  captured who called (42-0447 was a missed call; 42-0433 had the name, DOB and ZIP); WANTS = the newest call's request, or for a
 *  call without rows (voicemail, missed) its own short summary; NEXT STEP = the newest call that has one. */
function firstSentence(t: string | null | undefined): string {
  // 12.10.17.2 (#1818 #1822): "Dr." / "Mr." / "St." never end the sentence - "...follow-up for Dr. Philogene" was cut at "for Dr."
  const x = (t ?? '').trim(); const m = x.match(/^(.+?(?<!\b(?:Dr|Mr|Mrs|Ms|Sr|Jr|St|Dra|Sra|Srta))[.!?])(\s|$)/); return (m ? m[1] : x).trim();
}
/** 12.10.17.2 (#1818, Tushar 10/16-10/19): the call of a group with the most content leads the card and WANTS - a voicemail with
 *  words or a call with a request, then a call that hung up, then an empty missed call; newest first among equals. */
/** v12.10.19 (#1885, LOCKED 10/23 S82): the placeholder Wants are NOT content - they never outrank a real request. */
function isPlaceholderWants(w: string | null | undefined): boolean {
  const x = (w ?? '').trim();
  return !x || /^(request|solicitud)$/i.test(x) || /^(hung up before saying|no request (heard|given)|colg\u00f3 antes|no se escuch\u00f3|no dio ninguna)/i.test(x);
}
function contentRank(m: WsMessage): number {
  if (isBareMissed(m) && isEmptySummary(m.aiSummary)) return 0;   // v12.10.21 (#1953): a hung-up call has content (its transcript)
  const w = (m.summaryRows?.en?.wants ?? '').trim();
  if (m.channel === 'voicemail' && (!isEmptySummary(m.aiSummary) || !isPlaceholderWants(w))) return 3;
  if (!isPlaceholderWants(w)) return 3;
  return 1;
}
/** v12.10.19 (#1925): a call with something meaningful - a real request, or a voicemail with words. */
function isMeaningful(m: WsMessage): boolean { return contentRank(m) === 3; }
function leadOf(group: WsMessage[] | null | undefined): WsMessage | null {
  if (!group || group.length === 0) return null;
  let best = group[0];
  for (const m of group) if (contentRank(m) > contentRank(best)) best = m;
  return best;
}
function wantsOf(m: WsMessage, lang: string): string {
  const r = summaryRowsFor(m, lang)?.wants ?? m.summaryRows?.en?.wants;
  // v12.10.17.1 (#1781): an older call whose Wants is the bare "Request" reads like the card line (D3), never "earlier: Request"
  if (r && !/^(request|solicitud)$/i.test(r.trim())) return r;
  if (m.channel === 'missed' && m.hungUp && isEmptySummary(m.aiSummary)) return HUNG_UP_LINE;   // v12.10.21 (#1953)
  if (m.channel === 'missed' && isEmptySummary(m.aiSummary)) return 'Missed call - no voicemail';
  if (m.channel === 'voicemail') return 'Voicemail: ' + firstSentence(m.aiSummary);
  return firstSentence(m.aiSummary);
}
function buildCombinedRows(group: WsMessage[], lang: string): SummaryRows {
  const newest = group[0];
  const rowsOf = (m: WsMessage) => summaryRowsFor(m, lang) ?? m.summaryRows?.en ?? null;
  const who = group.find((m) => m.hasName && rowsOf(m)?.caller) ?? group.find((m) => rowsOf(m)?.caller);
  const callerText = who ? rowsOf(who)!.caller + (who.id !== newest.id ? ` · ${formatReference(who.referenceNo)}` : '') : (newest.hasName ? newest.name : (newest.phone ?? newest.name));
  // v12.10.19 (#1924): the AI version reads the whole group in one run - the newest call carries its answer.
  // v12.10.23 (#2070): the row in the language read (ES = the AI's own Spanish), else the English AI row.
  const aiRows = newest.summaryRows?.[lang]?.source === 'ai' ? newest.summaryRows[lang] : newest.summaryRows?.en?.source === 'ai' ? newest.summaryRows.en : null;
  const callBack = callBackOfGroup(group, lang);
  if (aiRows) return { caller: callerText, wants: aiRows.wants, wantsByCall: aiRows.wantsByCall ?? null, outcome: rowsOf(newest)?.outcome ?? null, next: aiRows.next ?? '', flags: rowsOf(newest)?.flags ?? null, callBack };
  // ══ v12.10.19 (#1925, LOCKED 10/23 S127): the LATEST meaningful call leads; only one -> that one; several -> one line per call,
  // newest first, each with its reference; all empty -> "No request given". Next step and Flags come from the call(s) shown (S131).
  const meaningful = group.filter(isMeaningful);   // the group is newest first
  if (meaningful.length === 0) {
    return { caller: callerText, wants: lang === 'es' ? 'No dio ninguna solicitud' : 'No request given', outcome: rowsOf(newest)?.outcome ?? null,
             next: rowsOf(newest)?.next ?? '', flags: null, callBack };   // v12.10.23 (#2070): no filler Next step
  }
  if (meaningful.length === 1) {
    const m = meaningful[0];
    return { caller: callerText, wants: wantsOf(m, lang), outcome: rowsOf(m)?.outcome ?? rowsOf(newest)?.outcome ?? null,
             next: rowsOf(m)?.next ?? '', flags: rowsOf(m)?.flags ?? null, callBack,
             wantsByCall: [{ ref: ref0(m), referenceNo: m.referenceNo, wants: wantsOf(m, lang) }] };   // v12.10.23 (#2070): the tag first in Combined
  }
  const flags = meaningful.map((m) => rowsOf(m)?.flags).filter(Boolean) as string[];
  // v12.10.23 (#2070, LOCKED): one Wants line per call with its tag FIRST; ONE Next step (the newest meaningful call's), no call numbers.
  return {
    caller: callerText,
    wants: meaningful.map((m) => wantsOf(m, lang)).join('; '),
    wantsByCall: meaningful.map((m) => ({ ref: ref0(m), referenceNo: m.referenceNo, wants: wantsOf(m, lang) })),
    outcome: rowsOf(meaningful[0])?.outcome ?? null,
    next: rowsOf(meaningful[0])?.next ?? '',
    flags: flags.length ? flags.join(' | ') : null,
    callBack,
  };
}
function ref0(m: WsMessage): string { return formatReference(m.referenceNo).replace(/^#/, ''); }

/** v12.10.19 (#1905, LOCKED 10/22): the card line = the FULL Wants text + the Next step (one call or the Combined rows). */
function cardLine(rows: SummaryRows | null, fallback: string, callBack?: string | null): string {
  if (!rows) return fallback;
  // v12.10.23 (#2070, LOCKED v1.2 tab 3): Wants + the call-back number + Next step; no call tags.
  const w = rows.wants.replace(/\n/g, ' | ');
  const cb = rows.callBack ?? callBack ?? null;
  const n = (rows.next ?? '').replace(/\n/g, ' | ');
  return [w, cb ? `${CALL_BACK_WORD.en} ${cb}` : '', n].filter((x) => x.trim()).join(' · ');
}

// v12.10.18 (#1863 T148, UI-PROTO-T148 v1.10 section 5): what a repeat caller ADDED ("anything else?") - every addition kept,
// oldest first, with its time and the call it was said on. The label is the practice's word for call.addendum (ES "Adenda").
const ADDENDUM_LABEL: Record<string, string> = { en: 'Addendum', es: 'Adenda' };
function addendaOf(group: WsMessage[]): { text: string; at: string; ref: string }[] {
  return [...group].sort((a, b) => ((a.startedAt ?? '') < (b.startedAt ?? '') ? -1 : 1)).flatMap((m) => {
    const v = (m.capturedFields ?? []).find((f) => f.token === 'call.addendum' && (f.value ?? '').trim())?.value ?? '';
    return v.trim() ? [{ text: v.trim(), at: m.time, ref: formatReference(m.referenceNo) }] : [];
  });
}

/** The practice's word for call.addendum (the captured field's label) - English only; other languages use their own word. */
function addendumLabelOf(group: WsMessage[], lang: string): string {
  if (lang !== 'en') return ADDENDUM_LABEL[lang] ?? ADDENDUM_LABEL.en;
  for (const m of group) { const f = (m.capturedFields ?? []).find((x) => x.token === 'call.addendum'); if (f?.label) return f.label; }
  return ADDENDUM_LABEL.en;
}

function SummaryRowsGrid({ rows, lang, wantsRef, earlier, addenda, addendumLabel }: { rows: SummaryRows; lang: string; wantsRef?: string; earlier?: { text: string; ref: string }[];
  addenda?: { text: string; at: string; ref: string }[]; addendumLabel?: string }) {
  const k = (SUMMARY_UI[lang] ?? SUMMARY_UI.en).keys;
  // ══ v12.10.23 (#2070, UI-PROTO-T178-2070 v1.2 LOCKED): Wants = the call tag FIRST (Combined only), at most 3 lines then "… more";
  // Next step = the call-back number first (click copies), then the 7-word step, blank = no row; History behind View. ══
  const [wantsOpen, setWantsOpen] = useState(false);
  const [wantsLong, setWantsLong] = useState(false);
  const [histOpen, setHistOpen] = useState(false);
  const wantsBox = useRef<HTMLDivElement | null>(null);
  const byCall = wantsRef ? (rows.wantsByCall && rows.wantsByCall.length > 0 ? rows.wantsByCall : [{ ref: wantsRef.replace(/^#/, ''), wants: rows.wants }]) : null;
  useLayoutEffect(() => {
    const el = wantsBox.current;
    if (el && !wantsOpen) setWantsLong(el.scrollHeight > el.clientHeight + 2);
  }, [rows.wants, rows.wantsByCall, wantsOpen, wantsRef]);
  const nextText = (rows.next ?? '').trim();
  const words = (VIEW_WORD[lang] ?? VIEW_WORD.en); const more = (MORE_WORD[lang] ?? MORE_WORD.en);
  return (
    <div className="aw-sum-grid">
      <div className="aw-sum-k">{k[0]}</div><div>{rows.caller}</div>
      <div className="aw-sum-k">{k[1]}</div>
      <div>
        <div ref={wantsBox} className={`aw-sum-wants${wantsOpen ? '' : ' aw-sum-clamp'}`}>
          {byCall
            ? byCall.map((w, i) => <div key={`${w.ref}-${i}`} className="aw-sum-wline"><span className="aw-grp-chip aw-grp-chip-lead">#{w.ref}</span>{w.wants}</div>)
            : <span style={{ whiteSpace: 'pre-line' }}>{rows.wants}</span>}
        </div>
        {(wantsLong || wantsOpen) && <button type="button" className="aw-sum-more" onClick={() => setWantsOpen((o) => !o)} data-track="drawer.summary.wantsMore">{wantsOpen ? more[1] : `\u2026 ${more[0]}`}</button>}
      </div>
      {/* v12.10.18 (#1863): Addendum - BELOW Wants, ABOVE History; the HISTORY row pattern (#1821) */}
      {(addenda ?? []).length > 0 && (
        <>
          <div className="aw-sum-k">{addendumLabel || ADDENDUM_LABEL[lang] || ADDENDUM_LABEL.en}</div>
          <div>{(addenda ?? []).map((a, i) => <div key={`${a.ref}-${i}`} className="aw-grp-earlier">{a.text}<span className="aw-grp-chip">{a.at}</span><span className="aw-grp-chip">{a.ref}</span></div>)}</div>
        </>
      )}
      {rows.outcome && (<><div className="aw-sum-k">{k[2]}</div><div>{rows.outcome}</div></>)}
      {(rows.callBack || nextText) && (
        <>
          <div className="aw-sum-k">{k[3]}</div>
          <div>
            {rows.callBack && <div className="aw-sum-cb"><span className="aw-muted">{CALL_BACK_WORD[lang] ?? CALL_BACK_WORD.en}:</span> <PhoneCopy phone={rows.callBack} className="aw-sum-cbnum" /></div>}
            {nextText && <div style={{ whiteSpace: 'pre-line' }}>{nextText}</div>}
          </div>
        </>
      )}
      {/* 12.10.17.2 (#1821, Tushar 10/17): Combined - the other calls of the group move out of WANTS into HISTORY, newest first.
          v12.10.23 (#2070): behind a View link. */}
      {(earlier ?? []).length > 0 && (
        <>
          <div className="aw-sum-k">{(SUMMARY_UI[lang] ?? SUMMARY_UI.en).history}</div>
          <div>
            <button type="button" className="aw-sum-more aw-sum-view" onClick={() => setHistOpen((o) => !o)} aria-expanded={histOpen} data-track="drawer.summary.history">{histOpen ? words[1] : words[0]}</button>
            {histOpen && <div className="aw-sum-hist">{(earlier ?? []).map((e) => <div key={e.ref} className="aw-grp-earlier">{e.text}<span className="aw-grp-chip">{e.ref}</span></div>)}</div>}
          </div>
        </>
      )}
      {rows.flags && (
        <>
          <div className="aw-sum-k">{k[4]}</div>
          <div className="aw-sum-flags">{rows.flags.split(' · ').map((f) => <span key={f} className="aw-sum-flag">{f}</span>)}</div>
        </>
      )}
    </div>
  );
}

// v12.9.27 (#1048): NotConfirmedPill retired - the row names the flagged fields instead (FlagsChip).
// ── v12.9.27 (#1048, AGREED 2026-10-01): THE CHIP NAMES THE FIELDS. ──────────────────────────────────────
// "Check: DOB, appt date" - only the fields still not confirmed after we tried (FLAGGED). No flag, no chip: a
// field the caller confirmed stays confirmed. A full name follows its parts, so it is never named twice.
const FLAG_SHORT: Record<string, string> = {
  firstname: 'first name', lastname: 'last name', name: 'name', dob: 'DOB', birthdate: 'DOB', dateofbirth: 'DOB',
  zip: 'ZIP', phone: 'phone', reason: 'reason', newdate: 'new appt date', newtime: 'new appt time',
};
export function flaggedFieldNames(fields: CapturedField[] | undefined, category?: string | null): string[] {
  const appt = /appoint|cita/i.test(category ?? '') || !(category ?? '').trim();
  const flagged = (fields ?? []).filter((f) => f.flag === 'flagged' && !f.notCaptured);
  const segs = flagged.map((f) => ({ f, seg: (f.token.split('.').pop() ?? '').toLowerCase() }));
  const hasPart = segs.some((x) => x.seg === 'firstname' || x.seg === 'lastname');
  const out: string[] = [];
  for (const { f, seg } of segs) {
    if (seg === 'name' && hasPart) continue;
    const word = seg === 'date' ? (appt ? 'appt date' : 'date') : seg === 'time' ? (appt ? 'appt time' : 'time') : (FLAG_SHORT[seg] ?? f.label);
    if (!out.includes(word)) out.push(word);
  }
  return out;
}
function FlagsChip({ fields, category }: { fields?: CapturedField[]; category?: string | null }) {
  const names = flaggedFieldNames(fields, category);
  if (names.length === 0) return null;
  return <span className="aw-notconf" title="Still not confirmed after we tried. Check these with the caller - Call data has the reason for each.">Check: {names.join(', ')}</span>;
}

/** v12.10.21 (#1953): a TRUE missed call - nobody said anything. A "missed" call where the agent spoke is a caller who hung up
 *  during the call: it reads "Hung up during the call", its transcript shows and its recording plays. */
function isBareMissed(m: Pick<WsMessage, 'channel' | 'hungUp'>): boolean {
  return m.channel === 'missed' && !m.hungUp;
}
const HUNG_UP_LINE = 'Hung up during the call';   // v12.10.21 (#1953)
/** v12.10.21 (#1953): the channel word of one message - "Hung up" for a hung-up call, else channelLabel. */
function msgChannelLabel(m: Pick<WsMessage, 'channel' | 'hungUp'>): string {
  return m.channel === 'missed' && m.hungUp ? 'Hung up' : channelLabel(m.channel);
}
/** v12.10.21 (#1952): the downloaded recording's name - "<call number> - <yyyymmdd of the call>.<ext>", e.g. "43-0800 - 20261023.mp3"
 *  (the API names the attachment the same way; this is the browser's fallback). */
function recordingFileName(m: Pick<WsMessage, 'referenceNo' | 'startedAt' | 'id'>, ext: string): string {
  const d = new Date(m.startedAt ?? '');
  const ymd = Number.isNaN(d.getTime()) ? '' : `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  const num = formatReference(m.referenceNo) || `call-${m.id}`;
  return `${num}${ymd ? ` - ${ymd}` : ''}.${(ext || 'mp3').replace(/^\./, '').toLowerCase()}`.replace(/[\\/:*?"<>|]/g, '');
}

function channelLabel(channel: Channel) {
  if (channel === 'voicemail') return 'Voicemail';
  if (channel === 'missed') return 'Missed';
  // ── v12.7.0 (#583 / B1): "Live" was the CHANNEL - an answered call as opposed to a voicemail, a missed
  // call or a text - but it sat in the drawer's meta line beside the date and the duration, where it read as
  // "this call is happening right now". Tushar's screenshot of #39-0007 showed "10:30 PM · Live · 2:04" on a
  // call that had ended. The distinction the channel is drawing is real and stays; the word was the problem.
  // A genuinely live call is still announced, in the list, by `message.inProgress` (#476).
  if (channel === 'live') return 'Call';
  return 'Text';
}

function languageCode(language: Language) {
  if (language === 'Spanish') return 'ES';
  if (language === 'French') return 'FR';
  if (language === 'German') return 'DE';
  return 'EN';
}

// V1: format the card phone as (NNN) NNN-NNNN when it's a US number, never raw +E.164.
// The API usually pre-formats it; this guards any row that still carries a raw number.
// ══ v12.10.15 (#1668, LOCKED): CLICK A PHONE NUMBER TO COPY THE 10 DIGITS (4138229340) - staff paste it into DigiDMS. ══
// A blocked clipboard selects the digits so Ctrl+C works. On a phone a tap copies; Call back still dials.
function phoneDigits(phone: string | null | undefined): string {
  const d = (phone ?? '').replace(/\D/g, '');
  return d.length === 11 && d.startsWith('1') ? d.slice(1) : d;
}
export function PhoneCopy({ phone, className }: { phone: string; className?: string }) {
  const digits = phoneDigits(phone);
  if (digits.length < 7) return <span className={className}>{formatCardPhone(phone)}</span>;
  return (
    <span role="button" tabIndex={0} className={`aw-phone-copy${className ? ' ' + className : ''}`} title={`Copy ${digits}`} data-track="message.phone.copy"
      onClick={(e) => {
        e.stopPropagation();
        const el = e.currentTarget;
        const fallback = () => {
          try { const r = document.createRange(); r.selectNodeContents(el); const sel = window.getSelection(); sel?.removeAllRanges(); sel?.addRange(r); } catch { /* nothing to select */ }
          toast('info', 'Press Ctrl+C to copy', digits);
        };
        if (navigator.clipboard?.writeText) navigator.clipboard.writeText(digits).then(() => toast('success', 'Phone copied', digits), fallback);
        else fallback();
      }}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); (e.currentTarget as HTMLElement).click(); } }}>
      {formatCardPhone(phone)}
    </span>
  );
}
/** v12.10.15 (#1663): the Callback card's number, when it differs from the number they called from. */
function callbackOf(m: { phone: string; capturedFields?: { token: string; value: string }[] }): string | null {
  const cb = (m.capturedFields ?? []).find((f) => (f.token ?? '').toLowerCase() === 'caller.callback')?.value ?? '';
  return phoneDigits(cb).length >= 10 && phoneDigits(cb) !== phoneDigits(m.phone) ? cb : null;
}

function formatCardPhone(phone: string): string {
  if (!phone) return phone;
  if (/[()]/.test(phone)) return phone; // already formatted
  const digits = phone.replace(/\D/g, '');
  const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (local.length === 10) return `(${local.slice(0, 3)}) ${local.slice(3, 6)}-${local.slice(6)}`;
  return phone;
}

// ══ v12.9.12 (#793): SEND TEXT HELPERS ══════════════════════════════════════════════════════════════
//
// The national digits of a number, with a US country code stripped. There is no per-country formatter in
// this app - formatCardPhone above is US-only and PhoneNumbersPage validates E.164 without formatting - so
// 12.9.12 ships +1 only, by his decision: *"for now you can just leave +1 USA"*. A picker offering five
// countries (as the prototype does) would be a promise the formatter cannot keep. Logged as #800.
// v12.9.13 (#801): moved to lib/smsText.ts so the .NET Unit project can pin the rule. See that file.

// GSM-7 holds 160 characters in one segment; a longer message is CONCATENATED, and the per-segment budget
// drops to 153 because each part carries a header saying which part it is. That is why 320 is not 2 segments.
// This warns, it never blocks - the agent is told what will happen and decides.
// v12.9.13 (#801): moved to lib/smsText.ts - pinned in C# and guarded by Check-SmsTextParity.mjs.

// The prototype's five chips, per his instruction: *"whatever templates you see in prototype you can load
// it."* ONE DEPARTURE, DELIBERATE: the prototype writes them for a single caller - "Hi Tushar, this is
// Harlem Medical..." - and shipping that literally would put the wrong name in front of every other caller.
// They interpolate instead. Template MANAGEMENT (tenant-authored, in Personalization) is #799.
// v12.9.24 (#911, replaces #920): each template has a Spanish body. The Spanish is MACHINE-DRAFTED and goes on
// Santos's next proofread sheet before it is relied on - Documents/Brain/Language Proofing.
// v12.9.26 (#938): text per LANGUAGE CODE ({en, es, ...}), not body + es - a third language is a new key, not new code.
// v12.10.28 (#2185): the practice name is in front of every text already ("Riverside Family Practice: ...") - the templates no longer repeat it.
const TEXT_TEMPLATES: { label: string; text: Record<string, string> }[] = [
  { label: 'Appointment confirmed', text: { en: 'Hi {name}, your appointment on {date} is confirmed. Reply or call us if you need to change it.',
      es: 'Hola {name}, su cita del {date} está confirmada. Responda o llámenos si necesita cambiarla.' } },
  { label: 'We tried to reach you', text: { en: 'Hi {name}, we tried to reach you. Please call us back at your convenience.',
      es: 'Hola {name}, intentamos comunicarnos con usted. Por favor llámenos cuando le sea conveniente.' } },
  { label: 'Please call us back',   text: { en: 'Hi {name}, please give us a call back when you have a moment.',
      es: 'Hola {name}, por favor llámenos cuando tenga un momento.' } },
  { label: 'Refill is ready',       text: { en: 'Hi {name}, your refill is ready for pickup at your pharmacy.',
      es: 'Hola {name}, su resurtido está listo para recoger en su farmacia.' } },
  { label: 'Office hours',          text: { en: 'Our office hours are Mon-Fri 9 AM to 5 PM.',
      es: 'Nuestro horario es de lunes a viernes, de 9 a. m. a 5 p. m.' } },
];

// v12.9.24 (#911): one template, filled in one language. A missing first name reads naturally in either language.
// v12.9.26 (#938): null when the template has no text in that language - the caller of this inserts the English and
// translates it, the same path staff's own text takes.
// v12.10.26 (#T154 Q3): Text replies + the office number, set by the page from GET texting/status - the templates' closing sentence follows it.
const textingWording: { repliesOn: boolean; officePhone: string | null } = { repliesOn: false, officePhone: null };

function fillTemplateIn(t: { text: Record<string, string> }, lang: string, firstName: string, practice: string, when: string): string | null {
  const raw = t.text[lang];
  if (!raw) return null;
  const body = applyOutgoingWording(raw, textingWording.repliesOn, textingWording.officePhone);   // v12.10.26 (#T154 Q3): follows Text replies
  const name = firstName || (lang === 'en' ? 'there' : '');
  return fillTemplate(body, name, practice, when).replace(/^Hola\s+,/, 'Hola,');
}

// v12.9.13 (#801): moved to lib/smsText.ts.

// ══ v12.9.14 (#822): THE TEXT NAMES THE APPOINTMENT, NOT THE CALL. ══════════════════════════════════════
//
// The confirmation text told a patient their appointment was the moment they phoned:
//
//     "Your appointment on Saturday, Sep 26, 2026 - 10:42 PM is confirmed."
//
// The appointment stored on that call (39-0077) was 2027-09-24 16:59 - a year and two days later. It
// reproduced live on 39-0079 while we were discussing it. And the format gave the mechanism away: that
// string carries the DRAWER's own middot separator, because the merge field was
// `formatDetailDate(selectedMessage.startedAt)` - the CALL's start time, which was the only date T2 had.
//
// It is the one defect of this batch that is patient-facing AND in writing. Everything else found this week
// was heard once and gone; this sits on the patient's phone.
//
// NOW IT READS THE CAPTURED APPOINTMENT, which 12.9.14 persists per field (#830's capturedFields).
//
// WHEN THERE IS NO APPOINTMENT, IT REFUSES TO GUESS. A call with no request.date captured - a callback, a
// refill, an old call whose values were never stored - yields a visible placeholder that a human must
// replace before sending. That is deliberately awkward: the failure mode we are leaving behind is a
// confident wrong date going out silently, and a blank that stops the sender is strictly better than a
// plausible sentence that is false.
function appointmentWhen(msg: { capturedFields?: CapturedField[] }): string {
  const find = (suffix: string) =>
    msg.capturedFields?.find((f) => f.token.toLowerCase().endsWith(suffix))?.value ?? '';

  const date = find('.date');
  const time = find('.time');
  if (!date) return '[appointment date]';

  // The values are canonical (YYYY-MM-DD / HH:mm) - render them the way a person reads them, and never
  // fall back to the call's own timestamp, which is the whole of this defect.
  const d = new Date(`${date}T${time || '00:00'}`);
  if (Number.isNaN(d.getTime())) return time ? `${date} ${time}` : date;

  const day = d.toLocaleDateString(undefined, {
    weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
  });
  if (!time) return day;
  const hhmm = d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
    .replace(':00 ', ' ');   // "3:00 PM" -> "3 PM", the same rule #824 applied to speech
  return `${day} at ${hhmm}`;
}

function initials(name: string) {
  return name.split(' ').map((part) => part[0]).slice(0, 2).join('').toUpperCase();
}

function titleFromSlug(slug: string) {
  return slug
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ') || 'Tenant workspace';
}

function displayNameFromEmail(email: string) {
  if (!email || email === 'Signed in') return 'Signed in';
  const local = email.split('@')[0] ?? email;
  return local
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ') || local;
}

function roleLabel(role: string | undefined) {
  const normalized = role?.trim();
  if (!normalized) return 'Front desk';
  if (normalized.toLowerCase().includes('admin')) return 'Administrator';
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}

function channelIcon(channel: Channel) {
  if (channel === 'text') return 'message';
  if (channel === 'voicemail') return 'voicemail';   // v12.2.4.0: dedicated voicemail glyph, not a bare mic
  return 'phone';
}

/** v12.10.26 (#2121): the end of the date window (exclusive) - the counters count [start, end). Null = no end (After a date). */
function scopeEndIso(scope: DateScope): string | null {
  const today = startOfLocalDay(new Date());
  const dayAfter = (d: Date) => { const n = startOfLocalDay(d); n.setDate(n.getDate() + 1); return n.toISOString(); };
  if (scope.kind === 'preset') return scope.value === 'Yesterday' ? today.toISOString() : dayAfter(today);
  const from = parseInputDate(scope.from);
  const to = parseInputDate(scope.to);
  if (scope.mode === 'date') return from ? dayAfter(from) : null;
  if (scope.mode === 'before') return from ? dayAfter(from) : null;
  if (scope.mode === 'after') return null;
  return to ? dayAfter(to) : null;
}

function dateScopeLabel(scope: DateScope) {
  if (scope.kind === 'preset') return scope.value;   // v12.10.14 (#1611): words on the button - "Last 7 days"; 7D / 15D / 30D only inside the control
  if (scope.mode === 'date') return scope.from ? dayName(scope.from) : 'Pick a date';
  if (scope.mode === 'range' && scope.year && scope.quarter) return `Q${scope.quarter} ${scope.year}`;
  if (scope.mode === 'range' && scope.year && scope.month != null) return `${MONTH_SHORT[scope.month]} ${scope.year}`;
  if (scope.mode === 'range' && scope.year) return `Year ${scope.year}`;
  if (scope.mode === 'range') return scope.from && scope.to ? `${shortDate(scope.from)} - ${shortDate(scope.to)}` : 'Date range';
  if (scope.mode === 'before') return scope.from ? `Before ${shortDate(scope.from)}` : 'Before date';
  return scope.from ? `After ${shortDate(scope.from)}` : 'After date';
}

function matchesDateScope(message: WsMessage, scope: DateScope) {
  const messageDate = parseMessageDate(message);
  if (!messageDate) {
    if (scope.kind === 'preset' && scope.value === 'Today') return message.dateBucket === 'Today';
    if (scope.kind === 'preset' && scope.value === 'Yesterday') return message.dateBucket === 'Yesterday';
    if (scope.kind === 'preset') return message.dateBucket === 'Today' || message.dateBucket === 'Yesterday';
    return true;
  }

  const day = startOfLocalDay(messageDate);

  if (scope.kind === 'custom') {
    const from = parseInputDate(scope.from);
    const to = parseInputDate(scope.to);
    if (scope.mode === 'date') return from ? day.getTime() === startOfLocalDay(from).getTime() : true;   // v12.10.14 (#1605)
    if (scope.mode === 'before') return from ? day <= endOfLocalDay(from) : true;
    if (scope.mode === 'after') return from ? day >= startOfLocalDay(from) : true;
    if (from && to) return day >= startOfLocalDay(from) && day <= endOfLocalDay(to);
    if (from) return day >= startOfLocalDay(from);
    if (to) return day <= endOfLocalDay(to);
    return true;
  }

  const today = startOfLocalDay(new Date());
  if (scope.value === 'Today') return day.getTime() === today.getTime();
  if (scope.value === 'Yesterday') { const y = new Date(today); y.setDate(y.getDate() - 1); return day.getTime() === y.getTime(); }   // v12.10.13 (#1566)
  const days = scope.value === 'Last 30 days' ? 30 : scope.value === 'Last 15 days' ? 15 : 7;
  const start = new Date(today);
  start.setDate(start.getDate() - (days - 1));
  return day >= start && day <= endOfLocalDay(today);
}

const MONTH_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function shortDate(value: string) {
  const parsed = parseInputDate(value);
  if (!parsed) return value;
  return parsed.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

function parseInputDate(value?: string) {
  if (!value) return null;
  const [year, month, day] = value.split('-').map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

function parseMessageDate(message: WsMessage) {
  if (!message.startedAt) return null;
  const parsed = new Date(message.startedAt);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function startOfLocalDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function endOfLocalDay(date: Date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}

function isDefaultDateScope(scope: DateScope) {
  return scope.kind === 'preset' && scope.value === 'Last 7 days';
}

function hasNonDateFilters(filters: Filters) {
  return Boolean(
    filters.query.trim()
    || filters.status !== 'all'
    || filters.priority !== 'all'
    || filters.callerType !== 'all'
    || filters.language !== 'all'
    || filters.category !== 'all'
    || filters.label !== 'all'
    || (filters.type ?? 'all') !== 'all' || (filters.opened ?? 'all') !== 'all'   // v12.10.13 (#1561)
    || (filters.notes ?? 'all') !== 'all' || (filters.outcome ?? 'all') !== 'all'
    || (filters.audit ?? 'all') !== 'all'   // v12.10.18 (#1865)
    || filters.dueOnly
    || (filters.modes ?? []).length > 0   // v12.10.12 (#1530)
    || (filters.assigned ?? []).length > 0   // v12.10.10 (#1399)
  );
}

// ══ v12.10.30 (#2242 part 2, Tushar 11/3 ~5:30 PM: "the filters should run on the server if all the data is not loaded for a defiend date
// range. search should work first on loaded data and then backend call to server if no data found."). A big range (more calls than the
// list loads) sends its filters to GET messages / messages/counts as ONE JSON parameter `f` (MessageListFilter on the server) and the
// list + counters are filtered in SQL. The screen still runs messageMatchesFilters over every row it gets - the server narrows the rows,
// the exact rule stays here. ══
/** The filters the server can apply - every non-date filter except the search box (the search goes to the server only when the loaded
 *  cards hold no match - serverQ). */
function hasServerFilters(filters: Filters): boolean {
  return hasNonDateFilters({ ...filters, query: '' });
}
/** v12.10.30 (#2242): taxonomy/isUnclassifiedValue's retired fallbacks - a category stored as one of these (and resolving to no item) is Unclassified. */
const RETIRED_CATEGORY_VALUES = ['', 'general', 'uncategorized', 'unclassified', 'request'];
const normRaw = (v: string | null | undefined) => (v ?? '').trim().toLowerCase();
/** v12.10.30 (#2242): the stored values resolveTaxonomy turns into THIS item - its key, name and aliases, each only when the resolver really
 *  lands on this item (another item's key wins over this item's name), so the server matches exactly what callerTypeMatches / categoryMatches do. */
function rawsResolvingTo(list: PracticeItem[], item: PracticeItem): string[] {
  const cands = [item.key, item.name, ...(item.aliases ?? [])].map(normRaw).filter(Boolean);
  return Array.from(new Set(cands.filter((c) => resolveTaxonomy(list, c)?.key === item.key)));
}
/** v12.10.30 (#2242): every stored value that resolves to SOME item - Unclassified = none of these. */
function rawsResolvingAny(list: PracticeItem[]): string[] {
  return Array.from(new Set(list.flatMap((x) => [x.key, x.name, ...(x.aliases ?? [])]).map(normRaw).filter(Boolean)));
}
/** v12.10.30 (#2242): the `f` parameter for these filters ('' = nothing for the server to filter). The same filters always give the same
 *  string - it is part of the list's restart key. */
function serverFilterParam(filters: Filters, meId: number | null, q: string | null): string {
  if (!hasServerFilters(filters) && !(q && q.trim().length >= 2)) return '';
  const f: Record<string, unknown> = {};
  if (filters.status !== 'all') f.st = filters.status === 'prog' || filters.status === 'new' ? 'open' : filters.status;   // #1497 Pending = new + prog
  if (filters.priority !== 'all') f.pr = filters.priority;
  const ct = fvals(filters.callerType);
  if (ct.length) {
    const vals: string[] = [];
    ct.forEach((v) => {
      if (v.toLowerCase() === UNCLASSIFIED_KEY) { f.ctu = true; return; }
      const item = resolveTaxonomy(displayCallerTypes, v);
      vals.push(...(item ? rawsResolvingTo(displayCallerTypes, item) : [v.toLowerCase()]));
    });
    if (vals.length) f.ct = Array.from(new Set(vals));
    if (f.ctu) f.ctx = rawsResolvingAny(displayCallerTypes);
  }
  const cat = fvals(filters.category);
  if (cat.length) {
    const vals: string[] = [];
    cat.forEach((v) => {
      if (v.toLowerCase() === UNCLASSIFIED_KEY) { vals.push(...RETIRED_CATEGORY_VALUES.filter((r) => !resolveTaxonomy(displayCategories, r))); return; }
      const item = resolveTaxonomy(displayCategories, v);
      vals.push(...(item ? rawsResolvingTo(displayCategories, item) : [v.toLowerCase()]));
    });
    f.cat = Array.from(new Set(vals));
  }
  const lang = fvals(filters.language).map((l) => (l.length <= 3 ? l.toLowerCase() : langCodeOfName(l)));
  if (lang.length) f.lang = lang;
  const lbl = fvals(filters.label);
  if (lbl.length) f.lbl = lbl;
  const ty = fvals(filters.type);
  if (ty.length) f.ty = ty;
  if ((filters.opened ?? 'all') !== 'all') f.op = filters.opened;
  if ((filters.notes ?? 'all') !== 'all') f.nt = filters.notes;
  if ((filters.audit ?? 'all') !== 'all') f.aud = filters.audit;
  const oc = fvals(filters.outcome);
  if (oc.length) f.oc = oc;
  if (filters.dueOnly) f.due = todayIso();   // the screen's today - isDue compares the reminder date with it
  if ((filters.assigned ?? []).length) f.asg = filters.assigned;
  if ((filters.modes ?? []).length) f.md = filters.modes;
  if (q && q.trim().length >= 2) f.q = q.trim();
  if (Object.keys(f).length === 0) return '';
  if (meId != null) f.me = meId;
  return JSON.stringify(f);
}

/** v12.10.10 (#1399): Assigned to - Me, Unassigned and/or people; any one match keeps the message. */
function matchesAssigned(message: WsMessage, assigned: string[] | undefined): boolean {
  const picks = assigned ?? [];
  if (picks.length === 0) return true;
  const uid = message.assignedToUserId ?? null;
  if (picks.includes('none') && !uid && !message.assignedTo) return true;
  if (picks.includes('me') && uid !== null && uid === assignMeId) return true;
  return uid !== null && picks.includes(String(uid));
}

function messageMatchesFilters(message: WsMessage, filters: Filters, options: { includeDoneWhenAll?: boolean; requireOpen?: boolean } = {}) {
  // v12.10.12 (#1529): Messages always stays inside the selected dates - Me / Reminders / Urgent included. The Follow-ups
  // view has no date (#1527 stays).
  if (!filters.fuView && !filters.allDates && !matchesDateScope(message, filters.dateScope)) return false;   // v12.10.19 (#1926)
  if (options.requireOpen && message.status === 'done') return false;
  // v12.10.12 (#1530 S55): the picked pills combine - every one must match (open calls only).
  if ((filters.modes ?? []).length && !modesMatch(message, filters.modes)) return false;
  if (filters.fuView) {
    if (message.status === 'done' || !message.reminder) return false;
    const pills = filters.fuPills && filters.fuPills.length ? filters.fuPills : ['today'];
    if (!pills.includes('all') && !pills.includes(fuBucket(message.reminderDue))) return false;
  }
  // E1: Status = All includes done in the LIST. (Callers that want the "to work" COUNT pass
  // requireOpen / filter status !== 'done' themselves; the list render no longer suppresses done.)
  // v12.10.11.2 (#1497): Pending (prog, or a saved 'new') matches both new and in-progress messages.
  if (filters.status !== 'all') {
    const pend = filters.status === 'prog' || filters.status === 'new';
    if (pend ? !(message.status === 'new' || message.status === 'prog') : message.status !== filters.status) return false;
  }
  if (filters.priority !== 'all' && message.priority !== filters.priority) return false;
  // v12.10.13 (#1561): Caller / Category / Language come from the practice; Type / Opened / Notes / Outcome are new.
  // v12.10.14 (#1607): any of the picked values inside a group
  if (filters.callerType !== 'all' && !fvals(filters.callerType).some((v) => callerTypeMatches(message, v))) return false;
  if (filters.language !== 'all' && !fvals(filters.language).some((l) => langCodeOfName(message.language) === (l.length <= 3 ? l.toLowerCase() : langCodeOfName(l)))) return false;
  if (filters.category !== 'all' && !fvals(filters.category).some((v) => categoryMatches(message, v))) return false;
  if (filters.label !== 'all' && !fvals(filters.label).some((l) => message.labels.includes(l))) return false;
  if ((filters.type ?? 'all') !== 'all' && !fvals(filters.type).some((v) => (message.kind === 'text' ? textStateMatches(message, v) : typeMatches(message.channel, v)))) return false;   // v12.10.27 (#2146)
  if (filters.opened === 'unread' && message.status !== 'new') return false;
  if (filters.opened === 'read' && message.status === 'new') return false;
  if (filters.notes === 'with' && message.notes.length === 0) return false;
  if (filters.notes === 'without' && message.notes.length > 0) return false;
  if (filters.audit === 'marked' && !message.auditMarkedAt) return false;   // v12.10.18 (#1865)
  if (filters.audit === 'not' && message.auditMarkedAt) return false;
  if ((filters.outcome ?? 'all') !== 'all' && !fvals(filters.outcome).includes(outcomeById[message.id])) return false;
  if (filters.dueOnly && !isDue(message)) return false;   // v12.10.11.3 (#1527): due = today or overdue
  if (!matchesAssigned(message, filters.assigned)) return false;   // v12.10.10 (#1399)
  const query = filters.query.trim().toLowerCase();
  if (query) {
    const haystack = `${message.name} ${message.phone} ${message.summary} ${message.aiSummary} ${message.category} ${message.labels.join(' ')}`.toLowerCase();
    // v12.3.14 (#369): SPEC_confirmation_number_v1_0.md §6.1 - "queue search must match on it. With or without
    // the #, and on a partial trailing match (0001). This is the main reason the feature exists" - a caller
    // quoting the number back is the primary use case, and a reference that only exists in one drawer is not a
    // reference. Matched on the digits alone so #260901-0001, 260901-0001, 2609010001 and 0001 all find it.
    if (haystack.includes(query)) return true;
    if (matchesReference(message.referenceNo, query)) return true;
    return false;
  }
  return true;
}

/** v12.3.14 (#369): clipboard blocked - select the chip's text so Ctrl+C still works (SPEC §3.3, §3.5). */
function selectReferenceText(): void {
  const el = document.querySelector('.aw-ref-text');
  if (!el) return;
  const range = document.createRange();
  range.selectNodeContents(el);
  const sel = window.getSelection();
  sel?.removeAllRanges();
  sel?.addRange(range);
}

/**
 * v12.3.14 (#369): reference matching - digits only, so punctuation and the '#' never decide a search.
 *
 * v12.4.2: a caller is now told only the LAST SIX ("36-0025"), so that is what they read back down the phone
 * and that is what staff type. A plain includes() still finds it - Tushar checked, "i just checked by
 * searching 02-0025 and that worked" - and it keeps working for the old ten-digit references, which are not
 * being migrated because no tenant was live.
 *
 * The SUFFIX check is what makes a six-digit search precise rather than merely successful: includes() would
 * also match those digits appearing anywhere inside a longer reference, and after a year of history that is a
 * lot of rows for one query. Ordering is handled by the caller - newest first - so the current week's call is
 * the top row rather than one of many.
 */
/**
 * v12.9.14 (#833): the comparable form of a reference, or of what someone typed.
 *
 * Mirrors ReferenceNumbers.SearchKey on the server. "2026390073", "39-0073", "39-73", "0073" and "73" all
 * reduce to something that matches, because the caller writes down what they HEARD and the agent now says
 * the padding-stripped form.
 *
 * SUBSTRING MATCHING DOES NOT SAVE US, which is the part that would have been missed: "39-0073".includes(
 * "39-73") is FALSE. Both sides have to be normalised before comparing.
 */
function referenceSearchKey(value: string | null | undefined): string {
  const raw = (value ?? '').trim();
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  // The stored 10-digit form: YEAR 0..3 | WEEK 4..5 | SEQUENCE 6..9 (the same offsets as formatReference -
  // they must match, and getting them wrong once already returned "00-25" on the server).
  if (digits.length === 10 && digits.startsWith('20')) {
    return digits.slice(4, 6) + (digits.slice(6).replace(/^0+/, '') || '0');
  }
  if (raw.includes('-')) {
    const [head, tail] = raw.split('-', 2);
    return head.replace(/\D/g, '') + ((tail ?? '').replace(/\D/g, '').replace(/^0+/, '') || '0');
  }
  return digits.replace(/^0+/, '') || digits;
}

function matchesReference(referenceNo: string | null | undefined, query: string): boolean {
  const ref = (referenceNo ?? '').replace(/\D/g, '');
  if (!ref) return false;
  const q = query.replace(/\D/g, '');
  if (!q) return false;
  if (q.length >= 4 && ref.endsWith(q)) return true;   // v12.4.2: what the caller was actually told
  if (ref.includes(q)) return true;
  // v12.9.14 (#833): and the form the caller HEARD - "39-73" for 39-0073. A caller who writes down what
  // they were told used to type it into nothing, and staff would conclude the reference was wrong.
  const rk = referenceSearchKey(referenceNo);
  const qk = referenceSearchKey(query);
  return rk.length > 0 && qk.length > 0 && (rk === qk || rk.endsWith(qk));
}

/**
 * v12.3.14 (#369): the canonical displayed form, #YYMMDD-NNNN.
 *
 * SPEC §5: the format was inconsistent - the header rendered 260901-0001 while other references showed
 * #26901-0001, differing by a digit. There is one function now and everything calls it. Nothing is STORED with
 * a '#' or a dash: ReferenceNumbers.Grouped() on the server returns 260901-0043 and the database holds
 * 2609010043. The '#' is display only, and it is part of what gets copied - it is what makes the string read as
 * a reference rather than a quantity, and it is what a caller says out loud.
 */
// v12.4.13 (#469): WHICH ELEMENT ACTUALLY SCROLLS. Desktop: `.tenant-main .aw-main` (height:100dvh, overflow-y
// auto). Below 980px that override lifts and `.tenant-main` becomes the scrollport (`.tenant-main:has(.aw-app)
// {overflow:auto}`) while `.aw-main` and `.aw-app` go visible - and the window does not scroll at all. A scroll
// event does not bubble, so listening on the wrong element means hearing nothing, which is exactly what happened
// on his phone. Walk up from the header and take the first ancestor that both declares a scrolling overflow and
// has something to scroll; null means the window.
// v12.4.16 (#469): the sentence above - "the window does not scroll at all" - was measured at window.scrollY 0
// and is wrong at the one scroll position the bug lives at. The window DID scroll, by the height of the tenant
// mobile topbar, because `.tenant-app` is a 100vh grid holding a 56px row plus a 100dvh row. This resolver is
// still right (it returns `.tenant-main`, which owns the list's scroll); what was missing is that the element it
// returns is itself moving. agent-workspace.css v12.4.16 takes that second movement away rather than teaching
// every reader of scrollTopOf() to add window.scrollY - a reader that forgets would reintroduce this exactly.
export function resolveQueueScroller(from: HTMLElement | null): HTMLElement | null {
  let el: HTMLElement | null = from?.parentElement ?? null;
  while (el && el !== document.body) {
    const overflowY = getComputedStyle(el).overflowY;
    if ((overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay') && el.scrollHeight > el.clientHeight + 4) return el;
    el = el.parentElement;
  }
  return null;
}
export function scrollTopOf(el: HTMLElement | null): number {
  return el ? el.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0);
}

// v12.10.17 (#1773): formatReference moved to lib/reference.ts (shared with Contacts) - re-exported here for existing importers.
export { formatReference };

function emptyStateCopy(hasAnyMessages: boolean, filters: Filters) {
  if (!hasAnyMessages) {
    return {
      heading: 'No messages yet',
      body: 'Calls and texts will appear here once they start coming in.',
    };
  }
  // v12.10.13 (#1556): the Follow-ups view says what its pills ask for - never "No messages in this date range".
  if (filters.fuView) {
    const pills = filters.fuPills && filters.fuPills.length ? filters.fuPills : ['today'];
    const one = pills.length === 1 ? pills[0] : null;
    const label = one ? (fuPillDefs().find((p) => p.key === one)?.label ?? '') : '';
    const heading = !one || one === 'all' ? 'No follow-ups due'
      : one === 'overdue' ? 'Nothing overdue'
      : one === 'today' || one === 'tomorrow' ? `No follow-ups due ${label.toLowerCase()}`
      : one === 'nextweek' ? 'No follow-ups due next week'
      : one === 'later' ? 'No follow-ups due later'
      : `No follow-ups due on ${label}`;
    return { heading, body: hasNonDateFilters(filters) ? 'Nothing matches your filters - try clearing them.' : 'You are caught up.' };
  }
  if (filters.dueOnly) {
    return {
      heading: 'No follow-ups due',
      body: 'You are caught up for the selected date range.',
    };
  }
  if (hasNonDateFilters(filters)) {
    return {
      heading: 'No messages match your filters',
      body: 'Try clearing or adjusting your filters to see more.',
    };
  }
  return {
    heading: filters.dateScope.kind === 'preset' && filters.dateScope.value === 'Today' ? 'No messages today' : 'No messages in this date range',
    body: 'Try widening the date range to see earlier activity.',
  };
}

function isTypingTarget(target: EventTarget | null) {
  const element = target as HTMLElement | null;
  if (!element) return false;
  return ['INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName) || element.isContentEditable;
}

function formatDuration(seconds?: number) {
  if (!seconds) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const remaining = seconds % 60;
  return `${minutes}:${remaining.toString().padStart(2, '0')}`;
}

function emptyQueues(): WsQueues {
  return { call: [], text: [] };
}

function normalizeKind(value: string): MessageKind {
  return value?.toLowerCase() === 'text' ? 'text' : 'call';
}

function normalizeChannel(value: string): Channel {
  const normalized = value?.toLowerCase();
  if (normalized === 'text') return 'text';
  if (normalized === 'missed') return 'missed';
  if (normalized === 'live') return 'live';
  return 'voicemail';
}

// v12.10.17 (#1723 D2, BDR-018): a blank caller type is no longer turned into Patient - it is Unclassified. The avatar and
// filters use callerTypeRaw through lib/taxonomy; this coarse value only survives for old code paths.
function normalizeCallerType(value: string): CallerType {
  const normalized = value?.toLowerCase();
  if (normalized === 'pharmacy') return 'Pharmacy';
  if (normalized === 'physician') return 'Physician';
  if (normalized === 'patient') return 'Patient';
  return 'Unclassified';
}

function normalizeStatus(value: string): MsgStatus {
  const normalized = value?.toLowerCase();
  if (normalized === 'done' || normalized === 'complete') return 'done';
  if (normalized === 'prog' || normalized === 'progress' || normalized === 'in progress') return 'prog';
  return 'new';
}

function normalizePriority(value: string): Priority {
  return value?.toLowerCase() === 'urgent' ? 'urgent' : 'normal';
}

// v12.9.23 (#846): the banner names the language in words - "Translated from Spanish", not "from ES".
function languageName(code: string): string {
  const k = (code || '').toLowerCase().split('-')[0];
  if (k === 'und') return 'another language';   // v12.9.26 (#931): an untagged turn from a call before 12.9.24
  return ({ en: 'English', es: 'Spanish', fr: 'French', de: 'German', hi: 'Hindi', gu: 'Gujarati', zh: 'Chinese', ar: 'Arabic' } as Record<string, string>)[k] ?? k.toUpperCase();
}

function normalizeLanguage(value: string): Language {
  const normalized = value?.toLowerCase();
  if (normalized === 'spanish' || normalized === 'es') return 'Spanish';
  if (normalized === 'french' || normalized === 'fr') return 'French';
  if (normalized === 'german' || normalized === 'de') return 'German';
  return 'English';
}

function normalizeCategory(value: string): Category {
  const normalized = value?.toLowerCase();
  if (normalized?.includes('rx') || normalized?.includes('refill')) return 'Rx Refill';
  // B2: Reschedule is displayed as Appointment (derived client-side, not from the DB).
  if (normalized?.includes('appoint') || normalized?.includes('resched')) return 'Appointment';
  if (normalized?.includes('pharmacy')) return 'Pharmacy';
  if (normalized?.includes('refer')) return 'Referral';
  return 'General';
}

function dateBucket(startedAt: string): DateBucket {
  const started = new Date(startedAt);
  if (Number.isNaN(started.getTime())) return 'Older';
  const today = new Date();
  const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const startOfYesterday = new Date(startOfToday);
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  if (started >= startOfToday) return 'Today';
  if (started >= startOfYesterday) return 'Yesterday';
  return 'Older';
}

// v12.10.11.1 (#1494): notes newest first. A note's `at` is an ISO time (or 'Just now' / 'Captured' for the
// optimistic copy and old rows); unparseable ones keep their place relative to the array (later = newer).
function noteTime(at: string | undefined): number {
  const t = Date.parse(at ?? '');
  return Number.isNaN(t) ? Number.POSITIVE_INFINITY : t;
}
function orderNotes<T extends { at?: string }>(notes: T[]): T[] {
  return notes.map((n, i) => ({ n, i })).sort((a, b) => {
    const ta = noteTime(a.n.at), tb = noteTime(b.n.at);
    if (ta !== tb) return tb - ta;
    return b.i - a.i;
  }).map((x) => ({ ...x.n }));
}
/** v12.10.11.1 (#1494): "Oct 9, 12:50 AM" - never the raw ISO string. */
export function formatNoteTime(at: string | undefined): string {
  const d = new Date(at ?? '');
  if (!at || Number.isNaN(d.getTime())) return at ?? '';
  const date = d.toLocaleDateString([], { month: 'short', day: 'numeric' });
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return `${date}, ${time}`;
}

function formatMessageTime(startedAt: string) {
  const started = new Date(startedAt);
  if (Number.isNaN(started.getTime())) return '';
  return started.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
}

// v12.2.38.0 (#221): full date + time for the call detail header, e.g. "Tuesday, Aug 20, 2026 · 11:14 AM",
// so the placed-on date is visible when a card is open (the list card time alone hid the date).

/** v12.10.10 (#1399 header V2): short date + time - "Tue, Oct 6, 2026 · 11:47 AM". */
function formatShortDetailDate(startedAt: string | undefined): string {
  if (!startedAt) return '';
  const d = new Date(startedAt);
  if (Number.isNaN(d.getTime())) return '';
  const date = d.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' });
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return `${date} · ${time}`;
}

/** v12.10.10 (#1402): the API's "nothing captured" fallbacks - a missed call with nothing said reads differently. */
function isEmptySummary(text: string | null | undefined): boolean {
  const t = (text ?? '').trim();
  return !t || /^No (AI |call )?summary captured yet\.?$/i.test(t);
}

// B7 - three-tier time from the message's real startedAt timestamp.
const CARD_DAY_MS = 86_400_000;
function formatCardTime(startedAt: string | undefined): string {
  if (!startedAt) return '';
  const d = new Date(startedAt);
  if (Number.isNaN(d.getTime())) return '';
  const now = new Date();
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (d >= startOfToday) {
    const mins = Math.max(0, Math.floor((now.getTime() - d.getTime()) / 60000));
    if (mins < 1) return 'just now';
    if (mins < 60) return `${mins} min${mins === 1 ? '' : 's'} ago`;
    return `${Math.floor(mins / 60)}h ago`;
  }
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (now.getTime() - d.getTime() < 7 * CARD_DAY_MS) {
    // <= 7 days: weekday + short date + time, NO year (e.g. "Wed · Jul 1 · 7:41 AM").
    const weekday = d.toLocaleDateString([], { weekday: 'short' });
    const date = d.toLocaleDateString([], { month: 'short', day: 'numeric' });
    return `${weekday} · ${date} · ${time}`;
  }
  // older: short date + year + time (e.g. "Jun 19, 2026 · 6:34 PM").
  const dated = d.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
  return `${dated} · ${time}`;
}

// v12.10.17 (#1723 D5): the fixed CATEGORY_META chip classes retired - every pill is the workflow card's own colour + icon.
/** v12.10.14 (#1613): the practice's own category (Settings › Personalization) for a message - its name, colour and icon. */
function practiceCategoryOf(message: WsMessage): PracticeItem | undefined {
  return resolveTaxonomy(displayCategories, message.categoryRaw);   // v12.10.17 (#1723 D12): key first, then name, then alias
}
/** v12.10.17 (#1723 D5 D6): the pill / drawer facts - the workflow card (or Unclassified) and "card · request type". */
/** v12.10.22 (#2011): "Workflow › Intent" for a call whose intent files under ANOTHER intent's category; null otherwise. */
function intentPathOf(message: WsMessage): string | null {
  const ik = (message.intentKey || '').trim().toLowerCase();
  if (!ik || ik === (message.categoryRaw || '').trim().toLowerCase()) return null;
  for (const c of displayCategories) {
    const at = (c.usedByKeys ?? []).findIndex((k) => k.toLowerCase() === ik);
    if (at >= 0) return c.usedBy?.[at] ?? null;
  }
  return null;
}
function requestOf(message: WsMessage): { name: string; color: string; icon: string; unclassified: boolean; words: string } {
  const cat = categoryDisplay(displayCategories, message.categoryRaw);
  return { ...cat, words: requestWords(cat, requestTypeOf(message.capturedFields)) };
}
/** v12.10.17 (#1723 D3): the card's middle line - what happened / what the caller wants, in words. A record from before
 *  12.10.17 whose Wants row is the bare "Request" falls back to the summary paragraph. */
/** v12.10.17.1 (#1794, Tushar 10/16 S14 + S19): ONE face for a card and its drawer header. A group's newest call can be an
 *  empty voicemail (#42-0801) - its blank caller type turned the whole group grey "Unclassified" and its missing name put the
 *  bare phone in the drawer while the card named the caller from another call. Now: the name = this call's, else the newest
 *  call in the group that captured one, else the contact book's (the linked contact, or the one named contact on the phone);
 *  the caller type and the request = this call's, else the newest call in the group that has one. A single call keeps its own
 *  face except for the contact book's name. */
function faceOf(v: WsMessage, grp?: WsMessage[] | null): WsMessage {
  let f = v;
  const others = (grp ?? []).filter((x) => x.id !== v.id);
  if (!f.hasName) {
    const named = others.find((x) => x.hasName);
    if (named) f = { ...f, name: named.name, hasName: true };
    else {
      const cn = f.contactName || others.find((x) => x.contactName)?.contactName;
      if (cn) f = { ...f, name: cn, hasName: true, nameFromContact: true };
    }
  }
  if (!(f.callerTypeRaw || '').trim()) {
    const typed = others.find((x) => (x.callerTypeRaw || '').trim());
    if (typed) f = { ...f, callerTypeRaw: typed.callerTypeRaw, callerType: typed.callerType };
  }
  if (!(f.categoryRaw || '').trim()) {
    const cat = others.find((x) => (x.categoryRaw || '').trim());
    if (cat) f = { ...f, categoryRaw: cat.categoryRaw, category: cat.category, capturedFields: (f.capturedFields?.length ? f.capturedFields : cat.capturedFields) };
  }
  return f;
}

function middleLine(message: WsMessage): string {
  const w = withoutRequestPhrase(message, (message.summaryRows?.en?.wants ?? '').trim());
  if (w && !/^(request|solicitud)$/i.test(w)) return w;
  if (message.channel === 'missed' && message.hungUp && isEmptySummary(message.aiSummary)) return HUNG_UP_LINE;   // v12.10.21 (#1953)
  if (message.channel === 'missed' && isEmptySummary(message.aiSummary)) return 'Missed call - no voicemail';
  return message.aiSummary;
}

/** v12.10.17.1 (#1792, Tushar 10/16 S11: "drop the fixed phrase as the third line already shows that"): the card's middle line
 *  leads with what the CALLER gave (date and time, reason, medication, what they added) - the fixed request words the summary
 *  starts with ("Schedule an appointment", "Change an appointment", the card's own name) are already on the pill below. They
 *  were also wrong when the call ended before the type was heard (#42-0803 Change -> "Schedule"). Nothing left -> the AI
 *  summary. Card only - the drawer's What the caller needs row is unchanged. An Unclassified call keeps its words ("Hung up
 *  before saying what they need"). */
const FIXED_REQUEST_PHRASES = ['schedule an appointment', 'change an appointment', 'cancel an appointment',
  'programar una cita', 'cambiar una cita', 'cancelar una cita'];
function withoutRequestPhrase(message: WsMessage, wants: string): string {
  if (!wants) return wants;
  const rq = requestOf(message);
  if (rq.unclassified) return wants;
  const parts = wants.split(' \u00b7 ');
  const head = parts[0].trim().toLowerCase();
  const isRequestWords = FIXED_REQUEST_PHRASES.includes(head) || head === rq.name.trim().toLowerCase() || head === rq.words.trim().toLowerCase();
  if (!isRequestWords) return wants;
  return parts.slice(1).join(' \u00b7 ').trim();
}

// D: leading colored dot from the tenant-configured label color (fallback muted grey).
const LABEL_DOT_FALLBACK = '#94a3b8';
function labelDotColor(label: string, colors: Record<string, string>): string {
  return colors[label] || LABEL_DOT_FALLBACK;
}

// v12.4.10 (#453/#462): how often the queue re-reads itself.
//
// THIS CONSTANT IS A STAND-IN AND IT HAS AN EXPIRY DATE. A poll is not the right answer - an open
// connection is, and #462 is deferred to the server move (#292) because it needs the WebSocket
// Protocol feature enabled in IIS, which belongs to a server change and not to a patch build.
//
// WHEN #462 SHIPS, DELETE THIS CONSTANT AND THE HEARTBEAT BELOW. Do not leave a poll running behind a
// live connection "as a fallback" - that is two mechanisms for one concept, which is the fault the
// whole of 12.4.9 was spent removing (#455, #456, #458).
//
// Tushar considered exposing this as a tenant setting in the session section and decided against it,
// 2026-09-04, for the right reason: a knob that a live connection makes meaningless is a knob you have
// to migrate away later. Hardcoded and deleted beats configurable and orphaned.
//
// 10s, not 30: the tab-hidden pause below already stops this running against a screen nobody is
// watching, so there is no need for a second, slower tier for the unfocused case - hidden is paused,
// visible is 10 seconds. Worst-case unseen window is 10s, and the "+N new" chip covers the rest.
const REFRESH_MS = 60000;   // v12.10.25 (#2104): default 60 s (was 30; v12.10.16.1 #1702 was 10)

// ══ v12.10.16 (T104 #1688): MESSAGES SHOWS AT ONCE. ══════════════════════════════════════════════════════════════
// Tushar 10/13: "whenever now i go to messages it keeps on saying [Loading messages] ... this i have never seen before".
// (1) The last list this tab loaded is kept IN MEMORY (never in browser storage - it is PHI) and shown the moment
// Messages opens again, while a background refresh brings it up to date. It is keyed to the signed-in token and the
// date window, so another sign-in or other dates never see it. (2) A first open with nothing kept asks for the newest
// FIRST_PAGE cards (?take=), paints them, and asks for the rest straight away; filters keep working on the whole list.
const FIRST_PAGE = 50;
// v12.10.20 (#1934): the rest of the dates comes in chunks of this size, newest first, then the open calls outside the dates.
const FILL_CHUNK = 2000;
// ══ v12.10.30 (#2242, LOCKED 11/3): A LONG RANGE IS NEVER LOADED WHOLE. The first 50, then the list fills to FILL_CAP calls; past that the
// next MORE_CHUNK come when the end of the list is scrolled near (no button). The counters always come from the server for such a list.
// UAT1 2 years (788k calls) loaded whole was ~2 GB and froze the page; 1,000 calls is about the 7-day memory level (50-100 MB). ══
const FILL_CAP = 1000;
const MORE_CHUNK = 500;
// v12.10.20 (#1935): cards drawn at first and added each time the end of the drawn cards comes near the screen.
const RENDER_STEP = 120;
interface ListCache { token: string | null; windowFrom: string; queues: WsQueues; labels: { name: string; color: string }[]; truncated: boolean; groupRule?: GroupRule | null }
let listCache: ListCache | null = null;
function currentToken(): string | null {
  try { return localStorage.getItem('vs_t2_token'); } catch { return null; }
}
function cachedList(windowFrom?: string): ListCache | null {
  const c = listCache;
  if (!c || c.token !== currentToken()) return null;
  return windowFrom === undefined || c.windowFrom === windowFrom ? c : null;
}

// I1: note template chips (click fills / appends the textarea).
const NOTE_TEMPLATES: { label: string; text: string }[] = [
  { label: 'Called back', text: 'Called back.' },
  { label: 'Left voicemail', text: 'Left voicemail.' },
  { label: 'Appt scheduled', text: 'Appointment scheduled.' },
  { label: 'Refill approved', text: 'Refill approved.' },
  { label: 'Spoke w/ pharmacy', text: 'Spoke with pharmacy.' },
];

// I2: reminder preset chips.
const REMINDER_PRESETS: { label: string; value: string }[] = [
  { label: 'Today', value: 'Today' },   // v12.10.15 (#1650, LOCKED): due today, so it shows under Follow-ups › Today
  { label: '1d', value: 'In 1 day' },
  { label: '2d', value: 'In 2 days' },
  { label: '3d', value: 'In 3 days' },
  { label: '4d', value: 'In 4 days' },
  { label: '1w', value: 'In 1 week' },
  { label: '2w', value: 'In 2 weeks' },
];

function reminderDateLabel(value: string): string {
  const parsed = parseInputDate(value);
  if (!parsed) return value;
  return parsed.toLocaleDateString([], { month: 'short', day: 'numeric', year: 'numeric' });
}

// v12.10.15 (#1648, UI-PROTO-SETTLED-TOPICS-B1 v1.2 LOCKED): one line per action, "Maria L. · Pending → Completed".
const ACT_TIME = (iso: string) => { const d = new Date(iso); return Number.isNaN(d.getTime()) ? '' : d.toLocaleString([], { month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }); };
const READ_BY_WORDS: Record<string, string> = { play: 'played the recording', print: 'printed', save: 'saved a copy', copy: 'copied the call record', assign: 'assigned it', call: 'called back' };
function activityWords(a: ApiActivityRow): string {
  const ft = (x?: string | null) => (x && x.trim() ? x : 'none');
  switch (a.action) {
    case 'read': { const how = /\((.+)\)/.exec(a.to ?? '')?.[1] ?? ''; const w = READ_BY_WORDS[how]; return w ? `${w} → read` : 'read'; }
    case 'status': return a.to === 'New' ? 'marked unread' : `${a.from ?? ''} → ${a.to ?? ''}`;
    case 'urgent': return a.to === 'on' ? 'marked urgent' : 'removed urgent';
    case 'assign': return a.to ? `assigned to ${a.to}` : `unassigned (was ${ft(a.from)})`;
    case 'labels': return `labels: ${ft(a.from)} → ${ft(a.to)}`;
    case 'reminder': return a.to ? `reminder: ${a.to}` : 'removed the reminder';
    case 'chart': return `chart #: ${ft(a.from)} → ${ft(a.to)}`;
    case 'note': return 'added a note';
    case 'text': return 'sent a text';
    case 'print': return 'printed';
    case 'save': return 'saved a copy (PDF / HTML)';
    case 'copy': return 'copied the call record';
    case 'play': return 'played the recording';
    case 'call': return 'called back';
    case 'callback': return `called back ${a.from ?? ''}${a.to ? ` - ${a.to}` : ''}`.trim();   // v12.10.30 (#1156 P1): the browser call back, written when it ended
    case 'audit': return a.to === 'marked' ? 'marked for audit' : 'removed the audit mark';   // v12.10.18 (#1865)
    default: return a.action;
  }
}
/** The newest row of these actions, as a hover line "Completed by Maria L. · 10/13 9:52 AM". */
function lastActivity(rows: ApiActivityRow[] | undefined, actions: string[], lead: (a: ApiActivityRow) => string): string | undefined {
  const a = [...(rows ?? [])].reverse().find((r) => actions.includes(r.action));
  return a ? `${lead(a)} by ${a.by || 'someone'} · ${ACT_TIME(a.at)}` : undefined;
}

const LOG_ONLY = new Set(['print', 'save', 'copy', 'play', 'call']);   // v12.10.15 (#1648): the server's LoggedOnlyActions

function toMessage(row: ApiMessageRow): WsMessage {
  // D: render whatever label strings the message carries (no hardcoded-enum filtering).
  const labels = (row.labels ?? []).filter((label): label is string => Boolean(label));
  const kind = normalizeKind(row.kind);
  return {
    id: row.id,
    callerKey: row.callerKey ?? null,   // v12.10.16 (#1690)
    groupId: row.groupId ?? null,       // v12.10.25 (#2117)
    contactName: row.contactName ?? null,   // v12.10.17.1 (#1794)
    referenceNo: row.referenceNo ?? null,   // v12.3.13 (#356)
    // v12.9.14 (#830 / #822): absent on every call before this release - the engine stored field LABELS
    // only, so there is nothing to backfill. Empty means "no record", not "captured nothing".
    capturedFields: row.capturedFields ?? [],
    kind,
    channel: kind === 'text' ? 'text' : normalizeChannel(row.channel),
    callerType: normalizeCallerType(row.callerType),
    callerTypeRaw: row.callerType || '',   // v12.2.43.0 (#244)
    categoryRaw: row.category || '',       // v12.10.13 (#1561)
    name: row.name || row.phone || 'Unknown caller',
    hasName: capturedName(row.name, row.phone),   // v12.4.11 (#458 REOPENED)
    phone: row.phone || 'Unknown number',
    language: normalizeLanguage(row.language),
    verified: Boolean(row.verified),
    lineType: row.lineType ?? null,        // v12.7.0 (#580 / R1)
    lineCarrier: row.lineCarrier ?? null,
    phone2: row.phone2 ?? null,   // v12.10.19 (#1921 #1922)
    bookingOk: row.bookingOk ?? null,      // v12.7.0 (#582 / R2)
    bookingRef: row.bookingRef ?? null,
    bookingSystem: row.bookingSystem ?? null,   // v12.7.2 (#594)
    notConfirmed: row.notConfirmed ?? null,     // v12.9.25 (#959)
    summaryRows: row.summaryRows ?? null,       // v12.9.26 (#977)
    status: normalizeStatus(row.status),
    priority: normalizePriority(row.priority),
    category: normalizeCategory(row.category),
    labels,
    // v12.4.15 (#476): while the call is running there is NO summary, and the usual fallbacks must not invent one -
    // 'No summary captured yet' on a live call reads as a finished call that said nothing. The card shows the
    // in-progress label in place of the text instead.
    inProgress: Boolean(row.inProgress),
    noRecording: row.recordingCount === 0 && !row.inProgress,
    hungUp: Boolean(row.hungUp),   // v12.10.21 (#1953)
    intentKey: row.intentKey ?? null,   // v12.10.22 (#2011)
    newText: Boolean(row.newText),     // v12.10.26 (#T154 Q16)
    newTextCount: Number(row.newTextCount ?? 0) || 0,   // v12.10.27 (#2146 Q33)
    followUp: Boolean(row.followUp),   // v12.10.26 (#T154 Q16)
    setupTestCall: Boolean(row.setupTestCall),   // v12.10.11.1 (#1461)
    fromVoicemail: Boolean(row.fromVoicemail),   // v12.10.15 (#1666)
    auditMarkedAt: row.auditMarkedAt ?? null,   // v12.10.18 (#1865)
    summary: row.inProgress ? '' : (row.summary || 'No summary captured yet.'),
    aiSummary: row.inProgress ? '' : (row.aiSummary || row.summary || 'No AI summary captured yet.'),
    startedAt: row.startedAt,
    dateBucket: dateBucket(row.startedAt),
    time: formatMessageTime(row.startedAt),
    reminder: row.reminder ?? null,
    reminderDue: row.reminderDue ?? null,   // v12.10.11.3 (#1527)
    assignedTo: row.assignedTo ?? null,
    assignedToUserId: row.assignedToUserId ?? null,   // v12.10.10 (#1399)
    notes: orderNotes(row.notes ?? []),   // v12.10.11.1 (#1494): newest first, whatever order the API sends
    durationSec: row.durationSeconds,
    chartNumber: row.chartNumber ?? undefined,
    transcript: row.transcript ?? [],
  };
}

function SearchableText({ query, message }: { query: string; message: WsMessage }) {
  const text = `${message.name} ${message.phone} ${message.language} ${message.summary} ${message.aiSummary} ${message.category} ${message.labels.join(' ')}`.toLowerCase();
  return <span className="sr-only">{text.includes(query.toLowerCase()) ? 'matches search' : ''}</span>;
}

export default function MessagesPage() {
  const navigate = useNavigate();
  // v12.10.30 (#1155 #1156 #1157): the practice's Call back switch (Support Ops › Features, ships OFF). Off = every Call back control below
  // behaves exactly as before (sets In progress, logs, toast) and nothing new appears.
  const callBackOn = usePracticeFeature('call_back');
  const bphone = usePhone();
  const queryClient = useQueryClient();   // v12.10.11.3 (#1527)
  // v12.10.9.3 (#1331): a phone gets the shorter search hint so nothing is cut mid-word.
  const [narrowSearch, setNarrowSearch] = useState(() => typeof window !== 'undefined' && window.matchMedia?.('(max-width: 480px)').matches);
  useEffect(() => {
    const mq = window.matchMedia?.('(max-width: 480px)');
    if (!mq) return;
    const on = () => setNarrowSearch(mq.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  // v12.10.9.4 (#1358, UI-PROTO-T40 C8 LOCKED): on a phone the compact bar is the ONLY top bar, from the first screen.
  const [isPhone, setIsPhone] = useState(() => typeof window !== 'undefined' && !!window.matchMedia?.('(max-width: 600px)').matches);
  useEffect(() => {
    const mq = window.matchMedia?.('(max-width: 600px)');
    if (!mq) return;
    const on = () => setIsPhone(mq.matches);
    mq.addEventListener?.('change', on);
    return () => mq.removeEventListener?.('change', on);
  }, []);
  const [searchParams, setSearchParams] = useSearchParams();
  const { claims, logout } = useAuth();
  const { me: secMe, hasAccess, canOpen: canOpenArea } = useAccess();   // v12.10.9.1 (#1268); v12.10.9.4 (#1381) one tick per message action
  // v12.10.16 (#1688): the kept list (if any) is on screen from the first paint - no spinner when a list was loaded.
  const [queues, setQueues] = useState<WsQueues>(() => cachedList()?.queues ?? emptyQueues());
  const [availableLabels, setAvailableLabels] = useState<{ name: string; color: string }[]>(() => cachedList()?.labels ?? []);
  const [messagesLoading, setMessagesLoading] = useState(() => !cachedList());
  const [messagesError, setMessagesError] = useState('');
  const [kind, setKind] = useState<MessageKind>('call');
  // v12.10.9.4 (#1380): the filters you set survive a refresh (this tab only); the left menu's Messages / Follow-ups reset them.
  const [filters, setFilters] = useState<Filters>(loadSavedFilters);
  const [draftFilters, setDraftFilters] = useState<Filters>(loadSavedFilters);
  // v12.10.10 (#1399): who a message can be assigned to - loaded once from the API (active practice users).
  const [assignees, setAssignees] = useState<Assignee[]>([]);
  useEffect(() => {
    let off = false;
    api.get<ApiAssignee[]>('/t2/security/assignees')
      .then((rows) => {
        if (off || !Array.isArray(rows)) return;
        setAssignees(rows.map((r) => ({ id: String(r.id), name: r.name, role: (r.groupNames ?? []).join(', '), self: Boolean(r.self), photo: r.photo ?? null })));
      })
      .catch(() => { /* no right to see Messages, or an older API - the menu shows "Assign to me" only */ });
    return () => { off = true; };
  }, []);
  const location = useLocation();
  useEffect(() => {
    try { sessionStorage.setItem(FILTERS_KEY, JSON.stringify(filters)); } catch { /* storage off - filters just won't survive a refresh */ }
    lsSet(DATE_KEY, JSON.stringify(filters.dateScope));   // v12.10.11.3 (#1521): the date choice is remembered on this computer
    // v12.10.11.3 (#1527): the Follow-ups view lights Follow-ups in the left menu too.
    window.dispatchEvent(new CustomEvent(FILTERS_EVENT, { detail: { dueOnly: filters.dueOnly || !!filters.fuView } }));
  }, [filters]);
  // Left menu "Messages" -> navigate('/messages', { state: { menuReset } }): every filter back to its default, even when
  // Messages is already open.
  const menuReset = (location.state as { menuReset?: number } | null)?.menuReset;
  // v12.10.11.3 (#1527): the filters the person had before opening Follow-ups - Messages brings them back.
  const beforeFollowupsRef = useRef<Filters | null>(null);
  useEffect(() => {
    if (!menuReset) return;
    // v12.10.22 (#2002): the router keeps location.state in the browser history, so a REFRESH re-delivered the last menu click and
    // reset every filter (Caller · General Request lost). A menu click is handled once: remembered for this tab, and the state is
    // taken off the history entry.
    try { if (sessionStorage.getItem(MENU_RESET_KEY) === String(menuReset)) return; sessionStorage.setItem(MENU_RESET_KEY, String(menuReset)); } catch { /* storage off */ }
    navigate(location.pathname + location.search, { replace: true, state: null });
    setFilters((current) => {
      // Coming back from Follow-ups: the filters they had (Tushar 10/9: "when i click on messages then it will remeber").
      if (current.fuView && beforeFollowupsRef.current) { const back = beforeFollowupsRef.current; beforeFollowupsRef.current = null; setDraftFilters(back); return back; }
      // Otherwise the defaults - but the remembered date stays (#1521).
      const reset = { ...initialFilters, dateScope: current.dateScope };
      setDraftFilters(reset);
      return reset;
    });
  }, [menuReset]);
  // v12.10.11.3 (#1521): Newest first / Oldest first - remembered per person on this computer.
  const [sortOrder, setSortOrderState] = useState<'newest' | 'oldest'>(() => (lsGet(SORT_KEY) === 'oldest' ? 'oldest' : 'newest'));
  const setSortOrder = (v: 'newest' | 'oldest') => { setSortOrderState(v); lsSet(SORT_KEY, v); };
  // v12.10.11.3 (#1524): the message last opened keeps a solid mark after the drawer closes.
  const [lastOpenedId, setLastOpenedId] = useState<string | null>(null);
  // v12.10.11.3 (#1524): a half-typed note or text asks once before it is thrown away.
  const [pendingSwitch, setPendingSwitch] = useState<{ to: string | null } | null>(null);
  // v12.10.11.3 (#1522): the safety ceiling cut the list - said on screen, never silent.
  const [listTruncated, setListTruncated] = useState(() => cachedList()?.truncated ?? false);
  const [listPartial, setListPartial] = useState(false);   // v12.10.16 (#1688): the first page is showing, the rest is on its way
  // v12.10.26 (#2121): the counters the first page brought (key = the dates they were counted for) - shown while the rest loads.
  const [serverCounts, setServerCounts] = useState<{ key: string; c: ApiWindowCounts } | null>(null);
  const [fillProgress, setFillProgress] = useState<{ loaded: number; total: number } | null>(null);
  // v12.10.30 (#2242): the list holds only part of the dates - `next` = the skip of the next page, `total` = the calls in the dates.
  const [moreLeft, setMoreLeftState] = useState<{ window: string; next: number; total: number; oldest: boolean } | null>(null);
  const moreLeftRef = useRef<{ window: string; next: number; total: number; oldest: boolean } | null>(null);
  const setMoreLeft = (v: { window: string; next: number; total: number; oldest: boolean } | null) => { moreLeftRef.current = v; setMoreLeftState(v); };
  // v12.10.30 (#2242 part 2): the dates hold more calls than the list ever loads (over FILL_CAP - told by an UNFILTERED first page), so
  // filters run on the server. Keyed by the dates (`window` = the ?from= the calls were counted for).
  const [bigRange, setBigRange] = useState<{ window: string; total: number } | null>(null);
  // v12.10.30 (#2242 part 2): the search sent to the server - set only when the loaded cards of a big range hold no match.
  const [serverQ, setServerQ] = useState<string | null>(null);
  const listQsRef = useRef('');   // the `&f=` (+ `&to=`) every list / counts request of a server-filtered list carries; '' = none
  const serverModeRef = useRef(false);
  const loadingMoreRef = useRef(false);
  const [loadingMore, setLoadingMore] = useState(false);   // v12.10.20 (#1934): the yellow bar's count
  const [groupRule, setGroupRule] = useState<GroupRule | null>(() => cachedList()?.groupRule ?? null);   // v12.10.16 (#1690)
  // v12.10.16 (T115 #1693): batch select
  const [batchMode, setBatchMode] = useState(false);
  const [batchSel, setBatchSel] = useState<Set<string>>(() => new Set());
  const [batchStage, setBatchStage] = useState<BatchStage>({});
  const [batchEditing, setBatchEditing] = useState<null | 'note' | 'reminder' | 'labels'>(null);
  const [batchNoteDraft, setBatchNoteDraft] = useState('');
  const [batchLabelDraft, setBatchLabelDraft] = useState<string[]>([]);
  const [batchPickDate, setBatchPickDate] = useState('');
  const [batchConfirm, setBatchConfirm] = useState(false);
  const [batchTyped, setBatchTyped] = useState('');
  const [batchUndo, setBatchUndo] = useState<{ text: string; snapshot: { id: string; status: MsgStatus; priority: WsMessage['priority']; labels: string[]; reminder: string | null; reminderDue: string | null }[] } | null>(null);
  const [filterOpen, setFilterOpen] = useState(false);
  // v12.10.14 (#1610): a group chip on the filter line opens the panel on that group (highlighted)
  const [fpFocus, setFpFocus] = useState<string | null>(null);
  useEffect(() => { if (!filterOpen) setFpFocus(null); }, [filterOpen]);
  // v12.10.14 (#1610): the filter line holds at most 2 lines, then "+N · Show all filters"
  const pillsRef = useRef<HTMLDivElement>(null);
  const [pillFit, setPillFit] = useState<number | null>(null);
  // v12.10.13 (#1558, §42): the panel is measured from its own top so it never runs off the screen and never moves the page.
  const filterPanelRef = useRef<HTMLDivElement | null>(null);
  const [dateOpen, setDateOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [mobileAccountOpen, setMobileAccountOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  // v12.10.26 (#T154): Text replies / workflow / office number; the Text Messages sheet when the workflow is On.
  const { data: textingStatus } = useTextingStatus();
  // v12.10.27 (#2146): textsOpen retired with the sheet
  useEffect(() => { textingWording.repliesOn = !!textingStatus?.repliesOn; textingWording.officePhone = textingStatus?.officePhone ?? null; }, [textingStatus]);
  // v12.10.22 (#2001): the heartbeat (a callback) needs the open call's id, and a counter that makes the drawer read it again.
  const selectedIdRef = useRef<string | null>(null);
  selectedIdRef.current = selectedId;
  const [detailReload, setDetailReload] = useState(0);
  // v12.3.14 (#369): the chip confirms locally for 1.5s AND raises a toast - SPEC §3.2 wants both, because the
  // chip is for the agent who is looking at it and the toast is for the one whose eyes were on the caller.
  const [refCopied, setRefCopied] = useState(false);
  const refCopyTimer = useRef<number | null>(null);
  useEffect(() => () => { if (refCopyTimer.current) window.clearTimeout(refCopyTimer.current); }, []);
  const copyReference = useCallback((value: string) => {
    const done = () => {
      setRefCopied(true);
      toast('success', 'Reference copied');
      if (refCopyTimer.current) window.clearTimeout(refCopyTimer.current);
      refCopyTimer.current = window.setTimeout(() => setRefCopied(false), 1500);
    };
    // SPEC §3.3: on clipboard failure, SELECT the text rather than failing silently. A blocked clipboard is
    // common in a locked-down browser and an agent mid-call needs the number either way.
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(value).then(done).catch(() => {
        selectReferenceText();
        toast('error', 'Could not copy', 'The reference is selected - press Ctrl+C.');
      });
    } else {
      selectReferenceText();
      toast('error', 'Could not copy', 'The reference is selected - press Ctrl+C.');
    }
  }, []);
  // v12.2.43.0 (#244) / v12.10.17 (#1723 D12): the avatar tile resolves through lib/taxonomy (module lists below).
  useEffect(() => {
    api.get<{ callerTypes?: { name?: string; key?: string; color?: string; icon?: string; active?: boolean; aliases?: string[] }[]; categories?: { name?: string; key?: string; color?: string; icon?: string; active?: boolean; aliases?: string[] }[] }>('/t2/surface/personalization')
      .then((d) => {
        // v12.10.13 (#1561): the Caller and Category filters list the practice's OWN types (Settings › Personalization).
        // v12.10.17 (#1723 D10 D12): those lists are the workflow's caller types and intent cards (server-derived), each with
        // the aliases an old record may carry. Display resolves against every item; the filters offer the active ones.
        const all = (xs?: { name?: string; key?: string; active?: boolean; color?: string; icon?: string; aliases?: string[]; usedBy?: string[]; usedByKeys?: string[] }[]) => (xs ?? []).filter((x) => x.name || x.key)
          .map((x) => ({ key: (x.key || x.name || '').trim(), name: (x.name || x.key || '').trim(), color: x.color, icon: x.icon, aliases: x.aliases ?? [], active: x.active !== false,
            usedBy: x.usedBy ?? [], usedByKeys: x.usedByKeys ?? [] }));   // v12.10.22 (#2011)
        displayCallerTypes = all(d.callerTypes);
        displayCategories = all(d.categories);
        practiceCallerTypes = displayCallerTypes.filter((x) => x.active);
        practiceCategories = displayCategories.filter((x) => x.active);
        setPracticeListsVer((v) => v + 1);
      })
      .catch(() => { /* avatar falls back to initials */ });
  }, []);
  // v12.10.17 (#1723 D1 D2 D12): the avatar is the caller type ONLY - key first, then name, then alias; nothing = Unclassified.
  const callerTileMeta = (m: WsMessage) => callerTypeDisplay(displayCallerTypes, m.callerTypeRaw);
  const [practiceListsVer, setPracticeListsVer] = useState(0);   // v12.10.13 (#1561): re-render when the practice lists arrive
  // v12.10.13 (#1561, §42): the Filters lists are the practice's own words - All first (in ChipGroup), then A-Z.
  const callerFilterItems = useMemo(() => [
    ...[...practiceCallerTypes].sort((x, y) => x.name.localeCompare(y.name)).map((t) => ({ k: t.key, label: t.name })),
    { k: 'unclassified', label: 'Unclassified' },
  ], [practiceListsVer]);   // eslint-disable-line react-hooks/exhaustive-deps
  const categoryFilterItems = useMemo(() => [
    ...[...practiceCategories].sort((x, y) => x.name.localeCompare(y.name)).map((c) => ({ k: c.key, label: c.name })),
    { k: UNCLASSIFIED_KEY, label: 'Unclassified' },   // v12.10.17 (#1723 D10): the system Unclassified in both lists
  ], [practiceListsVer]);   // eslint-disable-line react-hooks/exhaustive-deps
  const draftOnCount = (['status', 'priority', 'callerType', 'language', 'category', 'label', 'type', 'opened', 'notes', 'outcome'] as const)
    .filter((k) => { const v = (draftFilters as unknown as Record<string, unknown>)[k]; return v !== undefined && v !== 'all'; }).length
    + ((draftFilters.assigned ?? []).length > 0 ? 1 : 0);
  const [noteText, setNoteText] = useState('');
  const [reminderDate, setReminderDate] = useState('');
  const [drawerTool, setDrawerTool] = useState<DrawerTool>(null);
  const [allNotesFor, setAllNotesFor] = useState<string | null>(null);   // v12.10.11.1 (#1494): 'Show all N notes' for this message
  // v12.2.3.0 (CE-E1): voicemail playback. We fetch the short-lived signed stream URL when a call
  // with a recording is selected and bind it to a NATIVE <audio controls> element. The old approach
  // (new Audio(url).play() inside an async onClick) rejected after the await consumed the click's
  // transient user-activation - Chrome blocked the scripted play() and never issued the media
  // request, so the user saw "Recording is not available" and no stream?token call in the network
  // tab. A native player needs no scripted activation: the browser issues the request and surfaces
  // decode/HTTP errors on its own <audio> error event, which we catch to refetch (URL expiry).
  const [recordingUrl, setRecordingUrl] = useState<string | null>(null);
  const [recordingState, setRecordingState] = useState<'idle' | 'loading' | 'ready' | 'error'>('idle');
  // v12.9.26 (#982 / #999): the signed link lives 5 minutes (RecordingSignedUrlTtlMinutes) and the audio element
  // makes a NEW request on every play and seek - so a call reviewed for longer than that started failing, and the log
  // shows the storm (118 expired-token 401s, 54 in one minute). Now a refused link is refreshed SILENTLY, once, and
  // playback resumes at the same second; only if the fresh link also fails does the message show - ONE toast at a time.
  const recToastRef = useRef<ToastHandle | null>(null);
  const recToast = (type: 'info' | 'warning', title: string, message: string) => {
    recToastRef.current?.close();
    recToastRef.current = toast(type, title, message);
  };
  const resumeRef = useRef<{ at: number; play: boolean } | null>(null);
  const refreshTriedRef = useRef(false);
  // v12.10.6 (#982 reopened - Tushar 10/3: idle on the screen, press play, "recorder failed" / "recording not available",
  // Retry fixes it). The 12.9.26 guard allowed ONE silent refresh per call until the next successful PLAY - a message
  // left open longer than two link lifetimes spent its one refresh in the background and then showed the error. Now:
  // the link's age is tracked, a stale link is renewed silently while the player is paused (every minute, and when the
  // tab comes back), and a refused link may be renewed again once 20 s have passed since the last renewal.
  const urlAtRef = useRef(0);
  const lastRefreshRef = useRef(0);
  const URL_FRESH_MS = 4 * 60 * 1000;   // the signed link lives 5 minutes (RecordingSignedUrlTtlMinutes)

  // ══ v12.9.12 (#791/#792/#793): SEND TEXT, THE MORE-MENU, AND THE COMPOSER. ══
  const [moreOpen, setMoreOpen] = useState(false);
  const [composerOpen, setComposerOpen] = useState(false);
  const [textBody, setTextBody] = useState('');
  // ── v12.10.27 (#2150, UI-PROTO-T154-SEND-TEXT-PREVIEW v1.6 LOCKED): the practice-name chip in front, the reply-line chip at the end (Text
  // replies Off, calls only), both changeable for THIS text by clicking; the preview shows the exact text while the pointer is on Send text. ──
  const [nameChip, setNameChip] = useState<string | null>(null);   // null = the practice's standard name
  const [endChip, setEndChip] = useState<string | null>(null);     // null = the standard reply line
  const [chipEdit, setChipEdit] = useState<'name' | 'end' | null>(null);
  const [previewHover, setPreviewHover] = useState(false);
  const [apptDate, setApptDate] = useState('');   // v12.10.11.1 (#1472): fills [appointment date] before sending
  const needsApptDate = textBody.includes('[appointment date]');
  // v12.9.24 (#911): the Send Text language switch. Defaults to the CALL's language when the composer opens.
  const [textLang, setTextLang] = useState<string>('en');
  // v12.9.26 (#938): the organization's languages drive the Send Text and summary language buttons.
  const [orgLangs, setOrgLangs] = useState<string[]>(['en', 'es']);
  useEffect(() => {
    let off = false;
    api.get<{ identity?: { enabledLanguages?: string[] } }>('/t2/settings/organization')
      .then((r) => { const l = (r?.identity?.enabledLanguages ?? []).map((x) => x.toLowerCase().split('-')[0]).filter(Boolean);
        if (!off && l.length > 0) setOrgLangs(l.includes('en') ? l : ['en', ...l]); })
      .catch(() => { /* keep the default pair */ });
    return () => { off = true; };
  }, []);
  // The template the draft came from, and the exact text inserted - so a flip can tell "unedited template"
  // (swap to the other language's version) from "staff edited it" (translate their text).
  const [textFrom, setTextFrom] = useState<{ index: number; filled: string } | null>(null);
  const [textXl, setTextXl] = useState<'idle' | 'loading' | 'error'>('idle');
  const [toEditing, setToEditing] = useState(false);
  const [toNumber, setToNumber] = useState('');          // national digits; the +1 is fixed - see #800
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState<string | null>(null);
  const moreBtnRef = useRef<HTMLButtonElement | null>(null);
  const moreWrapRef = useRef<HTMLDivElement | null>(null);
  const sendTextBtnRef = useRef<HTMLButtonElement | null>(null);
  const textAreaRef = useRef<HTMLTextAreaElement | null>(null);
  // v12.9.11 (#770): is the real player still on screen? An IntersectionObserver rather than a scroll
  // listener, so it costs nothing while the caller reads and is correct at any drawer height.
  const playerCardRef = useRef<HTMLElement | null>(null);
  const [, setPlayerOnScreen] = useState(true);   // v12.10.14 (#1616): the "Player" link is gone - nothing reads it now
  const [recordingReload, setRecordingReload] = useState(0);
  const [recordingFormat, setRecordingFormat] = useState<string>('mp3');
  const [isPlaying, setIsPlaying] = useState(false);
  const [recordingProgress, setRecordingProgress] = useState(0);   // 0..1, drives the waveform fill
  const [recordingLength, setRecordingLength] = useState(0);   // v12.10.21 (#1953): seconds, from the audio itself (0 = not known yet)
  const [playbackRate, setPlaybackRate] = useState(1);
  const audioRef = useRef<HTMLAudioElement | null>(null);
  // v12.2.47.0 (#261): track playhead so the transcript can highlight/scroll to the current line, and seek on click.
  const [currentTime, setCurrentTime] = useState(0);
  // v12.9.11 (#785): A CLICK THAT DOES NOTHING, SILENTLY, IS INDISTINGUISHABLE FROM A BROKEN PAGE.
  //
  // His report: *"Now once the call recording is completed, if you click then also it does not play."* The old
  // body was `if (!a) return;` followed by `.catch(() => {})` - two silent exits, so a transcript line that
  // LOOKED clickable swallowed the click and said nothing. He had to work out which of the two it was while
  // verifying a build, which is the worst possible moment to be guessing at the UI.
  //
  // The message distinguishes NOT READY YET from NOT AVAILABLE, because they call for different actions.
  //
  // IT NAMES NO VENDOR. Not the provider, not its error text, not a URL, not our account state - that rule
  // holds on every surface T2 renders, and an audio failure is exactly where a raw provider string would
  // otherwise leak out.
  const seekTo = (sec: number) => {
    const a = audioRef.current;
    if (!a || !recordingUrl) {
      if (recordingState === 'loading') recToast('info', 'Recording still loading', 'Give it a moment and try again.');
      else if (recordingState === 'error') recToast('warning', 'Recording unavailable', 'This call has no playable recording.');
      else if (!hasRecording) return;   // v12.10.11.1 (#982): the card already says there is no recording - no pop-up per click
      else recToast('warning', 'Recording unavailable', 'This call has no playable recording.');
      return;
    }
    a.currentTime = sec;
    void a.play().catch(() => recoverRecording(sec, true));
  };
  // HH: the Apply-labels editor accumulates toggles in this local draft only (optimistic, no PUT
  // per chip); ONE persist({labels}) fires on Done if the set actually changed.
  const [labelDraft, setLabelDraft] = useState<string[] | null>(null);
  // v12.4.12 (#468 reopened): the draft's SOURCE OF TRUTH is this ref; the state above is only its render
  // mirror. The heartbeat merges inside a setQueues updater long after the click, and an exit path (close,
  // prev/next, Mark complete) runs in the same tick as the click that ends the edit - both must read what the
  // agent actually picked, never a render-old closure. It carries its own message id and the baseline it
  // opened with, so a commit that runs after the selection has already moved still writes the right message.
  const labelDraftRef = useRef<{ id: string; baseline: string[]; labels: string[] } | null>(null);
  const searchRef = useRef<HTMLInputElement>(null);
  const drawerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLDivElement>(null);                     // v12.4.9 (#453)
  const knownIdsRef = useRef<Set<string>>(new Set());               // v12.4.9 (#453)
  // v12.4.9 (#453/#454): the messages with a write still on its way. v12.10.16 (#1677): a COUNT per message, not a set -
  // two writes to one message (read, then Mark complete) are both in flight, and the first echo must not unmark the second.
  const pendingRef = useRef<Map<string, number>>(new Map());
  // ══ v12.10.16 (T104 #1677): A LIST REFRESH NEVER PUTS AN OLD STATUS BACK. ═════════════════════════════════════
  // UMG 10/13, reproduced live: filter Pending, open, Mark complete, repeat - completed messages came back to the top,
  // the counts went up, and Mark complete walked into messages already completed. The 10 s heartbeat had been ASKED
  // before the click and ANSWERED after the save's echo had cleared pendingRef, so its old copy (status Pending) was
  // laid over the new one. Every local change now takes a number (mutSeqRef); each load remembers the number it
  // started at, and a row changed here after that keeps the local copy. listVersionRef counts the lists applied.
  const mutSeqRef = useRef(0);
  const lastMutRef = useRef<Map<string, number>>(new Map());
  const listVersionRef = useRef(0);
  const loadedWindowRef = useRef<string | null>(cachedList()?.windowFrom ?? null);
  const accountRef = useRef<HTMLDivElement>(null);
  const mobileAccountRef = useRef<HTMLDivElement>(null);
  const dateWrapRef = useRef<HTMLDivElement>(null);
  const filterWrapRef = useRef<HTMLDivElement>(null);
  const phoneFilterRef = useRef<HTMLButtonElement>(null);   // v12.10.14 (#1612)
  // v12.4.11 (#469 / BDR-012): the collapsed queue header.
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerCollapsed, setHeaderCollapsed] = useState(false);
  // v12.4.13 (#469): true as soon as the list has moved under the header, collapsed or not - it drives the seam.
  const [headerPinned, setHeaderPinned] = useState(false);
  // The expander restores the full header WITHOUT scrolling to the top (BDR-012 §2), so it needs a state
  // that outranks the scroll position until the reader moves again.
  const [headerForcedOpen, setHeaderForcedOpen] = useState(false);
  const forcedAtRef = useRef(0);
  // The FULL header's height, captured while it is expanded - see the note in the collapse effect.
  const expandedHeightRef = useRef(0);
  // v12.4.12 (#469): the scroll position a collapse was decided at, and the collapsed bar's last height - see the
  // height-compensation effect below headerIsCollapsed.
  const collapseAtRef = useRef<number | null>(null);
  const collapsedHeightRef = useRef(0);
  // v12.4.12 (#468 reopened): the baseline that lived here now travels inside labelDraftRef.

  const allMessages = queues[kind];
  const allTenantMessages = useMemo(() => [...queues.call, ...queues.text], [queues]);
  // v12.10.6 (#1153): the Year row of the Date scope offers only years that have messages
  const messageYears = useMemo(() => Array.from(new Set(allTenantMessages
    .map((m) => parseMessageDate(m)?.getFullYear()).filter((y): y is number => typeof y === 'number'))).sort((x, y) => y - x), [allTenantMessages]);
  // v12.10.11.3 (#1522): the tab count = every call in the selected dates (exact - it was the first 100 the API sent).
  // v12.10.16 (#1690): one card per caller - the group's other calls are not cards of their own.
  const callGroups = useMemo(() => buildCallGroups(queues.call, groupRule), [queues.call, groupRule]);
  // v12.10.29.1 (#2238, Tushar 11/3 "there is no point showing x5 time as 5 to work. it's that same caller"): every counter counts
  // CARDS - a grouped caller is one. isCard = the call that carries the card; cardOpen = the card is open while ANY of its calls is.
  const isCard = (m: WsMessage) => { const c = callGroups.carrierOf.get(m.id); return !c || c === m.id; };
  const cardOpen = (m: WsMessage) => m.status !== 'done' || (callGroups.members.get(m.id) ?? []).some((x) => x.status !== 'done');
  const counts = useMemo(() => ({
    // v12.10.11.1 (#1461): the setup test call stays in the list, marked, but is not one of the practice's calls in a count.
    call: queues.call.filter((message) => !message.setupTestCall && isCard(message) && matchesDateScope(message, filters.dateScope)).length,   // #2238 cards
    text: queues.text.filter((message) => matchesDateScope(message, filters.dateScope)).length,
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [filters.dateScope, queues, callGroups]);
  // v12.10.11.3 (#1521 / #1527): the list in the chosen order - by call time, or by follow-up date in the Follow-ups view.
  // v12.10.13 (#1561): the Outcome filter's flags - asked for only while Outcome is used (the list itself stays lean).
  const [endings, setEndings] = useState<{ from: string; map: Record<string, string> } | null>(null);
  outcomeById = endings?.map ?? {};
  const refreshMs = Math.min(300, Math.max(10, groupRule?.refreshSeconds || REFRESH_MS / 1000)) * 1000;   // v12.10.16.1 (#1702)
  // ══ v12.10.19 (#1926, LOCKED 10/23 S132): a search with nothing in the chosen dates offers "Search all dates (n found)". Clicking it
  // shows the matches of every date for THIS search - the date filter is not changed; clearing the search returns to it.
  const [allDatesQuery, setAllDatesQuery] = useState<string | null>(null);
  const [allDatesCount, setAllDatesCount] = useState<{ q: string; n: number } | null>(null);
  const searchAllDates = Boolean(allDatesQuery) && allDatesQuery === filters.query.trim();
  const openAllDates = () => {
    const q = filters.query.trim();
    api.get<ApiMessagesEnvelope>(`/t2/surface/messages/search?q=${encodeURIComponent(q)}`)
      .then((env) => {
        const rows = (env?.messages ?? []).map(toMessage);
        setQueues((cur) => {
          const have = new Set([...cur.call, ...cur.text].map((m) => m.id));
          const add = rows.filter((m) => !have.has(m.id));
          return { call: [...cur.call, ...add.filter((m) => m.kind === 'call')], text: [...cur.text, ...add.filter((m) => m.kind === 'text')] };
        });
        setAllDatesQuery(q);
      })
      .catch(() => toast('error', 'Search failed', 'Could not search every date - try again.'));
  };
  useEffect(() => {
    const q = filters.query.trim();
    if (q.length < 2 || searchAllDates) return;
    let off = false;
    const tm = window.setTimeout(() => {
      api.get<{ count: number }>(`/t2/surface/messages/search?q=${encodeURIComponent(q)}&count=true`)
        .then((r) => { if (!off) setAllDatesCount({ q, n: r?.count ?? 0 }); })
        .catch(() => { if (!off) setAllDatesCount({ q, n: 0 }); });
    }, 450);
    return () => { off = true; window.clearTimeout(tm); };
  }, [filters.query, searchAllDates]);
  const listFilters: Filters = useMemo(() => (searchAllDates ? { ...filters, allDates: true } : filters), [filters, searchAllDates]);   // v12.10.19 (#1926)
  const visibleMessages = useMemo(() => {
    // v12.10.16 (#1690 "search finds any reference"): a search that matches an EARLIER call of a group finds the group's card.
    // v12.10.16.1 (#1701): a group is open while ANY of its calls is open - a completed (or auto-completed) newest call no longer
    // takes an open earlier call off the Pending list. The card shows the open call's status.
    const groupView = (m: WsMessage): WsMessage => {
      const grp = callGroups.members.get(m.id);
      if (!grp) return faceOf(m);   // v12.10.17.1 (#1794): a single call still takes the contact book's name
      let v = m;
      if (v.status === 'done') { const open = grp.find((x) => x.status !== 'done'); if (open) v = { ...v, status: open.status }; }
      // v12.10.16.1 (#1700 AC2): the group card names the caller when ANY call in the group captured the name (42-0447 / 42-0433).
      // v12.10.17.1 (#1794): name, caller type and request from the group / the contact book (faceOf)
      return faceOf(v, grp);
    };
    const rows = allMessages.filter((message) => { const c = callGroups.carrierOf.get(message.id); return !c || c === message.id; })
      .map(groupView)
      .filter((message) => messageMatchesFilters(message, listFilters)
        || ((Boolean(listFilters.query?.trim()) || listFilters.audit === 'marked') && (callGroups.members.get(message.id) ?? []).some((m) => m.id !== message.id && messageMatchesFilters(m, listFilters))));   // v12.10.19 (#1893): a group with any call marked
    const t = (m: WsMessage) => (listFilters.fuView ? (m.reminderDue ?? '9999') + (m.startedAt ?? '') : (m.startedAt ?? ''));
    return [...rows].sort((a, b) => (sortOrder === 'oldest' ? t(a).localeCompare(t(b)) : t(b).localeCompare(t(a))));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allMessages, listFilters, sortOrder, endings, practiceListsVer, callGroups]);

  // v12.3.11 (#307): [path] lines record WHY a call went where it did. They are for diagnosing a call,
  // NOT for the person reading what the caller said, so they are hidden from the transcript by default and
  // revealed by a toggle. Without this the diagnostics would sit inline among the caller's words.
  const [showCallPath, setShowCallPath] = useState(false);
  const [showRoute, setShowRoute] = useState(false);   // v12.10.22 (#2010): the path icon opens the Call route (layout C) - Owner only (Call path right)
  // v12.10.23 (Tushar 10/29): opening the Call route brings it into view.
  useEffect(() => {
    if (!showRoute) return;
    const t = window.setTimeout(() => document.getElementById('aw-callroute')?.scrollIntoView({ block: 'start', behavior: 'smooth' }), 60);
    return () => window.clearTimeout(t);
  }, [showRoute]);
  // ══ v12.9.23 (#846): THE TRANSCRIPT IS STORED IN THE LANGUAGE IT WAS SPOKEN IN. ═══════════════════
  // English is a VIEW, computed on first display and cached against the call - never stored as a record.
  // His rule: "can we store the orginal transcript rather than we convert transcript to english and then
  // again convert to language on demand?" Default view is English (S3); the toggle reveals the original.
  // v12.9.24 (#913): HIS DECISION - THE DEFAULT VIEW IS AS SPOKEN, ALWAYS. "the way it is right now, i could tell
  // what part went english for agent or caller. if we translate then we will never be able to find out."
  const [transcriptView, setTranscriptView] = useState<'en' | 'src'>('src');
  const [xlLines, setXlLines] = useState<Record<string, { lines: string[]; translated: boolean[]; fromLang: string[] }>>({});
  const [xlState, setXlState] = useState<'idle' | 'loading' | 'error' | 'unavailable'>('idle');
  // v12.9.24 (#908): WHY a translation could not be produced, in words a staff user can act on.
  const [xlReason, setXlReason] = useState<string | null>(null);
  // v12.9.24 (#909): the summary card's EN/ES switch. EN (as written) is the default; the reader chooses.
  const [summaryLang, setSummaryLang] = useState<string>('en');
  // v12.9.26 (#938): translations keyed '<callId>:<lang>' - any language the organization runs, not only ES.
  const [summaryXl, setSummaryXl] = useState<Record<string, string>>({});
  const xlOf = (id: string, lang: string) => summaryXl[id + ':' + lang];
  const fetchSummaryXl = (id: string, lang: string) => {
    if (lang === 'en' || summaryXl[id + ':' + lang]) return;
    setSummaryState('loading');
    api.get<{ ok: boolean; text: string; reason?: string }>(`/t2/calls/${id}/summary/translation?to=${encodeURIComponent(lang)}`)
      .then((r) => { if (r?.ok && r.text) { setSummaryXl((prev) => ({ ...prev, [id + ':' + lang]: r.text })); setSummaryState('idle'); } else setSummaryState('error'); })
      .catch(() => setSummaryState('error'));
  };
  const [summaryState, setSummaryState] = useState<'idle' | 'loading' | 'error'>('idle');
  // #909: EN is the default for every message opened - the reader's ES choice does not follow them to the next one.
  useEffect(() => { setSummaryLang('en'); setSummaryState('idle'); }, [selectedId]);
  // v12.9.26 (#977): the 'Classic' switch - OFF by default; ON shows the old paragraph. Temporary (his words: removed
  // once it is live at a few clients). Not saved anywhere: a reader's choice for this session only.
  const [summaryClassic, setSummaryClassic] = useState(false);
  useEffect(() => {
    // Classic switched ON while ES is chosen: the paragraph needs its translation, fetched once and cached as before.
    if (!summaryClassic || summaryLang === 'en' || !selectedId) return;
    fetchSummaryXl(selectedId, summaryLang);
  }, [summaryClassic, summaryLang, selectedId]);   // eslint-disable-line react-hooks/exhaustive-deps

  // v12.9.14 (#830): which of the two sibling views the drawer is showing. Reset when the selected
  // message changes, so opening a call never lands on a view the previous call happened to be in.
  const [dataView, setDataView] = useState(false);
  // v12.4.9 (#453): ids, not a count. A count would have to be re-derived by hand every time the tab,
  // the filters or the date scope changed; a list of ids is filtered by the same visibleMessages
  // everything else on this screen is filtered by, so the chip can never disagree with the list.
  const [arrivedIds, setArrivedIds] = useState<string[]>([]);
  // v12.4.9 (#453): the chip counts arrivals THAT PASS THE CURRENT FILTERS. An arrival that the
  // active tab, date scope or filter set excludes is not something the agent missed, so it is not
  // announced - and the count can never disagree with the list because both come from the same
  // visibleMessages.
  const newArrivals = useMemo(
    () => arrivedIds.filter((id) => visibleMessages.some((message) => message.id === id)).length,
    [arrivedIds, visibleMessages],
  );
  const selectedMessage = selectedId ? allTenantMessages.find((message) => message.id === selectedId) ?? null : null;
  // v12.10.26 (#T154 Q16): opening a card clears its "New text" pill (the follow-up flag stays until completed).
  const textSeenRef = useRef<Set<string>>(new Set());
  useEffect(() => {
    if (!selectedMessage || !(selectedMessage.newText || (selectedMessage.newTextCount ?? 0) > 0) || textSeenRef.current.has(selectedMessage.id)) return;   // v12.10.27 (#2146 Q33)
    textSeenRef.current.add(selectedMessage.id);
    void api.post(`/t2/texting/calls/${selectedMessage.id}/seen`).catch(() => { /* the pill clears on the next open */ });
  }, [selectedMessage?.id, selectedMessage?.newText, selectedMessage?.newTextCount]); // eslint-disable-line react-hooks/exhaustive-deps
  // v12.10.27 (#2146, prototype v1.3): a text conversation's reply box is always open - a chat, not a one-off text.
  useEffect(() => { if (selectedMessage?.kind === 'text' && canText && !composerOpen) setComposerOpen(true); }, [selectedMessage?.id, composerOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  // ══ v12.10.16 (T113 #1690): THE DRAWER OF A GROUPED CALLER. The newest call opens Combined (every call read together); a
  // call link opens that one call on its own; "Combined" goes back. Mark complete closes every open call in the group.
  // v12.10.29.1 (#2246, Tushar 11/3 "it took me to that call that should not have happen"): the drawer keeps the calls it opened with.
  // A new call from the same caller joins the card, but the open drawer stays on what the reader is reading (same Combined, same
  // language, same scroll) and shows a quiet "New call from this caller · Show" line. The snapshot renews when the reader opens
  // another card, or presses Show.
  const selCarrierLive = selectedId ? callGroups.carrierOf.get(selectedId) ?? null : null;
  const selGroupLive = selCarrierLive ? callGroups.members.get(selCarrierLive) ?? null : null;
  const [groupSnap, setGroupSnap] = useState<string[] | null>(null);
  useEffect(() => {
    if (!selectedId) { setGroupSnap(null); return; }
    setGroupSnap((s) => (s && s.includes(selectedId) ? s : (selGroupLive ? selGroupLive.map((m) => m.id) : [selectedId])));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);
  const selGroupKept = selGroupLive && groupSnap ? selGroupLive.filter((m) => groupSnap.includes(m.id)) : selGroupLive;
  const selGroup = selGroupKept && selGroupKept.length > 1 ? selGroupKept : null;
  const selCarrier = selGroup ? selGroup[0].id : (selGroupLive && groupSnap ? null : selCarrierLive);
  const newInGroup = selGroupLive && groupSnap ? selGroupLive.filter((m) => !groupSnap.includes(m.id)) : [];
  const [singleCall, setSingleCall] = useState(false);
  const [allGroupLinks, setAllGroupLinks] = useState(false);
  useEffect(() => { setSingleCall(false); setAllGroupLinks(false); }, [selCarrier]);
  const combinedView = !!selGroup && selGroup.length > 1 && selectedId === selGroup[0].id && !singleCall;
  // v12.10.17.1 (#1794): the drawer header wears the same face as the card - in Combined the group's, on one call its own (+ the contact book's name)
  const headMessage = selectedMessage ? faceOf(selectedMessage, combinedView ? selGroup : null) : null;
  // v12.10.16.1 (#1707 #1700): the rows the summary card shows - Combined always has rows (and the Rows | Paragraph switch).
  const combinedRowsSel = combinedView && selGroup ? buildCombinedRows(selGroup, summaryLang) : null;
  const viewRows = combinedRowsSel ?? (selectedMessage ? summaryRowsFor(selectedMessage, summaryLang) : null);
  // v12.9.23 (#846): fetch the English VIEW when a non-English call is opened and English is selected.
  // The server caches it against the call, so the wording is identical on every later viewing; wipe that
  // cache and nothing is lost, because it regenerates from the original.
  // v12.10.22.2 (#2069): on the Combined view EN / ES translates EVERY call of the group (it translated only the newest call), each
  // fetched once and cached against its call; an earlier call is translated once its transcript has loaded.
  const xlTargets = selectedMessage ? (combinedView && selGroup ? selGroup : [selectedMessage]) : [];
  const xlTargetKey = xlTargets.map((m) => `${m.id}:${(m.transcript ?? []).length}`).join(',');
  // v12.10.23 (#2069 VERIFICATION FAILED 10/29): each answer finishing re-ran this effect and CANCELLED the other calls' requests still in
  // flight, so only the call that answered first (the newest) was ever translated. Requests are now tracked per call + line count and
  // never cancelled; an answer is stored against its own call. #2045: a translation whose line count no longer matches the call (a line
  // was added after it was made) is asked for again - the server answers from its kept translation, only new lines are translated.
  const xlInFlight = useRef<Set<string>>(new Set());
  useEffect(() => {
    if (transcriptView !== 'en' || xlTargets.length === 0) return;
    for (const m of xlTargets) {
      const src = languageCode(m.language).toLowerCase();
      // v12.9.24 (#913): a call is mixed, so an "English" call can still hold a Spanish turn.
      const anyForeign = (m.transcript ?? []).some((l) => l.role !== 'path' && l.lang && l.lang.toLowerCase().split('-')[0] !== 'en');
      if (src === 'en' && !anyForeign) continue;
      const n = (m.transcript ?? []).length;
      if (n === 0 || (xlLines[m.id] && xlLines[m.id].lines.length === n)) continue;
      const fk = `${m.id}:${n}`;
      if (xlInFlight.current.has(fk)) continue;
      xlInFlight.current.add(fk);
      setXlState('loading');
      setXlReason(null);
      api.get<{ ok: boolean; needed: boolean; lines: string[]; translated?: boolean[]; fromLang?: string[]; reason?: string }>(`/t2/calls/${m.id}/transcript/translation?to=en`)
        .then((r) => {
          if (r?.ok && Array.isArray(r.lines) && r.lines.length) {
            setXlLines((prev) => ({ ...prev, [m.id]: { lines: r.lines, translated: r.translated ?? r.lines.map(() => r.needed), fromLang: r.fromLang ?? r.lines.map(() => src) } }));
            setXlState('idle');
          } else {
            setXlState(r?.reason === 'no-key' ? 'unavailable' : 'error');
            setXlReason(xlReasonText(r?.reason));
          }
        })
        .catch(() => { setXlState('error'); setXlReason(xlReasonText('network')); xlInFlight.current.delete(fk); });   // a network miss may be tried again; an answer is asked for once per line count (no loop)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [xlTargetKey, transcriptView, xlLines]);
  const selectedIndex = selectedMessage ? visibleMessages.findIndex((message) => message.id === selectedMessage.id) : -1;
  // W: a missed call (or a zero-duration call with no voicemail) has no real recording, so we
  // render the meaningful missed-call callout and suppress the empty player + system-only transcript.
  // v12.2.1.0 (CE-B2): "no voicemail" is decided by the channel (the backend sets 'voicemail' whenever
  // a recording exists), NOT by duration - a real voicemail can carry a 0s call-duration field.
  const isMissedNoRecording = Boolean(
    selectedMessage && selectedMessage.kind !== 'text'
      && isBareMissed(selectedMessage),   // v12.10.21 (#1953): a hung-up call shows its recording + transcript, not the Missed callout
  );
  // v12.2.3.0 (CE-E1): a call carries a playable recording when it is not text and not a bare
  // missed call. (The backend marks a call 'voicemail' the moment a recording row exists.)
  // v12.10.17 (#1751): the Combined view plays the call picked in it (a block's "Play" line or one of its lines) - not only the
  // newest call. playMessage is the call the player is loaded with; selectedMessage stays the drawer's own message.
  const [playPick, setPlayPick] = useState<string | null>(null);
  const pendingSeekRef = useRef<{ at: number; play: boolean } | null>(null);   // v12.10.17 (#1751): a line clicked on a call not yet loaded
  useEffect(() => { setPlayPick(null); pendingSeekRef.current = null; }, [selectedId, combinedView]);
  const playMessage = (combinedView && playPick && selGroup ? selGroup.find((m) => m.id === playPick) : undefined) ?? selectedMessage;
  const playIsMissed = Boolean(playMessage && playMessage.kind !== 'text' && isBareMissed(playMessage) && playMessage.noRecording);   // v12.10.17 (#1751); v12.10.21 (#1953 #1751): a hung-up call, or any call with a saved recording, is played
  const hasRecording = Boolean(
    playMessage && playMessage.kind !== 'text' && !playIsMissed && !playMessage.noRecording && hasAccess('phone', 'play'),   // v12.10.21 (#1953)   // v12.10.9.4 (#1381): Play recording; v12.10.17 (#1751): of the played call
  );
  const selectedCallId = selectedMessage?.id ?? null;
  const playCallId = playMessage?.id ?? null;   // v12.10.17 (#1751): every signed-url fetch below asks for THIS call
  // v12.10.17 (#1751): a Combined call can be played when it has a recording (not text, not a bare missed call, one was saved).
  // v12.10.21 (#1953 #1751): a call is playable when a recording was saved - a hung-up call (agent spoke) included; a bare missed call
  // with no recording is not.
  const canPlayCall = (m: WsMessage) => m.kind !== 'text' && !m.noRecording && hasAccess('phone', 'play');
  // v12.10.17 (#1751): pick a Combined call for the player - from its "Play" control (from the start) or one of its lines (from there).
  const pickPlay = (m: WsMessage, at?: number) => {
    if (m.id === playCallId) {
      const a = audioRef.current;
      if (at !== undefined) seekTo(at);
      else if (a) { if (a.paused) void a.play().catch(() => recoverRecording(a.currentTime, true)); else a.pause(); }
      return;
    }
    // v12.10.21 (#1751 guard, LOCKED 10/26): a picked call with no recording takes the player too - it then says "No recording for
    // <ref>" and never keeps playing another call's audio.
    if (!canPlayCall(m)) { audioRef.current?.pause(); pendingSeekRef.current = null; setPlayPick(m.id); return; }
    pendingSeekRef.current = { at: at ?? 0, play: true };
    setPlayPick(m.id);
  };
  const grpPlayBtn = (m: WsMessage) => (combinedView && m.kind !== 'text' && !canPlayCall(m) && hasAccess('phone', 'play') ? (
    // v12.10.21 (#1751 guard): a call of the group that has no recording says so - picking it never plays another call's audio.
    <span className="aw-grp-norec" role="note">No recording for {formatReference(m.referenceNo)}</span>
  ) : combinedView && canPlayCall(m) ? (
    <button type="button" className={`aw-grp-play${m.id === playCallId ? ' on' : ''}`} aria-pressed={m.id === playCallId}
      data-track="drawer.group.play" title={m.id === playCallId ? `The player has ${formatReference(m.referenceNo)}` : `Play ${formatReference(m.referenceNo)}`}
      onClick={() => pickPlay(m)}>
      <SvgIcon name={m.id === playCallId && isPlaying ? 'pause' : 'play'} /> {m.id === playCallId ? 'Playing' : 'Play'}
    </button>
  ) : null);
  const recoverRecording = (at: number, play: boolean) => {
    if ((refreshTriedRef.current && Date.now() - lastRefreshRef.current < 20_000) || !playCallId) {
      setRecordingUrl(null);
      setRecordingState('error');
      recToast('warning', 'Recording unavailable', 'This call has no playable recording.');
      return;
    }
    refreshTriedRef.current = true;
    lastRefreshRef.current = Date.now();
    resumeRef.current = { at, play };
    const id = playCallId;
    api.get<{ url: string; format: string }>(`/t2/recordings/signed-url?callId=${encodeURIComponent(id)}`)
      .then((res) => {
        if (id !== playCallId) return;
        urlAtRef.current = Date.now();
        setRecordingUrl(buildUrl(res.url));   // a new src remounts <audio> (key) - onLoadedMetadata resumes it
        setRecordingFormat(res.format || 'mp3');
        setRecordingState('ready');
      })
      .catch(() => {
        setRecordingUrl(null);
        setRecordingState('error');
        recToast('warning', 'Recording unavailable', 'This call has no playable recording.');
      });
  };
  useEffect(() => {
    refreshTriedRef.current = false;   // v12.9.26 (#982): each call (and each Retry) gets its one silent refresh
    resumeRef.current = pendingSeekRef.current;   // v12.10.17 (#1751): a line clicked on a Combined call that was not loaded yet
    pendingSeekRef.current = null;
    setRecordingLength(0);   // v12.10.21 (#1953): a new call's length comes from its own audio
    if (!hasRecording || !playCallId) { setRecordingUrl(null); setRecordingState('idle'); setIsPlaying(false); setCurrentTime(0); return; }   // v12.2.47.1 (#261)
    let cancelled = false;
    setRecordingState('loading');
    setRecordingUrl(null);
    setIsPlaying(false);
    setRecordingProgress(0);
    setCurrentTime(0);   // v12.2.47.1 (#261): a fresh message starts at the first line, not the previous playhead
    (async () => {
      try {
        const res = await api.get<{ url: string; format: string }>(
          `/t2/recordings/signed-url?callId=${encodeURIComponent(playCallId)}`,
        );
        if (cancelled) return;
        urlAtRef.current = Date.now();
        setRecordingUrl(buildUrl(res.url));
        setRecordingFormat(res.format || 'mp3');
        setRecordingState('ready');
      } catch {
        if (cancelled) return;
        setRecordingUrl(null);
        setRecordingState('error');
      }
    })();
    return () => { cancelled = true; };
  }, [hasRecording, playCallId, recordingReload]);

  // v12.10.6 (#982): keep the link fresh while the message sits open - renewed silently while PAUSED (never under a
  // playing recording), every minute and when the tab becomes visible again (a sleeping laptop stops timers).
  useEffect(() => {
    if (!hasRecording || !playCallId) return;
    const check = () => {
      const a = audioRef.current;
      if (recordingState !== 'ready' || !recordingUrl) return;
      if (a && !a.paused) return;
      if (Date.now() - urlAtRef.current < URL_FRESH_MS) return;
      const at = a?.currentTime ?? currentTime;
      const id = playCallId;
      api.get<{ url: string; format: string }>(`/t2/recordings/signed-url?callId=${encodeURIComponent(id)}`)
        .then((res) => {
          if (id !== playCallId) return;
          resumeRef.current = { at, play: false };
          urlAtRef.current = Date.now();
          setRecordingUrl(buildUrl(res.url));
          setRecordingFormat(res.format || 'mp3');
        })
        .catch(() => { /* the reactive path still renews on play */ });
    };
    const timer = window.setInterval(check, 60_000);
    const onVisible = () => { if (document.visibilityState === 'visible') check(); };
    document.addEventListener('visibilitychange', onVisible);
    window.addEventListener('focus', onVisible);
    return () => { window.clearInterval(timer); document.removeEventListener('visibilitychange', onVisible); window.removeEventListener('focus', onVisible); };
  }, [hasRecording, playCallId, recordingState, recordingUrl, currentTime]);

  // ── v12.9.12 (#792): close the menu on outside-click and Esc, and hand focus back to its button. ──
  useEffect(() => {
    if (!moreOpen) return;
    const onDown = (e: MouseEvent) => {
      if (moreWrapRef.current && !moreWrapRef.current.contains(e.target as Node)) setMoreOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { setMoreOpen(false); moreBtnRef.current?.focus(); }
    };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey); };
  }, [moreOpen]);

  // ── v12.9.12 (#793): the composer resets whenever the drawer moves to another message. A draft that
  //    survived onto a DIFFERENT caller would be the worst possible bug in a feature that sends texts. ──
  useEffect(() => {
    setComposerOpen(false); setTextBody(''); setToEditing(false);
    setSendError(null); setSending(false); setMoreOpen(false);
    // v12.9.24 (#911): the text language starts as the CALL's language - a chip inserts it in that language.
    { const callLang = selectedMessage ? languageCode(selectedMessage.language).toLowerCase().split('-')[0] : 'en';
      setTextLang(orgLangs.includes(callLang) ? callLang : 'en'); }
    setTextFrom(null); setTextXl('idle');
    setToNumber(nationalDigits(selectedMessage?.phone ?? ''));
  }, [selectedCallId]);   // eslint-disable-line react-hooks/exhaustive-deps

  // ── v12.9.13 (#803): SCROLL TO THE EDITOR WHEN IT OPENS, WHATEVER OPENED IT. ────────────────────────
  //
  // His report: N / R / L open the right editor but do not scroll to it, so from deep in a long transcript
  // nothing appears to happen - *"i tried with menu as well but that didn't work either."*
  //
  // MY WRITE-UP HAD THE CAUSE WRONG AND HIS ONE SENTENCE CORRECTED IT. I had said the menu solved this for
  // the mouse; it does not. #792's criterion - "the menu keeps them reachable while scrolled into a long
  // transcript" - passed on REACHABLE and never tested VISIBLE. Same failure shape as #790 and #771: a
  // criterion written about the mechanism instead of about what the person sees.
  //
  // Hung off the editor OPENING rather than off any control, so the keyboard, the more-actions menu and the
  // action cards are all covered by one fix instead of three. 'nearest' rather than 'center' so an editor
  // already on screen does not move under the cursor.
  const editorRef = useRef<HTMLDivElement | null>(null);
  const composerRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!drawerTool) return;
    window.setTimeout(() => editorRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 0);
  }, [drawerTool, selectedId]);
  useEffect(() => {
    if (!composerOpen) return;
    window.setTimeout(() => composerRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }), 0);
  }, [composerOpen]);

  // Focus the textarea when the composer opens; hand focus back to the button when it closes (C6).
  useEffect(() => {
    if (composerOpen) window.setTimeout(() => textAreaRef.current?.focus(), 0);
    else sendTextBtnRef.current?.focus?.();
  }, [composerOpen]);

  // ── v12.9.11 (#770): WATCH WHETHER THE PLAYER HAS SCROLLED AWAY. ────────────────────────────────────
  // His report: *"when you click on the transcript line, it starts recording, that is correct but then i can
  // not stop it until i scroll all the way to the top and pause it."* The only transport control lived at the
  // top of a drawer that runs for screens - and it bites hardest while VERIFYING a build, which is exactly
  // when he is scrolled furthest down reading the call path.
  useEffect(() => {
    const el = playerCardRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') { setPlayerOnScreen(true); return; }
    const obs = new IntersectionObserver((entries) => {
      for (const e of entries) setPlayerOnScreen(e.isIntersecting);
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [selectedCallId, recordingUrl, recordingState]);
  // v12.10.10 (#1399): the signed-in person (support sessions have none - no Me, no 'Assigned to me').
  const meId: number | null = secMe && !secMe.isSupport && secMe.user?.id ? Number(secMe.user.id) : null;
  assignMeId = meId;
  // ══ v12.10.30 (#2242 part 2): a big range with a filter (or with a search the loaded cards could not answer) is a SERVER-FILTERED list -
  // the first page, the fill to 1,000 and scroll for more all carry the filters (and the dates' end), and every counter comes from the
  // server with the same filters. A range loaded whole keeps filtering on screen - no server call (Last 7 days on UMG unchanged).
  // Follow-ups never (no dates). ══
  const rangeIsBig = bigRange != null && bigRange.window === scopeStartIso(filters.dateScope);
  const serverFilterJson = rangeIsBig && !filters.fuView ? serverFilterParam(filters, meId, serverQ) : '';
  const serverMode = serverFilterJson !== '';
  const serverTo = scopeEndIso(filters.dateScope);
  const listQs = serverMode ? `&f=${encodeURIComponent(serverFilterJson)}${serverTo ? `&to=${encodeURIComponent(serverTo)}` : ''}` : '';
  listQsRef.current = listQs;
  serverModeRef.current = serverMode;
  // ══ v12.10.12 (#1529 / #1530 / #1536, UI-PROTO-12.10.11.4 v1.6 LOCKED) ══════════════════════════════════════════
  // Messages: "N to work" = the open calls INSIDE THE SELECTED DATES (Tushar 10/9: "you select date range and the up to
  // work keeps on showing based on that so the list never grows too long"). Follow-ups: N = every open follow-up - past,
  // today and future. Me / Reminders / Urgent count inside that same base, and each one inside the OTHER picked pills
  // (pick Me, and Reminders shows how many of yours have a reminder). Setup test calls are never counted (#1461).
  const pickedModes: TopMode[] = filters.modes ?? [];
  const hasMode = (m: TopMode) => pickedModes.includes(m);
  const pillBase = allMessages.filter((message) => (filters.fuView ? message.status !== 'done' : (isCard(message) && cardOpen(message))) && !message.setupTestCall   // #2238 cards
    && (filters.fuView ? Boolean(message.reminder) : matchesDateScope(message, filters.dateScope)));
  const pillCount = (m: TopMode) => pillBase.filter((message) => modeMatch(message, m) && modesMatch(message, pickedModes, m)).length;
  const upNext = pillBase.length;
  const urgentCount = pillCount('urgent');
  const mineCount = meId === null ? 0 : pillCount('me');
  const remindersCount = pillCount('marked');
  // v12.10.21 (#1944, LOCKED v1.5): while the list is still loading (the first page, then the fill) no counter is final - Phone calls,
  // to work, Me, Reminders, Urgent and the "N calls" total show the soft grey loading mark, never 0 and never a partial number.
  const countsLoading = listPartial || messagesLoading || moreLeft != null || serverMode;   // v12.10.30 (#2242): a list not loaded whole is never counted on screen; a server-filtered one is counted by the server
  // ══ v12.10.26 (#2121, Tushar 10/30 "we agreed that we will instantly fetch all these counts on the top"): while the list loads, the
  // counters are the server's SQL counts for these dates (they came with the first page) - never blank, never a partial number. Once the
  // whole list is in, the screen counts it as before. Follow-ups (no dates) keeps the loading mark. ══
  const countsKey = `${scopeStartIso(filters.dateScope)}|${scopeEndIso(filters.dateScope) ?? ''}|${listQs}`;   // v12.10.30 (#2242): + the server filters
  const sc = !filters.fuView && serverCounts && serverCounts.key === countsKey ? serverCounts.c : null;
  // v12.10.30 (#2242 part 2): the "N calls" total - the dates' cards with no filter; for a server-filtered list the server's filtered cards
  // (with pills picked: that combination). A search the server was not asked (it found cards on screen) keeps the loading mark.
  const scTotal: number | null | undefined = !sc ? null : !hasNonDateFilters(filters) ? sc.cards
    : serverMode && (!filters.query.trim() || serverQ === filters.query.trim()) ? (pickedModes.length ? sc.combos?.[comboKey(pickedModes)] : sc.cards) : null;
  const scPill = (m: TopMode): number | undefined => sc?.combos?.[comboKey([...pickedModes.filter((x) => x !== m), m])];
  const countOrMark = (n: number, server?: number | null) => (countsLoading
    ? (server != null ? <CountText n={server} /> : <LoadingMark label="Loading the count" />)
    : <CountText n={n} />);
  const toggleMode = (m: TopMode) => setFilters((current) => {
    const cur = current.modes ?? [];
    return { ...current, modes: cur.includes(m) ? cur.filter((x) => x !== m) : [...cur, m], assigned: m === 'me' ? [] : current.assigned };
  });
  // The big number turns every pill off; in Follow-ups it also goes back to the view Follow-ups opened with (S42).
  const clearModes = () => setFilters((current) => ({ ...current, modes: [], ...(current.fuView ? { fuPills: fuDefaultPills() } : {}) }));
  // v12.10.12 (#1536 S42): in Follow-ups the date pills stay on the top row when they fit; on a narrower screen they drop
  // to their own row. Measured after every render and on resize (the prototype's fitFu).
  useLayoutEffect(() => {
    const top = headerRef.current?.querySelector('.aw-topline') as HTMLElement | null;
    if (!top) return;
    const fit = () => {
      top.classList.remove('aw-fuwrap');
      if (!filters.fuView || isPhone || !top.querySelector('.aw-fupg')) return;
      const kids = Array.from(top.children) as HTMLElement[];
      const first = kids.find((k) => k.offsetHeight > 0);
      if (!first) return;
      if (kids.some((k) => k.offsetHeight > 0 && k.offsetTop > first.offsetTop + 12)) top.classList.add('aw-fuwrap');
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  });
  // v12.10.11.3 (#1527): the top chip = due (today or overdue) INSIDE the filters applied; the left menu = every due follow-up.
  // v12.10.12 (#1534): the Follow-ups badge in this page's own menu = the person's choice, like the left menu.
  const fuPref = useFuPref();
  const totalDueCount = useMemo(() => {
    const keys = fuPrefPills(fuPref, fuPillDefs().map((p) => p.key));
    return allTenantMessages.filter((m) => m.status !== 'done' && m.reminder && !m.setupTestCall && (keys.includes('all') || keys.includes(fuBucket(m.reminderDue)))).length;
  }, [allTenantMessages, fuPref]);
  // v12.10.12 (#1540): opening Follow-ups from the left menu is a switch, not a load - time it until the list is painted.
  // The click time is taken where the left-menu link is handled (filter=follow-up below); reported once the list is painted.
  const fuOpenT0 = useRef<number | null>(null);
  useEffect(() => {
    const t0 = fuOpenT0.current;
    if (!filters.fuView || t0 === null) return;
    fuOpenT0.current = null;
    afterPaint(() => sendPerf('followups', performance.now() - t0, 0, document.querySelectorAll('.aw-list .aw-card').length));
  }, [filters.fuView, filters.fuPills]);
  // Follow-ups open on the choice; a change in Your account while the view is open moves the pills at once.
  useEffect(() => {
    setFilters((current) => (current.fuView ? { ...current, fuPills: fuPrefPills(fuPref, fuPillDefs().map((p) => p.key)) } : current));
  }, [fuPref]);
  // v12.10.11.3 (#1527): counts on the follow-up pills - every open follow-up, whatever its date.
  const fuCounts = useMemo(() => {
    const c: Record<string, number> = {};
    allMessages.forEach((m) => { if (m.status !== 'done' && m.reminder && !m.setupTestCall) { const k = fuBucket(m.reminderDue); c[k] = (c[k] ?? 0) + 1; c.all = (c.all ?? 0) + 1; } });
    return c;
  }, [allMessages]);
  // v12.10.9.1 (#1268): the person's own name and first group (Security me), not the email's first part and the token role.
  const currentUserEmail = secMe?.user?.email || claims?.email || 'Signed in';
  const secFullName = `${secMe?.user?.firstName ?? ''} ${secMe?.user?.lastName ?? ''}`.trim();
  const currentUserName = secMe?.isSupport ? 'VoiceSpectrum Support' : secFullName || displayNameFromEmail(currentUserEmail);
  const currentUserRole = secMe?.isSupport ? 'Support session' : secMe?.user?.groupNames?.[0] ?? roleLabel(claims?.role);
  const currentUserInitials = initials(currentUserName).slice(0, 2) || 'U';
  const tenantSlug = claims?.tenant_slug || sessionStorage.getItem('vs.tenantSlug') || 'workspace';
  // v12.10.11.1 (#1472): the practice's own Display name (Settings › Organization), not the slug - UMG texts said "this is Umg"
  // because a Support Ops visit never stored the name at sign-in. Fetched once; the stored name / slug only until it arrives.
  const [orgDisplayName, setOrgDisplayName] = useState<string>('');
  useEffect(() => {
    let off = false;
    api.get<{ identity?: { displayName?: string; legalName?: string } }>('/t2/settings/organization')
      .then((o) => { const n = (o?.identity?.displayName || o?.identity?.legalName || '').trim(); if (!off && n) { setOrgDisplayName(n); try { sessionStorage.setItem('vs.tenantDisplayName', n); } catch { /* blocked */ } } })
      .catch(() => { /* keep the fallback */ });
    return () => { off = true; };
  }, []);
  const tenantDisplayName = orgDisplayName || sessionStorage.getItem('vs.tenantDisplayName')?.trim() || titleFromSlug(tenantSlug);
  const tenantInitial = tenantDisplayName.trim().charAt(0).toUpperCase() || 'V';

  // v12.10.11.3 (#1523): each day heading carries its count; Oldest first lists the days oldest first (#1521). The Follow-ups
  // view is one run ordered by follow-up date.
  const groupedMessages = useMemo(() => {
    if (filters.fuView) return visibleMessages.length ? [{ bucket: 'Follow-ups' as DateBucket, messages: visibleMessages }] : [];
    const order = sortOrder === 'oldest' ? [...bucketOrder].reverse() : bucketOrder;
    return order
      .map((bucket) => ({ bucket, messages: visibleMessages.filter((message) => message.dateBucket === bucket) }))
      .filter((group) => group.messages.length > 0);
  }, [visibleMessages, sortOrder, filters.fuView]);
  // ══ v12.10.20 (#1935, T165): ONLY THE CARDS NEAR THE SCREEN ARE DRAWN. ═══════════════════════════════════════════════
  // 943 cards (40,375 page elements) were redrawn on every sort, pill and search keystroke - 1-4 s of a frozen screen (10/24).
  // The list still holds every message (counts, day headings, Batch select, "N of M", keyboard Next work on all of it); the page
  // draws the first RENDER_STEP cards and RENDER_STEP more each time the end of the drawn cards comes within 1,200 px of the
  // screen. The open / highlighted card is always drawn. A new sort, filter, search or dates starts again from the top.
  const [renderLimit, setRenderLimit] = useState(RENDER_STEP);
  useEffect(() => { setRenderLimit(RENDER_STEP); }, [listFilters, sortOrder]);   // the dates are part of listFilters
  const indexById = useMemo(() => new Map(visibleMessages.map((m, i) => [m.id, i] as const)), [visibleMessages]);
  const drawLimit = Math.max(renderLimit, highlightedIndex + 30, selectedIndex + 30);
  const drawnGroups = useMemo(() => {
    let left = drawLimit;
    const out: { bucket: DateBucket; messages: WsMessage[]; all: WsMessage[] }[] = [];
    for (const g of groupedMessages) {
      if (left <= 0) break;
      out.push({ bucket: g.bucket, messages: left >= g.messages.length ? g.messages : g.messages.slice(0, left), all: g.messages });
      left -= g.messages.length;
    }
    return out;
  }, [groupedMessages, drawLimit]);
  const moreToDraw = visibleMessages.length > drawLimit;
  const moreToFetch = !moreToDraw && moreLeft != null;   // v12.10.30 (#2242): every loaded card drawn and the dates hold more
  const moreRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const el = moreRef.current;
    if (!el || !(moreToDraw || moreToFetch) || typeof IntersectionObserver === 'undefined') return;
    const io = new IntersectionObserver((entries) => {
      if (!entries.some((e) => e.isIntersecting)) return;
      if (moreToDraw) setRenderLimit((l) => l + RENDER_STEP);
      else loadMoreRef.current();
    }, { rootMargin: '1200px 0px' });
    io.observe(el);
    return () => io.disconnect();
  }, [moreToDraw, moreToFetch, drawnGroups, loadingMore]);

  // v12.10.11.3 (#1523): "168 calls · Last 7 days" - exactly the rows the list holds (dates, filters, search).
  // v12.10.14 (#1612): Newest / Oldest - in the top bar on a desktop, on the count line on a phone
  const sortSeg = (
    <div className="aw-sort-seg" role="group" aria-label="Order">
      <button type="button" data-track="messages.sort" data-track-value="newest" className={sortOrder === 'newest' ? 'aw-on' : ''} aria-pressed={sortOrder === 'newest'} onClick={() => setSortOrder('newest')}>Newest</button>
      <button type="button" data-track="messages.sort" data-track-value="oldest" className={sortOrder === 'oldest' ? 'aw-on' : ''} aria-pressed={sortOrder === 'oldest'} onClick={() => setSortOrder('oldest')}>Oldest</button>
    </div>
  );
  // ══ v12.10.16 (T115 #1693, LOCKED UI-PROTO-BATCH-SELECT-B1 v1.5): BATCH SELECT. ══════════════════════════════════════════
  // "Batch select" on the counts line opens the panel and a checkbox in the margin of each card (the card's width never
  // changes); Ctrl+click picks cards without it and the panel opens by itself at 2. Phone: long-press, no checkboxes. Changes are
  // STAGED as chips - Add note / Set reminder / Apply label (the drawer's own templates, presets and label chips) and Mark Read |
  // Unread · Urgent | Not urgent · Pending | Completed - and nothing happens until Apply, which asks to type APPLY. A grouped
  // card counts as one card and the changes cover all its calls. Undo for 10 seconds puts status, urgency, labels and
  // reminders back (an added note stays - it is written to the message).
  const batchTargets = (ids: Iterable<string>) => {
    const out: string[] = [];
    for (const id of ids) for (const m of (callGroups.members.get(id) ?? [{ id } as WsMessage])) if (!out.includes(m.id)) out.push(m.id);
    return out;
  };
  function toggleBatch(id: string) {
    setBatchSel((cur) => {
      const next = new Set(cur);
      if (next.has(id)) next.delete(id); else next.add(id);
      if (next.size >= 2) setBatchMode(true);
      return next;
    });
  }
  function closeBatch() { setBatchMode(false); setBatchSel(new Set()); setBatchStage({}); setBatchEditing(null); setBatchConfirm(false); }
  const batchChips: [keyof BatchStage, string][] = [];
  if (batchStage.note) batchChips.push(['note', `Note: \u201c${batchStage.note}\u201d`]);
  if (batchStage.reminder) batchChips.push(['reminder', `Reminder: ${batchStage.reminder}`]);
  if (batchStage.labels?.length) batchChips.push(['labels', `Labels: ${batchStage.labels.join(', ')}`]);
  if (batchStage.read) batchChips.push(['read', `Mark ${batchStage.read.toLowerCase()}`]);
  if (batchStage.urgent) batchChips.push(['urgent', `Mark ${batchStage.urgent.toLowerCase()}`]);
  if (batchStage.status) batchChips.push(['status', `Mark ${batchStage.status.toLowerCase()}`]);
  function applyBatch() {
    const targets = batchTargets(batchSel);
    const snapshot = targets.map((id) => { const m = allTenantMessages.find((x) => x.id === id); return m ? { id, status: m.status, priority: m.priority, labels: [...m.labels], reminder: m.reminder ?? null, reminderDue: m.reminderDue ?? null } : null; })
      .filter((x): x is NonNullable<typeof x> => x !== null);
    const due = batchStage.reminder ? reminderDueFor(batchStage.reminder, batchStage.reminderPick) : null;
    for (const snap of snapshot) {
      const body: MessageMutation = {};
      let status: MsgStatus | undefined;
      if (batchStage.read === 'Read' && snap.status === 'new') status = 'prog';
      if (batchStage.read === 'Unread') status = 'new';
      if (batchStage.status === 'Pending') status = 'prog';
      if (batchStage.status === 'Completed') status = 'done';
      if (status && status !== snap.status) body.status = status;
      if (batchStage.urgent) body.priority = batchStage.urgent === 'Urgent' ? 'urgent' : 'normal';
      if (batchStage.labels?.length) body.labels = [...new Set([...snap.labels, ...batchStage.labels])];
      if (batchStage.reminder) { body.reminder = batchStage.reminder; body.reminderDue = due; }
      if (batchStage.note) body.addNote = { text: batchStage.note };
      if (Object.keys(body).length === 0) continue;
      updateMessage(snap.id, (m) => ({ ...m, ...(body.status ? { status: body.status as MsgStatus } : {}), ...(body.priority ? { priority: body.priority as WsMessage['priority'] } : {}),
        ...(body.labels ? { labels: body.labels } : {}), ...(body.reminder ? { reminder: body.reminder, reminderDue: body.reminderDue ?? null } : {}) }));
      persist(snap.id, body);
    }
    const k = batchChips.length, n = batchSel.size;
    setBatchUndo({ text: `${k} change${k > 1 ? 's' : ''} applied to ${n} message${n > 1 ? 's' : ''} \u00b7 written to each message\u2019s Activity`, snapshot });
    closeBatch();
  }
  function undoBatch() {
    const u = batchUndo;
    if (!u) return;
    for (const snap of u.snapshot) {
      updateMessage(snap.id, (m) => ({ ...m, status: snap.status, priority: snap.priority, labels: snap.labels, reminder: snap.reminder ?? null, reminderDue: snap.reminderDue }));
      persist(snap.id, { status: snap.status, priority: snap.priority, labels: snap.labels, reminder: snap.reminder ?? '', reminderDue: snap.reminderDue });
    }
    setBatchUndo(null);
    toast('info', 'Batch change undone', 'Status, urgency, labels and reminders are back. A note that was added stays.');
  }
  useEffect(() => {
    if (!batchUndo) return;
    const t = window.setTimeout(() => setBatchUndo(null), 10000);
    return () => window.clearTimeout(t);
  }, [batchUndo]);
  // Long-press on a phone selects a card (and opens batch mode) - no checkboxes there.
  const longPressRef = useRef<{ t: number; fired: boolean } | null>(null);
  const batchLink = !filters.fuView ? (
    <button type="button" className={`aw-bs-link${batchMode ? ' on' : ''}`} data-track="messages.batch.toggle"
      onClick={() => (batchMode ? closeBatch() : setBatchMode(true))}>{batchMode ? 'Batch select \u2715' : 'Batch select'}</button>
  ) : null;

  const totalLine = (
    <span className="aw-total-line">
      {/* v12.10.19 (#1882): no count while the rest of the list is on its way - "0 calls" read as "nothing came in". */}
      {/* v12.10.20 (#1934): while the rest is coming the count is never shown - the first page's 50 is not the total (the yellow bar
          says how far it got). */}
      {/* v12.10.21 (#1944, LOCKED v1.5): the soft grey mark in place of the number while the list loads - "<mark> calls". */}
      {/* v12.10.26 (#2121): with no filter beyond the dates the server's card count shows at once; with filters the mark stays until the list is in. */}
      <b>{countsLoading
        ? (scTotal != null ? <><CountText n={scTotal} /> {scTotal === 1 ? 'call' : 'calls'}</> : <><LoadingMark label="Loading the count" /> calls</>)   /* v12.10.30 (#2242) */
        : <><CountText n={visibleMessages.length} /> {visibleMessages.length === 1 ? 'call' : 'calls'}</>}</b>
      {' · '}{dateScopeLabel(filters.dateScope)}{hasNonDateFilters(filters) ? ' · filtered' : ''}
      {batchLink}{/* v12.10.16 (T115 #1693) */}
    </span>
  );
  // v12.10.12 (#1536): Follow-ups - "N follow-ups" at the right of the chip row (the date pills moved up into the top bar).
  const fuTotalLine = (
    <span className="aw-total-line">
      <b>{countOrMark(visibleMessages.length)}</b> {visibleMessages.length === 1 ? 'follow-up' : 'follow-ups'}{/* v12.10.21 (#1944) */}{hasNonDateFilters(filters) ? ' · filtered' : ''}
    </span>
  );
  // v12.10.11.3 (#1527): the follow-up pills, by reminder date, each with its count. Several can be on; "All" shows every one.
  const fuPillsRow = (
    <span className="aw-fu-pills" role="group" aria-label="Follow-up date">
      {fuPillDefs().map((p) => {
        const on = (filters.fuPills ?? ['today']).includes(p.key);
        return (
          <button key={p.key} type="button" aria-pressed={on} className={`aw-fu-pill${on ? ' aw-on' : ''}${p.key === 'overdue' ? ' aw-fu-overdue' : ''}`}
            onClick={() => setFilters((current) => {
              const cur = (current.fuPills ?? ['today']).filter((k) => k !== 'all');
              if (p.key === 'all') return { ...current, fuPills: ['all'] };
              const next = cur.includes(p.key) ? cur.filter((k) => k !== p.key) : [...cur, p.key];
              return { ...current, fuPills: next.length ? next : ['all'] };
            })}>
            {p.label}<span className="aw-fu-n">{fmtCount(fuCounts[p.key] ?? 0)}</span>
          </button>
        );
      })}
    </span>
  );
  const activeFilterLabels = useMemo(() => {
    const active: { key: keyof Filters; label: string; group?: string }[] = [];
    // v12.10.11.3 (#1522 / #1527): "N to work", the flag chip and "Me" show open calls of ANY date - the chip says so and
    // ✕ goes back to the dates; the Follow-ups view has no date at all (its pills sit at the right of this row).
    // v12.10.12 (#1529): the date chip always shows in Messages; one removable chip per picked pill (#1530 S55).
    if (!filters.fuView) active.push({ key: 'dateScope', label: `Date: ${dateScopeLabel(filters.dateScope)}` });
    (['me', 'marked', 'urgent'] as TopMode[]).filter((m) => (filters.modes ?? []).includes(m))
      .forEach((m) => active.push({ key: `mode:${m}` as keyof Filters, label: m === 'me' ? 'Assigned to me' : m === 'marked' ? 'Reminders' : 'Urgent' }));
    if (filters.query) active.push({ key: 'query', label: `Search: ${filters.query}` });
    // v12.10.14 (#1610, FILTER-PANEL v1.0 §2): one chip per group - "Label · 2" when several, "Caller · Patient" when one;
    // a click opens the panel on that group (group = its title there).
    const nameOf = (list: PracticeItem[], v: string) => list.find((x) => x.key.toLowerCase() === v.toLowerCase() || x.name.toLowerCase() === v.toLowerCase())?.name ?? (v === 'unclassified' ? 'Unclassified' : v);
    const grp = (key: keyof Filters, group: string, picked: string[], word: (v: string) => string) => {
      if (picked.length) active.push({ key, group, label: `${group} · ${picked.length > 1 ? picked.length : word(picked[0])}` });
    };
    const picks = filters.assigned ?? [];
    grp('assigned', 'Assigned to', picks, (v) => v === 'me' ? 'Me' : v === 'none' ? 'Unassigned' : (assignees.find((a) => a.id === v)?.name ?? '1 person'));
    grp('label', 'Label', fvals(filters.label), (v) => v);
    grp('callerType', 'Caller', fvals(filters.callerType), (v) => nameOf(practiceCallerTypes, v));
    grp('category', 'Category', fvals(filters.category), (v) => nameOf(practiceCategories, v));
    grp('type', 'Type', fvals(filters.type), (v) => TYPE_WORDS[v] ?? v);
    grp('outcome', 'Outcome', fvals(filters.outcome), (v) => OUTCOME_WORDS[v] ?? v);
    if (filters.status !== 'all') active.push({ key: 'status', group: 'Status', label: `Status · ${statusLabel(filters.status)}` });
    if (filters.priority !== 'all') active.push({ key: 'priority', group: 'Priority', label: `Priority · ${filters.priority === 'urgent' ? 'Urgent' : 'Normal'}` });
    if ((filters.opened ?? 'all') !== 'all') active.push({ key: 'opened', group: 'Opened', label: `Opened · ${filters.opened === 'read' ? 'Read' : 'Unread'}` });
    if ((filters.notes ?? 'all') !== 'all') active.push({ key: 'notes', group: 'Notes', label: `Notes · ${filters.notes === 'with' ? 'With notes' : 'Without notes'}` });
    if ((filters.audit ?? 'all') !== 'all') active.push({ key: 'audit', group: 'Audit', label: `Audit · ${filters.audit === 'marked' ? 'Marked for audit' : 'Not marked'}` });   // v12.10.18 (#1865)
    grp('language', 'Language', fvals(filters.language), (v) => langName(v));
    if (filters.dueOnly) active.push({ key: 'dueOnly', label: 'Due for follow-up' });
    return active;
  }, [filters, assignees, practiceListsVer]);
  // v12.10.14 (#1610): measure with every chip shown, then keep what fits on two lines (room left for "+N" and Clear all)
  useLayoutEffect(() => { setPillFit(null); }, [activeFilterLabels]);
  useLayoutEffect(() => {
    if (pillFit !== null) return;
    const box = pillsRef.current; if (!box) return;
    const chips = Array.from(box.querySelectorAll<HTMLElement>('.aw-active-pill'));
    if (chips.length < 2) return;
    const top0 = chips[0].offsetTop, lh = chips[0].offsetHeight + 6;
    const line = (el: HTMLElement) => Math.round((el.offsetTop - top0) / lh);
    const firstOver = chips.findIndex((c) => line(c) >= 2);
    if (firstOver < 0) return;
    setPillFit(Math.max(1, firstOver - 2));   // two chips' room for "+N · Show all filters" and Clear all
  }, [pillFit, activeFilterLabels]);
  useEffect(() => { const on = () => setPillFit(null); window.addEventListener('resize', on); return () => window.removeEventListener('resize', on); }, []);
  // v12.4.11 (#469 / BDR-012): collapse the pinned header once it has genuinely scrolled away.
  //
  // #461 pinned four bands in 12.4.10 and the pinning is right - the +N new chip lives in the header and a
  // chip that scrolls away cannot do its job (#453). But it pins 297px, a quarter of a 1270px viewport, held
  // permanently for chrome. Tushar: "when we scroll, it looks awkward... eliminating phone, text button,
  // selected filter line?"
  //
  // THRESHOLD, his words: "it will collapse when you scroll below the original rendered page" - the header's
  // OWN height, not the first pixel of scroll. Most filtered views are short; collapsing immediately would
  // flicker on any list barely taller than the viewport, and would change state when there was nothing to
  // gain. HYSTERESIS is not optional: collapse and expand read different pixels or the bar oscillates while
  // you rest at the boundary. Expand later than you collapse.
  //
  // THE SCROLLPORT MOVES. On desktop `.tenant-main .aw-main` is the scroller (the #461 finding - it is not
  // the window). Below 980px that override lifts, `.aw-main` goes height:auto and the WINDOW scrolls with
  // the tenant topbar owning the top of the screen. So resolve the scroller each time rather than caching a
  // node, and listen on both.
  useEffect(() => {
    // v12.4.13 (#469): resolve the real scroller instead of assuming `.aw-main` or the window.
    let scroller = resolveQueueScroller(headerRef.current);
    let frame = 0;
    const evaluate = () => {
      frame = 0;
      const y = scrollTopOf(scroller);
      // The band reads as a different surface the moment anything passes under it - not only once collapsed.
      setHeaderPinned(y > 8);
      // Release a forced-open header once the reader has actually moved on (BDR-012 §2: it survives until
      // they scroll again, not until the next stray pixel).
      if (headerForcedOpen && Math.abs(y - forcedAtRef.current) > 40) setHeaderForcedOpen(false);
      setHeaderCollapsed((collapsed) => {
        const measured = headerRef.current?.offsetHeight ?? 0;
        // MEASURE THE THRESHOLD ONLY WHILE EXPANDED, and remember it.
        // Reading offsetHeight unconditionally made this a control that fed back on its own output: the
        // moment it collapsed, the "header height" it compared against became the COLLAPSED height (61px),
        // so the expand threshold fell to 5px and the bar could never come back. The threshold is a property
        // of the full header - "scroll below the original rendered page", in Tushar's words - so it has to be
        // captured while the full header is what is on screen.
        if (!collapsed && measured > 0) expandedHeightRef.current = measured;
        const base = expandedHeightRef.current || measured;
        if (base === 0) return collapsed;
        // Hysteresis, and it is not optional: collapse and expand must read DIFFERENT pixels or the bar
        // oscillates while the reader rests at the boundary. Expand later than you collapse.
        if (!collapsed && y > base) { collapseAtRef.current = y; return true; }   // v12.4.12 (#469)
        if (collapsed && y < Math.max(base - 56, 0)) return false;
        return collapsed;
      });
    };
    // requestAnimationFrame NEVER FIRES IN A HIDDEN TAB, so coalescing through it alone leaves the header
    // frozen in whatever state it was in when the tab went to the background - and then wrong the moment it
    // comes back. Found while measuring this: the bar sat collapsed at scroll position 0. Fall through to a
    // direct call when the document is hidden, and re-evaluate on visibilitychange so returning to the tab
    // always shows a header that matches the scroll position.
    const onScroll = () => {
      if (document.hidden) { evaluate(); return; }
      if (!frame) frame = requestAnimationFrame(evaluate);
    };
    // BIND TO THE SCROLLER ITSELF, and re-bind when the list mounts.
    // Two wrong turns are recorded here because both look right:
    //   1. Binding once on mount. `.aw-main` does not exist yet while the list renders its loading state, so
    //      the query returned null and NOTHING was ever listening. Hence `messagesLoading` in the deps: the
    //      effect re-runs the moment the real list exists.
    //   2. Listening on document in the CAPTURE phase, to sidestep (1) entirely. Measured: zero events.
    //      A scrolling ELEMENT's scroll event does not reach document here at all, capture phase included -
    //      only the scroller itself sees it. The window listener below is not a duplicate of it either; it is
    //      the phone case, where below 980px `.aw-main` stops being the scrollport and the window scrolls.
    scroller?.addEventListener('scroll', onScroll, { passive: true });
    // The window listener is not a duplicate: it is the case where the document itself is the scrollport.
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('visibilitychange', onScroll);
    // A width change can move the scrollport between elements (the 980px breakpoint does exactly that), so the
    // listener is re-bound on resize rather than assuming the element found at mount is still the right one.
    const onResize = () => {
      const next = resolveQueueScroller(headerRef.current);
      if (next !== scroller) {
        scroller?.removeEventListener('scroll', onScroll);
        scroller = next;
        scroller?.addEventListener('scroll', onScroll, { passive: true });
      }
      onScroll();
    };
    window.addEventListener('resize', onResize, { passive: true });
    evaluate();
    return () => {
      if (frame) cancelAnimationFrame(frame);
      scroller?.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      document.removeEventListener('visibilitychange', onScroll);
    };
  }, [headerForcedOpen, messagesLoading]);

  const headerIsCollapsed = isPhone || (headerCollapsed && !headerForcedOpen);   // v12.10.9.4 (#1358): always compact on a phone

  // v12.10.11.3 (#1523): the day headings pin just under whatever header is pinned above the list. The header is sticky in
  // some layouts and not in others (and changes height when it collapses), so measure it rather than guess.
  useEffect(() => {
    const header = headerRef.current;
    const list = listRef.current;
    if (!header || !list) return;
    const apply = () => {
      const cs = window.getComputedStyle(header);
      const pinned = cs.position === 'sticky' || cs.position === 'fixed';
      // Where the header's bottom edge sits when pinned: its own top offset + its height (not its margin - collapsed, the
      // header keeps a bottom margin as a spacer for the height it gave up).
      const top = pinned ? (parseFloat(cs.top) || 0) + header.getBoundingClientRect().height : 0;
      list.style.setProperty('--aw-sticky-top', `${Math.round(top)}px`);
    };
    apply();
    const ro = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(apply) : null;
    ro?.observe(header, { box: 'border-box' });
    window.addEventListener('resize', apply);
    return () => { ro?.disconnect(); window.removeEventListener('resize', apply); };
  }, [headerIsCollapsed, headerPinned, messagesLoading]);

  // v12.10.11.3 (#1523, locked 10/9): a pinned day heading reads "TODAY · 40 (continued)" while its day scrolls under it.
  // Classes are set straight on the DOM - this runs on every scroll frame and must not re-render the list.
  useEffect(() => {
    const list = listRef.current;
    if (!list) return;
    let scroller = resolveQueueScroller(headerRef.current);
    let frame = 0;
    const mark = () => {
      frame = 0;
      const pin = parseFloat(list.style.getPropertyValue('--aw-sticky-top')) || 0;
      const base = scroller ? scroller.getBoundingClientRect().top : 0;
      list.querySelectorAll<HTMLElement>('.aw-bucket').forEach((section) => {
        const head = section.querySelector<HTMLElement>('.aw-bucket-head');
        if (!head) return;
        const stuck = section.getBoundingClientRect().top - base < pin - 2 && section.getBoundingClientRect().bottom - base > pin + head.offsetHeight;
        head.classList.toggle('aw-stuck', stuck);
      });
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(mark); };
    scroller?.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    const onResize = () => {
      const next = resolveQueueScroller(headerRef.current);
      if (next !== scroller) { scroller?.removeEventListener('scroll', onScroll); scroller = next; scroller?.addEventListener('scroll', onScroll, { passive: true }); }
      onScroll();
    };
    window.addEventListener('resize', onResize, { passive: true });
    mark();
    return () => {
      if (frame) cancelAnimationFrame(frame);
      scroller?.removeEventListener('scroll', onScroll);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
    };
  }, [messagesLoading, headerIsCollapsed]);

  // v12.4.12 (#469): THE FLICKER. COLLAPSING MUST NOT MOVE THE LIST.
  //
  // The header is position:sticky but still IN FLOW, so collapsing it took ~236px out of the page above the list.
  // The browser's scroll anchoring then did its job - it pulled scrollTop up by the same amount to keep the card
  // under the reader still - which put the scroll position back below the expand threshold. Expanding put the
  // 236px back, anchoring pushed scrollTop down past the collapse threshold, and round it went. Hysteresis cannot
  // stop that: the band is 56px and every state change moves the position 236px. It showed up "at the bucket
  // boundaries" because that is simply where his lists sit when the scroll crosses the header's own height, and
  // the COLLAPSED frame is the one that could not hold - his own key to the screenshots.
  //
  // So the collapsed bar keeps the full header's footprint as a bottom margin: the list stays exactly where it
  // was, scrollHeight does not change, and there is nothing for anchoring to correct or for the scroller to clamp.
  // The margin sits above the viewport (the collapse only happens once the full header has scrolled past), under
  // the pinned bar. A ResizeObserver keeps it exact while the padding transition runs and if the bar's own
  // height changes. And if anything moved scrollTop before the margin landed, the decided position is restored.
  useLayoutEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    if (!headerIsCollapsed) { el.style.marginBottom = ''; collapseAtRef.current = null; return; }
    const apply = () => {
      const full = expandedHeightRef.current;
      if (full <= 0) { el.style.marginBottom = ''; return; }
      const h = el.offsetHeight;
      if (h > 0) collapsedHeightRef.current = h;
      el.style.marginBottom = `${Math.max(0, full - h)}px`;
    };
    // Lay down the last known margin BEFORE anything reads layout, then measure and correct.
    if (expandedHeightRef.current > 0 && collapsedHeightRef.current > 0)
      el.style.marginBottom = `${Math.max(0, expandedHeightRef.current - collapsedHeightRef.current)}px`;
    apply();
    const at = collapseAtRef.current;
    collapseAtRef.current = null;
    if (at !== null) {
      // v12.4.13 (#469): the same resolver the collapse logic uses - on a phone this is `.tenant-main`.
      const sc = resolveQueueScroller(el);
      if (sc) { if (Math.abs(sc.scrollTop - at) > 1) sc.scrollTop = at; }
      else if (Math.abs((window.scrollY || document.documentElement.scrollTop || 0) - at) > 1) window.scrollTo({ top: at });
    }
    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, [headerIsCollapsed]);

  // v12.4.11 (#469 / BDR-012 §3): the filter chip. The DOMINANT filter is spelled out and the rest become a
  // count, so the chip never grows wider as filters are added - "Last 7 days +2", "Jun 19 - Sep 4 +2".
  // Dominant = the date scope, because it is the filter that decides whether a short list means a quiet week
  // or you are looking at seven days; falling back to the first active label in the existing order.
  // NO HOVER AFFORDANCE ANYWHERE, and this is locked, not a preference: hover does not exist on touch and
  // this screen is explicitly supported on phone. A hover-only list would leave a phone user with no way at
  // all to see which filters are on - and filter state has to be passively legible, or you have already
  // misread the list, which is the exact failure the pinning exists to prevent.
  const groupsOn = activeFilterLabels.filter((x) => x.group).length;   // v12.10.14 (#1612): the phone filter icon's count
  const collapsedFilterChip = useMemo(() => {
    const narrowing = activeFilterLabels.filter((item) => item.key !== 'dateScope');
    // A custom range is always a deliberate scope; a preset only counts as "set" when it differs from the
    // default the screen loads with, so the resting state reads a neutral "Filters" rather than pretending
    // the default date scope is narrowing anything.
    // A date scope is ALWAYS present on this screen - activeFilterLabels pushes it unconditionally, and the
    // pill row has always shown "Date: Last 7 days" even at rest. So the date scope is always the dominant
    // label, exactly as BDR-012's table reads it ("one -> Last 7 days", "three -> Last 7 days +2"). The
    // neutral "Filters" state is kept for the case where there is genuinely nothing to name.
    const dominant = dateScopeLabel(filters.dateScope);
    const none = !dominant && narrowing.length === 0;
    return { none, label: none ? 'Filters' : dominant, extra: narrowing.length };
  }, [activeFilterLabels, filters.dateScope]);

  // v12.10.14 (#1618): a call-path line, by its role (or, on transcripts written before 12.3.12, by its prefix).
// (moved out of the transcript block so the footer switch can count them)
// v12.10.9.4 (#1359): the one mini player - in the footer row on a phone, floating bottom-left elsewhere (#797)
  const miniPlayer = recordingUrl && recordingState === 'ready' ? (
              <div className="aw-mini-player" role="group" aria-label="Recording playback">
                <button
                  type="button"
                  className="aw-mini-play"
                  aria-label={isPlaying ? 'Pause recording' : 'Play recording'}
                  onClick={() => {
                    const a = audioRef.current;
                    if (!a) return;
                    if (a.paused) void a.play().catch(() => recoverRecording(a.currentTime, true));
                    else a.pause();
                  }}>
                  <SvgIcon name={isPlaying ? 'pause' : 'play'} />
                </button>
                {/* v12.10.14 (#1616, S234/S235): "Player" is gone - the time itself is the link to the Recording section (scroll only;
                    play / pause stays on the round button). Tooltip, no caption. */}
                <button type="button" className="aw-mini-time aw-mini-link" title="Go to the recording" aria-label={`${fmtClock(currentTime)} - go to the recording`}
                  onClick={() => {
                    const card = playerCardRef.current; if (!card) return;
                    card.scrollIntoView({ block: 'center', behavior: 'smooth' });
                    card.classList.add('aw-flash'); window.setTimeout(() => card.classList.remove('aw-flash'), 1200);
                  }}>{fmtClock(currentTime)}</button>
              </div>
              ) : null;

  const emptyCopy = emptyStateCopy(allTenantMessages.length > 0, filters);
  // v12.4.9 (#456): THE single label-colour source. Every dot on this page - picker, card chip, drawer
  // chip - resolves through this map, which is derived from availableLabels and nothing else.
  const labelColorMap = useMemo<Record<string, string>>(
    () => Object.fromEntries(availableLabels.map((label) => [label.name, label.color || LABEL_DOT_FALLBACK])),
    [availableLabels],
  );

  // D: Label filter options come from the tenant-configured availableLabels (not a hardcoded list).
  const labelFilterItems = useMemo<string[]>(() => ['all', ...availableLabels.map((label) => label.name)], [availableLabels]);

  useEffect(() => {
    if (highlightedIndex >= visibleMessages.length) {
      setHighlightedIndex(Math.max(visibleMessages.length - 1, 0));
    }
  }, [highlightedIndex, visibleMessages.length]);

  // v12.4.9 (#453) ---------------------------------------------------------------------------------
  // THE QUEUE KEEPS ITSELF CURRENT. PROTO_new_calls_chip_v1.1: this list is newest-first and
  // chronological - the Gmail case - so a new call inserts at the TOP, and inserting at the top
  // disturbs nothing below it: not the scroll position, not the row you were about to click, not the
  // record open in the drawer. That is why this needs no "click to load" gate, and why the chip is a
  // much narrower thing than a reload button: A SIGNAL THAT SOMETHING ARRIVED WHERE YOU CANNOT SEE IT.
  //
  // Out of sight means one of exactly two things, and both are read from the DOM rather than from
  // state so this loader has no React dependencies and the heartbeat below never has to be torn down
  // and rebuilt: the drawer is open (it landed on the list behind it), or the top of the list has
  // scrolled above the viewport (it inserted off screen). At the top of the list with no drawer, the
  // row simply appears and "to work" ticks up - there is nothing you missed, so there is no chip.
  // v12.10.11.3 (#1521): with Oldest first, new calls land at the BOTTOM of the list - out of sight is below, not above.
  const sortRef = useRef(sortOrder);
  sortRef.current = sortOrder;
  function arrivalIsOutOfSight() {
    if (drawerRef.current) return true;
    const rect = listRef.current?.getBoundingClientRect();
    if (!rect) return false;
    return sortRef.current === 'oldest' ? rect.bottom > window.innerHeight : rect.top < 0;
  }

  // v12.10.11.3 (#1522): the API sends the calls in the selected dates plus every open call; the dates travel as ?from=.
  const windowFromIso = scopeStartIso(filters.dateScope);
  // ══ v12.10.20 (T165 #1937): EVERY ACTION ON MESSAGES IS TIMED THE WAY STAFF FEEL IT. ═══════════════════════════════════
  // From the click / keystroke to the first cards on screen, to the whole list (open, dates), the longest the screen was frozen
  // meanwhile, the rows and cards drawn, and whether "No messages" showed before the cards came (a false empty). Numbers only.
  const lastInputAtRef = useRef(0);
  useEffect(() => {
    const mark = (e: Event) => { lastInputAtRef.current = e.timeStamp || performance.now(); };
    window.addEventListener('pointerdown', mark, true);
    window.addEventListener('keydown', mark, true);
    window.addEventListener('input', mark, true);
    return () => {
      window.removeEventListener('pointerdown', mark, true);
      window.removeEventListener('keydown', mark, true);
      window.removeEventListener('input', mark, true);
    };
  }, []);
  const perfActRef = useRef<{ action: ListAction; t0: number; first: number; sawEmpty: boolean; waitFull: boolean } | null>(null);
  const visibleCountRef = useRef(0);
  const startAct = (action: ListAction, waitFull: boolean) => {
    const now = performance.now();
    const t = lastInputAtRef.current;
    perfActRef.current = { action, t0: t > 0 && now - t < 2000 ? t : now, first: 0, sawEmpty: false, waitFull };
  };
  const finishAct = (fullMs: number) => {
    const a = perfActRef.current;
    if (!a) return;
    perfActRef.current = null;
    if (!a.first) a.first = performance.now() - a.t0;
    sendListPerf({ action: a.action, firstMs: a.first, fullMs, frozenMs: longestFrozen(a.t0, performance.now()),
      rows: visibleCountRef.current, drawn: document.querySelectorAll('.aw-card').length, falseEmpty: a.sawEmpty && visibleCountRef.current > 0 });
  };
  const actSigRef = useRef<{ sort: string; modes: string; query: string; rest: string; win: string } | null>(null);
  useEffect(() => {
    const { modes, query, dateScope: _d, ...rest } = filters;
    const sig = { sort: sortOrder, modes: JSON.stringify(modes ?? []), query: query ?? '', rest: JSON.stringify(rest), win: windowFromIso };
    const prev = actSigRef.current;
    actSigRef.current = sig;
    if (!prev) return;
    const action: ListAction | null = sig.win !== prev.win ? 'dates' : sig.sort !== prev.sort ? 'sort' : sig.modes !== prev.modes ? 'pill'
      : sig.query !== prev.query ? 'search' : sig.rest !== prev.rest ? 'filter' : null;
    if (!action) return;
    startAct(action, action === 'dates');
    if (action !== 'dates') afterPaint(() => { if (perfActRef.current?.action === action) finishAct(0); });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortOrder, filters, windowFromIso]);
  visibleCountRef.current = visibleMessages.length;   // v12.10.20 (#1937)
  if (perfActRef.current && !messagesLoading && !messagesError && !listPartial && groupedMessages.length === 0) perfActRef.current.sawEmpty = true;
  // v12.10.13 (#1561): fetch the Success / Watch / Failure flags for the window once Outcome is picked (draft or applied).
  const wantEndings = (filters.outcome ?? 'all') !== 'all' || (filterOpen && (draftFilters.outcome ?? 'all') !== 'all');
  useEffect(() => {
    if (!wantEndings || endings?.from === windowFromIso) return;
    let off = false;
    api.get<{ endings?: Record<string, string> }>(`/t2/surface/message-endings?from=${encodeURIComponent(windowFromIso)}`)
      .then((r) => { if (!off) setEndings({ from: windowFromIso, map: r?.endings ?? {} }); })
      .catch(() => { if (!off) setEndings({ from: windowFromIso, map: {} }); });
    return () => { off = true; };
  }, [wantEndings, windowFromIso, endings?.from]);
  const windowFromRef = useRef(windowFromIso);
  windowFromRef.current = windowFromIso;
  // v12.10.11.3 (#1522): list rows come without transcript lines; the drawer reads the full message once and it is kept here
  // so a background refresh never wipes what the drawer is showing.
  const detailRef = useRef<Map<string, WsMessage>>(new Map());
  // v12.10.15 (#1648): each opened message's activity (who / when / from → to), from the detail, the PUT echo and the activity POST.
  const [activityById, setActivityById] = useState<Record<string, ApiActivityRow[]>>({});
  const keepActivity = useCallback((id: string, rows: ApiActivityRow[] | null | undefined) => {
    if (rows) setActivityById((cur) => ({ ...cur, [id]: rows }));
  }, []);
  // v12.10.12 (#1540): which list a load is for - the Performance Analyzer keeps Messages and Follow-ups apart.
  const fuViewRef = useRef(false);
  fuViewRef.current = Boolean(filters.fuView);
  // v12.10.16.1 (#1703): what the first page must follow - read inside loadMessages without re-creating it.
  const firstPageRef = useRef({ oldest: false, open: false });
  firstPageRef.current = { oldest: sortOrder === 'oldest', open: filters.status === 'prog' || filters.status === 'new' };
  // v12.10.26 (#2121): what the first page's counters are counted for - the end of the dates and the signed-in person (Me).
  const countsToRef = useRef<string | null>(null);
  countsToRef.current = scopeEndIso(filters.dateScope);
  const countsMeRef = useRef<number | null>(null);
  countsMeRef.current = meId;
  // v12.10.26 (#2122): every first-page load (open / dates / a restart) gets a token - an answer to an older one is dropped.
  const loadTokenRef = useRef(0);
  // v12.10.19 (#1882): the row-version cursor of the last FULL list for these dates - null = ask for the full list.
  const cursorRef = useRef<number | null>(null);
  // v12.10.20 (#1934): the chunked fill - a token per fill (a newer fill or other dates stop the old one) and whether one is running.
  const fillTokenRef = useRef(0);
  const fillingRef = useRef(false);
  const fillRestRef = useRef<(askedWindow: string, windowTotal: number | null, firstCount: number, askedQs?: string) => void>(() => {});   // v12.10.30 (#2242): + askedQs
  const fillMergeRef = useRef<((rows: ApiMessageRow[]) => void) | null>(null);   // v12.10.30 (#2242)
  const loadMessages = useCallback((mode: 'initial' | 'refresh' | 'window' | 'fill', take?: number) => {
    let cancelled = false;
    const startSeq = mutSeqRef.current;   // v12.10.16 (#1677): what this answer may NOT overwrite - anything changed after now
    const askedWindow = windowFromRef.current;
    const askedTo = countsToRef.current;   // v12.10.26 (#2121)
    const askedQs = listQsRef.current;   // v12.10.30 (#2242 part 2): the server filters this answer is for ('' = none)
    const loadToken = mode === 'initial' || mode === 'window' ? ++loadTokenRef.current : loadTokenRef.current;   // v12.10.26 (#2122)
    const perfT0 = performance.now();   // v12.10.12 (#1540): a background refresh is not timed - nobody is waiting on it
    // v12.10.20 (#1934): other dates - the old list leaves the screen at once (no "49 calls" from the previous dates while the new
    // ones load); the spinner shows until the first cards arrive, then the yellow bar until the rest is in.
    if (mode === 'window') {
      fillTokenRef.current += 1; fillingRef.current = false;
      cursorRef.current = null;
      setQueues(emptyQueues());
      setListPartial(true);
      setFillProgress(null);
      setListTruncated(false);
    }
    if (mode === 'initial' || mode === 'window') setMoreLeft(null);   // v12.10.30 (#2242)
    if (mode === 'initial') {
      setMessagesLoading(true);
      setMessagesError('');
    }

    // NEW: /t2/surface/messages returns an ENVELOPE (messages + labelColors + availableLabels).
    // v12.10.16.1 (#1703): the first page follows the sort and the Pending filter on screen (UMG works oldest first).
    const fp = firstPageRef.current;
    // v12.10.19 (#1882): a heartbeat on the dates already loaded asks only for what changed since the last answer.
    const since = mode === 'refresh' && !take && cursorRef.current != null && loadedWindowRef.current === askedWindow ? cursorRef.current : null;
    // v12.10.26 (#2121): the first page also asks for the counters of these dates (counted in SQL on the server).
    const countsQ = take && mode !== 'fill'
      ? `&counts=true${askedTo ? `&cto=${encodeURIComponent(askedTo)}` : ''}${countsMeRef.current != null ? `&me=${countsMeRef.current}` : ''}` : '';
    api.get<ApiMessagesEnvelope>(`/t2/surface/messages?from=${encodeURIComponent(askedWindow)}${take ? `&take=${take}${fp.oldest ? '&order=oldest' : ''}${fp.open ? '&open=true' : ''}` : ''}${countsQ}${askedQs}${since != null ? `&since=${since}` : ''}`)
      .then((envelope) => {
        if (cancelled) return;
        // v12.10.26 (#2122): a newer first-page load (Oldest / Newest or Pending changed while loading) replaced this one.
        if ((mode === 'initial' || mode === 'window') && loadToken !== loadTokenRef.current) return;
        if (envelope?.counts) setServerCounts({ key: `${askedWindow}|${askedTo ?? ''}|${askedQs}`, c: envelope.counts });   // v12.10.26 (#2121); v12.10.30 (#2242): + filters
        // v12.10.16 (#1688): an answer for dates the screen has since left is dropped (a new load for the new dates is on its way).
        if (askedWindow !== windowFromRef.current) return;
        if (askedQs !== listQsRef.current) return;   // v12.10.30 (#2242): the server filters changed meanwhile - the restart's load is on its way
        // ══ v12.10.19 (#1882): a DELTA - merge the changed calls in place, drop the removed ones, keep everything else. ══
        if (envelope?.delta) {
          cursorRef.current = envelope.cursor ?? cursorRef.current;
          const changed = (envelope.messages ?? []).map(toMessage);
          const gone = new Set(envelope.removed ?? []);
          if (changed.length === 0 && gone.size === 0) return;
          changed.forEach((m) => { if (!m.inProgress) detailRef.current.delete(m.id); });   // the drawer reads a changed call again
          if (changed.some((m) => m.id === selectedIdRef.current)) setDetailReload((n) => n + 1);   // v12.10.22 (#2001): ...and it really does
          gone.forEach((id) => detailRef.current.delete(id));
          const arrived = changed.map((m) => m.id).filter((id) => !knownIdsRef.current.has(id));
          if (arrived.length > 0 && knownIdsRef.current.size > 0 && arrivalIsOutOfSight()) {
            setArrivedIds((current) => [...current, ...arrived.filter((id) => !current.includes(id))]);
          }
          arrived.forEach((id) => knownIdsRef.current.add(id));
          gone.forEach((id) => knownIdsRef.current.delete(id));
          listVersionRef.current += 1;
          setQueues((current) => {
            const byId = new Map(changed.map((m) => [m.id, m] as const));
            const keep = (m: WsMessage) => (pendingRef.current.get(m.id) ?? 0) > 0 || (lastMutRef.current.get(m.id) ?? 0) > startSeq;
            const draft = labelDraftRef.current;
            const apply = (list: WsMessage[], kind: 'call' | 'text') => {
              const out = list.filter((m) => !gone.has(m.id)).map((m) => {
                const n = byId.get(m.id);
                if (!n || keep(m)) return m;
                const full = detailRef.current.get(m.id);
                // v12.10.22 (#2001, #44-0191 / #44-0198): a changed call's detail is dropped above so it is read again - but until that read
                // lands, the lean row (no transcript) replaced the open drawer's transcript and it vanished (playing / pausing writes
                // activity, so the open call is exactly the one that changes). The lines already on screen stay until the new read arrives.
                const merged = full ? { ...n, transcript: full.transcript, capturedFields: full.capturedFields }
                  : { ...n, transcript: n.transcript && n.transcript.length > 0 ? n.transcript : m.transcript, capturedFields: n.capturedFields && n.capturedFields.length > 0 ? n.capturedFields : m.capturedFields };   // v12.10.20 (#1936)
                return draft && m.id === draft.id ? { ...merged, labels: draft.labels } : merged;
              });
              const have = new Set(list.map((m) => m.id));
              changed.forEach((m) => { if (m.kind === kind && !have.has(m.id)) out.push(m); });
              return out;
            };
            return { call: apply(current.call, 'call'), text: apply(current.text, 'text') };
          });
          setMessagesError('');
          return;
        }
        if (!envelope?.partial) cursorRef.current = envelope?.cursor ?? null;   // v12.10.19 (#1882): a full list sets the cursor
        const rows = envelope?.messages ?? [];
        const perfFetch = performance.now() - perfT0;
        if (mode !== 'refresh' && mode !== 'fill') afterPaint(() => sendPerf(fuViewRef.current ? 'followups' : 'messages', performance.now() - perfT0, perfFetch, rows.length));
        // v12.10.20 (#1937): the first cards of an open / date change are on screen
        if (mode !== 'refresh' && mode !== 'fill') afterPaint(() => { const a = perfActRef.current; if (a?.waitFull && !a.first) a.first = performance.now() - a.t0; if (a?.waitFull && !envelope?.partial) finishAct(performance.now() - a.t0); });
        const next = emptyQueues();
        rows.map(toMessage).forEach((message) => {
          const full = detailRef.current.get(message.id);
          next[message.kind].push(full ? { ...message, transcript: full.transcript, capturedFields: full.capturedFields } : message);   // v12.10.20 (#1936)
        });
        setListTruncated(Boolean(envelope?.truncated));
        if (envelope?.grouping !== undefined) setGroupRule(envelope.grouping ?? null);   // v12.10.16 (#1690)
        const incoming = [...next.call, ...next.text];

        // Anything not in the baseline is an arrival. The first refresh after a successful initial
        // load announces nothing, because that load filled knownIdsRef. If the initial load FAILED the
        // baseline is empty, and diffing against it would announce the entire queue as new - so an
        // empty baseline is treated as "no baseline yet" and only seeds one.
        // v12.10.11.3 (#1522): widening the dates brings older calls in - those are not arrivals.
        if (mode === 'refresh' && knownIdsRef.current.size > 0 && !envelope?.partial) {
          const arrived = incoming.map((message) => message.id).filter((id) => !knownIdsRef.current.has(id));
          if (arrived.length > 0 && arrivalIsOutOfSight()) {
            setArrivedIds((current) => [...current, ...arrived.filter((id) => !current.includes(id))]);
          }
        }
        // v12.10.16 (#1688): a first page is not the whole list - the known ids grow with it, never shrink to it.
        if (envelope?.partial) incoming.forEach((message) => knownIdsRef.current.add(message.id));
        else knownIdsRef.current = new Set(incoming.map((message) => message.id));
        listVersionRef.current += 1;
        loadedWindowRef.current = askedWindow;

        setQueues((current) => {
          // A poll must never overwrite a change that is still in flight to the server. Rows with an
          // open PUT keep their optimistic local copy; persist() clears them when the echo lands.
          // v12.4.12 (#468 reopened): NOR may it overwrite labels picked in the editor and not yet committed.
          // The editor has no PUT until it closes (HH), so pendingRef never held that row and every tick wiped
          // the picks - 7-8 seconds after the click on his screen, and the chips cleared with them. The draft is
          // laid over the incoming row; every OTHER field on that row still refreshes.
          // v12.10.16 (#1677): NOR may an answer to a question asked BEFORE a change overwrite it - even once the
          // change's echo has landed. A row changed here after this load started keeps the local copy.
          const draft = labelDraftRef.current;
          const held = new Map<string, WsMessage>();
          [...current.call, ...current.text].forEach((message) => {
            if ((pendingRef.current.get(message.id) ?? 0) > 0 || (lastMutRef.current.get(message.id) ?? 0) > startSeq) held.set(message.id, message);
          });
          // v12.10.16 (#1688): the first page keeps the rows it does not carry (they are on their way in the fill).
          if (envelope?.partial && mode !== 'initial') {
            const got = new Set(incoming.map((m) => m.id));
            current.call.forEach((m) => { if (!got.has(m.id)) next.call.push(m); });
            current.text.forEach((m) => { if (!got.has(m.id)) next.text.push(m); });
          }
          if (held.size === 0 && !draft) return next;
          const merge = (message: WsMessage): WsMessage => held.get(message.id)
            ?? (draft && message.id === draft.id ? { ...message, labels: draft.labels } : message);
          return {
            call: next.call.map(merge),
            text: next.text.map(merge),
          };
        });
        setAvailableLabels(envelope?.availableLabels ?? []);
        setSelectedId((current) => (
          current && incoming.some((message) => message.id === current)
            ? current
            : (mode === 'refresh' || mode === 'fill' ? current : null)
        ));
        if (mode === 'refresh' || mode === 'fill') setMessagesError('');
        setListPartial(Boolean(envelope?.partial));
        // v12.10.16 (#1688): the first page is on screen - ask for the whole list now.
        // v12.10.20 (#1934): the rest in chunks with a count (an API without the count: the whole list in one answer, as before).
        if (envelope?.partial && mode !== 'fill') fillRestRef.current(askedWindow, envelope.windowTotal ?? null, rows.length, askedQs);   // v12.10.30 (#2242): + filters
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        // A failed BACKGROUND refresh must not blank a queue the agent is working in. It stays quiet
        // and the next tick tries again; only the initial load owns the error surface.
        if (mode === 'refresh') return;
        if (mode === 'fill') { setListPartial(false); return; }   // v12.10.16: the first page stays; the heartbeat brings the rest
        if (err instanceof ApiError && err.status === 403) {
          // v12.10.9.4 (#1379): refused = no access, said plainly.
          setMessagesError('You don’t have access to Messages - ask your practice admin.');
        } else if (err instanceof ApiError) {
          setMessagesError(`API ${err.status}: messages could not be loaded from the tenant database.`);
        } else {
          setMessagesError('Messages could not be loaded from the tenant database.');
        }
        setQueues(emptyQueues());
      })
      .finally(() => {
        if (!cancelled && mode === 'initial') setMessagesLoading(false);
      });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // v12.10.16 (#1688): a kept list for these dates is already on screen - bring it up to date quietly. Nothing kept:
  // the first page, then the rest.
  useEffect(() => {
    if (cachedList(windowFromRef.current)) return loadMessages('refresh');
    setMessagesLoading(true);
    startAct('open', true);   // v12.10.20 (#1937)
    return loadMessages('initial', FIRST_PAGE);
  }, [loadMessages]);
  // ══ v12.10.20 (#1934, T165): THE REST OF THE DATES IN CHUNKS. ══════════════════════════════════════════════════════════
  // After the first page: the dates' calls newest first, FILL_CHUNK at a time, merged in as they come (the cards already on screen
  // stay put), the yellow bar saying how far it got; then the open calls outside the dates; then the heartbeat cursor of the FIRST
  // chunk (taken before it was read, so nothing written meanwhile is missed). Other dates or a newer fill stop this one.
  fillRestRef.current = (askedWindow: string, windowTotal: number | null, firstCount: number, askedQs = '') => {
    if (windowTotal == null) { loadMessages('fill'); return; }
    // v12.10.30 (#2242 part 2): an UNFILTERED first page says how big the dates are - over FILL_CAP the list is never whole, so from now on
    // filters (and a search with no match on screen) run on the server. A filtered answer's total is the matches, never the dates'.
    if (!askedQs) setBigRange(windowTotal > FILL_CAP ? { window: askedWindow, total: windowTotal } : null);
    const token = ++fillTokenRef.current;
    fillingRef.current = true;
    const alive = () => fillTokenRef.current === token && askedWindow === windowFromRef.current;
    setFillProgress({ loaded: Math.min(firstCount, windowTotal), total: windowTotal });
    const merge = (rows: ApiMessageRow[]) => {
      const incoming = rows.map(toMessage).map((m) => {
        const full = detailRef.current.get(m.id);
        return full ? { ...m, transcript: full.transcript, capturedFields: full.capturedFields } : m;
      });
      incoming.forEach((m) => knownIdsRef.current.add(m.id));
      setQueues((current) => {
        const byId = new Map(incoming.map((m) => [m.id, m] as const));
        const keep = (m: WsMessage) => (pendingRef.current.get(m.id) ?? 0) > 0 || labelDraftRef.current?.id === m.id;
        const apply = (list: WsMessage[], kind: 'call' | 'text') => {
          const have = new Set(list.map((m) => m.id));
          const out = list.map((m) => { const n = byId.get(m.id); return n && !keep(m) ? n : m; });
          incoming.forEach((m) => { if (m.kind === kind && !have.has(m.id)) out.push(m); });
          return out;
        };
        return { call: apply(current.call, 'call'), text: apply(current.text, 'text') };
      });
    };
    fillMergeRef.current = merge;   // v12.10.30 (#2242): scroll for more merges the same way
    const base = `/t2/surface/messages?from=${encodeURIComponent(askedWindow)}`;
    const listBase = base + askedQs;   // v12.10.30 (#2242 part 2): the chunks carry the server filters (the follow-ups outside the dates do not)
    // v12.10.30 (#2242): fill to FILL_CAP only, in the order on screen; the rest comes by scrolling (loadMore).
    const oldest = firstPageRef.current.oldest;
    const fillTo = Math.min(windowTotal, FILL_CAP);
    void (async () => {
      let cursor: number | null = null;
      try {
        for (let skip = 0; skip < fillTo; skip += FILL_CHUNK) {
          const env = await api.get<ApiMessagesEnvelope>(`${listBase}&take=${Math.min(FILL_CHUNK, fillTo - skip)}&skip=${skip}${oldest ? '&order=oldest' : ''}`);
          if (!alive()) return;
          if (skip === 0) cursor = env?.cursor ?? null;
          merge(env?.messages ?? []);
          setFillProgress({ loaded: Math.min(fillTo, skip + FILL_CHUNK), total: fillTo });
        }
        setMoreLeft(windowTotal > fillTo ? { window: askedWindow, next: fillTo, total: windowTotal, oldest } : null);
        const out = await api.get<ApiMessagesEnvelope>(`${base}&outside=true`);
        if (!alive()) return;
        merge(out?.messages ?? []);
        setListTruncated(Boolean(out?.truncated));
        cursorRef.current = cursor;
        loadedWindowRef.current = askedWindow;
        listVersionRef.current += 1;
      } catch {
        /* the cards in so far stay; the heartbeat reads the full list (no cursor) */
      } finally {
        if (fillTokenRef.current === token) {
          fillingRef.current = false;
          setListPartial(false);
          setFillProgress(null);
          // v12.10.20 (#1937): the whole list is in - the open / dates action reports first cards + full list
          afterPaint(() => { const a = perfActRef.current; if (a?.waitFull) finishAct(performance.now() - a.t0); });
        }
      }
    })();
  };
  useEffect(() => () => { fillTokenRef.current += 1; fillingRef.current = false; }, []);   // leaving Messages stops a fill
  // ══ v12.10.30 (#2242): SCROLL FOR MORE - the next MORE_CHUNK calls of the dates, in the order on screen, merged like the fill. ══
  const loadMore = () => {
    const m = moreLeftRef.current;
    if (!m || loadingMoreRef.current || fillingRef.current || m.window !== windowFromRef.current) return;
    loadingMoreRef.current = true; setLoadingMore(true);
    const token = fillTokenRef.current;
    api.get<ApiMessagesEnvelope>(`/t2/surface/messages?from=${encodeURIComponent(m.window)}&take=${MORE_CHUNK}&skip=${m.next}${m.oldest ? '&order=oldest' : ''}${listQsRef.current}`)   // v12.10.30 (#2242): + the server filters
      .then((env) => {
        if (token !== fillTokenRef.current || moreLeftRef.current !== m) return;   // other dates / a restart meanwhile
        fillMergeRef.current?.(env?.messages ?? []);
        const next = m.next + MORE_CHUNK;
        setMoreLeft(next < m.total && (env?.messages ?? []).length > 0 ? { ...m, next } : null);
        listVersionRef.current += 1;
      })
      .catch(() => { /* the cards in stay; the next scroll tries again */ })
      .finally(() => { loadingMoreRef.current = false; setLoadingMore(false); });
  };
  const loadMoreRef = useRef(loadMore);
  loadMoreRef.current = loadMore;

  // v12.10.16 (#1688): keep the list for the next visit - every change, so a Mark complete is kept too.
  useEffect(() => {
    if (messagesLoading || messagesError || listPartial || moreLeftRef.current || listQsRef.current || !loadedWindowRef.current) return;   // v12.10.30 (#2242): a part list / a server-filtered list is not kept
    listCache = { token: currentToken(), windowFrom: loadedWindowRef.current, queues, labels: availableLabels, truncated: listTruncated, groupRule };
  }, [queues, availableLabels, listTruncated, messagesLoading, messagesError, listPartial, groupRule]);
  // v12.10.11.3 (#1522): a different date choice asks the API for that window (open calls come either way).
  const lastWindowRef = useRef(windowFromIso);
  useEffect(() => {
    if (lastWindowRef.current === windowFromIso) return;
    lastWindowRef.current = windowFromIso;
    return loadMessages('window', FIRST_PAGE);   // v12.10.20 (#1934): first cards first, on every date change
  }, [windowFromIso, loadMessages]);
  // ══ v12.10.26 (#2122, UAT1 10/30: Oldest at 2.3 s re-sorted only the newest 50 until the whole list was in, ~13 s): Oldest / Newest or
  // the Pending filter changed WHILE the list is still loading -> the load restarts at once with the new order: the server sends the
  // oldest (or newest) first page of the dates (?order=oldest), then the rest comes as before. Other filters work on the cards already in
  // and on every chunk as it lands. Once the whole list is in, a change only re-sorts / re-filters what is on screen. ══
  // v12.10.30 (#2242 part 2): + the server filters of a big range ('' for a range loaded whole, so its key - and behaviour - is unchanged).
  const restartKey = `${sortOrder}|${filters.status === 'prog' || filters.status === 'new' ? 'open' : 'all'}|${listQs}`;
  const restartKeyRef = useRef(restartKey);
  const restartQsRef = useRef(listQs);
  const restartWinRef = useRef(windowFromIso);
  useEffect(() => {
    if (restartKeyRef.current === restartKey) return;
    restartKeyRef.current = restartKey;
    // v12.10.30 (#2242 part 2): the server filters changed (on, off or other ones) - the cards on screen are the wrong set of calls, so the
    // list reloads whatever its state (also into Follow-ups: it needs the dates' whole list back). Not when the dates changed in the same
    // moment - the dates' own load (above) already asked with the filters of now.
    const qsChanged = restartQsRef.current !== listQs;
    restartQsRef.current = listQs;
    if (qsChanged) return restartWinRef.current !== windowFromIso ? undefined : loadMessages('window', FIRST_PAGE);
    if (!(listPartial || fillingRef.current || messagesLoading || moreLeftRef.current) || filters.fuView) return;   // v12.10.30 (#2242): + a part list
    return loadMessages('window', FIRST_PAGE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [restartKey, loadMessages]);
  useEffect(() => { restartWinRef.current = windowFromIso; });   // v12.10.30 (#2242): after the restart check - "the dates changed in this same render"
  // ══ v12.10.30 (#2242 part 2, Tushar 11/3 "search should work first on loaded data and then backend call to server if no data found"):
  // the search runs on the loaded cards first (messageMatchesFilters, as always). Only a big range whose loaded cards hold NO match asks the
  // server - the same list request with the search in `f` (reference / phone digits / name, inside the dates and the filters). A refined
  // search (the asked one + more) keeps the server's answer and narrows it on screen - if that leaves nothing it asks again; another search,
  // or none, goes back to the dates' list. Nothing on the server either -> the "Search all dates (N found)" offer, as before. ══
  useEffect(() => {
    const q = filters.query.trim();
    if (serverQ && (!q || !q.toLowerCase().includes(serverQ.toLowerCase()))) { setServerQ(null); return; }
    if (q.length < 2 || !rangeIsBig || filters.fuView || searchAllDates || serverQ === q) return;
    if (messagesLoading || listPartial || fillingRef.current || visibleMessages.length > 0) return;
    const tm = window.setTimeout(() => setServerQ(q), 450);
    return () => window.clearTimeout(tm);
  }, [filters.query, serverQ, rangeIsBig, filters.fuView, searchAllDates, messagesLoading, listPartial, visibleMessages.length]);
  // v12.10.11.3 (#1522): the drawer's message, complete (transcript lines included), read once when it opens.
  // v12.10.22 (#2001): and again when the heartbeat says the open call changed (detailReload) - the lines on screen stay meanwhile.
  useEffect(() => {
    if (!selectedId) return;
    setLastOpenedId(selectedId);   // #1524: the solid "Last opened" mark after the drawer closes
    if (detailRef.current.has(selectedId)) return;
    let off = false;
    const perfT0 = performance.now();   // v12.10.12 (#1540): "Open one message"
    api.get<ApiMessageRow>(`/t2/surface/messages/${encodeURIComponent(selectedId)}`)
      .then((row) => {
        if (off || !row) return;
        const perfFetch = performance.now() - perfT0;
        afterPaint(() => sendPerf('message', performance.now() - perfT0, perfFetch, 1));
        const full = toMessage(row);
        keepActivity(full.id, row.activity);   // v12.10.15 (#1648)
        if (!full.inProgress) detailRef.current.set(full.id, full);   // a call still on the line is read again next time
        const put = (m: WsMessage) => (m.id === full.id ? { ...m, transcript: full.transcript, capturedFields: full.capturedFields } : m);
        setQueues((current) => ({ call: current.call.map(put), text: current.text.map(put) }));
      })
      .catch(() => { /* the drawer still shows the summary; the transcript area says nothing was loaded */ });
    return () => { off = true; };
  }, [selectedId, detailReload]);

  // v12.10.30 (#1156): the call back was written on its message (system note, transcript block, Activity line) - read that message
  // again so they show at once. The server writes a moment after Twilio's ending, so it is read twice.
  useEffect(() => {
    const onDone = (e: Event) => {
      const id = (e as CustomEvent<{ messageId?: string | null }>).detail?.messageId;
      if (!id) return;
      detailRef.current.delete(id);
      [700, 4000].forEach((ms) => window.setTimeout(() => {
        api.get<ApiMessageRow>(`/t2/surface/messages/${encodeURIComponent(id)}`)
          .then((row) => { if (!row) return; reconcileMessage(row); keepActivity(row.id, row.activity); setActivityTick((n) => n + 1); })
          .catch(() => { /* the next heartbeat brings it */ });
      }, ms));
    };
    window.addEventListener(CALLBACK_DONE_EVENT, onDone);
    return () => window.removeEventListener(CALLBACK_DONE_EVENT, onDone);
  });

  // v12.10.30 (#1157 H2 / 5b): a live transfer was accepted - the caller's own card opens (the call starts on hold in its window).
  useEffect(() => {
    const open = (id: string | null | undefined) => { if (id) requestSelectRef.current(id); };
    open(takePendingOpen());
    const on = (e: Event) => { takePendingOpen(); open((e as CustomEvent<{ id?: string }>).detail?.id); };
    window.addEventListener(OPEN_MESSAGE_EVENT, on);
    return () => window.removeEventListener(OPEN_MESSAGE_EVENT, on);
  }, []);

  // v12.10.16 (#1690): the Combined view reads every call in the group - each one's transcript and Call data, once.
  useEffect(() => {
    if (!combinedView || !selGroup) return;
    let off = false;
    for (const m of selGroup.slice(1)) {
      if (detailRef.current.has(m.id)) continue;
      api.get<ApiMessageRow>(`/t2/surface/messages/${encodeURIComponent(m.id)}`)
        .then((row) => {
          if (off || !row) return;
          const full = toMessage(row);
          if (!full.inProgress) detailRef.current.set(full.id, full);
          const put = (x: WsMessage) => (x.id === full.id ? { ...x, transcript: full.transcript, capturedFields: full.capturedFields } : x);
          setQueues((current) => ({ call: current.call.map(put), text: current.text.map(put) }));
        })
        .catch(() => { /* that call's transcript area says Loading; the rest of the drawer works */ });
    }
    return () => { off = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [combinedView, selGroup?.map((m) => m.id).join(',')]);

  // The heartbeat. Paused while the tab is hidden - polling a background tab spends the tenant's API
  // budget on a screen nobody is looking at - and fired once the moment it comes back, so returning
  // to the tab shows the current queue rather than one up to 30s stale.
  useEffect(() => {
    let cancelInFlight: (() => void) | undefined;
    function tick() {
      if (document.visibilityState !== 'visible') return;
      if (fillingRef.current) return;   // v12.10.20 (#1934): the chunks are still coming - the heartbeat waits for them
      // Cancel the previous poll before starting another. Two overlapping responses would land in
      // an order the network chose rather than the one they were asked in.
      cancelInFlight?.();
      cancelInFlight = loadMessages('refresh');
      // v12.10.30 (#2242): a list not loaded whole cannot count itself - the counters of the dates come from the server on every beat.
      // v12.10.30 (#2242 part 2): a server-filtered list is counted by the server too (with its filters), loaded whole or not.
      const m = moreLeftRef.current;
      const qs = listQsRef.current;
      const win = m?.window ?? (serverModeRef.current ? windowFromRef.current : null);
      if (win) {
        const to = countsToRef.current; const me = countsMeRef.current;
        api.get<{ counts: ApiWindowCounts | null }>(`/t2/surface/messages/counts?from=${encodeURIComponent(win)}${to ? `&cto=${encodeURIComponent(to)}` : ''}${me != null ? `&me=${me}` : ''}${qs}`)
          .then((r) => { if (r?.counts && windowFromRef.current === win && listQsRef.current === qs) setServerCounts({ key: `${win}|${to ?? ''}|${qs}`, c: r.counts }); })
          .catch(() => { /* the counters on screen stay */ });
      }
    }
    // v12.10.16.1 (#1702, Tushar 10/14 "Practice setting for refresh interval"): every 10 s re-read UMG's whole list (1.4 MB,
    // 2.3 s) per open tab. The practice sets it (Settings › Personalization › Repeat callers), default 30 s.
    const timer = window.setInterval(tick, refreshMs);
    document.addEventListener('visibilitychange', tick);
    return () => {
      cancelInFlight?.();
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', tick);
    };
  }, [loadMessages, refreshMs]);

  // The chip clears itself the moment what it is pointing at becomes visible - the agent scrolls back
  // to the top, or closes the drawer - without them having to click it. A chip that outlives the thing
  // it announces is the next defect.
  useEffect(() => {
    if (arrivedIds.length === 0) return;
    function check() {
      if (!arrivalIsOutOfSight()) setArrivedIds([]);
    }
    check();
    window.addEventListener('scroll', check, true);
    return () => window.removeEventListener('scroll', check, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [arrivedIds.length, selectedId]);

  // X: the sidebar "Follow-ups" nav routes to /messages?filter=follow-up. Auto-apply the
  // dueOnly filter so the filtered screen loads, then strip the param so refresh/back is clean.
  // v12.10.7 (#1163): Contacts › Calls opens a call here as /messages?q=<reference> - the search box is filled with it.
  useEffect(() => {
    const q = searchParams.get('q');
    if (!q) return;
    setFilters((current) => ({ ...current, query: q }));
    const next = new URLSearchParams(searchParams);
    next.delete('q');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (searchParams.get('filter') !== 'follow-up') return;
    // v12.10.9.4 (#1380): Follow-ups opens the default view with only "Due for follow-up" on.
    // v12.10.11.3 (#1527): Follow-ups = every due follow-up, NO date filter, pills by reminder date with Overdue + Today
    // chosen (so the list matches the left-menu number). The filters they had are kept for the way back to Messages.
    if (!messagesLoading) fuOpenT0.current = performance.now();   // v12.10.12 (#1540) - a first load is timed by loadMessages
    setFilters((current) => {
      if (!current.fuView) beforeFollowupsRef.current = current;
      const fu: Filters = { ...initialFilters, dateScope: current.dateScope, fuView: true, fuPills: fuDefaultPills(), modes: [] };   // v12.10.12 (#1534)
      setDraftFilters(fu);
      return fu;
    });
    const next = new URLSearchParams(searchParams);
    next.delete('filter');
    setSearchParams(next, { replace: true });
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    if (!accountOpen) return;
    function closeOnOutsideClick(event: MouseEvent) {
      if (accountRef.current?.contains(event.target as Node)) return;
      setAccountOpen(false);
    }
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [accountOpen]);

  useEffect(() => {
    if (!mobileAccountOpen) return;
    function closeOnOutsideClick(event: MouseEvent) {
      if (mobileAccountRef.current?.contains(event.target as Node)) return;
      setMobileAccountOpen(false);
    }
    document.addEventListener('mousedown', closeOnOutsideClick);
    return () => document.removeEventListener('mousedown', closeOnOutsideClick);
  }, [mobileAccountOpen]);

  // v12.10.13 (#1558, §42): the Filters panel fits the window from where it starts; only its groups scroll if they must.
  useLayoutEffect(() => {
    if (!filterOpen || isPhone) return;
    const fit = () => {
      const el = filterPanelRef.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top;
      el.style.maxHeight = `${Math.max(240, Math.floor(window.innerHeight - top - 12))}px`;
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [filterOpen, isPhone]);

  useEffect(() => {
    if (!dateOpen && !filterOpen) return;
    function closeFloatingPanels(event: PointerEvent) {
      const target = event.target as Node;
      if (dateWrapRef.current?.contains(target)) return;
      if (filterWrapRef.current?.contains(target)) return;
      if (filterPanelRef.current?.contains(target) || phoneFilterRef.current?.contains(target)) return;   // v12.10.14 (#1612): the phone sheet + its icon
      setDateOpen(false);
      setFilterOpen(false);
    }
    document.addEventListener('pointerdown', closeFloatingPanels);
    return () => document.removeEventListener('pointerdown', closeFloatingPanels);
  }, [dateOpen, filterOpen]);

  // v12.10.22.2 (#2059): Esc closes the open Filters panel (as Cancel - the draft is dropped) and the date panel, like every drawer
  // and menu. Caught first (capture) so the open message drawer is not closed by the same key.
  useEffect(() => {
    if (!dateOpen && !filterOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.stopPropagation(); e.preventDefault();
      if (filterOpen) { setDraftFilters(filters); setFilterOpen(false); }
      setDateOpen(false);
    };
    document.addEventListener('keydown', onKey, true);
    return () => document.removeEventListener('keydown', onKey, true);
  }, [dateOpen, filterOpen, filters]);

  useEffect(() => {
    if (!selectedId) return;
    // v12.2.40.0 (#233): bring the open card into view (esp. when prev/next reaches an off-screen message).
    document.getElementById('aw-card-' + selectedId)?.scrollIntoView({ block: 'nearest' });
    setDrawerTool(null);
    setNoteText('');
    setReminderDate('');
    // v12.4.12 (#468 reopened): picks on the message being left are COMMITTED by the label-draft effect, not
    // dropped - that effect reads labelDraftRef, which this line does not touch.
    setLabelDraft(null);
    // S: opening a message (card click, keyboard, or prev/next) marks it READ and persists it -> the card
    // treatment updates. open->prog; open+close stays prog; Mark as unread reverts to new; Skip changes
    // nothing. Only 'new' is bumped, so prog/done are never disturbed.
    //
    // ── v12.7.2 (#583 clause 2, answered by #599): THE BEHAVIOUR WAS ALREADY RIGHT. THE WORDS WERE NOT. ──
    //
    // #583's second clause - "opening a message should not claim someone is working on it" - was never built,
    // and the obvious reading was that this line should stop firing. It should not. The three stored states
    // are unread / read / completed, which is exactly what a queue needs, and this line is what moves unread
    // to read. **What claimed a person was working on it was the LABEL**: `prog` rendered as "In progress".
    //
    // Since #599 both `new` and `prog` read "Pending" and only the unread dot distinguishes them, so opening
    // a message now says what it always did - somebody has looked at this - and nothing more. Removing the
    // bump would have cost the unread dot and fixed nothing. Tushar's own framing settled it: *"it can be
    // read/ unread but new will not change until the status is marked as complete."*
    // v12.10.15 (#1651, SETTLED S80): opening a message changes NOTHING - it stays unread until someone acts on it (markReadBy).
    // Opening, next / previous, the Call path switch, the transcript and the Rows / Paragraph / language pills never mark read.
    // v12.9.14 (#830): a new call opens on the Transcript, never on whatever view the previous one was
    // left in - and never on a Call data view that this call has no data for.
    setDataView(false);
    const target = drawerRef.current?.querySelector<HTMLElement>('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    target?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedId]);

  // E2: local optimistic update. Kept as-is so the UI updates immediately.
  function updateMessage(messageId: string, updater: (message: WsMessage) => WsMessage) {
    lastMutRef.current.set(messageId, ++mutSeqRef.current);   // v12.10.16 (#1677): a load asked before this may not undo it
    setQueues((current) => ({
      call: current.call.map((message) => (message.id === messageId ? updater(message) : message)),
      text: current.text.map((message) => (message.id === messageId ? updater(message) : message)),
    }));
  }

  // Reconcile a message from the server's returned MessageRow after a PUT.
  function reconcileMessage(row: ApiMessageRow, askedAt?: number) {
    // v12.10.16 (#1677): the echo of an EARLIER write on a message that has changed again since is not laid over the newer
    // local copy - the newer write's own echo brings the server's version of everything.
    if (askedAt !== undefined && (lastMutRef.current.get(row.id) ?? 0) > askedAt) return;
    // v12.4.12 (#468 reopened): an echo from ANOTHER write on this message (Flag, Assign, Chart #) carries the
    // server's labels, which do not include picks still open in the editor. Same rule as the heartbeat.
    const echoed = toMessage(row);
    const draft = labelDraftRef.current;
    const fresh = draft && draft.id === echoed.id ? { ...echoed, labels: draft.labels } : echoed;
    setQueues((current) => ({
      call: current.call.map((message) => (message.id === fresh.id ? fresh : message)),
      text: current.text.map((message) => (message.id === fresh.id ? fresh : message)),
    }));
  }

  // E2: persist EVERY mutation via PUT /t2/surface/messages/{id}; optimistic-update above,
  // then reconcile from the returned MessageRow. Surfaces failures via the canonical toaster.
  //
  // BB (v12.1.30.0): the API's NormalizeStatus (TenantSurfaceController) maps a status to 'prog'
  // ONLY when it contains "progress" / "working" / "open" - the literal "prog" we were sending
  // matched none of those, so it was persisted AND echoed back as "new". reconcileMessage then
  // overwrote the optimistic 'prog', so opening a New message never stuck to In progress (and did
  // not survive reload). Translate our local status to a wire value the backend recognizes before
  // the PUT; the optimistic updateMessage still uses our local MsgStatus so the UI is instant.
  function persist(messageId: string, body: MessageMutation, onFail?: () => void) {
    const payload = body.status ? { ...body, status: toWireStatus(body.status) } : body;
    // v12.4.9 (#453): mark the row in flight. The 30s refresh holds the optimistic copy for anything
    // in this set, so a poll landing between the click and the echo cannot flash the old value back.
    pendingRef.current.set(messageId, (pendingRef.current.get(messageId) ?? 0) + 1);
    const askedAt = lastMutRef.current.get(messageId) ?? mutSeqRef.current;   // v12.10.16 (#1677)
    api.put<ApiMessageRow>(`/t2/surface/messages/${messageId}`, payload)
      .then((row) => { if (row) { reconcileMessage(row, askedAt); keepActivity(row.id, row.activity); setActivityTick((n) => n + 1); } void queryClient.invalidateQueries({ queryKey: ['t2-message-counts'] }); })
      .catch(() => { toast('error', 'Could not save', 'The change was not saved to the tenant database.'); onFail?.(); })   // v12.10.11 (#1445)
      .finally(() => {
        const left = (pendingRef.current.get(messageId) ?? 1) - 1;
        if (left > 0) pendingRef.current.set(messageId, left); else pendingRef.current.delete(messageId);
      });
  }

  // v12.10.15 (#1651): ONE read state per practice, set only by an ACTION - play, print / copy, note, reminder, label, assign,
  // reply / call back / text, Mark complete. An unread (New) message becomes read (Pending); Completed is never touched.
  function markReadBy(messageId: string, action: string) {
    const m = allTenantMessages.find((x) => x.id === messageId);
    if (!m) return;
    if (m.status !== 'new') { if (LOG_ONLY.has(action)) logActivity(messageId, action); return; }   // #1648: already read - still on its record
    updateMessage(messageId, (current) => (current.status === 'new' ? { ...current, status: 'prog' } : current));
    persist(messageId, { status: 'prog', readBy: action });
  }

  // v12.10.15 (#1648): an action that changes nothing on the message still goes on its record (print, save, copy, play, call back).
  function logActivity(messageId: string, action: string) {
    api.post<{ ok: boolean; activity?: ApiActivityRow[] }>(`/t2/surface/messages/${encodeURIComponent(messageId)}/activity`, { action })
      .then((r) => { keepActivity(messageId, r?.activity); setActivityTick((n) => n + 1); })   // v12.10.16 (#1673)
      .catch(() => { /* the action itself worked; only its line in Activity is missing */ });
  }

  function touchMessage(messageId: string, updater: (message: WsMessage) => WsMessage = (message) => message) {
    updateMessage(messageId, (message) => {
      const updated = updater(message);
      return updated.status === 'done' ? updated : { ...updated, status: 'prog' };
    });
  }

  // v12.4.9 (#454): read the CURRENT priority and decide the next one BEFORE the update runs.
  //
  // What was here assigned `isFlagged` inside the setQueues updater, which React does not run
  // synchronously at call time - so the two lines after it always read the initial `false`. Every
  // click PUT 'normal', every click toasted "Flag removed", and reconcileMessage then echoed 'normal'
  // back and reverted the optimistic UI, which is why it never stuck either. One bug, three symptoms.
  //
  // Same shape as #451 and #441: A VALUE READ BEFORE THE THING THAT WRITES IT HAS RUN. The rest of
  // this file was audited for the pattern - toggleFlag was the only instance.
  function toggleFlag(messageId: string) {
    const current = allTenantMessages.find((message) => message.id === messageId);
    if (!current) return;
    const nextPriority: Priority = current.priority === 'urgent' ? 'normal' : 'urgent';
    updateMessage(messageId, (message) => ({ ...message, priority: nextPriority }));
    persist(messageId, { priority: nextPriority });
    toast('success', nextPriority === 'urgent' ? 'Message flagged' : 'Flag removed');
  }

  // v12.4.9 (#453): the chip does NOT reload anything - the rows are already in the list, put there by
  // the heartbeat. It only takes you to where they landed, so nothing you are reading is disturbed.
  // In the drawer that means stepping to the newest record (the same place the now-live previous arrow
  // goes); on the list it means scrolling the top of the list back into view.
  function goToNewest() {
    setArrivedIds([]);
    const oldestFirst = sortOrder === 'oldest';   // v12.10.11.3 (#1521): the newest is at the bottom then
    if (selectedId) {
      const newest = oldestFirst ? visibleMessages[visibleMessages.length - 1] : visibleMessages[0];
      if (newest) requestSelect(newest.id);
      return;
    }
    listRef.current?.scrollIntoView({ behavior: 'smooth', block: oldestFirst ? 'end' : 'start' });
  }

  function newArrivalsChip(where: 'list' | 'drawer') {
    if (newArrivals < 1) return null;
    return (
      <button
        type="button"
        className={`aw-new-chip aw-new-chip-${where}`}
        onClick={goToNewest}
        title={where === 'drawer'
          ? 'New calls arrived while you were reading. Go to the newest - this record stays open until you do.'
          : sortOrder === 'oldest' ? 'New calls arrived below the bottom of the list. Go to them.' : 'New calls arrived above the top of the list. Go to them.'}
        aria-label={`${newArrivals} new ${newArrivals === 1 ? 'message' : 'messages'} - go to the newest`}
      >
        <span className="aw-new-chip-ic" aria-hidden="true">+</span>
        {newArrivals} new
      </button>
    );
  }

  function handleNav(key: string) {
    setNavOpen(false);
    setAccountOpen(false);
    setMobileAccountOpen(false);
    if (key === 'messages') {
      navigate('/messages');
      return;
    }
    if (key === 'reports') {
      navigate('/reports');
      return;
    }
    if (key === 'settings') {
      navigate('/settings');
      return;
    }
    if (key === 'help') {
      setHelpOpen(true);
      return;
    }
    toast('info', 'Coming soon', `${key.replace('-', ' ')} is coming in a later tenant workspace pass.`);
  }

  function signOut() {
    logout();
    navigate('/login', { replace: true });
  }

  // v12.10.11.3 (#1524): every way of leaving the open message - another card, ‹ ›, ✕, Esc - comes through here. A half-typed
  // note or text asks once (Keep editing / Discard); otherwise it never asks.
  function requestSelect(id: string | null) {
    if (id === selectedId) return;
    if (selectedId && (noteText.trim() || textBody.trim())) { setPendingSwitch({ to: id }); return; }
    setSelectedId(id);
  }

  // ══ v12.10.13 (#1565): on a phone, Back closes the open message instead of leaving the app (it went to the sign-in
  // screen). Opening the drawer adds one history step; Back takes it; closing with X / Close / Mark complete removes it. ══
  const drawerPushedRef = useRef(false);
  const requestSelectRef = useRef(requestSelect);
  requestSelectRef.current = requestSelect;
  useEffect(() => {
    if (!isPhone) return;
    if (selectedId && !drawerPushedRef.current) {
      window.history.pushState({ ...(window.history.state ?? {}), awDrawer: true }, '');
      drawerPushedRef.current = true;
    } else if (!selectedId && drawerPushedRef.current) {
      drawerPushedRef.current = false;
      if (window.history.state?.awDrawer) window.history.back();
    }
  }, [selectedId, isPhone]);
  useEffect(() => {
    if (!isPhone) return;
    const onPop = () => { if (drawerPushedRef.current) { drawerPushedRef.current = false; requestSelectRef.current(null); } };
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, [isPhone]);

  // v12.10.13 (#1601): time in the drawer (one overlay per open message) and how far down it was read - once per drawer.
  const drawerOpen = Boolean(selectedId);
  useEffect(() => {
    if (!drawerOpen) return;
    const stop = trackOverlay('drawer');
    return stop;
  }, [drawerOpen]);
  useEffect(() => {
    if (!selectedId) return;
    const body = document.querySelector('.aw-drawer-body') as HTMLElement | null;
    if (!body) return;
    const seen = new Set<string>();
    const mark = (k: string) => { if (!seen.has(k)) { seen.add(k); track(`drawer.scroll.${k}`); } };
    const onScroll = () => {
      const view = body.scrollTop + body.clientHeight;
      const rec = body.querySelector('.aw-recording-card') as HTMLElement | null;
      const tr = body.querySelector('.aw-transcript') as HTMLElement | null;
      if (rec && view >= rec.offsetTop + 40) mark('recording');
      if (tr && view >= tr.offsetTop + 40) mark('transcript');
      if (body.scrollHeight - view < 8 && body.scrollTop > 0) mark('end');
    };
    body.addEventListener('scroll', onScroll, { passive: true });
    return () => body.removeEventListener('scroll', onScroll);
  }, [selectedId]);

  // v12.10.30 (#2258, Tushar 11/3 "how can i give a quick jump to what the caller need, recording, add note panel, transcript?"):
  // a slim chip row at the foot of the drawer's sticky top. The sections carry data-jump; a chip shows only while its section is in the
  // body (no recording -> no Recording chip). A jump puts the section's header at the top edge of the scrolling body - where the
  // Transcript | Call data bar sticks (#2244) - and Add note opens the same note editor as N / the Add note card, then focuses it.
  const [jumpKeys, setJumpKeys] = useState('');
  useEffect(() => {
    if (!selectedId) return;
    const body = drawerRef.current?.querySelector('.aw-drawer-body') as HTMLElement | null;
    if (!body) return;
    const read = () => setJumpKeys(Array.from(body.querySelectorAll<HTMLElement>(':scope > [data-jump]')).map((el) => el.dataset.jump ?? '').join(' '));
    read();
    const mo = new MutationObserver(read);
    mo.observe(body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-jump'] });
    return () => mo.disconnect();
  }, [selectedId]);
  function jumpTo(key: JumpKey): boolean {
    const body = drawerRef.current?.querySelector('.aw-drawer-body') as HTMLElement | null;
    if (!body || !body.querySelector(`:scope > [data-jump="${key}"]`)) return false;
    const go = () => {
      const sec = body.querySelector<HTMLElement>(`:scope > [data-jump="${key}"]`);
      if (!sec) return;
      const top = body.scrollTop + sec.getBoundingClientRect().top - body.getBoundingClientRect().top;
      body.scrollTo({ top: Math.max(0, Math.round(top)), behavior: 'smooth' });
    };
    if (key === 'note') {
      if (!can('note')) return false;
      setDrawerTool('note');   // the same editor N and the Add note card open (its own effect scrolls it 'nearest' at 0 ms - this runs after)
      window.setTimeout(() => { go(); editorRef.current?.querySelector('textarea')?.focus({ preventScroll: true }); }, 40);
      return true;
    }
    go();
    return true;
  }

  // v12.10.13 (#1564): Print ▾ in the drawer footer - Print, Download PDF. It opens Reports › Call record on this call in a new
  // tab (the same print, audit and patient-information notice as the report; the drawer stays open here).
  const [printMenuOpen, setPrintMenuOpen] = useState(false);
  const printWrapRef = useRef<HTMLSpanElement | null>(null);
  const closePrintMenu = useCallback(() => setPrintMenuOpen(false), []);
  useMenuDismiss(printMenuOpen, closePrintMenu, printWrapRef);
  // v12.10.14 (#1619, S237): Print ▾ = Print · with transcript (P) · Print · summary only · Download PDF · Save as HTML - printed RIGHT HERE
  // (CallRecordPrint draws the locked call record off screen and opens the print window; no new tab, the drawer stays).
  const [printJob, setPrintJob] = useState<{ id: string; action: CrsAction } | null>(null);
  function printSelected(action: CrsAction) {
    if (!selectedId) return;
    setPrintMenuOpen(false);
    track('drawer.section.print', { value: action });
    markReadBy(selectedId, action === 'html' || action === 'pdf' ? 'save' : 'print');   // v12.10.15 (#1651)
    setPrintJob({ id: selectedId, action });
  }

  // v12.10.15 (#1636, LOCKED): Print ▾ › Copy call record - the whole record as text, the same text as Reports › Call record › Copy,
  // with Call data; the transcript only when ticked. Copying reads the message (#1651) and goes on its Activity (#1648).
  const [copyWithTranscript, setCopyWithTranscript] = useState(false);
  const orgName = useQuery<{ identity?: { displayName?: string; legalName?: string } }>({ queryKey: ['t2-org-name'], queryFn: () => api.get('/t2/settings/organization'), staleTime: 300_000 });
  async function copyCallRecord() {
    if (!selectedId) return;
    const id = selectedId;
    setPrintMenuOpen(false);
    track('drawer.section.print', { value: 'copy' });
    try {
      const row = await api.get<CrsRecord>(`/t2/surface/messages/${encodeURIComponent(id)}`);
      if (!row) throw new Error('empty');
      const practice = orgName.data?.identity?.displayName || orgName.data?.identity?.legalName || sessionPracticeName() || 'Your practice';
      const parts = CRS_ALL.filter((p) => p !== 'transcript' || copyWithTranscript);
      // v12.10.17 (#1723 D12): the copy names the caller type and the request in words, not the stored keys.
      const named = { ...row, callerType: callerTypeDisplay(displayCallerTypes, row.callerType).name,
        category: requestWords(categoryDisplay(displayCategories, row.category), requestTypeOf(row.capturedFields)) };
      // ══ v12.10.23 (#2076, agreed 10/29): a Combined group copies EVERY call - the header names each call, the Calls line, What the caller
      // needs as the drawer shows it, the Combined Call data (each value with its call), and every transcript, oldest first. ══
      if (combinedView && selGroup && selGroup.length > 1) {
        const oldestFirst = [...selGroup].reverse();
        const recs = await Promise.all(oldestFirst.map((m) => (m.id === id ? Promise.resolve(row) : api.get<CrsRecord>(`/t2/surface/messages/${encodeURIComponent(m.id)}`).catch(() => null))));
        const tm = (iso?: string | null) => (iso ? new Date(iso).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : '');
        const refs = oldestFirst.map((m) => formatReference(m.referenceNo));
        const out: string[] = [`${practice} · Call record · ${formatReference(row.referenceNo)} (Combined: ${refs.join(' · ')})`, named.name || selectedMessage?.phone || ''];
        out.push(`Calls: ${oldestFirst.map((m) => `${formatReference(m.referenceNo)} ${tm(m.startedAt)}`.trim()).join(' · ')}`);
        out.push('', 'What the caller needs:', summaryRowsText(buildCombinedRows(selGroup, 'en'), 'en'));
        const byTok = new Map<string, CrsField>();
        recs.forEach((r, i) => {
          if (!r) return;
          for (const f of (r.capturedFields ?? []).filter((x) => !x.notCaptured && !(x.notCaptured ?? '').toLowerCase().startsWith('never reached') && (x.value ?? '').trim()))
            byTok.set(f.token, { ...f, value: `${f.value} (${refs[i]})` });   // the newest call's value wins, with its call
        });
        if (byTok.size) out.push('', 'Call data:', callDataText(named.name || '', [...byTok.values()]));
        if (copyWithTranscript) {
          recs.forEach((r, i) => {
            const lines = (r?.transcript ?? []).filter((l) => l.role !== 'path');
            out.push('', `--- ${refs[i]} · ${tm(oldestFirst[i].startedAt)} ---`);
            if (lines.length === 0) out.push('  Nothing was said on this call.');
            lines.forEach((l) => out.push(`  ${l.role === 'caller' ? 'Caller' : 'Agent'}: ${l.text}`));
          });
        }
        await navigator.clipboard.writeText(out.join('\n'));
        toast('success', 'Call record copied', `All ${selGroup.length} calls - ready to paste.`);
        markReadBy(id, 'copy');
        return;
      }
      await navigator.clipboard.writeText(callRecordText(named, parts, practice, formatReference(row.referenceNo), { callData: true }));
      toast('success', 'Call record copied', 'Ready to paste.');
      markReadBy(id, 'copy');
    } catch {
      toast('error', 'Could not copy', 'Your browser blocked the clipboard, or the record could not be read - use Print instead.');
    }
  }

  // v12.10.15 (#1648, LOCKED): the Activity list - opened from the footer, shown in the drawer.
  const [activityOpen, setActivityOpen] = useState(false);
  useEffect(() => { setActivityOpen(false); }, [selectedId]);
  // v12.10.16 (#1673): the open panel reads the list fresh - when it opens, and again shortly after every action taken while
  // it is open (activityTick), so a copy / print / status change is in the list at once, never only after close + reopen.
  const [activityTick, setActivityTick] = useState(0);
  useEffect(() => {
    if (!activityOpen || !selectedId) return;
    let off = false;
    const id = selectedId;
    const t = window.setTimeout(() => {
      api.get<{ activity?: ApiActivityRow[] }>(`/t2/surface/messages/${encodeURIComponent(id)}/activity`)
        .then((r) => { if (!off && r?.activity) keepActivity(id, r.activity); })
        .catch(() => { /* the list keeps what it has */ });
    }, activityTick === 0 ? 0 : 600);
    return () => { off = true; window.clearTimeout(t); };
  }, [activityOpen, selectedId, activityTick, keepActivity]);

  function openMessage(message: WsMessage) {
    requestSelect(message.id);
    setNavOpen(false);
  }

  function moveSelection(delta: number) {
    if (!visibleMessages.length) return;
    const next = (highlightedIndex + delta + visibleMessages.length) % visibleMessages.length;
    setHighlightedIndex(next);
  }

  function moveDrawer(delta: number) {
    if (!visibleMessages.length) return;
    const base = selectedIndex >= 0 ? selectedIndex : 0;
    // v12.4.9 (#458): CLAMP, do not wrap. The arrows now show their end-of-run state by going disabled,
    // and a keyboard walk that silently wrapped past a disabled arrow would contradict the header.
    const next = Math.min(Math.max(base + delta, 0), visibleMessages.length - 1);
    if (next === base) return;
    requestSelect(visibleMessages[next].id);
  }

  // v12.4.11 (#475): WHERE THE DRAWER GOES WHEN THE CURRENT MESSAGE IS DISPOSED OF.
  //
  // Mark complete and Mark as unread both did `visibleMessages.find(m => m.id !== selectedMessage.id)`,
  // which returns THE FIRST MESSAGE IN THE LIST that is not this one - the top of the queue, not the next
  // message. Tushar, working row 19 of a long list, marked one complete and the drawer landed on a message
  // near the top; the `selectedId` effect then called scrollIntoView on that card and dragged the list up
  // with it, so he had to scroll back down to find his place. TWO SYMPTOMS, ONE LINE - and my own first
  // theory (the list re-keys and the scroll container remounts, with #453's poll re-triggering it) was
  // wrong. Instrumenting first is what found it.
  //
  // It also silently contradicted #458's clamp rule: the prev/next arrows were taught to clamp rather than
  // wrap precisely so the drawer never jumps across the list, and this path jumped further than a wrap.
  //
  // Advance in ORDER: the next message down, falling back to the previous one at the end of the list, and
  // only closing the drawer when there is genuinely nothing left. Index is taken BEFORE the list updates,
  // so idx+1 is the same message whether or not the completed one is filtered out on the next render.
  // v12.10.16 (#1677): FINAL 10/14 - "Mark complete moves to the next message of the UPDATED list (never to a message
  // already completed)". The walk is the same (down, then up), but a message that is already Completed is stepped over.
  function neighbourAfter(messageId: string): string | null {
    const list = visibleMessages;
    const ok = (m: WsMessage) => m.id !== messageId && m.status !== 'done';
    const index = list.findIndex((message) => message.id === messageId);
    if (index < 0) return list.find(ok)?.id ?? null;
    for (let i = index + 1; i < list.length; i++) if (ok(list[i])) return list[i].id;
    for (let i = index - 1; i >= 0; i--) if (ok(list[i])) return list[i].id;
    return null;
  }

  function completeSelected() {
    if (!selectedMessage) return;
    // v12.4.12 (#468 reopened): open picks ride THIS write. Two PUTs to one message in the same tick is the
    // HH race again, and his 12.4.10 report was exactly this path: 'if you mark as completed, the labels disappear.'
    const labels = takeLabelDraft(selectedMessage.id);
    const next = neighbourAfter(selectedMessage.id);   // v12.4.11 (#475) - taken BEFORE the list changes
    updateMessage(selectedMessage.id, (message) => ({ ...message, status: 'done', ...(labels ? { labels } : {}) }));
    // v12.10.16 (#1677): one server log line per Mark complete - which message, where the drawer went, which list.
    const nav = { next, listVersion: listVersionRef.current, listCount: visibleMessages.length, filter: `${filters.fuView ? 'followups' : 'messages'}:${filters.status}` };
    persist(selectedMessage.id, { status: 'done', ...(labels ? { labels } : {}), nav });
    // v12.10.16 (#1690, locked rule): Mark complete closes EVERY open call in the caller's group.
    const groupOpen = (selGroup ?? []).filter((m) => m.id !== selectedMessage.id && m.status !== 'done');
    for (const m of groupOpen) {
      updateMessage(m.id, (x) => ({ ...x, status: 'done' }));
      persist(m.id, { status: 'done' });
    }
    toast('success', groupOpen.length > 0 ? `Marked complete - ${groupOpen.length + 1} calls from this number` : 'Message marked complete');
    setSelectedId(next);
  }

  // M: Mark as unread = re-queue as New (status back to 'new'), persist, then close the drawer.
  // v12.10.18 (#1865 T149): one click - marked for audit (who + when + an Activity line on the server). The status is untouched.
  function toggleAudit() {
    if (!selectedMessage) return;
    // v12.10.19 (#1893, LOCKED 10/23 S146-S147): on a Combined card the mark (and its removal) applies to EVERY call in the group,
    // in one click - the Audit filter then finds the group whichever call leads it. The menu reads the GROUP's state.
    const ids = combinedView && selGroup && selGroup.length > 1 ? selGroup.map((m) => m.id) : [selectedMessage.id];
    const anyMarked = (combinedView && selGroup && selGroup.length > 1 ? selGroup : [selectedMessage]).some((m) => Boolean(m.auditMarkedAt));
    const marked = !anyMarked;
    const was = new Map(ids.map((id) => [id, allTenantMessages.find((m) => m.id === id)?.auditMarkedAt ?? null] as const));
    ids.forEach((id) => updateMessage(id, (m) => ({ ...m, auditMarkedAt: marked ? new Date().toISOString() : null })));
    Promise.all(ids.map((id) => api.put<{ ok: boolean; auditMarkedAt?: string | null; activity?: ApiActivityRow[] }>(`/t2/surface/messages/${encodeURIComponent(id)}/audit`, { marked })
      .then((r) => { updateMessage(id, (m) => ({ ...m, auditMarkedAt: r?.auditMarkedAt ?? null })); keepActivity(id, r?.activity); })))
      .then(() => {
        setActivityTick((n) => n + 1);
        toast('success', marked ? (ids.length > 1 ? `Marked for audit · ${ids.length} calls` : 'Marked for audit') : (ids.length > 1 ? `Audit mark removed · ${ids.length} calls` : 'Audit mark removed'),
          marked ? 'Find it with Filters › Audit.' : '');
      })
      .catch(() => {
        ids.forEach((id) => updateMessage(id, (m) => ({ ...m, auditMarkedAt: was.get(id) ?? null })));
        toast('error', 'Could not save', 'The audit mark was not saved - try again.');
      });
  }

  function markUnread() {
    if (!selectedMessage) return;
    const labels = takeLabelDraft(selectedMessage.id);   // v12.4.12 (#468 reopened): same as completeSelected
    updateMessage(selectedMessage.id, (message) => ({ ...message, status: 'new', ...(labels ? { labels } : {}) }));
    persist(selectedMessage.id, { status: 'new', ...(labels ? { labels } : {}) });
    toast('info', 'Marked as unread', 'Message re-queued to New.');
    // v12.4.11 (#475): markUnread carried the identical `find` bug. Fixing only the reported one is how
    // #442 came back; both callers go through neighbourAfter.
    setSelectedId(neighbourAfter(selectedMessage.id));
  }

  // ══ v12.9.12 (#794 / C1): MARK PENDING - THE THIRD MEMBER OF A FAMILY THAT ALREADY HAS A RULE. ══
  //
  // The footer rendered "Mark complete" whatever the status, so a completed message offered to complete
  // itself again and gave no way back. The fix is a toggle - but the toggle's new half is a WRITE, and
  // writes to this message have a hard-won shape.
  //
  // IT FOLDS takeLabelDraft INTO ITS SINGLE WRITE, exactly like completeSelected and markUnread above.
  // That is not tidiness: #468 was REOPENED in 12.4.12 because two PUTs to one message in the same tick
  // lost labels, and his report was literally *"if you mark as completed, the labels disappear."* A
  // status-only PUT here would put that bug straight back.
  //
  // AND IT ROUTES THROUGH neighbourAfter() - #442 came back as #475 precisely because only the reported
  // caller was fixed the first time. Three callers, one helper.
  //
  // Unlike its two siblings it does NOT close the drawer: reopening a message is something you do in
  // order to keep working on it, so the selection stays put.
  function markPending() {
    if (!selectedMessage) return;
    const labels = takeLabelDraft(selectedMessage.id);
    updateMessage(selectedMessage.id, (message) => ({ ...message, status: 'prog', ...(labels ? { labels } : {}) }));
    persist(selectedMessage.id, { status: 'prog', ...(labels ? { labels } : {}) });
    toast('info', 'Message reopened', 'Moved back to in progress.');
  }

  // v12.9.12 (#794): ONE RULE, THREE ENTRY POINTS - footer, the more-menu, and Ctrl+Enter all read this.
  const isDone = selectedMessage?.status === 'done';
  function toggleComplete() { if (isDone) markPending(); else completeSelected(); }

  // ── v12.9.12 (#791 / C5): CAN THIS LINE ACTUALLY TAKE A TEXT? ──────────────────────────────────────
  // The SAME allow-list the engine uses, read the same way the card's line mark reads it. 'unknown'
  // (never checked - his 39-0075 drawer says "Line type not checked") is NOT textable: we cannot assert
  // it, so we do not offer the action. Hide, never show-and-fail.
  // v12.10.9.4 (#1381, UI-PROTO-T40 LOCKED 10/7): each action follows its own tick in the person's user group (Phone calls or
  // Text messages, by the message's kind). Hidden when not allowed - the server refuses it too.
  const msgArea = selectedMessage?.kind === 'text' ? 'texts' : 'phone';
  const can = (action: string) => hasAccess(msgArea, action);
  const canText = Boolean(selectedMessage)
    && (selectedMessage!.kind === 'text' || LINE_TEXTABLE.has((selectedMessage!.lineType ?? '').toLowerCase())) && can('text');   // v12.10.27 (#2146): a text conversation takes texts
  // ── v12.10.10 (#1403, Tushar 10/7-10/8): CALL BACK AND SEND TEXT ARE NEVER HIDDEN. ──────────────────────────────
  // Jessica (front desk, Call back unticked) saw the button vanish and could not tell why. Both buttons now always
  // stand in the bar; one the person cannot use is greyed (dashed) and its hover says why. This REVERSES, on his
  // instruction, #1381's "hidden when not allowed" and #791's "Send Text never shown-and-disabled on a line that cannot
  // take a text". The server refuses either way; the shortcuts (Ctrl+K, T) stay gated by the same checks.
  const callAction = selectedMessage?.kind === 'text' ? 'text' : 'call';
  const callLabel = selectedMessage?.kind === 'text' ? 'Reply' : 'Call back';
  const callBlockedWhy = selectedMessage && !can(callAction)
    ? `Your user group doesn't allow ${callLabel}. Ask your practice owner (Settings › Security › User groups).` : null;
  const textBlockedWhy = !selectedMessage || canText ? null
    : !can('text') ? "Your user group doesn't allow Send Text. Ask your practice owner (Settings › Security › User groups)."
    : (() => {
        const fam = lineFamily(selectedMessage.lineType ?? null);
        if (fam === 'unknown') return "We haven't checked whether this number takes texts.";
        const word = fam === 'landline' ? 'landline' : (selectedMessage.lineType ?? 'this line type');
        return `This number can't take texts (${word}).`;
      })();

  // ── v12.10.30 (#1156 0a, LOCKED 11/1): THE NUMBERS CALL BACK CAN DIAL - the call-back number on the message first (the default), then
  // the number they called / texted from. Pressing Call back leaves the message status AS IT IS (P2 - Tushar 11/1: "when call back is
  // pressed … we will keep the message status as is … the call will be logged in the note when completed").
  const callBackNumbers: CallBackNumber[] = (() => {
    if (!selectedMessage) return [];
    const out: CallBackNumber[] = [];
    const add = (n: string | null | undefined, label: string) => {
      const d = (n ?? '').replace(/\D+/g, '');
      if (d.length >= 10 && !out.some((x) => x.number.replace(/\D+/g, '').slice(-10) === d.slice(-10))) out.push({ number: n as string, label });
    };
    add(callBackOf(selectedMessage), 'Call-back number');
    add(selectedMessage.phone, selectedMessage.kind === 'text' ? 'Texted from' : 'Called from');
    return out;
  })();
  const callBackName = selectedMessage ? (selectedMessage.hasName ? selectedMessage.name : (callBackNumbers[0]?.number ?? selectedMessage.phone)) : '';
  function startCallBackFor() {
    if (!selectedMessage || !callBackNumbers[0]) return;
    void startCallBack({ messageId: selectedMessage.id, to: callBackNumbers[0].number, name: callBackName, language: selectedMessage.language });
  }

  // ── v12.9.12 (#793/#796): send ONE text, and let the same write record what happened. ──────────────
  //
  // Deliberately NOT a separate endpoint plus a separate note write. That would be two writes to one
  // message in the same tick, which is the exact shape #468 was reopened over - the rule this whole
  // package enforces elsewhere (C1). The server sends and appends the remark inside one transaction.
  // v12.10.27 (#2150): what the patient gets - "Name: words" + (Text replies Off, a call) the reply line.
  const stdName = (textingStatus?.senderName ?? tenantDisplayName ?? '').trim();
  const stdEnd = renderPhone('Texting not supported. Please call our office at {organization.phone}.', textingStatus?.officePhone ?? null);
  // v12.10.28 (#2182, Tushar 11/1 "it should not have gone with staff message. it should have gone only when i tried to reply something"):
  // a STAFF text never carries the "Texting not supported ..." line - that belongs only to the automatic reply. The STOP line keeps its row.
  const showStopLine = !!selectedMessage && selectedMessage.kind !== 'text' && !textingStatus?.repliesOn;
  const showEndChip = false;
  const composedText = (() => {
    const words = (needsApptDate && apptDate.trim() ? textBody.split('[appointment date]').join(apptDate.trim()) : textBody).trim();
    const name = (nameChip ?? stdName).trim().replace(/:\s*$/, '');
    const parts = [name && words ? `${name}: ${words}` : words];
    if (showEndChip && words) parts.push((endChip ?? stdEnd).trim());
    return parts.filter(Boolean).join(' ');
  })();
  useEffect(() => { setNameChip(null); setEndChip(null); setChipEdit(null); }, [selectedMessage?.id]);

  function sendText() {
    if (!selectedMessage || !textBody.trim() || sending) return;
    // v12.10.11.1 (#1472): a placeholder is never sent - the date must be filled in first.
    if (needsApptDate && !apptDate.trim()) { setSendError('Fill in the appointment date to send.'); return; }
    const body = composedText;   // v12.10.27 (#2150): name + words + reply line, exactly as previewed
    if (/\[[a-z ]+\]/i.test(body)) { setSendError('Replace the part in [brackets] before sending.'); return; }
    const to = toNumber.replace(/\D/g, '');
    setSending(true);
    setSendError(null);
    api.put<ApiMessageRow>(`/t2/surface/messages/${selectedMessage.id}`, { sendText: { to, body } })
      .then((row) => {
        if (row) reconcileMessage(row);
        // The remark the server just wrote IS the outcome - one source of truth, not a second flag.
        const newest = (row?.notes ?? [])[0];
        if (newest?.kind === 'text-failed') {
          // C3: the draft STAYS so the agent can fix the number and try again.
          setSendError('The text could not be sent. It is recorded on this message as not sent.');
          toast('warning', 'Text not sent', 'It is logged on this message so the history is accurate.');
        } else {
          setTextBody('');
          setApptDate('');
          setComposerOpen(false);
          toast('success', 'Text sent');
        }
      })
      .catch(() => {
        setSendError('The text could not be sent. Check the number and try again.');
        toast('error', 'Could not send', 'The message was not sent.');
      })
      .finally(() => setSending(false));
  }

  // CC (v12.1.30.0): Skip removed from the drawer footer (redundant with Mark as unread).

  function resetOneFilter(key: keyof Filters) {
    const k = String(key);
    if (k.startsWith('mode:')) { const m = k.slice(5) as TopMode; setFilters((current) => ({ ...current, modes: (current.modes ?? []).filter((x) => x !== m) })); return; }
    setFilters((current) => ({ ...current, [key]: initialFilters[key] }));
  }

  function setDraftFilter<K extends FilterKey>(key: K, value: Filters[K]) {
    setDraftFilters((current) => ({ ...current, [key]: value }));
  }

  // v12.10.13 (#1561): Show results tells the click analyzer which groups changed (the uiTrack contract - group names, and a
  // value only for the fixed lists; never a person, a label, a category or a caller type).
  function trackFilterShow(before: Filters, after: Filters) {
    const GROUP: Record<string, string> = { status: 'status', type: 'type', opened: 'opened', priority: 'priority', category: 'category', label: 'label',
      assigned: 'assigned', callerType: 'caller', outcome: 'outcome', notes: 'notes', audit: 'audit', language: 'language' };
    const FIXED = new Set(['status', 'type', 'opened', 'priority', 'outcome', 'notes', 'audit', 'language']);
    const STATUS_WORD: Record<string, string> = { prog: 'pending', done: 'completed' };
    let on = 0;
    Object.keys(GROUP).forEach((k) => {
      const a = (after as unknown as Record<string, unknown>)[k];
      const b = (before as unknown as Record<string, unknown>)[k];
      const isOn = Array.isArray(a) ? a.length > 0 : (a !== undefined && a !== 'all');
      if (isOn) on += 1;
      if (JSON.stringify(a ?? 'all') === JSON.stringify(b ?? 'all')) return;
      const v = typeof a === 'string' && a !== 'all' && FIXED.has(k) ? (STATUS_WORD[a] ?? a) : undefined;
      track(`filters.group.${GROUP[k]}`, v ? { value: v } : undefined);
    });
    track('filters.show', { value: String(on) });
  }

  function addNote() {
    if (!selectedMessage || !noteText.trim()) return;
    const text = noteText.trim();
    touchMessage(selectedMessage.id, (message) => ({
      ...message,
      notes: [{ id: `note-${Date.now()}`, author: 'You', at: 'Just now', text }, ...message.notes],
    }));
    // touchMessage bumps status to prog when not done; persist both the note and that bump.
    const status = selectedMessage.status === 'done' ? undefined : 'prog';
    // v12.10.11 (#1445): a failed save puts the typed note back in the box (it used to vanish with the error).
    const messageId = selectedMessage.id;
    persist(messageId, { addNote: { text }, status }, () => {
      updateMessage(messageId, (message) => ({ ...message, notes: message.notes.filter((n) => !(n.author === 'You' && n.at === 'Just now' && n.text === text)) }));
      setNoteText(text);
      setDrawerTool('note');
    });
    setNoteText('');
    setDrawerTool(null);
    toast('success', 'Note added', 'Your remarks were saved to this message.');
  }

  function setReminderValue(value: string, pickedIso?: string) {
    if (!selectedMessage || !value.trim()) return;
    const reminder = value.trim();
    // v12.10.11.3 (#1527): the DATE goes with the label, so "due" (today or overdue) can be counted.
    const reminderDue = reminderDueFor(reminder, pickedIso);
    touchMessage(selectedMessage.id, (message) => ({ ...message, reminder, reminderDue }));
    persist(selectedMessage.id, { reminder, reminderDue, ...(selectedMessage.status === 'done' ? {} : { status: 'prog' as MsgStatus }) });   // v12.10.15 (#1651): a reminder reads it
    setReminderDate('');
    setDrawerTool(null);
    toast('success', 'Reminder set', reminder);
  }

  // K: removing an applied chip (outside the editor) is a single, discrete action - one PUT with
  // the resulting label set. This is NOT the HH race (no rapid concurrent writes), so it persists
  // immediately. Per-toggle SUCCESS toasts are dropped (HH: no toast spam); an error still shows.
  function removeLabel(label: string) {
    if (!selectedMessage) return;
    // v12.4.12 (#468 reopened): with picks open, removing a chip is one more pick, not its own write - a
    // separate PUT would land first and the draft's commit would then put the label straight back.
    if (labelDraftRef.current?.id === selectedMessage.id) {
      toggleLabelDraft(label);
      return;
    }
    const nextLabels = selectedMessage.labels.filter((item) => item !== label);
    touchMessage(selectedMessage.id, (message) => ({ ...message, labels: nextLabels }));
    persist(selectedMessage.id, { labels: nextLabels, ...(selectedMessage.status === 'done' ? {} : { status: 'prog' as MsgStatus }) });   // v12.10.15 (#1651)
  }

  // HH: inside the Apply-labels editor, toggles only update the local draft (optimistic in the UI
  // via updateMessage, but NO PUT per chip). The single PUT happens when the editor is left - any way.
  // v12.4.12 (#468 reopened): computed from labelDraftRef synchronously. It used to compute inside a
  // setLabelDraft updater, which React runs at render time, not at the click.
  function toggleLabelDraft(label: string) {
    if (!selectedMessage) return;
    const open = labelDraftRef.current?.id === selectedMessage.id ? labelDraftRef.current : null;
    const base = open ? open.labels : selectedMessage.labels;
    const next = base.includes(label)
      ? base.filter((item) => item !== label)
      : [...base, label];
    labelDraftRef.current = {
      id: selectedMessage.id,
      baseline: open ? open.baseline : [...selectedMessage.labels],
      labels: next,
    };
    setLabelDraft(next);
    // keep the drawer/card labels visually in sync while editing (optimistic, still no PUT)
    updateMessage(selectedMessage.id, (message) => ({ ...message, labels: next }));
  }

  // HH/OO: open the Apply-labels editor.
  // v12.4.12 (#468 reopened): opening it again (the card, or L) while picks are open KEEPS them. It used to
  // re-snapshot the baseline FROM the optimistic picks, so the close then saw no change and wrote nothing.
  // The baseline is now taken at the first pick, from the row before any pick touched it.
  function openLabelEditor() {
    if (!selectedMessage) return;
    setDrawerTool('label');
  }

  // v12.4.12 (#468 reopened): close the draft for `messageId` and hand back its labels IF they differ from
  // the baseline. undefined = nothing to write.
  function takeLabelDraft(messageId: string): string[] | undefined {
    const draft = labelDraftRef.current;
    if (!draft || draft.id !== messageId) return undefined;
    labelDraftRef.current = null;
    setLabelDraft(null);
    const before = JSON.stringify([...draft.baseline].sort());
    const after = JSON.stringify([...draft.labels].sort());
    return before === after ? undefined : draft.labels;
  }

  // v12.4.12 (#468 reopened): ONE persist({labels}) for whatever draft is open, written to the message the
  // draft belongs to - which, when this runs from the effect below, is no longer the selected one.
  function commitLabelDraft() {
    const draft = labelDraftRef.current;
    if (!draft) return;
    const labels = takeLabelDraft(draft.id);
    if (!labels) return;
    const owner = allTenantMessages.find((message) => message.id === draft.id);
    // status may have been bumped to prog by the optimistic edits during the session
    const status = owner?.status === 'done' ? undefined : 'prog';
    persist(draft.id, { labels, status });
  }

  // HH: Done commits the accumulated label draft as ONE write.
  function closeLabelEditor() {
    setDrawerTool(null);
    commitLabelDraft();
  }

  // ── v12.9.13 (#807): APPLY LABEL HAD ONLY DONE, WHILE ADD NOTE AND SET REMINDER BOTH OFFER A WAY OUT.
  //
  // An editor that can only be COMPLETED is a trap on the one action that is hardest to undo - #468's whole
  // history is labels being lost by a write nobody meant to make. Cancel clears the ref FIRST, because the
  // commit-on-close effect above fires on the drawerTool change and would otherwise save the very picks
  // being cancelled. It also puts the row back: the chips are applied optimistically while picking, so
  // abandoning them has to undo that too or the drawer keeps labels the server never got.
  function cancelLabelEditor() {
    const draft = labelDraftRef.current;
    labelDraftRef.current = null;
    setLabelDraft(null);
    setDrawerTool(null);
    if (draft) updateMessage(draft.id, (message) => ({ ...message, labels: draft.baseline }));
  }

  // v12.4.12 (#468 reopened): EVERY way out of the editor commits the picks, not only Done. His 12.4.10 and
  // 12.4.11 reports both lost them on close, and he could not see a Done button - it sits at the foot of the
  // editor, below the fold of a laptop drawer. Covers the drawer X, Escape, the scrim, prev/next, a card click,
  // the Calls/Texts tab switch, and switching to Add note or Set reminder. Mark complete and Mark as unread
  // take the draft themselves so it rides their one write.
  useEffect(() => {
    const draft = labelDraftRef.current;
    if (!draft) return;
    if (drawerTool === 'label' && selectedId === draft.id) return;
    commitLabelDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [drawerTool, selectedId]);

  // v12.10.10 (#1399): assign to a PERSON (user id); null = Unassign. Not a status change - assigning is not working it.
  function assignTo(userId: number | null) {
    if (!selectedMessage) return;
    if (!can('assign')) { toast('error', 'Not allowed', "Your user group doesn't allow Assign."); return; }
    const person = userId === null ? null : assignees.find((a) => a.id === String(userId));
    const name = userId === null ? null : (person?.name ?? (userId === meId ? currentUserName : 'Assigned'));
    updateMessage(selectedMessage.id, (message) => ({ ...message, assignedTo: name, assignedToUserId: userId }));
    persist(selectedMessage.id, userId === null ? { assignedTo: '' } : { assignedToUserId: userId });
    markReadBy(selectedMessage.id, 'assign');   // v12.10.15 (#1651): assigning is an action - it reads the message (status stays as it was otherwise)
    toast('success', userId === null ? 'Unassigned' : userId === meId ? 'Assigned to you' : `Assigned to ${name}`);
  }

  // v12.10.10 (#1399): the Status chip - Pending / Completed (the same two as Mark complete in the footer).
  function setStatusFromChip(next: 'prog' | 'done') {
    if (!selectedMessage || selectedMessage.status === next) return;
    if (next === 'done') { if (can('complete')) completeSelected(); else toast('error', 'Not allowed', "Your user group doesn't allow Mark complete."); }
    else markPending();
  }


  function setStatus(status: MsgStatus) {
    if (!selectedMessage) return;
    updateMessage(selectedMessage.id, (message) => ({ ...message, status }));
    persist(selectedMessage.id, { status });
    toast('success', `Status set to ${statusLabel(status)}`);
  }


  function handleShortcut(event: KeyboardEvent) {
    const typing = isTypingTarget(event.target);
    // v12.10.11.3 (#1524): the keep / discard question is answered first - Esc keeps editing.
    if (pendingSwitch) { if (event.key === 'Escape') { event.preventDefault(); setPendingSwitch(null); } return; }
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      // v12.10.30 (#1156): Call back switch on -> Ctrl+K dials the default number from the browser; the status is left as it is (P2).
      if (callBackOn && selectedMessage && can('call') && callBackNumbers[0]) { startCallBackFor(); return; }
      if (selectedMessage && can(selectedMessage.kind === 'text' ? 'text' : 'call')) {   // v12.10.9.4 (#1381)
        touchMessage(selectedMessage.id);
        if (selectedMessage.status !== 'done') persist(selectedMessage.id, { status: 'prog' });
        toast('info', selectedMessage.kind === 'text' ? 'Reply started' : 'Callback started');
      }
      return;
    }
    if ((event.ctrlKey || event.metaKey) && event.key === 'Enter') {
      event.preventDefault();
      // v12.9.12 (#793): while the composer is open Ctrl+Enter SENDS. Closing a message from inside a
      // half-written text would lose the draft, and the composer is the nearer context.
      if (composerOpen) { sendText(); return; }
      if (!can('complete')) return;   // v12.10.9.4 (#1381)
      toggleComplete();   // v12.9.12 (#794): the shortcut obeys the same toggle as the footer and the menu
      return;
    }
    if (typing) return;
    if (event.key === '/') {
      event.preventDefault();
      searchRef.current?.focus();
      return;
    }
    if (event.key.toLowerCase() === 'f') {
      event.preventDefault();
      setDraftFilters(filters);
      setFilterOpen(true);
      return;
    }
    if (event.key === '?') {
      event.preventDefault();
      setHelpOpen(true);
      return;
    }
    if (!selectedMessage) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        moveSelection(1);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        moveSelection(-1);
      } else if (event.key === 'Enter' && visibleMessages[highlightedIndex]) {
        event.preventDefault();
        openMessage(visibleMessages[highlightedIndex]);
      }
      return;
    }
    // v12.10.30 (#2258): Alt+1..4 = Needs, Recording, Add note, Transcript (the quick-jump chips) - not while typing (returned above).
    if (event.altKey && !event.ctrlKey && !event.metaKey && /^(Digit|Numpad)[1-4]$/.test(event.code)) {
      event.preventDefault();
      const key = JUMP_ORDER[Number(event.code.slice(-1)) - 1];
      if (jumpTo(key)) track(`drawer.jump.${key}`, { value: 'alt' });
      return;
    }
    if (event.key === 'Escape') {
      event.preventDefault();
      // ── v12.9.13 (#807): ESC CLOSES THE EDITOR FIRST, THE DRAWER SECOND. ──
      // One exit for all four editors regardless of which is open, and it is the part of #807 that matters
      // most: Cancel sits at the foot of the editor, below the fold of a laptop drawer - which is exactly
      // why #468 kept losing label picks and why he could not find Done. Escaping out of a composer or an
      // editor should not also throw away the message you were reading.
      if (composerOpen) { setComposerOpen(false); return; }
      if (drawerTool === 'label') { cancelLabelEditor(); return; }
      if (drawerTool && !noteText.trim()) { setDrawerTool(null); return; }
      requestSelect(null);   // v12.10.11.3 (#1524): Esc closes - asking first only if something is half-typed
    } else if (event.key === 'ArrowRight' || event.key === ']') {
      event.preventDefault();
      moveDrawer(1);
    } else if (event.key === 'ArrowLeft' || event.key === '[') {
      event.preventDefault();
      moveDrawer(-1);
    } else if (event.key.toLowerCase() === 'p') {
      // v12.10.14 (#1616, S234 "let's give p key to print"): P prints this call with the transcript, right here.
      event.preventDefault();
      if (canOpenArea('rep_calls')) printSelected('print');
    } else if (event.key.toLowerCase() === 'u') {
      // v12.10.14 (#1616, Claude found - for Tushar to confirm): P went to Print, so Urgent on / off moves to U (U was a second key
      // for Mark unread; M stays Mark unread, as the footer chip shows).
      event.preventDefault();
      if (can('flag')) toggleFlag(selectedMessage.id);   // v12.10.9.4 (#1381)
    } else if (event.key.toLowerCase() === 'm') {
      // M: Mark as unread (re-queue as New) - matches the footer button.
      event.preventDefault();
      markUnread();
    } else if (event.key.toLowerCase() === 'a') {
      event.preventDefault();
      // v12.10.10 (#1399): A assigns the message to ME (not the first name in a list).
      if (meId === null) return;
      if (selectedMessage.assignedToUserId === meId) toast('info', 'Already assigned to you');
      else assignTo(meId);
    } else if (event.key.toLowerCase() === 'n') {
      event.preventDefault();
      if (can('note')) setDrawerTool('note');   // v12.10.9.4 (#1381)
    } else if (event.key.toLowerCase() === 'r') {
      event.preventDefault();
      if (can('reminder')) setDrawerTool('reminder');
    } else if (event.key.toLowerCase() === 'l') {
      // OO: L opens the Apply-label editor (parallels N = note, R = reminder). Same typing guard.
      event.preventDefault();
      if (can('label')) openLabelEditor();
    } else if (event.key.toLowerCase() === 't') {
      // ── v12.9.13 (#804): PLAIN T, NOT CTRL+T. His correction: "CTRL+T can't work as that is google
      //    chrome new tab shortcut." He is right and my verification was in the wrong namespace - I checked
      //    that Ctrl+T was unbound inside T2 and never asked whether the BROWSER owned it. preventDefault()
      //    cannot stop Chrome opening a tab, so it could never have fired once in production.
      //    His answer is also the more consistent one: N / R / L are unmodified letters, so a modifier on the
      //    fourth would have been the odd one out even if Chrome had left it alone. Below the typing guard,
      //    exactly like its three siblings.
      if (!canText) return;                    // nothing to open on a line that cannot take a text
      event.preventDefault();
      setComposerOpen((open) => !open);
    }
  }

  useEffect(() => {
    window.addEventListener('keydown', handleShortcut);
    return () => window.removeEventListener('keydown', handleShortcut);
  });

  // v12.10.13 (#1558 #1561, T2_UI_PRINCIPLES §42): under the Filters button on the right, the 12.10.12 width; opening it never
  // moves the page; header + Reset / Show results always visible; only the groups scroll, and only when they truly do not fit.
  const filterPanelEl = (
    <div className="aw-filter-panel aw-fp13" role="dialog" aria-label="Filters" ref={filterPanelRef}>
      <div className="aw-fp-head">
        <h2 className="aw-panel-title">Filter messages</h2>
        {draftOnCount > 0 && <span className="aw-fp-count">{draftOnCount} on</span>}
        {/* v12.10.14 (#1612): on a phone Reset sits in the header; the foot is Cancel + Show results */}
        {isPhone && <button type="button" className="aw-fp-reset-link" data-track="filters.reset" onClick={() => setDraftFilters((current) => ({ ...initialFilters, dateScope: initialFilters.dateScope, fuView: current.fuView, fuPills: current.fuPills, modes: current.modes }))}>Reset</button>}
      </div>
      <div className="aw-fp-body">
        {isPhone && (
          // v12.10.9.4 (#1358): on a phone every filter lives here - the date and Due for follow-up too
          <div className="aw-phone-filter-extra">
            <div className="aw-phone-filter-date">
              <h3>Date</h3>
              <DateScopePanel
                value={draftFilters.dateScope ?? filters.dateScope}
                years={messageYears}
                embedded   /* v12.10.14 (#1612, S220/S221): no own Apply / Cancel and no Year | Quarter / Month in the phone sheet - Show results applies */
                onChange={(scope) => { track('messages.date.pick', { value: dateTrackValue(scope) }); setDraftFilters((current) => ({ ...current, dateScope: scope })); }}
                onApply={(scope) => { track('messages.date.pick', { value: dateTrackValue(scope) }); setFilters((current) => ({ ...current, dateScope: scope })); setDraftFilters((current) => ({ ...current, dateScope: scope })); }}
              />
            </div>
            {!filters.fuView && (
              <FilterGroup title="Reminders" items={['all', 'marked']} value={(draftFilters.modes ?? []).includes('marked') ? 'marked' : 'all'}
                label={(value) => value === 'marked' ? `Reminders · ${fmtCount(remindersCount)}` : 'All'}
                onChange={(value) => setDraftFilters((current) => {
                  const rest = (current.modes ?? []).filter((m) => m !== 'marked');
                  return { ...current, dueOnly: false, modes: value === 'marked' ? [...rest, 'marked'] : rest };
                })} />
            )}
          </div>
        )}
        {/* v12.10.14 (#1606-#1608, FILTER-PANEL v1.0): three columns 1.2 : 1.2 : 0.8; each group a header bar with All on the right;
            the practice's own dot / icon on every chip, no ticks, picked = the light-indigo tint; several picks where allowed. */}
        <div className="aw-filter-grid aw-fp-cols">
          <div className="aw-fcol">
            <ChipGroup title="Assigned to" multi cap grows hl={fpFocus === 'Assigned to'}
              fixed={[...(meId !== null ? [{ k: 'me', label: 'Me' }] : []), { k: 'none', label: 'Unassigned' }]}
              items={[...assignees.filter((a) => meId === null || a.id !== String(meId))].sort((x, y) => x.name.localeCompare(y.name)).map((a) => ({ k: a.id, label: a.name }))}
              value={fjoin(draftFilters.assigned ?? [])} onChange={(v) => setDraftFilters((current) => ({ ...current, assigned: fvals(v) }))} />
            <ChipGroup title="Label" multi cap grows hl={fpFocus === 'Label'}
              items={labelFilterItems.filter((x) => x !== 'all').sort((x, y) => x.localeCompare(y)).map((x) => ({ k: x, label: x, mark: <span className="aw-fdot" style={{ background: labelDotColor(x, labelColorMap) }} /> }))}
              value={draftFilters.label} onChange={(v) => setDraftFilter('label', v)} />
            {/* v12.10.22 (#1971): Audit sits in column 1 under Label - column 3 no longer needs a scrollbar. */}
            {/* v12.10.18 (#1865, Tushar 10/22): the calls the front desk marked for audit - no badge on the card, this finds them. */}
            <ChipGroup title="Audit" hl={fpFocus === 'Audit'} items={[{ k: 'marked', label: 'Marked for audit' }, { k: 'not', label: 'Not marked' }]}
              value={draftFilters.audit ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, audit: v as Filters['audit'] }))} />
          </div>
          <div className="aw-fcol">
            <ChipGroup title="Caller" multi cap grows hl={fpFocus === 'Caller'}
              items={callerFilterItems.map((it) => { const t = practiceCallerTypes.find((x) => x.key === it.k); return { ...it, mark: <span className="aw-fico" style={{ color: t?.color || '#94A3B8' }}><PracticeIcon name={t?.icon} fallback="User" /></span> }; })}
              value={draftFilters.callerType} onChange={(v) => setDraftFilter('callerType', v)} />
            <ChipGroup title="Category" multi cap grows hl={fpFocus === 'Category'}
              items={categoryFilterItems.map((it) => { const c = practiceCategories.find((x) => x.key === it.k); return { ...it, mark: <span className="aw-fico" style={{ color: c?.color || '#64748B' }}><PracticeIcon name={c?.icon} /></span> }; })}
              value={draftFilters.category} onChange={(v) => setDraftFilter('category', v)} />
            {kind === 'text' ? (
            // v12.10.27 (#2146, prototype v1.3 LOCKED): a text has no Calls / Missed / Voicemails - its Type is the state of the conversation.
            <ChipGroup title="Conversation" multi hl={fpFocus === 'Type' || fpFocus === 'Conversation'}
              items={[{ k: 'aifinished', label: 'AI finished', mark: <span className="aw-fdot" style={{ background: '#16A34A' }} /> },
                { k: 'textingnow', label: 'Texting now', mark: <span className="aw-fdot" style={{ background: '#0D9488' }} /> },
                { k: 'closed', label: 'Closed - no reply', mark: <span className="aw-fdot" style={{ background: '#94A3B8' }} /> }]}
              value={draftFilters.type ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, type: v as Filters['type'] }))} />
            ) : (
            <ChipGroup title="Type" multi hl={fpFocus === 'Type'}
              items={[{ k: 'calls', label: 'Calls', mark: <span className="aw-fico" style={{ color: '#16A34A' }}><SvgIcon name="phone" /></span> },
                { k: 'missed', label: 'Missed', mark: <span className="aw-fico" style={{ color: '#DC2626' }}><SvgIcon name="phone" /></span> },
                { k: 'voicemails', label: 'Voicemails', mark: <span className="aw-fico" style={{ color: '#7C3AED' }}><SvgIcon name="voicemail" /></span> }]}
              value={draftFilters.type ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, type: v as Filters['type'] }))} />
            )}
            <ChipGroup title="Outcome" multi hl={fpFocus === 'Outcome'}
              items={[{ k: 'success', label: 'Success', mark: <span className="aw-fdot" style={{ background: '#16A34A' }} /> },
                { k: 'watch', label: 'Watch', mark: <span className="aw-fdot" style={{ background: '#D97706' }} /> },
                { k: 'failure', label: 'Failure', mark: <span className="aw-fdot" style={{ background: '#DC2626' }} /> }]}
              value={draftFilters.outcome ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, outcome: v as Filters['outcome'] }))} />
          </div>
          <div className="aw-fcol">
            <ChipGroup title="Status" hl={fpFocus === 'Status'}
              items={[{ k: 'prog', label: 'Pending', mark: <span className="aw-fdot" style={{ background: '#D97706' }} /> }, { k: 'done', label: 'Completed', mark: <span className="aw-fdot" style={{ background: '#16A34A' }} /> }]}
              value={draftFilters.status} onChange={(v) => setDraftFilter('status', v as Filters['status'])} />
            <ChipGroup title="Priority" hl={fpFocus === 'Priority'}
              items={[{ k: 'normal', label: 'Normal' }, { k: 'urgent', label: 'Urgent', mark: <span className="aw-fico" style={{ color: '#DC2626' }}><SvgIcon name="flag" /></span> }]}
              value={draftFilters.priority} onChange={(v) => setDraftFilter('priority', v as Filters['priority'])} />
            <ChipGroup title="Opened" hl={fpFocus === 'Opened'} items={[{ k: 'read', label: 'Read' }, { k: 'unread', label: 'Unread' }]}
              value={draftFilters.opened ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, opened: v as Filters['opened'] }))} />
            <ChipGroup title="Notes" hl={fpFocus === 'Notes'} items={[{ k: 'with', label: 'With notes' }, { k: 'without', label: 'Without notes' }]}
              value={draftFilters.notes ?? 'all'} onChange={(v) => setDraftFilters((current) => ({ ...current, notes: v as Filters['notes'] }))} />
            <ChipGroup title="Language" multi hl={fpFocus === 'Language'} items={orgLangs.map((c) => ({ k: c, label: langName(c) })).sort((x, y) => x.label.localeCompare(y.label))}
              value={draftFilters.language} onChange={(v) => setDraftFilter('language', v)} />
          </div>
        </div>
      </div>
      <div className="aw-filter-footer aw-fp-foot">
        {isPhone
          ? <button className="aw-secondary" type="button" data-track="filters.cancel" onClick={() => { setDraftFilters(filters); setFilterOpen(false); }}>Cancel</button>
          : <button className="aw-secondary" type="button" data-track="filters.reset" onClick={() => setDraftFilters((current) => ({ ...initialFilters, dateScope: current.dateScope, fuView: current.fuView, fuPills: current.fuPills, modes: current.modes }))}>Reset</button>}
        <button className="aw-primary" type="button" onClick={() => { trackFilterShow(filters, draftFilters); setFilters(draftFilters); setFilterOpen(false); }}>Show results</button>
      </div>
    </div>
  );

  return (
    <div className={`aw-app ${collapsed ? 'aw-collapsed' : ''} ${navOpen ? 'aw-nav-open' : ''}${kind === 'text' ? ' aw-txt' : ''}`}>{/* v12.10.27 (#2146 Q32): teal Text messages workspace */}
      {/* v12.10.14 (#1626): the second, hidden left menu (fixed word "Patients") is removed - the app shell's menu is the only one. */}

      <header className="aw-mobile-topbar" aria-label="Workspace mobile navigation">
        <button className="aw-mobile-burger" type="button" onClick={() => { setNavOpen(true); setMobileAccountOpen(false); }} aria-label="Open workspace navigation">
          <SvgIcon name="menu" />
        </button>
        <span className="aw-mobile-org">
          <span className="aw-mobile-logo" aria-hidden="true">{tenantInitial}</span>
          <strong>{tenantDisplayName}</strong>
        </span>
        <div className="aw-mobile-account" ref={mobileAccountRef}>
          <button className="aw-mobile-avatar" type="button" onClick={() => { setMobileAccountOpen((open) => !open); setNavOpen(false); }} aria-expanded={mobileAccountOpen} aria-haspopup="menu">
            <span>{currentUserInitials}</span>
          </button>
          {mobileAccountOpen && (
            <div className="aw-mobile-account-menu" role="menu">
              <div className="aw-account-menu-head">
                <strong>{currentUserName}</strong>
                <span>{currentUserEmail}</span>
              </div>
              {/* v12.10.9.1 (#1280): one entry - "Your account" */}
              <button type="button" role="menuitem" onClick={() => { setMobileAccountOpen(false); openYourAccount(); }}>
                Your account
              </button>
              <button type="button" role="menuitem" onClick={signOut}>
                Sign out
              </button>
            </div>
          )}
        </div>
      </header>

      <section className="aw-main" aria-label="Messages workspace">
        <div className="aw-main-inner">
          <div className="aw-page-head">
            <button className="aw-mobile-menu" type="button" onClick={() => setNavOpen(true)} aria-label="Open workspace navigation">
              <SvgIcon name="menu" />
            </button>
            <div>
              <h1>{filters.fuView ? 'Follow-ups' : 'Messages'}</h1>{/* v12.10.12 (#1536): the Follow-ups view says so */}
              <p>Work the inbound queue, document follow-up, and complete caller requests.</p>
            </div>
            <div className="aw-head-actions">
              <span className="aw-pill aw-pill-good">Live queue</span>
              <button className="aw-hotkeys" type="button" onClick={() => setHelpOpen(true)}>?</button>
            </div>
          </div>

          <div className="aw-dashboard">
            {/* v12.4.11 (#469); v12.4.13 (#469): aw-pinned drives the seam.
                v12.4.16 (#469): aw-forced-open is NOT the same thing as "not collapsed". Below 980px the
                expanded header is position:static, so a header the reader OPENED has to pin where they are
                rather than reappear at the top of the dashboard where nobody is looking - agent-workspace.css
                carries that rule. headerCollapsed (not headerIsCollapsed) is the right test: it says the
                scroll position still wants the mini bar, which is exactly when the full header needs pinning. */}
            <div
              className={`aw-dashboard-top${headerIsCollapsed ? ' aw-collapsed' : ''}${headerPinned ? ' aw-pinned' : ''}${!isPhone && headerCollapsed && headerForcedOpen ? ' aw-forced-open' : ''}${isPhone ? ' aw-phone' : ''}${isPhone && headerPinned ? ' aw-phone-scrolled' : ''}`}
              ref={headerRef}
            >
              {/* v12.10.12 (#1536, UI-PROTO v1.6): the Follow-ups view has no channel tabs. */}
              <div className="aw-tabs" role="tablist" aria-label="Message channel" hidden={!!filters.fuView}>
                <button className={`aw-tab ${kind === 'call' ? 'aw-active' : ''}`} type="button" data-track="messages.tab.calls" role="tab" aria-selected={kind === 'call'} onClick={() => { setKind('call'); setHighlightedIndex(0); setSelectedId(null); }}>
                  {/* v12.10.12 (#1532): the count as text - "Phone calls · 209", every call in the selected dates. */}
                  <SvgIcon name="phone" /> Phone calls <span className="aw-tc">· {countOrMark(counts.call, sc?.cards ?? sc?.calls)}</span>{/* #2238 cards */}{/* v12.10.21 (#1944) */}
                </button>
                {/* v12.10.12 (#1535): Text messages stays disabled - no FUTURE badge; hovering says "Not available yet". The title
                    sits on a wrapper because a disabled button gets no hover in some browsers. */}
                {/* v12.10.26 (#T154 Q9 TC8): enabled only when the practice's Text messaging workflow is On (count shown then); otherwise as before. */}
                {textingStatus?.workflowOn ? (
                  // v12.10.27 (#2146, UI-PROTO-T154-TEXT-WORKFLOW v1.3 LOCKED): the Text messages tab is the same list as Phone calls -
                  // text conversations run by the practice's workflow, as cards; the 12.10.26 sheet is retired.
                  <button className={`aw-tab ${kind === 'text' ? 'aw-active' : ''}`} type="button" role="tab" data-track="messages.tab.texts" aria-selected={kind === 'text'}
                    onClick={() => { setKind('text'); setHighlightedIndex(0); setSelectedId(null); }}>
                    <SvgIcon name="message" /> Text messages <span className="aw-tc">· {countOrMark(counts.text, undefined)}</span>
                  </button>
                ) : (
                <span className="aw-tab-hint" title="Not available yet">
                  <button className="aw-tab aw-tab-future" type="button" role="tab" aria-selected={false} aria-disabled="true" disabled aria-label="Text messages - not available yet">
                    <SvgIcon name="message" /> Text messages
                  </button>
                </span>
                )}
                {/* v12.10.27 (#2146): the 12.10.26 Text messages sheet (TextMessagesPanel) is replaced by the kind "text" list above. */}
              </div>

              <div className="aw-topline">
                {/* ══ v12.10.12 T69 (UI-PROTO-12.10.11.4 v1.6 LOCKED): UP NEXT, "N to work" | Me · N, Reminders · N, Urgent · N.
                    Same format in Messages and Follow-ups, desktop and phone. White pills of one size; a picked pill takes its own
                    colour (Me indigo, Reminders amber, Urgent red); they combine; the number turns them all off. ══ */}
                <div className="aw-up-next">
                  <button type="button" className="aw-upnext-num"
                    title={filters.fuView ? 'Every marked follow-up - past, today and future. Click to go back to how Follow-ups opened' : 'Open calls in these dates - click to clear Me / Reminders / Urgent'}
                    onClick={clearModes}>
                    <strong>{countOrMark(upNext, sc?.open)}</strong>{/* v12.10.21 (#1944) */}
                  </button>
                  <span className="aw-tw">to work</span>
                  <span className="aw-vsep" aria-hidden="true" />
                  {meId !== null && (
                    <button type="button" data-track="messages.pill.me" className={`aw-qc aw-qc-me${hasMode('me') ? ' aw-on' : ''}`} aria-pressed={hasMode('me')}
                      title="Assigned to me" aria-label={countsLoading ? 'Assigned to me: loading' : `Assigned to me: ${mineCount}`} onClick={() => toggleMode('me')}>
                      <span>Me</span><span className="aw-qc-d aw-qc-long">·</span><b>{countOrMark(mineCount, meId === null ? (sc ? 0 : null) : scPill('me'))}</b>
                    </button>
                  )}
                  {!filters.fuView && (
                    <button type="button" data-track="messages.pill.reminders" className={`aw-qc aw-qc-rem${hasMode('marked') ? ' aw-on' : ''}`} aria-pressed={hasMode('marked')}
                      title="Reminders - open calls in these dates with a reminder set, whatever its due date" aria-label={countsLoading ? 'Reminders: loading' : `Reminders: ${remindersCount}`}
                      onClick={() => toggleMode('marked')}>
                      <SvgIcon name="clock" /><span className="aw-qc-long">Reminders</span><span className="aw-qc-d aw-qc-long">·</span><b>{countOrMark(remindersCount, scPill('marked'))}</b>
                    </button>
                  )}
                  <button type="button" data-track="messages.pill.urgent" className={`aw-qc aw-qc-urg${!countsLoading && urgentCount > 0 ? ' aw-hot' : ''}${hasMode('urgent') ? ' aw-on' : ''}`} aria-pressed={hasMode('urgent')}
                    title="Urgent" aria-label={countsLoading ? 'Urgent: loading' : `Urgent: ${urgentCount}`} onClick={() => toggleMode('urgent')}>
                    <SvgIcon name="flag" /><span className="aw-qc-long">Urgent</span><span className="aw-qc-d aw-qc-long">·</span><b>{countOrMark(urgentCount, scPill('urgent'))}</b>
                  </button>
                  {/* v12.10.14 (#1612, FILTER-PANEL v1.0 §4): phone - one filter icon with a count (groups on) next to the flag, no arrow */}
                  {isPhone && (
                    <button type="button" ref={phoneFilterRef} className={`aw-qc aw-qc-filter${groupsOn > 0 ? ' aw-on' : ''}`} data-track="messages.filters.open"
                      aria-label={groupsOn > 0 ? `Filters: ${groupsOn} on` : 'Filters'} title="Filters"
                      onClick={() => { setDateOpen(false); setDraftFilters(filters); setFilterOpen((open) => !open); }}>
                      <SvgIcon name="filter" />{groupsOn > 0 && <b className="aw-qc-badge">{groupsOn}</b>}
                    </button>
                  )}
                  {/* v12.4.9 (#453): only when the arrival landed off screen - see PROTO_new_calls_chip_v1.1. */}
                  {newArrivalsChip('list')}
                </div>
                {isPhone && filterOpen && filterPanelEl}   {/* v12.10.14 (#1612): the phone sheet, opened by the icon above */}
                {/* v12.10.12 (#1536): Follow-ups - the date pills sit right after the pills, between two separators; when they
                    do not fit (e.g. 1366 px) they drop to their own row (aw-fuwrap, measured below). Phone: under the bar. */}
                {filters.fuView && !isPhone && (
                  <div className="aw-fupg"><span className="aw-vsep" aria-hidden="true" />{fuPillsRow}<span className="aw-vsep" aria-hidden="true" /></div>
                )}

                {/* v12.10.11.3 (#1521): sort + the filters group (date · Due · Filters) - one unit that wraps as a whole. */}
                <div className="aw-ctl-group">
                {/* v12.10.12 (#1535 S42): "Newest" / "Oldest". v12.10.11.3 (#1521): on its own, left of the filters (Tushar: "filters go together and
                    sort stay separate"); remembered on this computer. */}
                {!isPhone && sortSeg}

                {/* v12.10.11.3 (#1527): the Follow-ups view has no date and no Due chip - its pills sit in the chip row. */}
                {!filters.fuView && (
                <div className="aw-date-wrap" ref={dateWrapRef}>
                  <button className="aw-control aw-date-control aw-on" type="button" data-track="messages.date.open" aria-expanded={dateOpen} onClick={() => { setFilterOpen(false); setDateOpen((open) => !open); }}>
                    <SvgIcon name="calendar" /> {dateScopeLabel(filters.dateScope)} <span className="aw-chevron-down" aria-hidden="true" />
                  </button>
                  {dateOpen && (
                    // v12.10.6 (#1153): the shared Date scope control - the same panel, now with Year / Month under Custom
                    <DateScopePanel
                      value={filters.dateScope}
                      years={messageYears}
                      onCancel={() => setDateOpen(false)}   /* v12.10.14 (#1605): Apply + Cancel always */
                      onApply={(scope) => { track('messages.date.pick', { value: dateTrackValue(scope) }); setFilters((current) => ({ ...current, dateScope: scope })); setDateOpen(false); }}
                    />
                  )}
                </div>
                )}

                {/* v12.10.12 (#1531): the "Due for follow-up" switch is gone - Reminders (after Me) replaces it; date and Filters sit together. */}
                <div className="aw-filter-wrap" ref={filterWrapRef}>
                  <button className={`aw-filter-button ${filterOpen || hasNonDateFilters(filters) ? 'aw-on' : ''}`} type="button" data-track="messages.filters.open" aria-expanded={filterOpen} onClick={() => { setDraftFilters(filters); setDateOpen(false); setFilterOpen((open) => !open); }}>
                    <SvgIcon name="filter" /> Filters
                  </button>
                  {/* v12.10.13 (#1558): the panel is built above (filterPanelEl). */}
                  {!isPhone && filterOpen && filterPanelEl}
                </div>
                </div>
              </div>

              <div className="aw-search-row">
                <label className="aw-search">
                  <span className="sr-only">Search messages</span>
                  <SvgIcon name="search" />
                  <input ref={searchRef} value={filters.query} placeholder={narrowSearch ? 'Search name, phone, reference…' : 'Search by name, phone, reference, or what you need...'} onChange={(event) => { if (!filters.query && event.target.value) track('messages.search'); setFilters((current) => ({ ...current, query: event.target.value })); }} />
                </label>
                <button className="aw-secondary" type="button" onClick={() => setHelpOpen(true)}>Keyboard shortcuts</button>
              </div>

              {/* v12.4.11 (#469 / BDR-012): collapsed-only furniture. Rendered ALWAYS and hidden by CSS
                  rather than mounted on collapse - the search input beside it must keep its node, or the
                  caret and focus are thrown away the moment the header changes state under a typing agent. */}
              <div className="aw-collapsed-only" aria-hidden={!headerIsCollapsed}>
                <button
                  className={`aw-control aw-filter-chip${collapsedFilterChip.none ? '' : ' aw-on'}`}
                  type="button"
                  data-track="messages.filters.open"
                  tabIndex={headerIsCollapsed ? 0 : -1}
                  aria-expanded={filterOpen}
                  aria-label={collapsedFilterChip.none
                    ? 'Filters - none active'
                    : `Filters - ${collapsedFilterChip.label}${collapsedFilterChip.extra > 0 ? ` and ${collapsedFilterChip.extra} more` : ''}`}
                  onClick={() => { setDateOpen(false); if (isPhone) setDraftFilters(filters); setFilterOpen((open) => !open); }}
                >
                  <SvgIcon name="filter" />
                  <span className="aw-filter-chip-label">{collapsedFilterChip.label}</span>
                  {collapsedFilterChip.extra > 0 && <span className="aw-filter-chip-more">+{collapsedFilterChip.extra}</span>}
                </button>
                {/* v12.10.11.3 (#1522 / #1523): the total, short form, in the mini bar, after the date chip (locked order). */}
                <span className="aw-mini-total"><b>{countOrMark(visibleMessages.length)}</b> {filters.fuView ? 'follow-ups' : 'calls'}</span>{/* v12.10.21 (#1944) */}
                <button
                  className="aw-control aw-header-expand"
                  type="button"
                  tabIndex={headerIsCollapsed ? 0 : -1}
                  aria-label={isPhone ? 'All filters' : 'Show the full header'}
                  title={isPhone ? 'All filters' : 'Show the full header'}
                  onClick={() => {
                    // v12.10.9.4 (#1358): on a phone there is no full header - the arrow opens all the filters
                    if (isPhone) { setDateOpen(false); setDraftFilters(filters); setFilterOpen((open) => !open); return; }
                    // v12.4.16 (#469): THE EXPANDER DID NOTHING ON A PHONE, and this was why. It read its
                    // baseline off `.tenant-main .aw-main`, which below 980px is height:auto/overflow:visible
                    // and never a scroller - so the ternary fell through to window.scrollY, which is 0 there.
                    // Setting headerForcedOpen re-runs the collapse effect (it is in its deps), that effect
                    // calls evaluate() synchronously, and evaluate compares the REAL scroll position against
                    // that 0: |1435 - 0| > 40, so it cancelled the forced-open before a frame was painted.
                    // MEASURED in the running app at 390px: clicking "Show the full header" left
                    // aw-collapsed on the element at +60ms and at +500ms. His words: "a down arrow that
                    // opens nothing." Use the same resolver the collapse logic uses, so the baseline is read
                    // off the element that is actually scrolling.
                    forcedAtRef.current = scrollTopOf(resolveQueueScroller(headerRef.current));
                    setHeaderForcedOpen(true);
                  }}
                >
                  <span className="aw-chevron-down" aria-hidden="true" />
                </button>
              </div>

              {/* v12.10.11.1 (#1492): no chip row on a phone - the filter button already says '+N'; changes and Clear all live in the filter screen. */}
              {!isPhone && (
              <div className="aw-active-pills" aria-label="Active filters" ref={pillsRef}>
                {activeFilterLabels.map((item, i) => (
                  <span key={item.key} className={`aw-active-pill${item.group ? ' aw-pill-grp' : ''}`} hidden={pillFit !== null && i >= pillFit}
                    role={item.group ? 'button' : undefined} tabIndex={item.group ? 0 : undefined} title={item.group ? `Change ${item.group}` : undefined}
                    onClick={item.group ? () => { setDraftFilters(filters); setDateOpen(false); setFilterOpen(true); setFpFocus(item.group!); } : undefined}
                    onKeyDown={item.group ? (e) => { if (e.key === 'Enter') { setDraftFilters(filters); setDateOpen(false); setFilterOpen(true); setFpFocus(item.group!); } } : undefined}>
                    {item.label}
                    <button type="button" aria-label={`Remove ${item.label}`} onClick={(e) => { e.stopPropagation(); resetOneFilter(item.key); }}>x</button>
                  </span>
                ))}
                {pillFit !== null && pillFit < activeFilterLabels.length && (
                  <button type="button" className="aw-pill-more" onClick={() => { setDraftFilters(filters); setDateOpen(false); setFilterOpen(true); }}>
                    +{activeFilterLabels.length - pillFit} · Show all filters
                  </button>
                )}
                {activeFilterLabels.length > 0 && (
                  <button className="aw-chip" type="button" onClick={() => setFilters((current) => ({ ...initialFilters, dateScope: current.dateScope, fuView: current.fuView, fuPills: current.fuView ? fuDefaultPills() : undefined }))}>Clear all</button>
                )}
                {filters.fuView ? fuTotalLine : totalLine}
              </div>
              )}
              {/* v12.10.11.3 (#1523 / #1527): on a phone there is no chip row - the total (or the follow-up pills) sits on its own line. */}
              {isPhone && (filters.fuView ? <div className="aw-phone-total">{fuPillsRow}</div> : <div className="aw-phone-total">{totalLine}{sortSeg}</div>)}   {/* v12.10.14 (#1612): Newest / Oldest on the count line */}
              {/* v12.10.11.3 (#1522): never silent - when the safety ceiling cut the list, say so. */}
              {/* v12.10.16 (#1688): the first page is showing - say the rest is coming, so a filter count is never read as final. */}
              {/* v12.10.21 (#1945, LOCKED v1.5): no yellow bar, no numbers - the compact logo frame while the rest loads, gone when it is in.
                  (fillProgress still drives the fill; it is no longer shown.) */}
              {listPartial && !messagesLoading && <ListLoadingFrame />}
              {searchAllDates && (
                <div className="aw-truncated" role="status">Showing {visibleMessages.length} from all dates - your date filter ({dateScopeLabel(filters.dateScope)}) is unchanged. Clear the search to return to it.</div>
              )}
              {listTruncated && (
                <div className="aw-truncated" role="status">Showing the newest 2,000 calls for these dates. Narrow the dates or search to see older ones.</div>
              )}
            </div>

            {/* ══ v12.10.16 (T115 #1693, LOCKED v1.5): the batch panel. ══ */}
            {batchMode && (
              <div className="aw-bs-panel" role="region" aria-label="Batch actions">
                <div className="aw-bs-head">
                  <b>Batch actions</b>
                  <span className="aw-bs-count">{batchSel.size} selected</span>
                  <button type="button" className="aw-bs-mini" onClick={() => setBatchSel(new Set(visibleMessages.map((m) => m.id)))}>Select all shown</button>
                  <button type="button" className="aw-bs-mini" onClick={() => setBatchSel(new Set())}>Clear</button>
                  {!isPhone && <span className="aw-bs-hint">Ctrl+click a card to add or remove it</span>}
                </div>
                <div className="aw-bs-acts">
                  <button type="button" disabled={!batchSel.size} className={`aw-bs-act${batchStage.note ? ' pk' : ''}`} onClick={() => { setBatchEditing('note'); setBatchNoteDraft(batchStage.note ?? ''); }}>Add note</button>
                  <button type="button" disabled={!batchSel.size} className={`aw-bs-act${batchStage.reminder ? ' pk' : ''}`} onClick={() => setBatchEditing('reminder')}>Set reminder</button>
                  <button type="button" disabled={!batchSel.size} className={`aw-bs-act${batchStage.labels?.length ? ' pk' : ''}`} onClick={() => { setBatchEditing('labels'); setBatchLabelDraft(batchStage.labels ?? []); }}>Apply label</button>
                  <span className="aw-bs-mk">Mark:</span>
                  {([['read', ['Read', 'Unread']], ['urgent', ['Urgent', 'Not urgent']], ['status', ['Pending', 'Completed']]] as [keyof BatchStage, string[]][]).map(([g, opts]) => (
                    <span key={g} className="aw-xlsw aw-xlsw-fill aw-bs-seg" role="group">
                      {opts.map((o) => (
                        <button key={o} type="button" disabled={!batchSel.size} className={`aw-xltab${batchStage[g] === o ? ' on' : ''}`} aria-pressed={batchStage[g] === o}
                          onClick={() => setBatchStage((cur) => ({ ...cur, [g]: cur[g] === o ? undefined : o }))}>{o}</button>
                      ))}
                    </span>
                  ))}
                  <button type="button" className="aw-primary aw-bs-apply" disabled={!batchSel.size || batchChips.length === 0}
                    data-track="messages.batch.apply" onClick={() => { setBatchTyped(''); setBatchConfirm(true); }}>Apply{batchChips.length ? ` \u00b7 ${batchChips.length}` : ''}</button>
                </div>
                {batchEditing === 'note' && (
                  <div className="aw-bs-ed">
                    <div className="aw-bs-eh">Remarks / action taken</div>
                    <div className="aw-bs-chips">{NOTE_TEMPLATES.map((t) => <button key={t.label} type="button" className="aw-bs-chip" onClick={() => setBatchNoteDraft((d) => (d ? `${d} ${t.text}` : t.text))}>{t.label}</button>)}</div>
                    <textarea rows={3} value={batchNoteDraft} onChange={(e) => setBatchNoteDraft(e.target.value)} placeholder="Describe the action taken..." />
                    <div className="aw-bs-ft"><button type="button" className="aw-secondary" onClick={() => setBatchEditing(null)}>Cancel</button>
                      <button type="button" className="aw-primary" disabled={!batchNoteDraft.trim()} onClick={() => { setBatchStage((c) => ({ ...c, note: batchNoteDraft.trim() })); setBatchEditing(null); }}>Save note</button></div>
                  </div>
                )}
                {batchEditing === 'reminder' && (
                  <div className="aw-bs-ed">
                    <div className="aw-bs-eh">Remind me to follow up</div>
                    <div className="aw-bs-chips">{REMINDER_PRESETS.map((pr) => (
                      <button key={pr.value} type="button" className={`aw-bs-chip${batchStage.reminder === pr.value ? ' on' : ''}`}
                        onClick={() => { setBatchStage((c) => ({ ...c, reminder: pr.value, reminderPick: undefined })); setBatchEditing(null); }}>{pr.label}</button>
                    ))}</div>
                    <div className="aw-bs-date">Or pick a date: <input type="date" value={batchPickDate} onChange={(e) => setBatchPickDate(e.target.value)} />
                      <button type="button" className="aw-primary" disabled={!batchPickDate} onClick={() => { setBatchStage((c) => ({ ...c, reminder: reminderDateLabel(batchPickDate), reminderPick: batchPickDate })); setBatchEditing(null); }}>Set</button></div>
                    <div className="aw-bs-ft"><button type="button" className="aw-secondary" onClick={() => setBatchEditing(null)}>Cancel</button></div>
                  </div>
                )}
                {batchEditing === 'labels' && (
                  <div className="aw-bs-ed">
                    <div className="aw-bs-eh">Apply labels</div>
                    <div className="aw-bs-chips">{availableLabels.map((l) => (
                      <button key={l.name} type="button" className={`aw-bs-chip${batchLabelDraft.includes(l.name) ? ' on' : ''}`}
                        onClick={() => setBatchLabelDraft((d) => (d.includes(l.name) ? d.filter((x) => x !== l.name) : [...d, l.name]))}>
                        <span className="aw-bs-dot" style={{ background: l.color }} />{l.name}</button>
                    ))}</div>
                    <div className="aw-bs-ft"><button type="button" className="aw-secondary" onClick={() => setBatchEditing(null)}>Cancel</button>
                      <button type="button" className="aw-primary" onClick={() => { setBatchStage((c) => ({ ...c, labels: batchLabelDraft.length ? batchLabelDraft : undefined })); setBatchEditing(null); }}>Done</button></div>
                  </div>
                )}
                <div className="aw-bs-stage">
                  {batchChips.length ? (<><span className="aw-bs-hint">To apply:</span>{batchChips.map(([k, t]) => (
                    <span key={k} className="aw-bs-sc">{t}<button type="button" aria-label={`Remove ${t}`} onClick={() => setBatchStage((c) => ({ ...c, [k]: undefined, ...(k === 'reminder' ? { reminderPick: undefined } : {}) }))}>{'\u00d7'}</button></span>
                  ))}</>) : <span className="aw-bs-hint">Pick one or more changes - nothing happens until Apply.</span>}
                </div>
              </div>
            )}
            {batchConfirm && (() => {
              const grouped = [...batchSel].reduce((sum, id) => sum + Math.max(0, (callGroups.members.get(id)?.length ?? 1) - 1), 0);
              const n = batchSel.size, k = batchChips.length;
              return (
                <div className="aw-bs-modal" role="dialog" aria-modal="true" aria-label="Confirm batch changes">
                  <div className="aw-bs-box">
                    <h3>Apply {k} change{k > 1 ? 's' : ''} to {n} message{n > 1 ? 's' : ''}?</h3>
                    <ul>{batchChips.map(([key, t]) => <li key={key}>{t}</li>)}</ul>
                    {grouped > 0 && <p>Grouped cards include {grouped} more call{grouped > 1 ? 's' : ''} - the changes cover them too.</p>}
                    <p>Type <b>APPLY</b> to confirm.</p>
                    <input autoFocus value={batchTyped} onChange={(e) => setBatchTyped(e.target.value)} placeholder="APPLY" autoComplete="off" />
                    <div className="aw-bs-ft">
                      <button type="button" className="aw-secondary" onClick={() => setBatchConfirm(false)}>Cancel</button>
                      <button type="button" className="aw-primary" disabled={batchTyped.trim().toUpperCase() !== 'APPLY'} onClick={applyBatch}>Apply {k} change{k > 1 ? 's' : ''}</button>
                    </div>
                  </div>
                </div>
              );
            })()}
            {batchUndo && (
              <div className="aw-bs-undo" role="status">{batchUndo.text} <button type="button" onClick={undoBatch}>Undo</button></div>
            )}

            <div className="aw-list" ref={listRef} role="list" aria-label={`${kind === 'call' ? 'Call' : 'Text'} messages`}>
              {messagesLoading ? (
                <div className="aw-loading" role="status">
                  <span className="aw-spinner" aria-hidden="true" />
                  <h2>Loading messages</h2>
                  <p>Reading call and message rows from your workspace.</p>
                </div>
              ) : messagesError ? (
                <div className="aw-load-error" role="alert">
                  <h2>{messagesError.startsWith('You don’t have access') ? 'No access to Messages' : 'Messages could not be loaded'}</h2>
                  <p>{messagesError}</p>
                </div>
              ) : groupedMessages.length === 0 && listPartial ? (
                // v12.10.19 (#1882): the rest of the list is still coming - never "No messages today" before it is in.
                <div className="aw-loading" role="status">
                  <span className="aw-spinner" aria-hidden="true" />
                  <h2>Loading messages</h2>
                  <p>Reading the rest of the list for these dates.</p>
                </div>
              ) : groupedMessages.length === 0 ? (
                <div className="aw-empty">
                  <h2>{emptyCopy.heading}</h2>
                  <p>{emptyCopy.body}</p>
                  {/* v12.10.13 (#1570): the filters that hide everything, by name, each removable - and Reset filters right here. */}
                  {(hasNonDateFilters(filters) || (allDatesCount && allDatesCount.q === filters.query.trim() && allDatesCount.n > 0)) && (
                    <div className="aw-empty-filters">
                      {/* v12.10.14 (#1610): no results = the message + Reset filters only - the chips are not repeated */}
                      {hasNonDateFilters(filters) && <button className="aw-secondary" type="button" data-track="messages.empty.reset"
                        onClick={() => setFilters((current) => ({ ...initialFilters, dateScope: current.dateScope, fuView: current.fuView, fuPills: current.fuView ? fuDefaultPills() : undefined }))}>
                        Reset filters
                      </button>}
                      {/* v12.10.19 (#1926): the search found nothing in these dates - every date, without changing the date filter */}
                      {allDatesCount && allDatesCount.q === filters.query.trim() && allDatesCount.n > 0 && !searchAllDates && (
                        <button className="aw-primary" type="button" data-track="messages.empty.alldates" onClick={openAllDates}>
                          Search all dates ({allDatesCount.n} found)
                        </button>
                      )}
                    </div>
                  )}
                </div>
              ) : drawnGroups.map((group, gi) => (   /* v12.10.20 (#1935): the drawn part of each day */
                <section className="aw-bucket" key={group.bucket}>
                  {/* v12.10.11.3 (#1523): each day carries its count; the heading stays pinned while its day scrolls by. */}
                  <div className="aw-bucket-head">
                    {/* v12.10.16 (T115 #1693): the day's checkbox picks (or clears) the whole day */}
                    {batchMode && !isPhone && (() => {
                      const n = group.all.filter((m) => batchSel.has(m.id)).length;
                      return <button type="button" className={`aw-bs-cb aw-bs-daycb${n === 0 ? '' : n === group.all.length ? ' on' : ' part'}`}
                        aria-label={`Select all of ${group.bucket}`} title={`Select all of ${String(group.bucket).toLowerCase()}`}
                        onClick={() => setBatchSel((cur) => { const next = new Set(cur); const all = group.all.every((m) => next.has(m.id)); group.all.forEach((m) => (all ? next.delete(m.id) : next.add(m.id))); return next; })} />;
                    })()}
                    <span>{group.bucket} · {fmtCount(group.all.length)}<span className="aw-cont"> (continued)</span></span>
                  </div>
                  {group.messages.map((message) => {
                    const index = indexById.get(message.id) ?? -1;   // v12.10.20 (#1935): was a search of the whole list for every card
                    return (
                      <button
                        key={message.id}
                        id={`aw-card-${message.id}`}
                        type="button"
                        role="listitem"
                        data-track="messages.row.open"
                        className={`aw-card aw-st-${message.status} ${message.priority === 'urgent' ? 'aw-urgent' : ''} ${index === highlightedIndex ? 'aw-highlighted' : ''} ${message.id === selectedId ? 'aw-open' : ''} ${!selectedId && message.id === lastOpenedId ? 'aw-last-opened' : ''}${batchSel.has(message.id) ? ' aw-bs-picked' : ''}`}
                        onMouseEnter={() => setHighlightedIndex(index)}
                        onClick={(e) => {
                          // v12.10.16 (T115 #1693): Ctrl+click (or any click in batch mode) picks the card instead of opening it
                          if (longPressRef.current?.fired) { longPressRef.current = null; return; }
                          if (e.ctrlKey || e.metaKey || batchMode) { e.preventDefault(); toggleBatch(message.id); return; }
                          openMessage(message);
                        }}
                        onPointerDown={isPhone ? () => {
                          const t = window.setTimeout(() => { longPressRef.current = { t: 0, fired: true }; setBatchMode(true); toggleBatch(message.id); }, 550);
                          longPressRef.current = { t, fired: false };
                        } : undefined}
                        onPointerUp={isPhone ? () => { if (longPressRef.current && !longPressRef.current.fired) { window.clearTimeout(longPressRef.current.t); longPressRef.current = null; } } : undefined}
                        onPointerLeave={isPhone ? () => { if (longPressRef.current && !longPressRef.current.fired) { window.clearTimeout(longPressRef.current.t); longPressRef.current = null; } } : undefined}
                      >
                        {/* v12.4.11 (#470): the index badge is GONE. #233 added it to match the drawer's
                            "Message N of M" counter, and 12.4.9 removed that counter from the drawer header -
                            so the badge has been pointing at something that no longer exists. Tushar found it
                            the way you find an orphan: "i have a question when did we bring these numbers on
                            the message cards . it says 11 on the message and on the card the number is
                            #36-0023" - a position that looks like an identifier and matches nothing, sitting
                            next to a reference number that IS one. When a counterpart is deleted, whatever was
                            built to mirror it goes in the same build. */}
                        {/* v12.10.16 (T115 #1693): the checkbox sits in the margin, outside the card's width; never on a phone */}
                        {batchMode && !isPhone && <span className={`aw-bs-cb${batchSel.has(message.id) ? ' on' : ''}`} aria-hidden="true" />}
                        <SearchableText query={filters.query} message={message} />
                        {(() => { const _ct = callerTileMeta(message); return (
                        <span className="aw-avatar aw-avatar-ct" style={{ background: _ct.color }} title={`${_ct.name} - ${msgChannelLabel(message)}`}>
                          {/* v12.10.17 (#1723 D1 D2): the caller type only - its icon + colour; unknown = the plain person on slate. */}
                          <CallerTypeIcon name={_ct.icon} size={18} className="aw-avatar-ico" />
                          <span className={`aw-channel-badge aw-channel-${message.channel}`}><SvgIcon name={channelIcon(message.channel)} /></span>
                        </span>); })()}
                        <span className="aw-card-main">
                          {/* v12.4.9 (#458) - SPEC_message_card_topline_v1_0 section 1. The locked line is
                              name · phone · LANG · verified. The NAME is first and primary and is the only element
                              whose weight changes with read state; the phone is secondary meta and prints
                              ONCE, in national format. No dot of any colour before the name - the 4px left
                              accent is the unread signal and two signals for one state is what made the
                              indigo dot read as a second unread marker. When no name was captured the phone
                              takes the name slot and the phone meta is dropped, so it still appears once. */}
                          <span className="aw-card-top">
                            <span className="aw-card-name" title={message.nameFromContact ? 'From the contact book - this call did not capture a name' : undefined}>{message.hasName ? message.name : <PhoneCopy phone={message.phone} />}</span>
                            {/* v12.10.11.3 (#1524): where they were - stays until another message is opened. */}
                            {!selectedId && message.id === lastOpenedId && <span className="aw-last-tag">Last opened</span>}
                            {/* v12.10.26 (#T154 Q16): a patient replied by text - the pill clears on open, the flag stays until completed. */}
                            {message.newText && message.kind !== 'text' && <span className="aw-newtext-pill" title="The patient replied by text">New text</span>}
                            {message.followUp && <span className="aw-followup-flag" title="Follow-up - the patient replied by text">⚑ Follow-up</span>}
                            <span className="aw-card-meta">
                              <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                              {message.hasName && (
                                <>
                                  {/* v12.7.0 (#580): the mark is a fact about the NUMBER, not the person, so it
                                      sits inside the number's group and survives the name wrapping. */}
                                  <LineMark type={message.lineType} carrier={message.lineCarrier} info={message.phone2} />
                                  <PhoneCopy className="aw-card-phone" phone={message.phone} />{/* v12.10.15 (#1668) */}
                                  <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                                </>
                              )}
                              <span className="aw-card-lang">{languageCode(message.language)}</span>
                              {/* v12.10.15 (#1663) -> v12.10.23 (#2070, LOCKED v1.2 tab 3): the call-back number moved into the card line (before the Next step) */}
                              {/* ── v12.7.0 (#581): THE VERIFIED BADGE IS GONE, AND IT IS NOT COMING BACK
                                  UNTIL IT MEANS SOMETHING. Tushar asked what it meant; the answer was
                                  `metadata?.Verified ?? true` in TenantSurfaceController - nothing in the
                                  engine ever wrote that key, so EVERY call ever recorded showed a green tick,
                                  including the ones that failed. On a medical call that reads as "we confirmed
                                  who this person is", which nothing had. His decision: remove it, and define
                                  it properly in ROADMAP-006 (matched in the connected system, or a known
                                  contact). "Unverified" was considered and rejected - it reads as a judgement
                                  about the CALLER when the truth is about US. */}
                              {/* v12.7.0 (#582): the outcome sits BEFORE the reference - the reference is the
                                  artifact of the booking, so outcome-then-reference reads in the right order. */}
                              {/* v12.7.2 (#593): the separator belongs to the SAME condition as the pill.
                                  The meta line read "EN  Not booked · #39-0012" with no dot after EN, and an
                                  unconditional one would give "EN · · #" on every call where no action ran -
                                  which is most of them, because the pill is three-state and renders nothing
                                  for null (#582). */}
                              {message.bookingOk !== null && message.bookingOk !== undefined && (
                                <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                              )}
                              <BookingPill ok={message.bookingOk} reference={message.bookingRef} system={message.bookingSystem} />
                              {/* v12.10.16 (#1690, LOCKED v1.10): "Check pills only inside the drawer" - the card no longer carries FlagsChip. */}
                              {/* v12.4.12 (#479): the call's reference - " · #37-0004". No reference, no separator. */}
                              {formatReference(message.referenceNo) && (
                                <>
                                  <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                                  <span className="aw-card-ref">{formatReference(message.referenceNo)}</span>
                                </>
                              )}
                              {/* v12.10.29 (#2226, Tushar 11/2 "this definitely looks ugly ... on hover of mouse we can display but this goes out for sure"):
                                  the card shows only "×N times" (was #1690 v1.10: ×N times · 503 · 501 · +N). Hover lists every call of the
                                  group with its full reference. While the search box holds the reference of an OLDER call of the group, that
                                  one reference shows after the pill ("×3 times · #45-0017") - why the card came up (Tushar 10/13 reason). */}
                              {(() => {
                                const grp = callGroups.members.get(message.id);
                                if (!grp || grp.length < 2) return null;
                                const others = grp.slice(1);
                                const qn = (filters.query ?? '').trim().replace(/^#/, '').toLowerCase();
                                const hitsRef = (r: string | null | undefined) => !!r && (r.toLowerCase().includes(qn) || formatReference(r).toLowerCase().replace(/^#/, '').includes(qn));
                                const matched = qn.length >= 2 && /\d/.test(qn) && !hitsRef(message.referenceNo) ? others.find((o) => hitsRef(o.referenceNo)) : undefined;
                                const tip = `${grp.length} calls from this number - ${grp.map((c) => formatReference(c.referenceNo)).join(', ')}`;
                                return (
                                  <>
                                    <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                                    <span className="aw-grp-pill" title={tip}>{'\u00d7'}{grp.length} times</span>
                                    {matched && (<><span className="aw-meta-sep" aria-hidden="true">{'·'}</span><span className="aw-grp-ref" title="This call of the group matches your search">{formatReference(matched.referenceNo)}</span></>)}
                                  </>
                                );
                              })()}
                            </span>
                          </span>
                          {/* v12.4.15 (#476): a call that is still happening says so, and says nothing else. Tushar,
                              12.4.11 verification: "i was on the call and saw this card... it says caller ended before
                              the call is completed." The summary only appears once the call actually has an ending. */}
                          {message.inProgress
                            ? <span className="aw-card-live"><span className="aw-card-live-dot" aria-hidden="true" />{message.kind === 'text' ? 'Texting in progress' : 'Call in progress'}</span>
                            : (() => { const grpM = callGroups.members.get(message.id); const lead = leadOf(grpM) ?? message;   /* 12.10.17.2 (#1818): the group's call with the most content */
                                // v12.10.19 (#1905 #1925): the full Wants + Next step - the Combined rows for a group, the call's own rows otherwise
                                const rows = grpM && grpM.length > 1 ? buildCombinedRows(grpM, 'en') : (lead.summaryRows?.en ?? null);
                                return <span className={`aw-card-summary${isBareMissed(lead) && isEmptySummary(lead.aiSummary) ? ' aw-sum-quiet' : ''}`}>{cardLine(rows, middleLine(lead), grpM && grpM.length > 1 ? callBackOfGroup(grpM, 'en') : callBackOf(lead))}</span>; })()}{/* v12.10.17 (#1723 D3 D4) */}{/* v12.10.10 (#1402) */}{/* v12.9.26 (#977): the preview line is the Wants line; older calls keep the paragraph */}{/* v12.2.38.0 (#222): show the AI summary, not the template recap */}
                          <span className="aw-card-tags">
                            {/* v12.10.11.1 (#1461): the call Support Ops made to prove the number on provisioning Step 4. */}
                            {message.setupTestCall && (
                              <span className="aw-tag aw-tag-label" title="The call Support Ops made to test this number while setting up the practice - not counted">Setup test call</span>
                            )}
                            {/* v12.10.17 (#1723 D7): the "From voicemail" pill is removed - the avatar badge says it was a voicemail. */}
                            {/* v12.10.17 (#1723 D5 D6): workflow card · request type, solid card colour + icon, white text; grey "Unclassified" when the request could not be told. */}
                            {(() => { const rq = requestOf(message); return <span className={`aw-tag aw-tag-category aw-cat-own${rq.unclassified ? ' aw-cat-unclassified' : ''}`} style={{ background: rq.color }}><PracticeIcon name={rq.icon} size={12} /> {rq.words}</span>; })()}
                            {/* v12.10.27 (#2146 Q33, Tushar 10/31 "+1 new ... like whatsapp ... next to type Appointment.schedule so it is always visible"):
                                patient texts nobody has opened yet - a teal badge right after the category tag; clears when the card is opened. */}
                            {message.kind === 'text' && (message.newTextCount ?? 0) > 0 && (
                              <span className="aw-new-count" title={`${message.newTextCount} new text${message.newTextCount === 1 ? '' : 's'} from the patient`}>+{message.newTextCount} new</span>
                            )}
                            {/* v12.10.27 (#2146 Q15): a text conversation with no reply for a day reads Closed - no reply. */}
                            {message.kind === 'text' && message.inProgress && message.startedAt && Date.now() - new Date(message.startedAt).getTime() > 24 * 3600_000 && (
                              <span className="aw-tag aw-tag-label"><span className="aw-label-dot" style={{ background: '#94a3b8' }} aria-hidden="true" />Closed - no reply</span>
                            )}
                            {/* C: Flagged chip removed - the red left accent encodes priority. */}
                            {/* D: render whatever labels the message carries, each with a configured colored dot. */}
                            {message.labels.map((label) => (
                              <span key={label} className="aw-tag aw-tag-label">
                                <span className="aw-label-dot" style={{ background: labelDotColor(label, labelColorMap) }} aria-hidden="true" />
                                {label}
                              </span>
                            ))}
                          </span>
                        </span>
                        <span className="aw-card-right">
                          <span className="aw-card-time">{formatCardTime(message.startedAt)}</span>
                          <span className={`aw-card-reminder ${message.reminder ? '' : 'aw-empty-reminder'} ${isDue(message) ? 'aw-reminder-due' : ''}`}>
                            {message.reminder ? <><SvgIcon name="clock" /> {dueLabel(message)}</> : null}
                          </span>
                          {/* v12.10.10 (#1399): initials + first name; highlighted when it is me; phone = initials only (CSS). */}
                          {message.assignedTo && (
                            <span className={`aw-card-assignee${meId !== null && message.assignedToUserId === meId ? ' aw-me' : ''}`}
                              title={`Assigned to ${message.assignedToUserId === meId ? 'you' : message.assignedTo}`}>
                              <span className="aw-as-ini" aria-hidden="true">{assigneeInitials(message.assignedTo)}</span>
                              <span className="aw-as-first">{message.assignedTo.replace(/^Dr\.?\s+/i, '').split(' ')[0]}</span>
                            </span>
                          )}
                        </span>
                        <span className="aw-chevron" aria-hidden="true" data-track="messages.row.arrow">&gt;</span>
                      </button>
                    );
                  })}
                  {gi === drawnGroups.length - 1 && (moreToDraw || moreToFetch) && <div ref={moreRef} className="aw-more-cards" aria-hidden="true" style={{ height: 1 }} />}
                  {gi === drawnGroups.length - 1 && moreToFetch && (
                    <div className="aw-more-note" role="status">{loadingMore ? 'Loading more calls…' : `Scroll for more · ${(moreLeft?.next ?? 0).toLocaleString()} of ${(moreLeft?.total ?? 0).toLocaleString()} calls loaded`}</div>
                  )}
                </section>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* v12.10.11.3 (#1524): asked only when a note or text is half-typed. */}
      {pendingSwitch && (
        <div className="aw-keep-dlg" role="presentation">
          <div className="aw-keep-dlg-in" role="alertdialog" aria-modal="true" aria-labelledby="aw-keep-h">
            <h2 id="aw-keep-h">Keep your unsent {noteText.trim() ? 'note' : 'text'}?</h2>
            <p>You started {noteText.trim() ? 'a note' : 'a text'} on {selectedMessage?.referenceNo ? formatReference(selectedMessage.referenceNo) : 'this message'} and haven&rsquo;t {noteText.trim() ? 'saved' : 'sent'} it.</p>
            <div className="aw-keep-dlg-a">
              <button type="button" className="aw-secondary" onClick={() => {
                const to = pendingSwitch.to;
                setPendingSwitch(null); setNoteText(''); setTextBody(''); setComposerOpen(false); setDrawerTool(null);
                setSelectedId(to);
              }}>Discard</button>
              <button type="button" className="aw-primary" autoFocus onClick={() => setPendingSwitch(null)}>Keep editing</button>
            </div>
          </div>
        </div>
      )}
      {selectedMessage && (
        // v12.10.11.3 (#1524): a click outside the drawer no longer closes it (staff kept losing their place); the list
        // behind stays clickable - another card switches the drawer to it. ✕ or Esc closes.
        <div className="aw-scrim aw-scrim-open" role="presentation">
          <aside ref={drawerRef} className={`aw-drawer${callBackOn && bphone.call && bphone.call.messageId === selectedMessage.id ? ' aw-oncall' : ''}`} role="dialog" aria-modal="true" aria-label={`${selectedMessage.name} message detail`}>
            {/* II: the whole top panel (nav + identity + Flag/Call back) is pinned so the caller
                info and Call back stay visible while only the body below scrolls. The duplicate
                caller name/phone that FF added to the nav bar has been REMOVED (no repetition). */}
            <div className="aw-drawer-sticky">
              {/* v12.10.30 (#1155 L1): the call window - the top bar in the drawer, 190 px in every state - while this message's call runs. */}
              {callBackOn && <CallWindowSlot messageId={selectedMessage.id} />}
              {/* v12.3.14 (#369): the reference moves OUT of the pagination cluster.
                  SPEC_confirmation_number_v1_0.md §0-§1: "260901-0001 is a permanent identity. Message 1 of 48 is
                  a temporary position that changes the moment the queue is filtered. Stacking them invites reading
                  them as a pair." It also rendered bolder than the identity line beneath it, so the eye landed on
                  a code before it landed on who called - and sitting between two arrow buttons it read as a label
                  for those controls. Now: arrows | position | arrow │ reference chip ←gap→ close.
                  The divider does real work - the controls to its left move you between records, the thing to its
                  right belongs to this record. The close button keeps margin-left:auto, which is what holds it
                  away from a frequently-used copy target. */}
              {/* v12.4.9 (#458) - drawer_header_reference_v1_0. "Message N of M" is REMOVED. It indexed a
                  list that reorders underneath the agent while they read it, so it was wrong every time a
                  call landed, and a number that is wrong is worse than a number that is absent. The
                  reference now sits BETWEEN the arrows: the arrows move you between records and the thing
                  between them names the record you are on. Position is carried by the arrows' disabled
                  state instead - a disabled previous means "nothing newer than this". The divider went with
                  the counter; it only ever existed to separate two numbering systems and there is one now. */}
              <div className="aw-drawer-top">
                <div className="aw-drawer-nav">
                  <button className="aw-icon-button" type="button" disabled={selectedIndex <= 0}
                    data-track="drawer.action.prev" onClick={() => moveDrawer(-1)} aria-label="Previous message">&lsaquo;</button>
                  {selectedMessage?.referenceNo ? (
                    <button
                      type="button"
                      className={'aw-ref-chip' + (refCopied ? ' aw-ref-copied' : '')}
                      aria-label={`Copy reference ${formatReference(selectedMessage.referenceNo)}`}
                      title="Reference number for this call. Give this to the caller, or search for it to find this message again."
                      onClick={() => copyReference(formatReference(selectedMessage.referenceNo))}>
                      <span className="aw-ref-text">{formatReference(selectedMessage.referenceNo)}</span>
                      <span className="aw-ref-glyph" aria-hidden="true">{refCopied ? '\u2713' : '\u29C9'}</span>
                    </button>
                  ) : null}
                  <button className="aw-icon-button" type="button" disabled={selectedIndex < 0 || selectedIndex >= visibleMessages.length - 1}
                    data-track="drawer.action.next" onClick={() => moveDrawer(1)} aria-label="Next message">&rsaquo;</button>
                  {/* v12.10.11.3 (#1524, locked 10/9): where you are in the list - reinstated by Tushar's lock (12.4.9 #458 had removed it). */}
                  {selectedIndex >= 0 && <span className="aw-drawer-pos">{selectedIndex + 1} of {fmtCount(visibleMessages.length)}</span>}
                </div>
                {/* v12.4.9 (#453): the list behind has already taken the arrivals in, so the previous
                    arrow above is genuinely live rather than a promise - it un-disables itself. The chip
                    says how many, and the open record never moves or closes. */}
                {newArrivalsChip('drawer')}
                {/* v12.10.10 (#1399, LOCKED 10/8 option A2): [Assigned-to chip ▾] [Status chip ▾] | ✕. On a phone the
                    Status chip and the divider go (Mark complete stays in the footer) and Assigned is a 44 × 44 initials button. */}
                <span className="aw-dh-actions">
                  <span className="aw-track-wrap" data-track="drawer.action.assign" style={{ display: 'contents' }}
                    title={lastActivity(activityById[selectedMessage.id], ['assign'], (a) => (a.to ? `Assigned to ${a.to}` : 'Unassigned'))}>{/* v12.10.15 (#1648) hover */}
                  <AssignChip
                    value={selectedMessage.assignedToUserId ?? null}
                    name={selectedMessage.assignedTo ?? null}
                    people={assignees}
                    meId={meId}
                    disabledWhy={can('assign') ? null : "Your user group doesn't allow Assign. Ask your practice owner."}
                    onPick={assignTo} />
                  </span>
                  <span style={{ display: 'contents' }} title={lastActivity(activityById[selectedMessage.id], ['status', 'read'], (a) => (a.action === 'read' ? 'Read' : a.to === 'New' ? 'Marked unread' : a.to ?? ''))}>{/* v12.10.15 (#1648) hover: "Completed by X · time" */}
                    <StatusChip status={selectedMessage.status} onPick={setStatusFromChip} />
                  </span>
                  <span className="aw-dh-div" aria-hidden="true" />
                </span>
                <button className="aw-icon-button aw-drawer-close" type="button" onClick={() => requestSelect(null)} aria-label="Close detail">&#10005;</button>
              </div>

              {/* v12.10.29.1 (#2246): a new call from this caller - said quietly, never jumped to */}
              {newInGroup.length > 0 && (
                <div className="aw-grp-newcall" role="status" style={{ margin: '6px 16px 0', padding: '6px 10px', borderRadius: 8, background: '#eef2ff', color: '#3730a3', fontSize: 13, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span>{newInGroup.length === 1 ? 'New call from this caller just arrived' : `${newInGroup.length} new calls from this caller just arrived`}
                    {newInGroup[0].startedAt ? ` · ${new Date(newInGroup[0].startedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}` : ''}</span>
                  <button type="button" className="aw-linkbtn" data-track="drawer.group.newcall.show"
                    onClick={() => { const live = selGroupLive ?? []; setGroupSnap(live.map((m) => m.id)); setSingleCall(false); if (live[0] && selectedId !== live[0].id) requestSelect(live[0].id); }}>Show</button>
                </div>
              )}
              {/* v12.10.16 (#1690, LOCKED v1.10 option A): the Combined bar - Combined · N calls, then each call with the app's own
                  call / missed / voicemail icon, its number and time; four links, then "+N more". */}
              {selGroup && selGroup.length > 1 && (
                <div className="aw-grp-bar" role="group" aria-label="Calls from this number">
                  <button type="button" className={`aw-grp-combined${combinedView ? ' on' : ''}`} aria-pressed={combinedView}
                    data-track="drawer.group.combined" onClick={() => { setSingleCall(false); if (selectedId !== selGroup[0].id) requestSelect(selGroup[0].id); }}
                    title={`Combined = every call in this group (${selGroup.length} calls since ${new Date(selGroup[selGroup.length - 1].startedAt ?? '').toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}${groupRule?.sameDay ? ', same day' : `, grouping window ${groupRule?.windowMinutes ?? 30} min, counted from the latest call`}). Assignee and labels came with the new call; notes stay on their own call; the reminder sits on the latest call only.`}>
                    Combined<small>{selGroup.length} calls</small>
                  </button>
                  {(allGroupLinks ? selGroup : selGroup.slice(0, 4)).map((m) => (
                    <button key={m.id} type="button" className={`aw-grp-link${!combinedView && selectedId === m.id ? ' on' : ''}`}
                      data-track="drawer.group.call" title={`${msgChannelLabel(m)} - ${formatReference(m.referenceNo)}`}
                      onClick={() => { if (m.id === selGroup[0].id) { setSingleCall(true); if (selectedId !== m.id) requestSelect(m.id); } else requestSelect(m.id); }}>
                      <span className={`aw-grp-ico aw-channel-${m.channel}`}><SvgIcon name={channelIcon(m.channel)} /></span>
                      {formatReference(m.referenceNo).replace('#', '')}
                      <small>{m.startedAt ? new Date(m.startedAt).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : ''}</small>
                    </button>
                  ))}
                  {!allGroupLinks && selGroup.length > 4 && (
                    <button type="button" className="aw-grp-more aw-linkbtn" onClick={() => setAllGroupLinks(true)}>+{selGroup.length - 4} more</button>
                  )}
                </div>
              )}
              {/* v12.10.16.1 (#1708, Tushar 10/14 "remove this paragraph from combined, keep it in tooltip"): the explanation is the
                  Combined button's tooltip now. */}

              <header className="aw-drawer-identity">
                {(() => { const _ct = callerTileMeta(headMessage!); return (
                <span className="aw-avatar aw-avatar-ct" style={{ background: _ct.color }} title={`${_ct.name} - ${msgChannelLabel(selectedMessage)}`}>
                  <CallerTypeIcon name={_ct.icon} size={20} className="aw-avatar-ico" />{/* v12.10.17 (#1723 D1 D2) */}
                  <span className={`aw-channel-badge aw-channel-${selectedMessage.channel}`}><SvgIcon name={channelIcon(selectedMessage.channel)} /></span>
                </span>); })()}
                <div className="aw-drawer-title">
                  {/* v12.4.9 (#458): same top line as the card - name · phone · LANG. Verified is NOT
                      repeated here; it is already on the meta line directly below. */}
                  <h2>
                    <span className="aw-drawer-name" title={headMessage!.nameFromContact ? 'From the contact book - this call did not capture a name' : undefined}>{headMessage!.hasName ? headMessage!.name : <PhoneCopy phone={selectedMessage.phone} />}</span>{/* v12.10.17.1 (#1794) */}
                    <span className="aw-drawer-idmeta">
                      {/* v12.10.10 (#1399 identity line 1): name · line-type icon · type · phone · EN */}
                      <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                      <LineMark type={selectedMessage.lineType} carrier={selectedMessage.lineCarrier} info={selectedMessage.phone2} />
                      {selectedMessage.lineType && <span className="aw-idtype">{lineTypeWord(selectedMessage.lineType)}</span>}
                      {headMessage!.hasName && (
                        <>
                          <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                          <PhoneCopy phone={selectedMessage.phone} />{/* v12.10.15 (#1668) */}
                        </>
                      )}
                      <span className="aw-meta-sep" aria-hidden="true">{'·'}</span>
                      <span>{languageCode(selectedMessage.language)}</span>
                    </span>
                    {/* v12.10.15 (#1663) -> v12.10.23 (#2070 2b, LOCKED): the call-back number on the RIGHT of the header line; click copies; wraps, never cut */}
                    {(() => { const cb = combinedView && selGroup ? callBackOfGroup(selGroup, 'en') : callBackOf(selectedMessage); return cb
                      ? <span className="aw-card-callback aw-hdr-callback">{CALL_BACK_WORD.en} <PhoneCopy phone={cb} /></span> : null; })()}
                  </h2>
                  {/* v12.10.10 (#1399 V2, #1402): ONE line that wraps - the CHANNEL first in its colour (Call green, Voicemail
                      purple, Missed red), short date + time, duration (none for Missed), category, caller type, booking pill.
                      The status moved to the Status chip in the top row; line type is on line 1. */}
                  <div className="aw-drawer-meta aw-meta-v2">
                    <span className={`aw-chan-word aw-chan-${selectedMessage.channel}`}>{msgChannelLabel(selectedMessage)}</span>
                    <span>{formatShortDetailDate(selectedMessage.startedAt)}</span>
                    {!isBareMissed(selectedMessage) && <span>{'\u23F1'} {formatDuration(selectedMessage.durationSec)}</span>}{/* v12.10.21 (#1953): a hung-up call has a length */}
                    {/* v12.10.17 (#1723 D13): quiet - a small icon + "Appointment · Schedule" in plain grey; no caller-type word, no pill. */}
                    {/* v12.10.29 (#2237, Tushar 11/3 "the type of request looks buried"): the same coloured pill as the card */}
                    {(() => { const rq = requestOf(headMessage!); return <span className={`aw-tag aw-tag-category aw-cat-own aw-drawer-request-pill${rq.unclassified ? ' aw-cat-unclassified' : ''}`} style={{ background: rq.color }}><PracticeIcon name={rq.icon} size={12} /> {rq.words}</span>; })()}
                    {/* v12.10.22 (#2011): the category may be shared by intents of different workflows - the header still names the exact
                        workflow › intent this call went through, when it is not the category's own intent. */}
                    {(() => { const it = intentPathOf(headMessage!); return it ? <span className="aw-drawer-intent" title="The workflow › intent this call went through">{it}</span> : null; })()}
                    <BookingPill ok={selectedMessage.bookingOk} reference={selectedMessage.bookingRef} system={selectedMessage.bookingSystem} />
                  </div>
                </div>
              </header>

              {/* ══ v12.9.12 (#791/#792): THE BAR GAINS SEND TEXT (CONDITIONALLY) AND THE MORE-MENU (ALWAYS). ══
                  The real .aw-primary-bar is a HARD-CODED 2-column grid (44px 1fr). The decision record
                  names adding buttons to it as one of two build mistakes - the row WRAPPED. So the 4-column
                  layout is a separate class applied only in the textable state, and an ordinary bar keeps
                  the rule it has always had. */}
              <div className={`aw-primary-bar aw-textable${selectedMessage.kind === 'text' ? ' aw-pb-text' : ''}`}>{/* v12.10.10 (#1403): both actions always present */}
                {/* R: icon-only flag; label via aria-label + hover title ("Mark urgent" / "Clear urgent"). */}
                {can('flag') && <button
                  className={`aw-flag ${selectedMessage.priority === 'urgent' ? 'aw-on' : ''}`}
                  type="button"
                  data-track="drawer.action.flag"
                  aria-pressed={selectedMessage.priority === 'urgent'}
                  aria-label={selectedMessage.priority === 'urgent' ? 'Clear urgent' : 'Mark urgent'}
                  title={selectedMessage.priority === 'urgent' ? 'Clear urgent (U)' : 'Mark urgent (U)'}
                  onClick={() => toggleFlag(selectedMessage.id)}
                >
                  <SvgIcon name="flag" />
                </button>}
                {/* v12.7.2 (#583 clause 2, via #599): STARTING A CALLBACK IS AN ACT; OPENING A MESSAGE IS NOT.
                    Setting the status here is right - a person just pressed Call back, so "Pending" is a true
                    statement about them. What was wrong is that merely OPENING the drawer did the same thing
                    (see openMessage), so reading a message claimed you were working on it. That half of #583
                    was tagged fixed in 12.7.0 and never built. */}
                {/* v12.10.27 (#2146, prototype v1.3 LOCKED): a text conversation has no top Call back / Send Text - the reply box is always
                    open at the bottom (a chat) and Call back sits in the footer, before Activity. */}
                {selectedMessage.kind === 'text' ? null : callBlockedWhy ? (
                  <span className="aw-act-blocked" title={callBlockedWhy} tabIndex={0} aria-label={`${callLabel} - not available. ${callBlockedWhy}`}>
                    <button className="aw-primary aw-act-dis" type="button" disabled aria-disabled="true">
                      <SvgIcon name={'phone'} />
                      <span className="aw-btn-label">{callLabel}</span> <span className="aw-kbd">Ctrl+K</span>
                    </button>
                  </span>
                ) : callBackOn ? (
                  /* v12.10.30 (#1156 0a): the browser phone's split button - only with the Call back switch on; off = the button below, unchanged. */
                  <CallBackButton messageId={selectedMessage.id} name={callBackName} language={selectedMessage.language} numbers={callBackNumbers} />
                ) : <button className="aw-primary" type="button"
                  aria-label={'Call back'}
                  data-track="drawer.action.callback"
                  onClick={() => { const wasNew = selectedMessage.status === 'new'; touchMessage(selectedMessage.id); if (wasNew) persist(selectedMessage.id, { status: 'prog', readBy: 'call' }); else { if (selectedMessage.status !== 'done') persist(selectedMessage.id, { status: 'prog' }); logActivity(selectedMessage.id, 'call'); } toast('info', 'Callback started'); }}>{/* v12.10.15 (#1648 #1651) */}
                  <SvgIcon name={'phone'} />
                  {/* v12.9.14 (#835): the label is a SPAN so the phone rule can drop it. A bare text node
                      cannot be hidden, and icons-only below the breakpoint is his rule: "icons only for
                      both to keep rule simple and no need to render text differently." aria-label carries
                      the meaning when the text is gone. */}
                  <span className="aw-btn-label">{'Call back'}</span> <span className="aw-kbd">Ctrl+K</span>
                </button>}

                {/* ══ v12.10.10 (#1403): SEND TEXT IS ALWAYS PRESENT - disabled with the reason when the line cannot take a
                    text, the line type was never checked, or the user group does not allow it. Both buttons FILLED
                    (Tushar 10/8, option B). The #791 note below is the history this reverses. ══
                    ══ v12.9.12 (#791): SEND TEXT - PRESENT ONLY WHEN THE LINE CAN ACTUALLY TAKE A TEXT. ══
                    Its PRESENCE is the signal. v12.7.2 (#595/#596) deliberately removed the "takes texts"
                    sentence from the meta line because a control that is there says it better than a
                    sentence that might be stale - the comment at lineTypeWord still says so and even names
                    "the Text button (#596)". So this must never be shown-and-disabled on a line that cannot
                    take a text, and it is hidden outright when the line type was never checked (C5): we
                    cannot assert textability, so we do not offer the action.
                    Call back stays the single FILLED primary; this is outlined. Equal width, different
                    weight - size says they are peers, colour says which one is the main intent. */}
                {selectedMessage.kind === 'text' ? null : textBlockedWhy ? (
                  <span className="aw-act-blocked" title={textBlockedWhy} tabIndex={0} aria-label={`Send Text - not available. ${textBlockedWhy}`}>
                    <button className="aw-send-text aw-send-filled aw-act-dis" type="button" disabled aria-disabled="true">
                      <SvgIcon name="send-text" /> <span className="aw-btn-label">Send Text</span> <span className="aw-kbd">T</span>
                    </button>
                  </span>
                ) : (
                  <button
                    className={`aw-send-text aw-send-filled${composerOpen ? ' aw-on' : ''}`}
                    type="button"
                    ref={sendTextBtnRef}
                    aria-expanded={composerOpen}
                    aria-label="Send Text"
                    data-track="drawer.action.text"
                    title="Send a one-time text message to this caller"
                    onClick={() => setComposerOpen((open) => !open)}
                  >
                    <SvgIcon name="send-text" /> <span className="aw-btn-label">Send Text</span> <span className="aw-kbd">T</span>
                  </button>
                )}

                {/* v12.9.12 (#792): the more-menu, on BOTH bar states. The popover is a SIBLING of the
                    button, never a child - a <div> inside a <button> is invalid HTML and the browser laid
                    the old one out in normal flow, smeared across the body. That is recorded as the second
                    build mistake in the decision record. */}
                <div className="aw-more-wrap" ref={moreWrapRef}>
                  <button
                    className="aw-more"
                    type="button"
                    ref={moreBtnRef}
                    aria-haspopup="menu"
                    aria-expanded={moreOpen}
                    aria-label="More actions"
                    title="More actions"
                    onClick={() => setMoreOpen((open) => !open)}
                  >
                    <SvgIcon name="dots" />
                  </button>
                  {moreOpen && (
                    <div className="aw-menu" role="menu" aria-label="More actions">
                      <div className="aw-menu-hint">Status</div>
                      {/* STATIC, not a toggle: opening the drawer marks the message read, so inside the
                          drawer there is never an unread message. "Mark as read" solves a state that
                          cannot exist - his correction during prototyping. */}
                      <button className="aw-menu-item" type="button" role="menuitem"
                              onClick={() => { setMoreOpen(false); markUnread(); }}>
                        <span className="aw-mi-ic"><SvgIcon name="mail" /></span>Mark unread<span className="aw-kbd">M</span>
                      </button>
                      {can('complete') && <button className="aw-menu-item" type="button" role="menuitem"
                              onClick={() => { setMoreOpen(false); toggleComplete(); }}>
                        <span className="aw-mi-ic"><SvgIcon name="check" /></span>
                        {isDone ? 'Mark pending' : 'Mark complete'}<span className="aw-kbd">Ctrl+&#8629;</span>
                      </button>}
                      <div className="aw-menu-sep" role="separator" />
                      <div className="aw-menu-hint">Actions</div>
                      {/* v12.10.18 (#1865 T149): one click, first under Actions; the same item takes the mark off. */}
                      <button className="aw-menu-item" type="button" role="menuitem" data-track="drawer.action.audit"
                              onClick={() => { setMoreOpen(false); toggleAudit(); }}>
                        <span className="aw-mi-ic"><SvgIcon name="flag" /></span>{(combinedView && selGroup && selGroup.length > 1 ? selGroup : (selectedMessage ? [selectedMessage] : [])).some((m) => m.auditMarkedAt) ? 'Remove audit mark' : 'Mark for audit'}{/* v12.10.19 (#1893) */}
                      </button>
                      {/* The SAME editors the action cards open. The cards sit near the top of a drawer
                          whose transcript runs for screens; this is a scroll-independent route to them.
                          One editor, two entry points - no duplicated editor state. */}
                      {can('note') && <button className="aw-menu-item" type="button" role="menuitem"
                              onClick={() => { setMoreOpen(false); setDrawerTool('note'); }}>
                        <span className="aw-mi-ic"><SvgIcon name="edit" /></span>Add note<span className="aw-kbd">N</span>
                      </button>}
                      {can('reminder') && <button className="aw-menu-item" type="button" role="menuitem"
                              onClick={() => { setMoreOpen(false); setDrawerTool('reminder'); }}>
                        <span className="aw-mi-ic aw-action-warn"><SvgIcon name="clock" /></span>Set reminder<span className="aw-kbd">R</span>
                      </button>}
                      {can('label') && <button className="aw-menu-item" type="button" role="menuitem"
                              data-track="drawer.action.label" onClick={() => { setMoreOpen(false); setDrawerTool('label'); }}>
                        <span className="aw-mi-ic"><SvgIcon name="tag" /></span>Apply label<span className="aw-kbd">L</span>
                      </button>}
                      {/* ══ v12.10.23 (Tushar 10/29, phone): the bottom bar keeps only the player, Mark unread and Mark complete (+ the Call path when it
                          fits on that one line) - Activity, Print and, on a narrow phone, the Call path come here. ══ */}
                      {isPhone && (<>
                        <div className="aw-menu-sep" role="separator" />
                        <button className="aw-menu-item" type="button" role="menuitem" data-track="drawer.section.activity"
                                onClick={() => { setMoreOpen(false); setActivityOpen(true); }}>
                          <span className="aw-mi-ic" aria-hidden="true">{'\u{1F558}'}</span>Activity
                        </button>
                        {canOpenArea('rep_calls') && (<>
                          <button className="aw-menu-item" type="button" role="menuitem" onClick={() => { setMoreOpen(false); printSelected('print'); }}>
                            <span className="aw-mi-ic"><SvgIcon name="printer" /></span>Print
                          </button>
                          <button className="aw-menu-item" type="button" role="menuitem" onClick={() => { setMoreOpen(false); printSelected('pdf'); }}>
                            <span className="aw-mi-ic"><SvgIcon name="printer" /></span>Download PDF
                          </button>
                          <button className="aw-menu-item" type="button" role="menuitem" data-track="drawer.action.copyrecord" onClick={() => { setMoreOpen(false); void copyCallRecord(); }}>
                            <span className="aw-mi-ic" aria-hidden="true">{'\u29C9'}</span>Copy call record
                          </button>
                        </>)}
                        {can('path') && (selectedMessage?.transcript ?? []).some((l) => l.role === 'path') && (<>
                          <button className="aw-menu-item aw-mi-narrow" type="button" role="menuitem" data-track="drawer.section.callroute"
                                  onClick={() => { setMoreOpen(false); setShowRoute((v) => !v); setShowCallPath(false); setDataView(false); }}>
                            <span className="aw-mi-ic" aria-hidden="true">{'\u21C4'}</span>{showRoute ? 'Hide call route' : 'Call route'}
                          </button>
                          <button className="aw-menu-item aw-mi-narrow" type="button" role="menuitem" data-track="drawer.section.callpath"
                                  onClick={() => { setMoreOpen(false); setShowCallPath((v) => !v); setShowRoute(false); }}>
                            <span className="aw-mi-ic" aria-hidden="true">{'\u2630'}</span>{showCallPath ? 'Hide call path lines' : 'Call path lines'}
                          </button>
                        </>)}
                      </>)}
                    </div>
                  )}
                </div>
              </div>
              {/* v12.10.30 (#2258): quick jump - Needs · Recording · Add note · Transcript (Alt+1..4); a chip shows only when its section is there. */}
              {jumpKeys && (
                <nav className="aw-jump" aria-label="Jump to section">
                  {JUMP_ORDER.filter((k) => jumpKeys.split(' ').includes(k)).map((k) => {
                    const label = k === 'transcript' && selectedMessage.channel === 'text' ? 'Conversation' : JUMP_META[k].label;
                    const n = JUMP_ORDER.indexOf(k) + 1;
                    return (
                      <button key={k} type="button" className={`aw-jump-chip aw-jump-${k}`} data-track={`drawer.jump.${k}`}
                              title={`${label} (Alt+${n})`} aria-keyshortcuts={`Alt+${n}`} onClick={() => jumpTo(k)}>
                        <span className="aw-jump-ic" aria-hidden="true"><SvgIcon name={k === 'transcript' && selectedMessage.channel === 'text' ? 'message' : JUMP_META[k].icon} /></span>
                        <span className="aw-jump-label">{label}</span>
                      </button>
                    );
                  })}
                </nav>
              )}
            </div>

            {/* II: only the body below the sticky panel scrolls. */}
            {/* v12.10.13 (#1563, Tushar 10/10): two looks, both kept until he picks one after the deploy (the other goes next build).
                Classic OFF = B: cards whose header is the top of the card (no space left, right or top).
                Classic ON = A: no cards - full-width header bands edge to edge - with the paragraph summary.
                Calls without summary rows (no Classic switch) show B. */}
            {/* v12.10.14 (#1617, DRAWER v1.10 S235): look A is removed - one look (B, cards). Rows | Paragraph replaces Classic. */}
            <div className="aw-drawer-body aw-look-b">
              {/* v12.10.13 (#1604): the Message facts card (Phone / Carrier / Chart # / Language) is removed - code and styles. */}
              <section className="aw-section-card aw-needs-card" data-jump="needs">{/* v12.10.30 (#2258): jump target + its own tint */}
                {/* v12.9.27.1 (#1064, his layout 2026-10-02): "keep language switch next to what the caller needs and copy button.
                    classic will go on right, matching the format we are displaying for transcript or call data." */}
                <div className="aw-section-h aw-viewbar aw-sumbar aw-sumstrip">{/* v12.10.10 (#1404): one full-width strip, Classic inside */}
                  <span className="aw-view is-on aw-sumgroup">
                    <h3 className="aw-viewcap"><SvgIcon name="star" /> {(SUMMARY_UI[viewRows && !summaryClassic ? summaryLang : 'en'] ?? SUMMARY_UI.en).title}{combinedView ? ' \u00b7 Combined' : ''}</h3>{/* v12.10.17 (#1723 D7): the "from voicemail" badge is removed */}
                    {/* v12.9.24 (#909): EN / ES BEFORE the copy button, so the reader copies the language they chose.
                        The summary is written in English; ES is translated on demand and cached with the call. */}
                    {/* v12.10.10 (#1404): 'Read in' before the buttons - the language the SUMMARY is read in, not the call's. */}
                    {/* v12.10.14 (#1617): "Read in" removed - the words live in the tooltip; the picked pill is the dark one. */}
                    <span className="aw-xlsw aw-xlsw-fill aw-sumlang" role="group" aria-label="Read the summary in" title="Read in - the language this summary is shown in, not the language of the call">
                      {orgLangs.map((lng) => (
                        <button key={lng} type="button" data-track="drawer.section.es" data-track-value={lng === 'en' || lng === 'es' ? lng : undefined} className={`aw-xltab${summaryLang === lng ? ' on' : ''}`} aria-pressed={summaryLang === lng}
                          onClick={() => {
                            setSummaryLang(lng);
                            // v12.9.26 (#977): structured rows carry their own text in that language - no translation call for them.
                            if (selectedMessage.summaryRows?.[lng] && !summaryClassic) return;
                            fetchSummaryXl(selectedMessage.id, lng);
                          }}>{lng.toUpperCase()}</button>
                      ))}
                    </span>
                    <CopyButton
                      text={viewRows && !summaryClassic
                        ? summaryRowsText(viewRows, summaryLang)
                        : (xlOf(selectedMessage.id, summaryLang) ?? selectedMessage.aiSummary)}
                      label="Copy summary" iconOnly />
                  </span>
                  {/* v12.9.26 (#977, UI-LOCK v1.3): Classic: off by default. v12.9.27.1 (#1064, his layout 2026-10-02): on the RIGHT, like the Call path switch. Shown only on
                      calls that HAVE the structured rows - an older call only has the paragraph, so there is nothing to switch. */}
                  {/* v12.10.14 (#1617, DRAWER v1.10 S235): the Classic switch is replaced by a small Rows | Paragraph icon pair on the right
                      (tooltips, no caption). Only on calls that HAVE the rows - an older call only has the paragraph. */}
                  {(selectedMessage.summaryRows || combinedRowsSel) && (
                    <span className="aw-xlsw aw-xlsw-fill aw-sumview" role="group" aria-label="Show as">
                      <button type="button" className={`aw-xltab${!summaryClassic ? ' on' : ''}`} aria-pressed={!summaryClassic} title="Show as rows" aria-label="Show as rows"
                        data-track="drawer.section.rows" onClick={() => setSummaryClassic(false)}>
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" /></svg>
                      </button>
                      <button type="button" className={`aw-xltab${summaryClassic ? ' on' : ''}`} aria-pressed={summaryClassic} title="Show as a paragraph" aria-label="Show as a paragraph"
                        data-track="drawer.section.classic" onClick={() => { setSummaryClassic(true); if (summaryLang !== 'en') fetchSummaryXl(selectedMessage.id, summaryLang); }}>
                        <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 6h16M4 10h16M4 14h16M4 18h10" /></svg>
                      </button>
                    </span>
                  )}
                </div>
                {viewRows && !summaryClassic ? (
                  <SummaryRowsGrid key={`${selectedMessage.id}-${combinedView ? 'c' : 's'}`} rows={viewRows} lang={summaryLang}
                    wantsRef={combinedView && selGroup ? formatReference((leadOf(selGroup) ?? selectedMessage).referenceNo) : undefined}
                    earlier={combinedView && selGroup ? selGroup.filter((m) => m.id !== (leadOf(selGroup) ?? selectedMessage).id).map((m) => ({
                      text: wantsOf(m, summaryLang),
                      ref: formatReference(m.referenceNo),
                    })) : undefined}
                    addenda={addendaOf(combinedView && selGroup ? selGroup : [selectedMessage])}
                    addendumLabel={addendumLabelOf(combinedView && selGroup ? selGroup : [selectedMessage], summaryLang)} />
                ) : combinedView && selGroup ? (
                  // v12.10.16.1 (#1707): Paragraph in Combined = each call's own paragraph with its number, newest first.
                  <div className="aw-grp-paras">
                    {selGroup.map((m) => (
                      <p key={m.id}><span className="aw-grp-chip">{formatReference(m.referenceNo)}</span> {(summaryLang !== 'en' ? xlOf(m.id, summaryLang) : null) ?? m.aiSummary}</p>
                    ))}
                  </div>
                ) : (
                  <>
                    <p>{xlOf(selectedMessage.id, summaryLang) ?? selectedMessage.aiSummary}</p>
                    {summaryLang !== 'en' && !xlOf(selectedMessage.id, summaryLang) && summaryState === 'loading' && <p className="aw-muted">Translating…</p>}
                    {summaryLang !== 'en' && !xlOf(selectedMessage.id, summaryLang) && summaryState === 'error' && <p className="aw-muted">The {languageName(summaryLang)} version could not be produced - showing English.</p>}
                  </>
                )}
              </section>

              {/* K: applied labels = removable chips (each with its configured colored dot) -> PUT labels without it */}
              {selectedMessage.labels.length > 0 && (
                <div className="aw-drawer-labels" aria-label="Current labels">
                  {selectedMessage.labels.map((label) => (
                    <span key={label} className="aw-tag aw-tag-label aw-removable-label">
                      <span className="aw-label-dot" style={{ background: labelDotColor(label, labelColorMap) }} aria-hidden="true" />
                      {label}
                      <button type="button" aria-label={`Remove ${label}`} onClick={() => removeLabel(label)}>&#10005;</button>
                    </span>
                  ))}
                </div>
              )}

              {/* NN: amber saved-reminder strip when a reminder is set - sits between "What the
                  caller needs" and the action cards. Remove clears it via the reminder PUT path. */}
              {selectedMessage.reminder && (
                <div className="aw-saved-reminder" role="note">
                  <SvgIcon name="clock" />
                  <span className="aw-saved-reminder-text">Follow-up: {dueLabel(selectedMessage)}{selectedMessage.reminderDue && dueLabel(selectedMessage) !== selectedMessage.reminder ? ` (set as "${selectedMessage.reminder}")` : ''}</span>
                  <button
                    type="button"
                    className="aw-saved-reminder-remove"
                    onClick={() => {
                      touchMessage(selectedMessage.id, (message) => ({ ...message, reminder: '', reminderDue: null }));
                      persist(selectedMessage.id, { reminder: '' });
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}

              {/* v12.9.12 (#795 / C2): a sent text lands in the SAME remark thread as a hand-typed note,
                  so it must not read as the agent's own words. The pill names what it was and the body is
                  quoted. A remark with no kind - every note written before this release - renders exactly
                  as it always has. */}
              {/* v12.10.11.1 (#1494): EVERY note and sent text, newest first - only notes[0] used to render, so adding a
                  note hid the previous one (they were all saved) and a note after Send Text hid behind the text (#1445).
                  The newest 3 show; 'Show all N notes' opens the rest. */}
              {(combinedView && selGroup ? selGroup.some((m) => m.notes.length > 0) : selectedMessage.notes.length > 0) && (() => {
                // v12.10.16 (#1690): Combined = the notes of every call, newest first, each with its call's number
                const all = combinedView && selGroup
                  ? selGroup.flatMap((m) => m.notes.map((n) => ({ ...n, groupRef: formatReference(m.referenceNo) })))
                      .sort((a, b) => String(b.at ?? '').localeCompare(String(a.at ?? '')))
                  : selectedMessage.notes;
                const shown = allNotesFor === selectedMessage.id ? all : all.slice(0, 3);
                return (
                  <div className="aw-notes" aria-label="Notes">
                    {shown.map((note) => {
                      const isText = note.kind === 'text-sent' || note.kind === 'text-failed';
                      const isCb = note.kind === 'callback';   // v12.10.30 (#1156 P1b): the call back's system note - always added (L4)
                      return (
                        <section key={note.id} className={`aw-note-callout${isText ? ' aw-note-text' : ''}${isCb ? ' aw-note-cb' : ''}`}>
                          <span className="aw-note-initials">{initials(note.author)}</span>
                          <div>
                            {'groupRef' in note && <span className="aw-grp-chip" style={{ marginLeft: 0, marginRight: 6 }}>{(note as { groupRef?: string }).groupRef}</span>}
                            <strong>{note.author}</strong>
                            {isText && (
                              <span className={`aw-note-pill${note.kind === 'text-failed' ? ' aw-note-pill-bad' : ''}`}>
                                {note.kind === 'text-failed' ? 'Text not sent' : 'Text sent'}
                              </span>
                            )}
                            {isCb && <span className="px-cb-chip">Call back</span>}
                            <span>{formatNoteTime(note.at)}</span>
                            {isText ? <blockquote>{note.text}</blockquote> : <p>{note.text}</p>}
                          </div>
                        </section>
                      );
                    })}
                    {all.length > 3 && (
                      <button type="button" className="aw-notes-more"
                        onClick={() => setAllNotesFor(allNotesFor === selectedMessage.id ? null : selectedMessage.id)}>
                        {allNotesFor === selectedMessage.id ? 'Show fewer' : `Show all ${all.length} notes`}
                      </button>
                    )}
                  </div>
                );
              })()}

              {/* ══ v12.9.12 (#793): THE SEND TEXT COMPOSER. ═══════════════════════════════════════════════
                  PLACEMENT IS FINAL AND WAS CHOSEN BY FEEL, NOT ARGUMENT: both candidate positions were
                  built into one prototype with a live chooser so he could try them. Directly under the
                  primary bar pushes "What the caller needs" out of view AT EXACTLY THE MOMENT the agent is
                  writing about it. Here - after the summary, before the action cards - the caller's context
                  stays on screen. The chooser was then removed.

                  ONE-TIME SEND, NOT A THREAD. Send, log, close. A reply arrives under Text messages. */}
              {composerOpen && canText && (
                <section ref={composerRef} className="aw-section-card aw-editor aw-text-composer" aria-label="Send text message">
                  <div className="aw-tc-h">
                    <b>Send text message</b>
                    <span className="aw-tc-to">
                      To{' '}
                      {toEditing ? (
                        <span className="aw-to-edit">
                          {/* +1 ONLY, by his decision. A picker offering five countries (as the prototype
                              does) would promise formatting this app cannot do - there is no per-country
                              formatter anywhere in it. Tenant-scoped list + formatting is #800. */}
                          {/* v12.9.13 (#808): the flag is GONE. Windows ships no emoji flag glyphs, so the
                              regional-indicator pair fell back to its two letters and the line read
                              "To us +1 (413) 822-9340". No CSS fixes a missing glyph, and his users are on
                              Windows. The cell phone / landline / chevron icons are untouched, per his
                              12.9.12 instruction to keep them. */}
                          <span className="aw-cc" aria-label="Country code">+1</span>
                          <input
                            className="aw-to-input"
                            type="tel"
                            value={toNumber}
                            aria-label="Phone number"
                            onChange={(e) => setToNumber(e.target.value.replace(/[^\d]/g, '').slice(0, 10))}
                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); setToEditing(false); } }}
                          />
                          <button className="aw-to-ok" type="button" onClick={() => setToEditing(false)}>Done</button>
                        </span>
                      ) : (
                        <button
                          className="aw-to-link"
                          type="button"
                          aria-label="Change number"
                          title="Click to change the number"
                          onClick={() => setToEditing(true)}
                        >
                          {'\uD83C\uDDFA\uD83C\uDDF8'} +1 {formatCardPhone(toNumber) || 'Add a number'}
                        </button>
                      )}
                      {' \u00b7 '}{lineTypeWord(selectedMessage.lineType)}
                    </span>
                  </div>

                  <div className="aw-tc-chips">
                    {/* v12.9.24 (#911, replaces #920): EN / ES. A chip inserts in the chosen language; flipping an
                        UNEDITED template swaps to its other version; flipping staff's own text translates it. */}
                    <span className="aw-xlsw" role="group" aria-label="Text language">
                      {orgLangs.map((lng) => (
                        <button key={lng} type="button" className={`aw-xltab${textLang === lng ? ' on' : ''}`} aria-pressed={textLang === lng}
                          onClick={() => {
                            if (lng === textLang) return;
                            setTextLang(lng);
                            const first = (selectedMessage.name || '').split(' ')[0] || '';
                            if (textFrom && textBody === textFrom.filled) {
                              const filled = fillTemplateIn(TEXT_TEMPLATES[textFrom.index], lng, first, tenantDisplayName, appointmentWhen(selectedMessage));
                              if (filled !== null) { setTextBody(filled); setTextFrom({ index: textFrom.index, filled }); return; }
                            }
                            if (!textBody.trim()) return;
                            setTextXl('loading');
                            api.post<{ ok: boolean; translated?: string }>('/t2/workflow/translate', { text: textBody, sourceLang: textLang, targetLang: lng })
                              .then((r) => { if (r?.ok && r.translated) { setTextBody(r.translated); setTextFrom(null); setTextXl('idle'); } else setTextXl('error'); })
                              .catch(() => setTextXl('error'));
                          }}>{lng.toUpperCase()}</button>
                      ))}
                    </span>
                    {TEXT_TEMPLATES.map((t, ti) => (
                      <button
                        key={t.label}
                        className="aw-chip"
                        type="button"
                        onClick={() => {
                          const first = (selectedMessage.name || '').split(' ')[0] || '';
                          const filled = fillTemplateIn(t, textLang, first, tenantDisplayName, appointmentWhen(selectedMessage));   // v12.9.14 (#822)
                          // v12.10.27 (#2150 v1.6): an empty box is filled; typed text gets the template added at its end.
                          if (filled !== null) { if (textBody.trim()) { setTextBody(textBody.trimEnd() + ' ' + filled); setTextFrom(null); } else { setTextBody(filled); setTextFrom({ index: ti, filled }); } return; }
                          // v12.9.26 (#938): no template text in this language - insert the English and translate it.
                          const en = fillTemplateIn(t, 'en', first, tenantDisplayName, appointmentWhen(selectedMessage)) ?? '';
                          setTextBody(en); setTextFrom(null); setTextXl('loading');
                          api.post<{ ok: boolean; translated?: string }>('/t2/workflow/translate', { text: en, sourceLang: 'en', targetLang: textLang })
                            .then((r) => { if (r?.ok && r.translated) { setTextBody(r.translated); setTextXl('idle'); } else setTextXl('error'); })
                            .catch(() => setTextXl('error'));
                        }}
                      >
                        {t.label}
                      </button>
                    ))}
                  </div>
                  {textXl === 'loading' && <div className="aw-muted">Translating…</div>}
                  {textXl === 'error' && <div className="aw-muted">Could not translate - the text is unchanged.</div>}

                  {/* v12.10.27 (#2150 v1.6 LOCKED): name chip above the words, reply-line chip right-aligned below (Off, calls only), STOP
                      plain grey (the first text to a number only); pointing at Send text shows the exact text in the same box. */}
                  <div className="aw-tc-box">
                    {previewHover ? (
                      <div className="aw-tc-preview" aria-live="polite">{composedText || 'Your words'}</div>
                    ) : (<>
                    <div className="aw-tc-chiprow">
                      {chipEdit === 'name'
                        ? <input className="aw-tc-chipin" autoFocus value={nameChip ?? stdName} maxLength={60} onChange={(e) => setNameChip(e.target.value)}
                            onBlur={() => setChipEdit(null)} onKeyDown={(e) => { if (e.key === 'Enter') setChipEdit(null); }} aria-label="Practice name for this text" />
                        : <button type="button" className="aw-tc-chip" title="Click to change for this text" onClick={() => setChipEdit('name')}>{(nameChip ?? stdName) ? `${nameChip ?? stdName}:` : 'Add practice name'}</button>}
                    </div>
                    <textarea
                      ref={textAreaRef}
                      rows={4}
                      value={textBody}
                      placeholder="Type a message to send to the caller..."
                      aria-label="Message to send"
                      onChange={(e) => setTextBody(e.target.value)}
                    />
                    {showStopLine && (
                      <div className="aw-tc-chiprow aw-tc-end">
                        <span className="aw-tc-stop" title="Added only on the first text we send to this number">Reply STOP to opt out, HELP for help.</span>
                      </div>
                    )}
                    </>)}
                  </div>

                  {needsApptDate && (
                    <label className="aw-tc-appt">
                      <span>Appointment date <b>*</b></span>
                      <input type="text" value={apptDate} placeholder="e.g. Tuesday, October 13 at 10:30 AM"
                        onChange={(e) => { setApptDate(e.target.value); setSendError(null); }} />
                      {!apptDate.trim() && <em>Fill in the appointment date to send.</em>}
                    </label>
                  )}
                  {sendError && <div className="aw-tc-error" role="alert">{sendError}</div>}

                  {/* ── v12.9.13 (#805): THE COUNT GETS ITS OWN LINE, ABOVE THE BUTTONS. ──
                      Past 160 characters it wrapped mid-phrase, stole width from the button row and pushed
                      the Ctrl+enter chip under the label. It is information ABOUT the message, not a control,
                      so it was competing for width with the buttons at exactly the moment it had most to say.
                      The count WARNS, it never blocks. Over 160 the message is concatenated and each part
                      carries a header, so the per-segment budget drops to 153 - which is why 320 characters
                      is 3 texts, not 2. The agent is told and decides. */}
                  <div className="aw-tc-countrow">
                    {/* v12.10.27 (#2150 v1.6): the count is EVERYTHING the patient gets (name + words + reply line), on two lines */}
                    <span className={`aw-tc-count${composedText.length > 160 ? ' aw-over' : ''}`} aria-live="polite">
                      <b>{composedText.length}</b> / 160 characters<br />{smsSegments(composedText)} message{smsSegments(composedText) === 1 ? '' : 's'}
                    </span>
                  </div>

                  <div className="aw-tc-foot">
                    <button className="aw-secondary" type="button" onClick={() => setComposerOpen(false)}>Cancel</button>
                    <button
                      /* ── v12.9.13 (#806): SECONDARY WHILE EMPTY, PRIMARY ONCE THERE IS TEXT. ──
                         His words: "we can show in same color as mark as unread and when the text is in, we
                         can color the button. because this is not permanent disable button." .aw-primary has
                         no :disabled rule anywhere in this app, which is why a disabled Send text still read
                         as the main action. No new rule either - T2_UI_PRINCIPLES section 7 already says
                         "Save section, disabled until dirty... a dirty section highlights amber and enables
                         its buttons", which is this exact shape on another surface. */
                      className={textBody.trim() && !(needsApptDate && !apptDate.trim()) ? 'aw-primary' : 'aw-secondary'}
                      type="button"
                      disabled={!textBody.trim() || sending || (needsApptDate && !apptDate.trim())}
                      onClick={sendText}
                      onMouseEnter={() => setPreviewHover(true)} onMouseLeave={() => setPreviewHover(false)}
                      onFocus={() => setPreviewHover(true)} onBlur={() => setPreviewHover(false)}
                    >
                      {sending ? 'Sending...' : 'Send text'} <span className="aw-kbd">Ctrl+{'\u21B5'}</span>
                    </button>
                  </div>

                  <div className="aw-tc-note">
                    {/* v12.10.27 (#2150 v1.6): the note follows Text replies; a text conversation is a chat. */}
                    <span>{selectedMessage.kind === 'text' ? 'A reply lands in this conversation.'
                      : textingStatus?.repliesOn ? 'Text replies is On - a reply lands on this call and turns on follow-up.'
                      : 'Text replies is Off - a reply gets the automatic text.'}</span>
                  </div>
                </section>
              )}

              <section className="aw-action-section" aria-label="Message actions" data-jump={can('note') ? 'note' : undefined}>{/* v12.10.30 (#2258) */}
                <div className="aw-action-grid">
                  {/* AA: compact single-row cards - icon + bold title + kbd; sub-labels removed. */}
                  {can('note') && <button className={`aw-action-card ${drawerTool === 'note' ? 'aw-selected' : ''}`} type="button" data-track="drawer.action.note" onClick={() => setDrawerTool('note')}>
                    <span className="aw-action-icon"><SvgIcon name="edit" /></span>
                    <strong>Add note</strong>
                    <kbd>N</kbd>
                  </button>}
                  {can('reminder') && <button className={`aw-action-card ${drawerTool === 'reminder' ? 'aw-selected' : ''}`} type="button" data-track="drawer.action.reminder" onClick={() => setDrawerTool('reminder')}>
                    <span className="aw-action-icon aw-action-warn"><SvgIcon name="clock" /></span>
                    <strong>Set reminder</strong>
                    <kbd>R</kbd>
                  </button>}
                  {can('label') && <button className={`aw-action-card ${drawerTool === 'label' ? 'aw-selected' : ''}`} type="button" onClick={openLabelEditor}>
                    <span className="aw-action-icon"><SvgIcon name="tag" /></span>
                    <strong>Apply label</strong>
                    {/* OO: L opens the Apply-label editor (parallels N/R). */}
                    <kbd>L</kbd>
                  </button>}
                </div>

                {/* I1: Note editor - REMARKS / ACTION TAKEN + template chips + Cancel / Save note */}
                {drawerTool === 'note' && (
                  <div ref={editorRef} className="aw-inline-tool aw-editor">
                    <div className="aw-editor-h">Remarks / action taken</div>
                    <div className="aw-tmpl-chips">
                      {NOTE_TEMPLATES.map((tpl) => (
                        <button key={tpl.label} type="button" className="aw-chip" onClick={() => setNoteText((current) => (current ? `${current.replace(/\s*$/, '')} ${tpl.text}` : tpl.text))}>
                          {tpl.label}
                        </button>
                      ))}
                    </div>
                    <textarea
                      value={noteText}
                      rows={3}
                      placeholder="Describe the action taken..."
                      onChange={(event) => setNoteText(event.target.value)}
                    />
                    <div className="aw-editor-foot">
                      <button className="aw-secondary" type="button" onClick={() => { setDrawerTool(null); setNoteText(''); }}>Cancel</button>
                      <button className="aw-primary" type="button" onClick={addNote}>Save note</button>
                    </div>
                  </div>
                )}
                {/* I2: Reminder editor - REMIND ME TO FOLLOW UP + preset chips + date input + Set / Cancel */}
                {drawerTool === 'reminder' && (
                  <div ref={editorRef} className="aw-inline-tool aw-editor">
                    <div className="aw-editor-h">Remind me to follow up</div>
                    <div className="aw-rem-presets">
                      {REMINDER_PRESETS.map((preset) => (
                        <button key={preset.label} type="button" className="aw-chip" onClick={() => setReminderValue(preset.value)}>
                          {preset.label}
                        </button>
                      ))}
                    </div>
                    <div className="aw-rem-date">
                      <label htmlFor="aw-rem-date-input">Or pick a date:</label>
                      <input id="aw-rem-date-input" type="date" value={reminderDate} onChange={(event) => setReminderDate(event.target.value)} />
                      <button className="aw-primary" type="button" onClick={() => reminderDate && setReminderValue(reminderDateLabel(reminderDate), reminderDate)}>Set</button>
                    </div>
                    <div className="aw-editor-foot">
                      <button className="aw-secondary" type="button" onClick={() => { setDrawerTool(null); setReminderDate(''); }}>Cancel</button>
                    </div>
                  </div>
                )}
                {/* I3: Label editor - APPLY LABELS + toggle chips from availableLabels (colored dot) + Done */}
                {drawerTool === 'label' && (
                  <div ref={editorRef} className="aw-inline-tool aw-editor">
                    <div className="aw-editor-h">Apply labels</div>
                    <div className="aw-labels" aria-label="Labels">
                      {availableLabels.map((label) => {
                        const selected = (labelDraft ?? selectedMessage.labels).includes(label.name);   // v12.4.12 (#468 reopened)
                        return (
                          <button key={label.name} type="button" className={`aw-chip aw-label-chip ${selected ? 'aw-selected' : ''}`} onClick={() => toggleLabelDraft(label.name)}>
                            <span className="aw-label-dot" style={{ background: labelDotColor(label.name, labelColorMap) }} aria-hidden="true" />
                            {label.name}
                          </button>
                        );
                      })}
                    </div>
                    <div className="aw-editor-foot">
                      {/* HH: Done commits the accumulated label set in ONE write (no PUT per chip).
                          v12.9.13 (#807): Cancel beside it, positioned as in Add note and Set reminder. */}
                      <button className="aw-secondary" type="button" onClick={cancelLabelEditor}>Cancel</button>
                      <button className="aw-primary" type="button" onClick={closeLabelEditor}>Done</button>
                    </div>
                  </div>
                )}
              </section>

              {/* W: for a missed call with no real recording, show the meaningful missed-call
                  callout (prototype) and SUPPRESS the empty voicemail player + the system-only
                  transcript line - regardless of a SYSTEM transcript line the seed may add.
                  A missed channel (or a zero-duration call) means there is no voicemail to play. */}
              {isMissedNoRecording ? (
                <section className="aw-section-card aw-missed-card">
                  <h3><SvgIcon name="phone" /> Missed call</h3>
                  <p>No voicemail was left.</p>{/* v12.10.10 (#1402): the person may not be allowed to call back */}
                </section>
              ) : selectedMessage.channel === 'text' ? (
                (selectedMessage.transcript ?? []).length > 0 && (
                  // v12.10.27 (#2146, prototype v1.3 LOCKED): a text conversation reads as a chat - "Conversation", the patient on the left,
                  // the AI and staff on the right (aw-chat, agent-workspace.css). Call-path lines stay behind Show call path as on a call.
                  <section className="aw-section-card aw-chat" data-jump="transcript">{/* v12.10.30 (#2258) */}
                    <div className="aw-section-h">
                      <h3><SvgIcon name="message" /> Conversation</h3>
                      {can('copytr') && <CopyButton text={transcriptToText(selectedMessage.transcript ?? [])} label="Copy conversation" />}
                    </div>
                    <TranscriptLines lines={(selectedMessage.transcript ?? []).filter((l) => l.role !== 'path' && !String(l.text ?? '').trimStart().startsWith('[path]'))} />
                  </section>
                )
              ) : (
                <>
                  <section className="aw-section-card aw-recording-card" ref={playerCardRef} data-jump="recording">{/* v12.10.30 (#2258) */}
                    {/* v12.10.17 (#1751): every line of this card speaks about the call being PLAYED (Combined can play an earlier call). */}
                    <h3>
                      <SvgIcon name="mic" />{' '}
                      {(playMessage ?? selectedMessage).channel === 'voicemail' || isBareMissed(playMessage ?? selectedMessage) ? 'Voicemail recording' : 'Recording'}{/* v12.10.21 (#1953): a hung-up call's is the call recording */}
                      {/* v12.10.17 (#1751): a grouped caller - the player says which call it is playing. */}
                      {selGroup && selGroup.length > 1 && hasRecording && formatReference((playMessage ?? selectedMessage).referenceNo) && (   /* v12.10.21 (#1751): only when it plays */
                        <span className="aw-rec-playing" role="status">Playing {formatReference((playMessage ?? selectedMessage).referenceNo)}</span>
                      )}
                    </h3>
                    {/* v12.10.12 (#1543): a voicemail whose words could not be written down says so - never a silent blank. */}
                    {(playMessage ?? selectedMessage).channel === 'voicemail' && !(playMessage ?? selectedMessage).noRecording
                      && !((playMessage ?? selectedMessage).transcript ?? []).some((l) => (l.role ?? '').toLowerCase() === 'caller' && (l.text ?? '').trim()) && (
                      <p className="aw-recording-none" role="status" style={{ margin: '0 0 8px' }}>Voicemail text not available - listen to the recording.</p>
                    )}
                    <div className="aw-recording-player">
                      {selGroup && selGroup.length > 1 && playMessage && playMessage.kind !== 'text' && (playIsMissed || playMessage.noRecording) ? (
                        // v12.10.21 (#1751 guard, LOCKED 10/26): a grouped call with no recording says which call - never another call's audio.
                        <p className="aw-recording-none" role="status">No recording for {formatReference(playMessage.referenceNo) || 'this call'}.</p>
                      ) : playIsMissed ? (
                        // v12.10.17 (#1751): the picked Combined call was a missed call - nothing to play.
                        <p className="aw-recording-none" role="status">No voicemail was left on this call.</p>
                      ) : (playMessage ?? selectedMessage).noRecording ? (
                        // v12.10.11.1 (#982, LOCKED v1.22): nothing was saved - say why once; Retry could never work.
                        <p className="aw-recording-none" role="status">
                          {(playMessage ?? selectedMessage).channel === 'voicemail' || (playMessage ?? selectedMessage).channel === 'missed'
                            ? 'No recording was saved for this call - the caller hung up before leaving a message.'
                            : 'No recording was saved for this call.'}
                        </p>
                      ) : recordingState === 'error' ? (
                        <p className="aw-recording-error" role="status" style={{ margin: 0, fontSize: '0.85rem', color: 'var(--aw-muted, #6b7280)' }}>
                          Recording is not available.{' '}
                          <button type="button" onClick={() => setRecordingReload((n) => n + 1)} style={{ background: 'none', border: 0, padding: 0, color: 'var(--aw-accent, #2563eb)', cursor: 'pointer', textDecoration: 'underline', font: 'inherit' }}>Retry</button>
                        </p>
                      ) : recordingUrl ? (
                        <>
                          {/* v12.2.4.0 (CE-F1b): designed player - styled play/pause + waveform + download,
                              backed by a hidden native <audio> (loads cross-origin now that the T2 CSP media-src
                              allows the API host). Restores the intended look; native controls were a stopgap. */}
                          <audio
                            ref={audioRef}
                            key={recordingUrl}
                            src={recordingUrl}
                            preload="metadata"
                            onLoadedMetadata={() => {
                              const a = audioRef.current;
                              if (!a) return;
                              if (a.duration && isFinite(a.duration)) setRecordingLength(a.duration);   // v12.10.21 (#1953)
                              a.playbackRate = playbackRate;
                              // v12.9.26 (#982): a refreshed link resumes where the refused one stopped.
                              const r = resumeRef.current;
                              resumeRef.current = null;
                              if (r) { a.currentTime = r.at; if (r.play) void a.play().catch(() => recoverRecording(r.at, true)); }
                            }}
                            onPlaying={() => { refreshTriedRef.current = false; }}
                            onPlay={() => { setIsPlaying(true); if (selectedMessage) markReadBy(selectedMessage.id, 'play'); }}   /* v12.10.15 (#1651): playing the recording reads it */
                            onPause={() => setIsPlaying(false)}
                            onTimeUpdate={() => { const a = audioRef.current; if (a) { setCurrentTime(a.currentTime); if (a.duration && isFinite(a.duration)) setRecordingProgress(a.currentTime / a.duration); } }}
                            onEnded={() => { setIsPlaying(false); setRecordingProgress(0); setCurrentTime(0); }}
                            onError={() => recoverRecording(audioRef.current?.currentTime ?? currentTime, Boolean(audioRef.current && !audioRef.current.paused) || isPlaying)}
                            style={{ display: 'none' }}
                          />
                          <button
                            type="button"
                            className="aw-recording-play"
                            aria-label={isPlaying ? 'Pause recording' : 'Play recording'}
                            onClick={() => {
                              const a = audioRef.current;
                              if (!a) return;
                              if (a.paused) { void a.play().catch(() => recoverRecording(a.currentTime, true)); }
                              else { a.pause(); }
                            }}
                          >
                            <SvgIcon name={isPlaying ? 'pause' : 'play'} />
                          </button>
                          {/* v12.4.11 (#466): the waveform SEEKS. It has filled like a progress bar since
                              12.2.5.0 and ignored every click, which is the one affordance a progress bar
                              makes a promise about - and the transcript beside it has been click-to-seek since
                              #261, so the two halves of the same player disagreed. CHECKED BEFORE BLAMING A
                              BUILD: the pre-12.4.9 file has identical markup and CSS, so neither 12.4.9 nor
                              12.4.10 broke this; it was never wired.
                              Fraction comes from the click's x within the bar's own rect, so it is correct at
                              any width (this is a phone surface too). The bars stay aria-hidden - a decorative
                              span array is not a control - and the accessible path is the real <input
                              type=range> a screen reader gets from the native audio element, plus the
                              transcript's own seekable lines. Keyboard users get ←/→ on the focused bar. */}
                          <div
                            className={`aw-waveform${isPlaying ? ' aw-playing' : ''}`}
                            role="slider"
                            tabIndex={0}
                            aria-label="Seek within the recording"
                            aria-valuemin={0}
                            aria-valuemax={100}
                            aria-valuenow={Math.round(recordingProgress * 100)}
                            onClick={(event) => {
                              const audio = audioRef.current;
                              if (!audio || !audio.duration || !isFinite(audio.duration)) return;
                              const rect = event.currentTarget.getBoundingClientRect();
                              if (rect.width <= 0) return;
                              const fraction = Math.min(Math.max((event.clientX - rect.left) / rect.width, 0), 1);
                              audio.currentTime = fraction * audio.duration;
                              setCurrentTime(audio.currentTime);
                              setRecordingProgress(fraction);
                            }}
                            onKeyDown={(event) => {
                              const audio = audioRef.current;
                              if (!audio || !audio.duration || !isFinite(audio.duration)) return;
                              const step = event.key === 'ArrowLeft' ? -5 : event.key === 'ArrowRight' ? 5 : 0;
                              if (!step) return;
                              event.preventDefault();
                              audio.currentTime = Math.min(Math.max(audio.currentTime + step, 0), audio.duration);
                              setCurrentTime(audio.currentTime);
                              setRecordingProgress(audio.currentTime / audio.duration);
                            }}
                          >
                            {Array.from({ length: 30 }).map((_, index) => (
                              <span
                                key={index}
                                aria-hidden="true"
                                style={{
                                  height: `${22 + ((index * 17) % 38)}%`,
                                  backgroundColor: (index + 1) / 30 <= recordingProgress ? 'var(--aw-accent, #4f46e5)' : undefined,
                                }}
                              />
                            ))}
                          </div>
                          <button
                            type="button"
                            className="aw-recording-speed"
                            aria-label={`Playback speed ${playbackRate}x`}
                            title="Playback speed"
                            onClick={() => {
                              const rates = [1, 1.5, 2, 0.5];
                              const next = rates[(rates.indexOf(playbackRate) + 1) % rates.length];
                              setPlaybackRate(next);
                              if (audioRef.current) audioRef.current.playbackRate = next;
                            }}
                            style={{ background: 'none', border: 0, cursor: 'pointer', font: 'inherit', fontSize: '0.8rem', fontWeight: 600, color: 'var(--aw-accent, #4f46e5)', minWidth: '2.4em' }}
                          >
                            {playbackRate}x
                          </button>
                          <span>{formatDuration(recordingLength > 0 ? Math.round(recordingLength) : (playMessage ?? selectedMessage).durationSec)}</span>{/* v12.10.21 (#1953): the played call's real length - the audio's own once known */}
                          {can('download') && <button
                            type="button"
                            className="aw-recording-download"
                            aria-label="Download recording"
                            title="Download recording"
                            onClick={() => {
                              if (!recordingUrl || !playCallId) return;   // v12.10.17 (#1751): the call being played
                              // v12.2.5.0 (CE-F1d): hit the stream with ?download=1 - the server returns it as an
                              // attachment (Content-Disposition), so the browser saves it cross-origin. No blob/CORS.
                              // v12.10.9.4 (#1381): a download needs its own link, minted for Download recording.
                              const msgId = playCallId;
                              api.get<{ url: string; format: string }>(`/t2/recordings/signed-url?callId=${encodeURIComponent(playCallId)}&download=1`)
                                .then((res) => {
                                  const u = buildUrl(res.url);
                                  const link = document.createElement('a');
                                  link.href = `${u}${u.includes('?') ? '&' : '?'}download=true`;
                                  // v12.10.21 (#1952): "<call number> - <yyyymmdd>.mp3" - the call being played (each call of a group its own number)
                                  const named = (selGroup ?? []).find((g) => g.id === msgId) ?? (playMessage?.id === msgId ? playMessage : selectedMessage);
                                  link.download = recordingFileName(named, res.format || recordingFormat || 'mp3');
                                  document.body.appendChild(link);
                                  link.click();
                                  link.remove();
                                })
                                .catch(() => toast('warning', 'Download not allowed', 'Your user group doesn’t include Download recording.'));
                            }}
                          >
                            <SvgIcon name="download" />
                          </button>}
                        </>
                      ) : (
                        <p className="aw-recording-loading" role="status" style={{ margin: 0, fontSize: '0.85rem', color: 'var(--aw-muted, #6b7280)' }}>Loading recording{'…'}</p>
                      )}
                    </div>
                  </section>
                  {((selectedMessage.transcript ?? []).length > 0 || combinedView) && (() => {   /* 12.10.17.2 (#1820): Combined always has its transcript */
                    const all = selectedMessage.transcript ?? [];
                    // v12.3.12 (#307): identify a call-path line by its ROLE, which the API now serves, and
                    // keep the text sniff only for transcripts written before this build. 12.3.11 shipped this
                    // toggle reading a prefix that never arrived - CallTranscriptRollover was dropping every
                    // [path] line before it was persisted - so the count was always 0 and the link never rendered.
                    const isPath = (l: TranscriptLine) =>
                      (l.role ?? '') === 'path' || (l.text ?? '').trimStart().startsWith('[path]');
                    const spoken = all.filter((l) => !isPath(l));
                    const baseShown = showCallPath && can('path') ? all : spoken;   // v12.10.14 (#1618): only with the Call path right
                    // v12.9.23 (#846): an English call has no translation to offer, so there is NO toggle -
                    // not a disabled one, not a banner. Absent entirely.
                    const srcLang = languageCode(selectedMessage.language).toLowerCase();
                    // v12.9.24 (#913): the toggle exists when ANY spoken turn is not English, not only when the
                    // call as a whole was tagged non-English.
                    const needsXlOf = (m: WsMessage, lines: TranscriptLine[]) => languageCode(m.language).toLowerCase() !== 'en'
                      || lines.some((l) => !isPath(l) && l.lang && l.lang.toLowerCase().split('-')[0] !== 'en')
                      // v12.9.26 (#931): a call before 12.9.24 has no tags - an untagged turn with accented letters is not English.
                      || lines.some((l) => !isPath(l) && !l.lang && /[^\u0000-\u007f]/.test(l.text ?? ''));
                    // v12.10.22.2 (#2069): on the Combined view the EN / ES switch shows when ANY call of the group needs it.
                    const needsXl = needsXlOf(selectedMessage, all)
                      || (combinedView && !!selGroup && selGroup.slice(1).some((m) => needsXlOf(m, m.transcript ?? [])));
                    // v12.10.22.2 (#2069): an earlier call of the group, in the English view - only its non-English turns replaced and marked.
                    const shownOf = (m: WsMessage, lines: TranscriptLine[]) => {
                      const mAll = m.transcript ?? [];
                      const mx = xlLines[m.id];
                      if (transcriptView !== 'en' || !mx || mx.lines.length !== mAll.length) return lines;
                      return lines.map((l) => {
                        if (isPath(l)) return l;
                        const i = mAll.indexOf(l);
                        return i >= 0 && mx.translated[i] ? { ...l, text: mx.lines[i] ?? l.text, xlFrom: mx.fromLang[i] } : l;
                      });
                    };
                    const hasTags = all.some((l) => !isPath(l) && !!l.lang);   // v12.9.26 (#935)
                    const xl = xlLines[selectedMessage.id];
                    const onEnglish = needsXl && transcriptView === 'en' && !!xl && xl.lines.length === all.length;
                    // The call path NEVER responds to this toggle and its caller quotes stay verbatim -
                    // translating them would make the diagnostic lie about what the engine processed (#887).
                    // v12.9.24 (#913): ONLY the turns that were not English are replaced, and each is marked
                    // "translated from <language>"; an English turn is shown exactly as spoken.
                    const shown = onEnglish
                      ? baseShown.map((l) => {
                          if (isPath(l)) return l;
                          const i = all.indexOf(l);
                          return xl.translated[i]
                            ? { ...l, text: xl.lines[i] ?? l.text, xlFrom: xl.fromLang[i] }
                            : l;
                        })
                      : baseShown;
                    // ══ v12.9.14 (#830): TRANSCRIPT AND CALL DATA ARE SIBLING VIEWS. ════════════════
                    //
                    // His correction on the mockup: "i think you are trying to lay over call data on top
                    // of transcript. that will not work" - so they are two views, ONE AT A TIME, and the
                    // caption of each is a link. Selected state is a PILL FILL ("pill fill is final").
                    // Each caption carries its OWN copy icon: "copy should be available for both
                    // Transcript and call data ... both copy buttons copy".
                    //
                    // Call path became a SWITCH, so the links are only the two views. It is labelled with
                    // the THING, not the action - the switch position already says show or hide - and it
                    // greys out on the Call data view rather than disappearing, so the row does not jump.
                    //
                    // THE CALL DATA LINK IS HIDDEN when there are no captured fields. His call, on being
                    // told old calls cannot be backfilled: "it's ok to not show for old calls."
                    // v12.10.2 (#1103): only the fields the call went through - a "never reached" row (a card the call never got
                    // to, or a disabled card) is not call data. Calls stored before 12.10.2 still carry those rows; they are left out here.
                    const fieldsOf = (m: WsMessage) => (m.capturedFields ?? []).filter((f) => !(f.notCaptured ?? '').toLowerCase().startsWith('never reached'));
                    const fields = fieldsOf(selectedMessage);
                    // v12.10.17 (#1698 #1748): Combined reads (and copies) every call in the group, not only the newest.
                    const grpCalls = combinedView && selGroup ? selGroup : null;   // newest first, as on screen
                    const anyFields = grpCalls ? grpCalls.some((m) => fieldsOf(m).length > 0) : fields.length > 0;
                    const onData = dataView && anyFields;
                    // v12.10.17 (#1698): the flagged / corrected / struggle counts moved into dataBlock (per call). v12.9.25 (#830): no 'cleared' count.
                    // #830: field name and value ONLY - never the flag reasons. Colon-separated, his choice:
                    // "colon is better option so somebody can read easily or even parsed easily for excel".
                    // He spotted the collision himself - "the only problem is the time" - and it has a
                    // one-line answer: a consumer splits on the FIRST colon, so "Preferred time: 3:00 PM"
                    // survives intact.
                    // v12.9.26 (#830-d): not-captured rows are left out of the copy (his rule).
                    // v12.10.14 (#1620, S248): the patient name, an underline, the fields; a correction keeps what it was; "Not captured: …" last.
                    // v12.10.17 (#1748): Combined copies every call, oldest to newest, each under "#42-0627 · 3:49 PM · Voicemail".
                    // ══ v12.10.19 (#1920, Tushar 10/23): Combined Call data is ONE table, the same as a one-call message. Reference number
                    // lists every call; every other row shows the value with the reference of the call that filled it, and "updated" (with
                    // the earlier value and its call) when a later call changed it. Copy copies this same table.
                    type MergedRow = { f: CapturedField; ref: string; prev?: { value: string; ref: string } };
                    const mergedOf = (calls: WsMessage[]): MergedRow[] => {
                      const byTok = new Map<string, MergedRow>();
                      for (const m of [...calls].reverse()) {   // oldest first - a later call wins
                        const ref = formatReference(m.referenceNo);
                        for (const f of fieldsOf(m)) {
                          if (f.token === 'request.referenceNumber') continue;
                          const cur = byTok.get(f.token);
                          const v = (f.value ?? '').trim();
                          if (!v) { if (!cur) byTok.set(f.token, { f, ref }); continue; }
                          const cv = (cur?.f.value ?? '').trim();
                          if (!cur || !cv) byTok.set(f.token, { f, ref });
                          else if (cv.toLowerCase() !== v.toLowerCase()) byTok.set(f.token, { f, ref, prev: { value: cv, ref: cur.ref } });
                        }
                      }
                      const refs = calls.map((m) => formatReference(m.referenceNo)).filter(Boolean).join(' \u00b7 ');
                      const refRow: MergedRow = { f: { token: 'request.referenceNumber', label: 'Reference number', value: refs, flag: null, flagReason: null }, ref: '' };
                      return [refRow, ...byTok.values()];
                    };
                    const merged = grpCalls ? mergedOf(grpCalls) : null;
                    const dataToText = () => (merged
                      ? callDataText(selectedMessage.hasName ? selectedMessage.name : '', merged.map((r) => (r.ref && (r.f.value ?? '').trim()
                          ? { ...r.f, value: `${r.f.value} (${r.ref}${r.prev ? `, updated - was ${r.prev.value} on ${r.prev.ref}` : ''})` } : r.f)))
                      : callDataText(selectedMessage.hasName ? selectedMessage.name : '', fields));
                    const transcriptCopyText = () => (onEnglish ? '[English view - turns marked (translated) are machine translation]\n' : '') + (grpCalls
                      ? [...grpCalls].reverse().map((m) => {
                          const lines = m.id === selectedMessage.id ? shown : shownOf(m, (m.transcript ?? []).filter((l) => (showCallPath && can('path')) || !isPath(l)));
                          return `${groupCopyHeader(m)}\n${lines.length ? transcriptToText(lines) : 'Nothing was said on this call.'}`;
                        }).join('\n\n')
                      : transcriptToText(shown));
                    // v12.10.17 (#1698): one call's Call data - the counts line and the field rows (was inline, for the newest call only).
                    const dataBlock = (m: WsMessage, fs: CapturedField[], extras?: Map<string, MergedRow>) => {
                      const flagged = fs.filter((f) => f.flag === 'flagged').length;
                      const corrected = fs.filter((f) => f.corrected).length;
                      const toCheck = fs.filter((f) => f.check).length;
                      const notCapturedCount = fs.filter((f) => f.notCaptured).length;
                      return (
                          <>
                            <div className="aw-cd-roll">
                              <span className="aw-cd-chip">{fs.length - notCapturedCount} of {fs.length} captured</span>
                              {flagged > 0 && <span className="aw-cd-chip is-flag">{flagged} still flagged</span>}
                              {corrected > 0 && <span className="aw-cd-chip is-fix">{corrected} corrected</span>}
                              {toCheck > 0 && <span className="aw-cd-chip is-check">{toCheck} struggle</span>}{/* v12.9.27 (#1048): was "to check" */}
                              {m.notConfirmed && <span className="aw-cd-chip is-flag">not confirmed by caller</span>}
                            </div>
                            <div className="aw-cd-grid">
                              {fs.map((f) => (
                                // v12.9.25 (#830, HIS DEFINITION 2026-09-30): "Flagged is when try to get it corrected
                                // from caller but still not confirmed and may be possible problems. Corrected, and
                                // flagged is possible. got it accurately then no need to display any flag."
                                <div key={f.token} className={`aw-cd-row${f.flag === 'flagged' ? ' is-flagged' : f.check ? ' is-check' : f.corrected ? ' is-corrected' : ''}`}>
                                  <div className="aw-cd-r1">
                                    <span className="aw-cd-name" title={f.token}>{f.label}</span>{/* v12.9.26 (#989): the key stays on hover */}
                                    {f.notCaptured
                                      ? <span className="aw-cd-val aw-cd-none">not captured</span>
                                      : <span className="aw-cd-val">{f.value}</span>}
                                    {f.source === 'voicemail' && !f.notCaptured && <span className="aw-cd-tag is-vm">from voicemail</span>}{/* v12.10.15 (#1666) */}
                                    {/* v12.10.19 (#1920): Combined - the call that filled it, and "updated" when a later call changed it */}
                                    {extras?.get(f.token)?.ref && !f.notCaptured && <span className="aw-grp-chip">{extras.get(f.token)!.ref}</span>}
                                    {extras?.get(f.token)?.prev && <span className="aw-cd-tag is-fix">updated</span>}
                                    {f.corrected && <span className="aw-cd-tag is-fix">CORRECTED{(f.corrections ?? 0) > 1 ? ` \u00d7${f.corrections}` : ''}</span>}{/* v12.10.19 (#1910) */}
                                    {f.flag === 'flagged' && <span className="aw-cd-tag is-flag">FLAGGED</span>}
                                    {/* v12.9.26 (#1013): separate from FLAGGED - confirmed, but only after a struggle. v12.9.27 (#1048): CHECK -> STRUGGLE, his word. */}
                                    {f.check && <span className="aw-cd-tag is-check">STRUGGLE</span>}
                                  </div>
                                  {f.corrected && f.previous && (
                                    <div className="aw-cd-why">Was “{f.previous}” — the caller corrected it on the call{(f.corrections ?? 0) > 1 ? ` (${f.corrections} corrections - this is the last value)` : ''}.</div>
                                  )}
                                  {extras?.get(f.token)?.prev && (
                                    <div className="aw-cd-why">Was “{extras.get(f.token)!.prev!.value}” on {extras.get(f.token)!.prev!.ref}.</div>
                                  )}
                                  {f.notCaptured && f.heard && <div className="aw-cd-why">Heard: “{f.heard}”</div>}{/* v12.10.19 (#1910) */}
                                  {f.flag === 'flagged' && f.flagReason && (
                                    <div className="aw-cd-why">{/* v12.9.27 (#1048): one plain reason, no fixed suffix */}{/[.!?]$/.test(f.flagReason.trim()) ? f.flagReason.trim() : `${f.flagReason.trim().charAt(0).toUpperCase()}${f.flagReason.trim().slice(1)}.`}</div>
                                  )}
                                  {f.check && (
                                    <div className="aw-cd-why">Confirmed, but after a struggle: {f.check}.</div>
                                  )}
                                  {f.notCaptured && <div className="aw-cd-why">{f.notCaptured.charAt(0).toUpperCase() + f.notCaptured.slice(1)}.</div>}
                                </div>
                              ))}
                            </div>
                          </>
                      );
                    };
                    // v12.10.14 (#1617): the spoken language is named on the pill - "ES · As spoken" never reads as English.
                    // v12.10.16.1 (#1709, 42-0459): only the CALLER's lines name it - the agent's own Spanish line ("También puede dejar su
                    // mensaje en español", the voicemail greeting) made an English voicemail read "ES · As spoken".
                    const spokenCode = (srcLang !== 'en' ? srcLang
                      : (all.find((l) => !isPath(l) && l.lang && !l.lang.toLowerCase().startsWith('en') && (l.role === 'caller' || /caller/i.test(String(l.speaker ?? ''))))?.lang ?? '')).split('-')[0].toUpperCase();
                    return (
                      <section className="aw-section-card" data-jump="transcript">{/* v12.10.30 (#2258) */}
                        <div className="aw-section-h aw-viewbar">
                          {/* v12.10.14 (#1617, DRAWER v1.10): Transcript is no longer boxed - only the picked language pill is lit (dark);
                              a language click shows the transcript at once, also from Call data; on Call data no language pill is lit. */}
                          <span className="aw-view aw-trview">
                            <button type="button" className="aw-viewcap" data-track="drawer.section.transcript" onClick={() => setDataView(false)}>
                              <SvgIcon name="list" /> Transcript
                            </button>
                            {needsXl && (
                              <span className="aw-xlsw aw-xlsw-fill aw-trlang" role="group" aria-label="Transcript language" title="Language of the transcript">
                                {/* v12.9.24 (#913): "As spoken" first - it is the default and the record. */}
                                <button type="button" className={`aw-xltab${!onData && transcriptView === 'src' ? ' on' : ''}`}
                                  aria-pressed={!onData && transcriptView === 'src'} onClick={() => { setTranscriptView('src'); setDataView(false); }}
                                  title="Every turn exactly as it was spoken, in the language it was spoken in">{spokenCode ? `${spokenCode} · As spoken` : 'As spoken'}</button>
                                <button type="button" className={`aw-xltab${!onData && transcriptView === 'en' ? ' on' : ''}`}
                                  aria-pressed={!onData && transcriptView === 'en'} onClick={() => { setTranscriptView('en'); setDataView(false); }}
                                  title="Turns that were not English are translated and marked; English turns are unchanged">EN</button>
                              </span>
                            )}
                            {/* Copy sits AFTER the toggle because copy acts on what the toggle selected.
                                On English it PREPENDS the marker; on the original it copies clean, because
                                that IS the record. */}
                            {can('copytr') && <CopyButton
                              text={transcriptCopyText()}
                              label="Copy transcript" iconOnly />}{/* v12.10.17 (#1748): Combined = every call shown */}
                          </span>

                          {anyFields && (/* v12.10.17 (#1698): Combined - any call in the group with Call data */
                            <>
                              <span className="aw-viewsep" aria-hidden="true">|</span>
                              <span className={`aw-view aw-cdview${onData ? ' is-on' : ''}`}>{/* v12.10.14 (#1617 S234): picked = solid, as ES · As spoken */}
                                <button type="button" className="aw-viewcap" data-track="drawer.section.calldata" onClick={() => setDataView(true)}>
                                  <SvgIcon name="database" /> Call data
                                </button>
                                {can('copydata') && <CopyButton text={dataToText()} label="Copy call data" iconOnly />}
                              </span>
                            </>
                          )}

                          {/* v12.10.14 (#1618): the Call path switch moved to the footer (Owner - the "Call path" right). */}
                        </div>

                        {onData ? (
                          merged ? (
                            // v12.10.19 (#1920): Combined - ONE table (was one block per call, #1698 - never approved)
                            dataBlock(selectedMessage, merged.map((r) => r.f), new Map(merged.map((r) => [r.f.token, r] as const)))
                          ) : dataBlock(selectedMessage, fields)
                        ) : (
<>
                            {needsXl && (
                              <div className={`aw-xlbanner${onEnglish ? '' : ' is-src'}`}>
                                {onEnglish
                                  ? 'English view \u00b7 turns that were not English are machine-translated and marked'
                                  : hasTags ? 'As spoken \u00b7 each turn is tagged with the language it was spoken in' : 'As spoken'}
                                {transcriptView === 'en' && !onEnglish && xlState === 'loading' && ' \u00b7 translating\u2026'}
                                {transcriptView === 'en' && !onEnglish && (xlState === 'error' || xlState === 'unavailable')
                                  && ` \u00b7 not translated \u2014 ${xlReason ?? 'the translation service did not answer'}. Showing the original.`}
                              </div>
                            )}
                            {/* v12.10.16 (#1690) · 12.10.17.2 (#1820): Combined - one transcript of every call, OLDEST first, each under its own line */}
                            {/* v12.10.23 (call route, Tushar 10/29): while the Call route is open the earlier calls step aside - the route of the newest call shows */}
                            {combinedView && selGroup && !(showRoute && can('path')) && [...selGroup.slice(1)].reverse().map((m) => (
                              <div key={m.id}>
                                <div className="aw-grp-sep">{groupSepLabel(m)}{grpPlayBtn(m)}</div>
                                {(m.transcript ?? []).length === 0
                                  ? <p className="aw-muted">{detailRef.current.has(m.id) ? 'Nothing was said on this call.' : 'Loading\u2026'}</p>
                                  : <TranscriptLines lines={shownOf(m, (m.transcript ?? []).filter((l) => (showCallPath && can('path')) || !isPath(l)))}
                                      startedAt={m.startedAt} callerFirstName={m.hasName ? m.name : undefined}
                                      /* v12.10.17 (#1751): a line of an earlier call plays THAT call's recording from there */
                                      currentTime={playCallId === m.id ? currentTime : undefined}
                                      onSeek={playCallId === m.id ? seekTo : (at) => pickPlay(m, at)}
                                      playable={playCallId === m.id ? Boolean(recordingUrl) && recordingState === 'ready' : canPlayCall(m)} />}
                              </div>
                            ))}
                            {combinedView && <div className="aw-grp-sep">{groupSepLabel(selectedMessage)}{grpPlayBtn(selectedMessage)}</div>}
                            {/* v12.10.22 (#2010): the Call route replaces the transcript while the path icon is on (Owner only - the Call path right). */}
                            {/* v12.10.23 (Tushar 10/29 "it goes white and next time blue but nothing happens"): the route showed only on a single call
                                and below the fold - it now shows in Combined too (the newest call's route; a call chip opens another call's) and scrolls into view. */}
                            {showRoute && can('path') ? <div id="aw-callroute" className="aw-callroute-wrap"><CallRoute lines={all} showPath={showCallPath} callerLabel={selectedMessage.hasName ? selectedMessage.name.split(' ')[0] : undefined} /></div> :
                            combinedView && shown.length === 0 ? <p className="aw-muted">Nothing was said on this call.</p> :
                            <TranscriptLines lines={shown} currentTime={playCallId === selectedMessage.id ? currentTime : undefined} startedAt={selectedMessage.startedAt}
                              onSeek={playCallId === selectedMessage.id ? seekTo : (at) => pickPlay(selectedMessage, at)}
                              playable={playCallId === selectedMessage.id ? Boolean(recordingUrl) && recordingState === 'ready' : canPlayCall(selectedMessage)}
                              callerFirstName={selectedMessage.hasName ? selectedMessage.name : undefined} />}{/* v12.10.11.1 (#1442): the speaker label comes from the SAME captured name as the header, never a different firstName field */}
                          </>
                        )}
                      </section>
                    );
                  })()}
                </>
              )}
            </div>

            {/* G: only Call back is primary; Mark complete is secondary. M: add Mark as unread.
                CC: Skip removed (redundant with Mark as unread) - footer is Mark as unread + Mark complete. */}
            {/* v12.10.14 (#1616, DRAWER v1.10 LOCKED): LEFT the mini player (in the row - no longer floating over Print) + the Call path switch
                (Owner - the "Call path" right; route icon, name and count in the tooltip); RIGHT Print ▾ · Mark unread · Mark complete as icon +
                shortcut chip, the names in the tooltip. Phone: one line of icons; Call path takes a second line only when it is shown. */}
            {(() => {
              const pathCount = can('path') ? (selectedMessage.transcript ?? []).filter((l) => (l.role ?? '') === 'path' || (l.text ?? '').trimStart().startsWith('[path]')).length : 0;
              // v12.10.17 (#1698): Combined is on Call data when ANY call of the group has it (the drawer shows them all).
              const onData = dataView && (combinedView && selGroup ? selGroup : [selectedMessage]).some((gm) => (gm.capturedFields ?? []).some((f) => !(f.notCaptured ?? '').toLowerCase().startsWith('never reached')));
              return (
            <div className={`aw-drawer-footer aw-foot14${miniPlayer ? ' aw-foot-with-player' : ''}${pathCount > 0 ? ' aw-foot-with-path' : ''}`}>
              <div className="aw-foot-left">
                {/* v12.10.27 (#2146, prototype v1.3 LOCKED, Tushar 10/31 "call back button we can keep before activity at bottom, it will give a
                    different color"): a text conversation's Call back - green, in the footer. */}
                {/* v12.10.30 (#1156 P4): a Text card's Call back opens the same browser call window when the Call back switch is on. */}
                {selectedMessage.kind === 'text' && callBackOn && (
                  <CallBackButton variant="foot" messageId={selectedMessage.id} name={callBackName} language={selectedMessage.language} numbers={callBackNumbers}
                    blockedWhy={can('call') ? null : "Your user group doesn't allow Call back. Ask your practice owner (Settings › Security › User groups)."} />
                )}
                {selectedMessage.kind === 'text' && !callBackOn && (
                  <button type="button" className="aw-foot-callback" data-track="drawer.action.callback" title="Call the patient back (Ctrl+K)"
                    onClick={() => { const wasNew = selectedMessage.status === 'new'; touchMessage(selectedMessage.id); if (wasNew) persist(selectedMessage.id, { status: 'prog', readBy: 'call' }); else { if (selectedMessage.status !== 'done') persist(selectedMessage.id, { status: 'prog' }); logActivity(selectedMessage.id, 'call'); } toast('info', 'Callback started'); }}>
                    <SvgIcon name="phone" /> <span className="aw-btn-label">Call back</span> <span className="aw-kbd">Ctrl+K</span>
                  </button>
                )}
                {miniPlayer}
                {callBackOn && <CallBackMiniPlayer messageId={selectedMessage.id} />}{/* v12.10.30 (#1156): ▶ Play of a call back block plays here */}
                {/* v12.10.15 (#1648, LOCKED): Activity - next to the player, before Call path; the full list opens in the drawer. */}
                <span className="aw-activity-wrap">
                  {/* v12.10.23 (Tushar 10/29, phone): Activity moves into ⋮ More actions on a phone - the bottom bar keeps one line */}
                  {!isPhone && <button type="button" className={`aw-secondary aw-foot-btn aw-activity-btn${activityOpen ? ' is-on' : ''}`} aria-expanded={activityOpen}
                    data-track="drawer.section.activity" title="Activity - who did what on this message, and when" aria-label="Activity"
                    onClick={() => setActivityOpen((o) => !o)}>
                    <span aria-hidden="true">{'\u{1F558}'}</span> <span className="aw-foot-lbl">Activity</span>
                  </button>}
                  {activityOpen && (
                    <span className="aw-activity-panel" role="dialog" aria-label="Activity">
                      <strong className="aw-activity-head">Activity</strong>
                      <ol className="aw-activity-list">
                        {[...(activityById[selectedMessage.id] ?? [])].reverse().map((a, i) => (
                          <li key={`${a.at}-${i}`}><span className="aw-activity-at">{ACT_TIME(a.at)}</span> <span><b>{a.by || 'Someone'}</b> · {activityWords(a)}</span></li>
                        ))}
                        <li className="is-sys"><span className="aw-activity-at">{ACT_TIME(selectedMessage.startedAt ?? '')}</span> <span><b>System</b> · message created (New)</span></li>
                      </ol>
                      {!(activityById[selectedMessage.id] ?? []).length && <small className="aw-print-note">Nothing done on this message yet. Actions from 12.10.15 on are listed here.</small>}
                    </span>
                  )}
                </span>
                {pathCount > 0 && (
                  <span className={`aw-pathsw aw-foot-path${onData ? ' is-off' : ''}`}
                    title={`Call path (${pathCount}) - the routing decisions this call took: what was classified, which branch it entered, and why`}>
                    {/* v12.10.22 (#2010, prototype v1.2): no new buttons - the path icon (already here) opens the Call route: every card the
                        call went through, a click opens that card's own lines. The switch stays today's view (the transcript with CALL PATH lines). */}
                    <button type="button" className={`aw-pathlbl aw-route-btn${showRoute && !onData ? ' is-on' : ''}`} id="aw-pathlbl" aria-pressed={showRoute && !onData}
                      aria-label={`Call route (${pathCount})`} data-track="drawer.section.callroute" disabled={onData}
                      title={onData ? 'Call route is part of the transcript - switch to Transcript to use it' : 'Call route - every card this call went through; click a card to see its lines'}
                      onClick={() => { setShowRoute((v) => !v); setShowCallPath(false); setDataView(false); }}>
                      <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="6" cy="19" r="2" /><circle cx="18" cy="5" r="2" /><path d="M8 19h7a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h7" /></svg>
                    </button>
                    <button type="button" role="switch" className="aw-sw" aria-checked={showCallPath} aria-label={`Call path lines (${pathCount})`} data-track="drawer.section.callpath"
                      disabled={onData} title={onData ? 'Call path is part of the transcript - switch to Transcript to use it' : `Call path (${pathCount})`}
                      onClick={() => { setShowCallPath((v) => !v); setShowRoute(false); }} />
                  </span>
                )}
              </div>
              <div className="aw-drawer-footer-right">
              {canOpenArea('rep_calls') && !isPhone && (   /* v12.10.23 (phone): Print moves into ⋮ More actions */
                <span className="aw-print-wrap" ref={printWrapRef}>
                  <button className="aw-secondary aw-foot-btn aw-print-btn" type="button" aria-haspopup="menu" aria-expanded={printMenuOpen}
                    aria-label="Print or download this call (P)" title="Print or download this call (P)" onClick={() => setPrintMenuOpen((o) => !o)}>
                    <SvgIcon name="printer" /> <span className="aw-kbd">P</span> <span className="aw-caret" aria-hidden="true">{'\u25BE'}</span>
                  </button>
                  {printMenuOpen && (
                    <span className="aw-as-menu aw-print-menu" role="menu">
                      <button type="button" role="menuitem" onClick={() => printSelected('print')}>Print · with transcript <span className="aw-kbd">P</span></button>
                      <button type="button" role="menuitem" onClick={() => printSelected('summary')}>Print · summary only</button>
                      <button type="button" role="menuitem" onClick={() => printSelected('pdf')}>Download PDF</button>
                      <button type="button" role="menuitem" onClick={() => printSelected('html')}>Save as HTML</button>
                      {/* v12.10.15 (#1636, LOCKED): Copy call record + include transcript */}
                      <button type="button" role="menuitem" data-track="drawer.action.copyrecord" onClick={() => { void copyCallRecord(); }}>{'\u29C9'} Copy call record</button>
                      <label className="aw-print-tick"><input type="checkbox" checked={copyWithTranscript} onChange={(e) => setCopyWithTranscript(e.target.checked)} /> include transcript</label>
                      <small className="aw-print-note">Prints right here - you stay on this screen. Every print and copy is written to the audit log and the message's Activity.</small>
                    </span>
                  )}
                </span>
              )}
                {/* v12.9.12 (#794): labels carry no "as" - his wording, applied identically here and in the
                    more-menu. Mark unread is STATIC: opening the drawer marks the message read, so inside
                    the drawer there is never an unread one and "Mark as read" solves a state that cannot
                    exist. The icons are inline glyphs sized like Call back's phone, NOT the 30px action
                    square, which is far too heavy inside a 40px outlined button - and they sit outside the
                    label span so a toggle repaint cannot drop them. */}
                {/* v12.10.9.1 (#1277, settled 10/6): at <= 480px the labels hide and these are 40 x 40 icon buttons -
                    the name stays as aria-label / title (long-press) - so the mini player fits in the same row. */}
                <button className="aw-secondary aw-foot-btn" type="button" data-track="drawer.action.unread" onClick={markUnread} aria-label="Mark unread (M)" title="Mark unread (M)">
                  <SvgIcon name="mail" /> <span className="aw-kbd">M</span>
                </button>
                {can('complete') && <button className="aw-secondary aw-foot-btn" type="button" data-track="drawer.action.complete" onClick={toggleComplete}
                  aria-label={isDone ? 'Mark pending (Ctrl+Enter)' : 'Mark complete (Ctrl+Enter)'} title={isDone ? 'Mark pending (Ctrl+Enter)' : 'Mark complete (Ctrl+Enter)'}>
                  <SvgIcon name="check" /> <span className="aw-kbd">Ctrl+Enter</span>
                </button>}
                {/* v12.10.13 (#1565) -> v12.10.23 (Tushar 10/29): the phone's bottom-right Close is gone - the X at the top and Back close the drawer. */}
              </div>
            </div>
              );
            })()}

            {/* ══ v12.9.11 (#770): THE MINI PLAYER. ══════════════════════════════════════════════════
                His spec, and the placement is his: *"The mini recorder play bar can stay on bottom left of
                the drawer so it does not come in way of trasncript read."*

                BOTTOM-LEFT AND NOT BOTTOM-RIGHT, for a reason worth keeping: the call-path lines are the
                longest content in this drawer and the transcript reads left-to-right, so the right edge is
                where wrapped text actually ends up. The left corner is the one reliably empty.

                It appears ONLY when the real player has scrolled out of view and there is something to
                play - it is a remote control for a control that exists, not a second player. Time is shown
                because a caller who has jumped to a transcript line wants to know where they landed. */}
            {/* ══ v12.9.12 (#797): IT LIVES IN THE FOOTER BAND NOW, AND IT STAYS THERE. ══════════════════
                His instruction after seeing 12.9.11 on a real call, with an arrow drawn to the blank
                bottom-left band: *"place it as i have pointed as that area is blank and it will not come
                in way of transcript. i think if we leave it permanently there then also it should not
                hurt."*

                So the `!playerOnScreen` condition is GONE - it is present whenever there is something to
                play. Worth recording that the condition was not broken: he confirmed *"it is staying
                put"*. The requirement changed once he could see it on a real call, which is the best
                possible reason to change something. `playerOnScreen` is kept because the "Player" link
                still needs to know whether scrolling to the real player is useful. */}
            {/* v12.10.9.4 (#1359): on a phone the mini player sits INSIDE the footer row (below) - one player, never on top of a button */}
            {/* v12.10.14 (#1616): the mini player lives in the footer row on every screen now (above). */}
            {/* v12.10.14 (#1619): the print job - the call record drawn off screen, printed here (no new tab). */}
            {printJob && (() => {
              const pc = practiceCategoryOf(selectedMessage);
              const xl = xlLines[printJob.id];
              return (
                <CallRecordPrint id={printJob.id} action={printJob.action} withPath={showCallPath && can('path')} labelColors={labelColorMap}
                  categoryColor={pc?.color || undefined} categoryName={pc ? requestOf(selectedMessage).words : undefined}
                  english={xl ? xl.lines.map((t, i) => (xl.translated[i] ? t : null)) : undefined}
                  onDone={() => setPrintJob(null)} />
              );
            })()}
          </aside>
        </div>
      )}

      {helpOpen && (
        <div className="aw-modal-scrim" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) setHelpOpen(false); }}>
          <div className="aw-help-panel" role="dialog" aria-modal="true" aria-label="Keyboard shortcuts">
            <h2 className="aw-panel-title">Keyboard shortcuts</h2>
            <div className="aw-shortcuts">
              <div><span className="aw-kbd">/</span> Focus search</div>
              <div><span className="aw-kbd">F</span> Open filters</div>
              <div><span className="aw-kbd">Up/Down</span> Move card highlight</div>
              <div><span className="aw-kbd">Enter</span> Open highlighted</div>
              <div><span className="aw-kbd">Esc</span> Close drawer</div>
              <div><span className="aw-kbd">[ ]</span> Previous / next</div>
              <div><span className="aw-kbd">Ctrl+K</span> Call back / reply</div>
              <div><span className="aw-kbd">Ctrl+Enter</span> Mark complete</div>
              <div><span className="aw-kbd">N</span> Draft note</div>
              <div><span className="aw-kbd">R</span> Draft reminder</div>
              <div><span className="aw-kbd">L</span> Apply label</div>
              {/* v12.9.13 (#804): T, not Ctrl+T - Chrome owns Ctrl+T and preventDefault cannot stop it.
                  Listed with its three siblings because that is what it now is: the fourth plain letter. */}
              <div><span className="aw-kbd">T</span> Send text</div>
              <div><span className="aw-kbd">A</span> Assign</div>
              <div><span className="aw-kbd">P</span> Print this call</div>
              <div><span className="aw-kbd">U</span> Urgent on / off</div>
              {/* v12.9.12 (#794): "Mark unread", matching the footer and the menu. This panel was missed when
                  the three labels dropped "as" - found by him asking what the acceptance criterion meant, which
                  is a better catch than the criterion itself managed. */}
              <div><span className="aw-kbd">M</span> Mark unread</div>
            </div>
            <div className="aw-filter-footer">
              <button className="aw-primary" type="button" onClick={() => setHelpOpen(false)}>Close</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

// L: structured transcript lines - timestamp gutter (indigo) + color-coded speaker + text.
function fmtTs(ts?: string | null): string {
  if (!ts) return '';
  const d = new Date(ts);
  if (isNaN(d.getTime())) return '';
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', second: '2-digit' });
}

// v12.9.26 (#960): once the call captured a first name, the caller's turns carry it ('SANTOS') instead of 'CALLER'.
// Every caller turn is relabelled, the early ones included - the transcript does not record WHEN the name landed.
function TranscriptLines({ lines, currentTime, startedAt, onSeek, playable, callerFirstName }: { lines: TranscriptLine[]; currentTime?: number; startedAt?: string; onSeek?: (seconds: number) => void; playable?: boolean; callerFirstName?: string }) {
  const callerLabel = (callerFirstName ?? '').trim().split(/\s+/)[0]?.toUpperCase() || null;
  // v12.2.47.0 (#261): when the player passes its playhead + the call start, sync the transcript to the recording:
  // highlight + auto-scroll the current line, and let a click jump the recording to that line.
  // ══ v12.9.11 (#784): ANCHOR THE OFFSETS TO THE RECORDING, NOT TO THE CALL RECORD. ═══════════════════
  //
  // His report on 39-0074: *"when I clicked on what is tushar's date of birth. It starts reading August 9th,
  // 2000 ... Sometime it also scolls 2-3 lines and starts reading."* He clicked a QUESTION and heard its
  // ANSWER - so every offset was systematically LATE by the same amount, which is what also pushes the
  // auto-scroll a couple of lines ahead.
  //
  // WHY. Offsets were measured from `startedAt`, the call RECORD's start. The recording's own t=0 is when the
  // call was ANSWERED. Ring time sits between the two - commonly a few seconds - and every offset inherited
  // it, so every seek landed that far into the future. One shift, applied to every line, exactly as observed.
  //
  // THE FIX NEEDS NO NEW DATA: anchor to the EARLIEST line instead. The agent's greeting is spoken at
  // recording t~0, so the first stamped line IS the origin. It is self-relative, so the ring time cancels.
  // Where `startedAt` was already the answer time the two agree to within milliseconds, which makes this a
  // no-op on those calls rather than a second source of error.
  //
  // WHAT THIS DOES **NOT** FIX, AND I AM NOT GUESSING AT IT. A CALLER line is stamped when the webhook
  // arrives, which is after the end-of-speech wait has elapsed - so a caller line is still late by roughly
  // that wait, and #786 has just made the wait longer and per-field-type. Correcting it properly needs to
  // know the wait that applied to that turn, which is one of the numbers #788 starts recording in this same
  // release. Deliberately left for 12.9.12 rather than papered over with a constant - see #763/#774 for what
  // a guessed constant costs here.
  const stamps = lines.map(l => (l.ts ? Date.parse(l.ts) : NaN)).filter(t => !isNaN(t));
  const recordedStartMs = stamps.length > 0 ? Math.min(...stamps) : NaN;
  const declaredStartMs = startedAt ? Date.parse(startedAt) : NaN;
  const startMs = !isNaN(recordedStartMs) ? recordedStartMs : declaredStartMs;
  // ══ v12.9.13 (#802, his option B): SEEK TO WHERE THE TURN BEGAN. ══
  //
  // His report: clicking "Hi, my name is T..." jumped two seconds PAST it. *"i understand if it is :28 but
  // then it should stay one up or down not after 2 seconds."*
  //
  // WHAT I FIRST PROMISED HIM WAS NOT BUILDABLE. The v1.0 scope said "exact, not estimated - the engine knows
  // the moment it hands each line over". It does not: every sentence of a turn goes to the vendor in ONE TwiML
  // document, so there is one moment for the whole turn and no per-line moment to record. Separating the lines
  // could only ever be an estimate. He chose B, and B needs no estimate at all.
  //
  // TWO STAMPS, TWO DIFFERENT LIES, AND THEY LEAN OPPOSITE WAYS:
  //   AI lines    - stamped when BUILT, milliseconds apart, before the vendor spends ten seconds speaking
  //                 them. Every line of a turn collapses onto one point, slightly EARLY of its own audio.
  //   CALLER lines - stamped when the WEBHOOK ARRIVED, which is after the caller stopped talking plus the
  //                 end-of-speech wait. That points PAST the speech, and #811 has just made that wait longer.
  //                 This is the one he clicked.
  //
  // So a caller line seeks to the moment the floor OPENED to them - the preceding line's stamp - because that
  // is the one instant we know for certain precedes their first word. Early, never late, exactly as he asked.
  // No constant is invented anywhere: #763 guessed one, missed a single letter, and produced #774 on the very
  // next call. The exact per-line offsets stay open in #784, waiting on #788's real measurements.
  const turnStartMs = (index: number): number => {
    const own = Date.parse(lines[index].ts ?? '');
    const role = lines[index].role;
    if (role === 'caller') {
      // ══ v12.9.27 (#1046, SETTLED 2026-10-01): ESTIMATE WHEN THE CALLER STARTED SPEAKING. ══
      // 40-0054: "Hi, my name is John Doe" (10:21:14) played from the prompt before it (10:20:43) - 30 s early. The
      // turn arrives after the caller FINISHES, so their start is about the arrival minus the length of what they
      // said (about 2 words a second) minus a 2 s margin - and never earlier than the end of the prompt before it
      // (that prompt's start plus its own length, about 2.5 words a second). Agent lines keep today's behaviour.
      // The engine's "Caller pauses" figure uses the same estimate (#1040).
      const words = (s: string | undefined) => (s ?? '').trim().split(/\s+/).filter(Boolean).length;
      let promptStart = NaN; let promptWords = 0;
      for (let i = index - 1; i >= 0; i--) {
        if (lines[i].role === 'caller') break;
        if (lines[i].role !== 'agent') continue;
        const prev = Date.parse(lines[i].ts ?? '');
        if (isNaN(prev) || prev > own) continue;
        promptStart = isNaN(promptStart) ? prev : Math.min(promptStart, prev);
        promptWords += words(lines[i].text);
      }
      if (isNaN(promptStart)) {
        for (let i = index - 1; i >= 0; i--) {
          const prev = Date.parse(lines[i].ts ?? '');
          if (!isNaN(prev) && prev <= own) { promptStart = prev; break; }
        }
      }
      const estimate = own - words(lines[index].text) * 500 - 2000;
      const floor = isNaN(promptStart) ? -Infinity : Math.min(own, promptStart + promptWords * 400);
      return Math.min(own, Math.max(floor, estimate));
    }
    // An AI turn is everything the agent said since the caller last spoke - NOT a contiguous run, because
    // call-path lines interleave with the spoken ones and the drawer can show or hide them. Anchoring on
    // "since the last caller line" gives the same answer whether the path is open or closed, which matters:
    // he reads this drawer both ways and a seek that moved when he toggled the path would be its own defect.
    let first = own;
    for (let i = index - 1; i >= 0; i--) {
      if (lines[i].role === 'caller') break;
      const prev = Date.parse(lines[i].ts ?? '');
      if (!isNaN(prev) && prev <= own) first = Math.min(first, prev);
    }
    return first;
  };
  const offsetOf = (line: TranscriptLine, index?: number): number | null => {
    if (!line.ts || isNaN(startMs)) return null;
    const own = Date.parse(line.ts);
    if (isNaN(own)) return null;
    const t = typeof index === 'number' ? turnStartMs(index) : own;
    return Math.max(0, ((isNaN(t) ? own : t) - startMs) / 1000);
  };
  const syncable = onSeek !== undefined && !isNaN(startMs);
  let activeIndex = -1;
  // v12.2.47.1 (#261): only track/scroll once playback is actually moving; at rest (currentTime 0) show the whole
  // transcript from the top with no highlight, so opening a message doesn't jump to a line.
  if (syncable && typeof currentTime === 'number' && currentTime > 0.05) {
    for (let i = 0; i < lines.length; i++) {
      const o = offsetOf(lines[i], i);
      if (o !== null && o <= currentTime + 0.25) activeIndex = i;
    }
  }
  const activeRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => { if (activeIndex >= 0) activeRef.current?.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, [activeIndex]);   // v12.2.47.1 (#261)
  return (
    <div className="aw-transcript">
      {lines.map((line, index) => {
        // v12.10.30 (#1156 P1/P1b): a call back made from this message - its own indigo block where it happened, ▶ Play in its header.
        if (line.callBack) return <CallBackBlock key={`cb-${line.callBack.id}`} info={line.callBack} at={line.ts} />;
        const o = offsetOf(line, index);
        const clickable = syncable && o !== null;
        const active = index === activeIndex;
        return (
          <div key={`${line.speaker}-${index}`}
            ref={active ? activeRef : undefined}
            /* v12.9.11 (#785): the CURSOR promises playback, so it is shown only when something can actually
               play. The click still reaches seekTo when a recording was expected but failed, because that is
               the case that owes the caller an explanation rather than silence. */
            className={`aw-transcript-line${line.role === 'agent' ? ' is-agent' : (line.role as string) === 'staff' ? ' is-agent is-staff' : line.role === 'path' ? ' is-path' : ' is-caller'}${active ? ' is-active' : ''}${clickable && playable !== false ? ' is-clickable' : ''}`}
            onClick={clickable ? () => onSeek!(o!) : undefined}
            title={clickable ? (playable !== false ? 'Jump to this point in the recording' : 'No playable recording for this call') : undefined}>
            {/* v12.10.14 (#1617, DRAWER v1.10 S239 B): the time sits at the right end of the speaker line; the text takes the full width. */}
            <div className="aw-transcript-body">
              <span className="aw-transcript-ts">{fmtTs(line.ts)}</span>
              {/* v12.3.12 (#307): a call-path line is machine output, so it is set apart from the words the
                  caller and the agent actually said rather than sitting among them looking like speech. */}
              <strong className={`aw-transcript-spk ${line.role === 'agent' || (line.role as string) === 'staff' ? 'aw-spk-agent' : line.role === 'path' ? 'aw-spk-path' : 'aw-spk-caller'}`}>
                {/* v12.10.14 (#1617, S240): the caller in indigo with a person icon (what staff scan for); the AI agent in dark slate with an
                    AI spark, indented 24 px (CSS). */}
                {line.role === 'agent' && <svg className="aw-spk-ic" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="AI assistant"><path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8L12 3z" /><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15z" /></svg>}
                {line.role === 'caller' && <svg className="aw-spk-ic" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-label="Caller"><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></svg>}
                {line.role === 'caller' && callerLabel ? callerLabel : line.speaker}
                {/* v12.9.24 (#913): the language this turn was actually spoken in - a call is mixed. */}
                {line.lang && line.role !== 'path' && <span className="aw-turn-lang" title={`Spoken in ${languageName(line.lang)}`}>{line.lang.toUpperCase()}</span>}
                {line.xlFrom && <span className="aw-turn-xl">translated from {languageName(line.xlFrom)}</span>}
              </strong>
              {line.role === 'path' && endOfCallRows(line.text) ? (
                /* v12.9.26 (#978, UI-LOCK v1.3 LOCKED): the end-of-call entry reads as short labelled lines. */
                <div className="aw-transcript-path aw-eoc">
                  <div className="aw-eoc-h">END OF CALL</div>
                  {endOfCallRows(line.text)!.map(([k, v]) => (
                    <div key={k} className="aw-eoc-row"><span className="aw-eoc-k">{k}</span><span>{v}</span></div>
                  ))}
                </div>
              ) : (
                <p className={line.role === 'path' ? 'aw-transcript-path' : undefined}>
                  {line.via === 'text' && <span className="aw-text-mark" title={line.role === 'caller' ? 'Came in by text' : 'Sent by text'}>TEXT</span>}{/* v12.10.27 (#2151): our own texts too */}{/* v12.10.26 (#T154 Q16) */}
                  {line.role === 'path' ? (line.text ?? '').replace(/^\s*\[path\]\s*/, '') : line.text}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

// v12.9.26 (#978): "end of call | Call: ... | Caller pauses: ... | Cut-offs: ... | Systems: ... | Engine: ..." ->
// [label, value] rows. Anything else (including the pre-12.9.26 run-on line) returns null and renders as before.
function endOfCallRows(text?: string | null): [string, string][] | null {
  const t = (text ?? '').replace(/^\s*\[path\]\s*/, '');
  if (!/^end of call \|/i.test(t)) return null;
  const rows: [string, string][] = [];
  for (const part of t.split(' | ').slice(1)) {
    const i = part.indexOf(': ');
    if (i > 0) rows.push([part.slice(0, i).trim(), part.slice(i + 2).trim()]);
  }
  return rows.length > 0 ? rows : null;
}

// v12.9.11 (#770): m:ss for the mini player's readout. A caller who has just jumped to a transcript line
// wants to know where they landed, and the mini bar is the only thing on screen that can tell them.
function fmtClock(seconds?: number): string {
  const t = Math.max(0, Math.floor(seconds ?? 0));
  return `${Math.floor(t / 60)}:${String(t % 60).padStart(2, '0')}`;
}

// v12.2.38.0 (#212): flatten transcript lines to "Speaker: text" for the copy button.
function transcriptToText(lines: TranscriptLine[]): string {
  // v12.9.24 (#913): the copy keeps what the screen shows - the language tag, and "(translated from ...)".
  return (lines ?? []).map((l) => `${l.speaker}${l.lang && l.role !== 'path' ? ` [${l.lang.toUpperCase()}]` : ''}: ${l.text}${l.xlFrom ? ` (translated from ${languageName(l.xlFrom)})` : ''}`).join('\n');
}

// v12.2.38.0 (#212): small copy-to-clipboard icon button used on the AI Summary + Transcript section headers.
function CopyButton({ text, label, iconOnly }: { text: string; label: string; iconOnly?: boolean }) {
  const [copied, setCopied] = useState(false);
  const doCopy = () => {
    const value = (text ?? '').trim();
    if (!value) return;
    const done = () => { setCopied(true); window.setTimeout(() => setCopied(false), 1500); };
    if (navigator.clipboard?.writeText) { navigator.clipboard.writeText(value).then(done).catch(() => {}); }
    else {
      try { const ta = document.createElement('textarea'); ta.value = value; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); ta.remove(); done(); } catch { /* no-op */ }
    }
  };
  return (
    <button
      type="button"
      className={iconOnly ? 'aw-copy-btn aw-copy-icon' : 'aw-copy-btn'}
      aria-label={copied ? 'Copied' : label}
      title={copied ? 'Copied' : label}
      onClick={doCopy}
      style={{ background: 'none', border: 0, padding: '4px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', color: copied ? 'var(--aw-accent, #4f46e5)' : 'var(--aw-muted, #6b7280)' }}
    >
      <SvgIcon name={copied ? 'check' : 'copy'} />
    </button>
  );
}

function statusLabelOrAll(value: string) {
  return value === 'all' ? 'All' : statusLabel(value as MsgStatus);
}



function FilterGroup<T extends string>({
  title,
  items,
  value,
  label,
  onChange,
}: {
  title: string;
  items: T[];
  value: T;
  label: (value: T) => string;
  onChange: (value: T) => void;
}) {
  return (
    <div className="aw-filter-group">
      <h3>{title}</h3>
      <div className="aw-chip-row">
        {items.map((item) => (
          <button key={item} type="button" className={`aw-chip ${value === item ? 'aw-selected' : ''}`} onClick={() => onChange(item)}>
            {label(item)}
          </button>
        ))}
      </div>
    </div>
  );
}

/** v12.10.14 (FILTER-PANEL v1.0, #1607 #1608): one Filters group - a header bar (caption left, All right), then the chips:
 *  the practice's dot / icon (mark), no ticks, picked = the light-indigo tint. `multi` = several picks (any of). `cap` = a practice
 *  list: a chip is never wider than half the column ("..." + the full name on hover). `fixed` chips (Me, Unassigned) always show.
 *  Long lists ('grows') show 8 then 'Show all N'; past 12 a search box. A picked item always stays in view. */
type ChipItem = { k: string; label: string; mark?: ReactNode };
function ChipGroup({ title, items, value, onChange, grows = false, multi = false, cap = false, hl = false, fixed = [] }: {
  title: string; items: ChipItem[]; value: string; onChange: (value: string) => void; grows?: boolean; multi?: boolean; cap?: boolean; hl?: boolean; fixed?: ChipItem[];
}) {
  const [all, setAll] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => { if (hl) ref.current?.scrollIntoView({ block: 'nearest' }); }, [hl]);
  const CAP = 8;
  const picked = fvals(value);
  const query = q.trim().toLowerCase();
  const matched = query ? items.filter((it) => it.label.toLowerCase().includes(query)) : items;
  let shown = grows && !all && !query ? matched.slice(0, CAP) : matched;
  items.filter((it) => picked.includes(it.k) && !shown.includes(it)).forEach((it) => { shown = [...shown, it]; });
  const click = (k: string) => onChange(multi ? fjoin(picked.includes(k) ? picked.filter((v) => v !== k) : [...picked, k]) : (picked[0] === k ? 'all' : k));
  const chip = (it: ChipItem) => (
    <button key={it.k} type="button" className={`aw-chip ${picked.includes(it.k) ? 'aw-selected' : ''}`} aria-pressed={picked.includes(it.k)} title={it.label} onClick={() => click(it.k)}>
      {it.mark}<span className="aw-chip-tx">{it.label}</span>
    </button>
  );
  return (
    <div ref={ref} className={`aw-filter-group aw-fg13${cap ? ' aw-fg-cap' : ''}${hl ? ' aw-fg-hl' : ''}`} data-group={title}>
      <h3 className="aw-fg-h"><span className="aw-fg-title">{title}</span>
        <button type="button" className={`aw-chip aw-fg-all ${picked.length === 0 ? 'aw-selected' : ''}`} onClick={() => onChange('all')}>All</button>
      </h3>
      {grows && items.length > 12 && (all || query) && (
        <input className="aw-fg-search" value={q} placeholder={`Search ${title.toLowerCase()}…`} aria-label={`Search ${title}`}
          data-track="filters.listsearch" onChange={(e) => setQ(e.target.value)} />
      )}
      <div className="aw-chip-row">
        {fixed.map(chip)}
        {shown.map(chip)}
        {grows && !query && items.length > CAP && (
          <button type="button" className="aw-chip aw-chip-more" data-track="filters.showall" onClick={() => { setAll((v) => !v); setQ(''); }}>
            {all ? 'Show fewer' : `Show all ${items.length}`}
          </button>
        )}
        {query && matched.length === 0 && <span className="aw-fg-none">No match</span>}
      </div>
    </div>
  );
}

// v12.9.24 (#908): a translation failure in words a staff user can act on. The API sends a code, never prose.
function xlReasonText(reason?: string | null): string {
  switch (reason) {
    case 'no-key': return 'no AI key is set for this organization (Settings \u2192 AI provider)';
    case 'ai-key-rejected': return 'the AI key for this organization was rejected - ask an administrator to check it';
    case 'ai-model-missing': return 'the AI model set for this organization is no longer available - ask an administrator';
    case 'ai-billing': return 'the AI account is out of credit - ask an administrator';
    case 'ai-busy': return 'the translation service is busy - try again in a minute';
    case 'ai-timeout': return 'the translation took too long - try again';
    case 'no-transcript': case 'no-turns': return 'this call has no transcript to translate';
    case 'network': return 'the connection dropped - try again';
    default: return 'the translation service did not answer';
  }
}

// ══ v12.10.10 (#1399): Assigned to + Status chips (UI-PROTO-T46-HEADER-OPTIONS v1.4, option A2) ══

function assigneeInitials(name: string): string {
  return initials(name.replace(/^Dr\.?\s+/i, '')) || '?';
}

/** Closes a small menu on an outside click or Escape. */
function useMenuDismiss(open: boolean, close: () => void, ref: { current: HTMLElement | null }) {
  useEffect(() => {
    if (!open) return;
    const onDown = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) close(); };
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
    document.addEventListener('mousedown', onDown);
    document.addEventListener('keydown', onKey, true);
    return () => { document.removeEventListener('mousedown', onDown); document.removeEventListener('keydown', onKey, true); };
  }, [open, close, ref]);
}

function AssignChip({ value, name, people, meId, disabledWhy, onPick }: {
  value: number | null; name: string | null; people: Assignee[]; meId: number | null;
  disabledWhy: string | null; onPick: (userId: number | null) => void;
}) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState('');
  const ref = useRef<HTMLSpanElement | null>(null);
  const close = useCallback(() => { setOpen(false); setQ(''); }, []);
  useMenuDismiss(open, close, ref);
  const assigned = Boolean(name);
  const isMe = meId !== null && value === meId;
  const query = q.trim().toLowerCase();
  const others = people.filter((p) => meId === null || p.id !== String(meId))
    .filter((p) => !query || p.name.toLowerCase().includes(query) || p.role.toLowerCase().includes(query));
  const showMe = meId !== null && !isMe && (!query || 'me'.startsWith(query) || people.some((p) => p.id === String(meId) && p.name.toLowerCase().includes(query)));
  const pick = (id: number | null) => { close(); onPick(id); };
  const label = assigned ? `Assigned to ${isMe ? 'you' : name}` : 'Assign';
  if (disabledWhy) {
    return (
      <span className="aw-as-wrap aw-act-blocked" title={disabledWhy} tabIndex={0} aria-label={`${label} - ${disabledWhy}`}>
        <button type="button" className={`aw-as-chip${assigned ? '' : ' aw-as-none'} aw-act-dis`} disabled aria-disabled="true">
          {assigned ? <><i aria-hidden="true">{assigneeInitials(name!)}</i><span className="aw-as-full">{name}</span></> : <span className="aw-as-full">+ Assign</span>}
          {!assigned && <span className="aw-as-plus" aria-hidden="true">+</span>}
        </button>
      </span>
    );
  }
  return (
    <span className="aw-as-wrap" ref={ref}>
      <button type="button" className={`aw-as-chip${assigned ? '' : ' aw-as-none'}${isMe ? ' aw-me' : ''}`} aria-haspopup="menu" aria-expanded={open}
        aria-label={label} title={label} onClick={() => setOpen((o) => !o)}>
        {assigned ? <><i aria-hidden="true">{assigneeInitials(name!)}</i><span className="aw-as-full">{name}</span></> : <span className="aw-as-full">+ Assign</span>}
        {!assigned && <span className="aw-as-plus" aria-hidden="true">+</span>}
        <span className="aw-as-car" aria-hidden="true">{'\u25BE'}</span>
      </button>
      {open && (
        <div className="aw-as-menu" role="menu">
          <input autoFocus value={q} placeholder="Search people…" aria-label="Search people" onChange={(e) => setQ(e.target.value)} />
          <div className="aw-as-list">
            {showMe && (<><button type="button" role="menuitem" onClick={() => pick(meId)}><b>Assign to me</b></button><div className="aw-as-sep" /></>)}
            {others.map((p) => (
              <button key={p.id} type="button" role="menuitem" onClick={() => pick(Number(p.id))}>
                <span className="aw-as-name">{p.name}{String(value) === p.id ? ' \u2713' : ''}</span>
                {p.role && <small>{p.role}</small>}
              </button>
            ))}
            {!showMe && others.length === 0 && <div className="aw-as-empty">No one matches</div>}
            {assigned && (<><div className="aw-as-sep" /><button type="button" role="menuitem" className="aw-as-unassign" onClick={() => pick(null)}>Unassign</button></>)}
          </div>
        </div>
      )}
    </span>
  );
}

function StatusChip({ status, onPick }: { status: MsgStatus; onPick: (next: 'prog' | 'done') => void }) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLSpanElement | null>(null);
  const close = useCallback(() => setOpen(false), []);
  useMenuDismiss(open, close, ref);
  const word = status === 'done' ? 'Completed' : status === 'prog' ? 'Pending' : 'New';
  return (
    <span className="aw-st-wrap" ref={ref}>
      <button type="button" className={`aw-st-chip aw-st-${status}`} aria-haspopup="menu" aria-expanded={open}
        aria-label={`Status: ${word}`} onClick={() => setOpen((o) => !o)}>
        {word} <span aria-hidden="true">{'\u25BE'}</span>
      </button>
      {open && (
        <div className="aw-as-menu aw-st-menu" role="menu">
          {(['prog', 'done'] as const).map((k) => (
            <button key={k} type="button" role="menuitem" onClick={() => { close(); onPick(k); }}>
              <span className="aw-as-name">{k === 'done' ? 'Completed' : 'Pending'}</span>{status === k && <small>{'\u2713'}</small>}
            </button>
          ))}
        </div>
      )}
    </span>
  );
}

/** v12.10.10 (#1399): the filter panel's Assigned to group - several may be ticked.
 *  v12.10.13 (#1558): Me and Unassigned always shown; people A-Z, 8 then 'Show all N', search past 12; ticked people stay in view. */
// v12.10.14: AssignedFilterGroup is gone - Assigned to is a ChipGroup (multi, fixed Me / Unassigned) like every other group.
